(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["EsuiteClient"] = factory();
	else
		root["EsuiteClient"] = factory();
})(this, function() {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '1.0.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return base64;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AccessCodeCreateRequestFromJSON": () => (/* reexport */ AccessCodeCreateRequestFromJSON),
  "AccessCodeCreateRequestFromJSONTyped": () => (/* reexport */ AccessCodeCreateRequestFromJSONTyped),
  "AccessCodeCreateRequestToJSON": () => (/* reexport */ AccessCodeCreateRequestToJSON),
  "AccessCodeResponseFromJSON": () => (/* reexport */ AccessCodeResponseFromJSON),
  "AccessCodeResponseFromJSONTyped": () => (/* reexport */ AccessCodeResponseFromJSONTyped),
  "AccessCodeResponseToJSON": () => (/* reexport */ AccessCodeResponseToJSON),
  "AccessControlCreateRequestFromJSON": () => (/* reexport */ AccessControlCreateRequestFromJSON),
  "AccessControlCreateRequestFromJSONTyped": () => (/* reexport */ AccessControlCreateRequestFromJSONTyped),
  "AccessControlCreateRequestToJSON": () => (/* reexport */ AccessControlCreateRequestToJSON),
  "AccessControlResource": () => (/* reexport */ AccessControlResource),
  "AccessControlResourceFromJSON": () => (/* reexport */ AccessControlResourceFromJSON),
  "AccessControlResourceFromJSONTyped": () => (/* reexport */ AccessControlResourceFromJSONTyped),
  "AccessControlResourceToJSON": () => (/* reexport */ AccessControlResourceToJSON),
  "AccessControlResponseFromJSON": () => (/* reexport */ AccessControlResponseFromJSON),
  "AccessControlResponseFromJSONTyped": () => (/* reexport */ AccessControlResponseFromJSONTyped),
  "AccessControlResponseOwnerTypeEnum": () => (/* reexport */ AccessControlResponseOwnerTypeEnum),
  "AccessControlResponseResourceTypeEnum": () => (/* reexport */ AccessControlResponseResourceTypeEnum),
  "AccessControlResponseToJSON": () => (/* reexport */ AccessControlResponseToJSON),
  "AccessTokenResponseFromJSON": () => (/* reexport */ AccessTokenResponseFromJSON),
  "AccessTokenResponseFromJSONTyped": () => (/* reexport */ AccessTokenResponseFromJSONTyped),
  "AccessTokenResponseToJSON": () => (/* reexport */ AccessTokenResponseToJSON),
  "ActivationFromJSON": () => (/* reexport */ ActivationFromJSON),
  "ActivationFromJSONTyped": () => (/* reexport */ ActivationFromJSONTyped),
  "ActivationKioskFromJSON": () => (/* reexport */ ActivationKioskFromJSON),
  "ActivationKioskFromJSONTyped": () => (/* reexport */ ActivationKioskFromJSONTyped),
  "ActivationKioskToJSON": () => (/* reexport */ ActivationKioskToJSON),
  "ActivationMode": () => (/* reexport */ ActivationMode),
  "ActivationModeFromJSON": () => (/* reexport */ ActivationModeFromJSON),
  "ActivationModeFromJSONTyped": () => (/* reexport */ ActivationModeFromJSONTyped),
  "ActivationModeToJSON": () => (/* reexport */ ActivationModeToJSON),
  "ActivationScheduleCreateRequestFromJSON": () => (/* reexport */ ActivationScheduleCreateRequestFromJSON),
  "ActivationScheduleCreateRequestFromJSONTyped": () => (/* reexport */ ActivationScheduleCreateRequestFromJSONTyped),
  "ActivationScheduleCreateRequestToJSON": () => (/* reexport */ ActivationScheduleCreateRequestToJSON),
  "ActivationScheduleDayFromJSON": () => (/* reexport */ ActivationScheduleDayFromJSON),
  "ActivationScheduleDayFromJSONTyped": () => (/* reexport */ ActivationScheduleDayFromJSONTyped),
  "ActivationScheduleDayToJSON": () => (/* reexport */ ActivationScheduleDayToJSON),
  "ActivationScheduleItemCreateRequestFromJSON": () => (/* reexport */ ActivationScheduleItemCreateRequestFromJSON),
  "ActivationScheduleItemCreateRequestFromJSONTyped": () => (/* reexport */ ActivationScheduleItemCreateRequestFromJSONTyped),
  "ActivationScheduleItemCreateRequestToJSON": () => (/* reexport */ ActivationScheduleItemCreateRequestToJSON),
  "ActivationScheduleItemResponseFromJSON": () => (/* reexport */ ActivationScheduleItemResponseFromJSON),
  "ActivationScheduleItemResponseFromJSONTyped": () => (/* reexport */ ActivationScheduleItemResponseFromJSONTyped),
  "ActivationScheduleItemResponseToJSON": () => (/* reexport */ ActivationScheduleItemResponseToJSON),
  "ActivationScheduleItemUpdateRequestFromJSON": () => (/* reexport */ ActivationScheduleItemUpdateRequestFromJSON),
  "ActivationScheduleItemUpdateRequestFromJSONTyped": () => (/* reexport */ ActivationScheduleItemUpdateRequestFromJSONTyped),
  "ActivationScheduleItemUpdateRequestToJSON": () => (/* reexport */ ActivationScheduleItemUpdateRequestToJSON),
  "ActivationScheduleResponseFromJSON": () => (/* reexport */ ActivationScheduleResponseFromJSON),
  "ActivationScheduleResponseFromJSONTyped": () => (/* reexport */ ActivationScheduleResponseFromJSONTyped),
  "ActivationScheduleResponseToJSON": () => (/* reexport */ ActivationScheduleResponseToJSON),
  "ActivationScheduleUpdateRequestFromJSON": () => (/* reexport */ ActivationScheduleUpdateRequestFromJSON),
  "ActivationScheduleUpdateRequestFromJSONTyped": () => (/* reexport */ ActivationScheduleUpdateRequestFromJSONTyped),
  "ActivationScheduleUpdateRequestToJSON": () => (/* reexport */ ActivationScheduleUpdateRequestToJSON),
  "ActivationToJSON": () => (/* reexport */ ActivationToJSON),
  "ActivationUpdateRequestFromJSON": () => (/* reexport */ ActivationUpdateRequestFromJSON),
  "ActivationUpdateRequestFromJSONTyped": () => (/* reexport */ ActivationUpdateRequestFromJSONTyped),
  "ActivationUpdateRequestToJSON": () => (/* reexport */ ActivationUpdateRequestToJSON),
  "AddressFromJSON": () => (/* reexport */ AddressFromJSON),
  "AddressFromJSONTyped": () => (/* reexport */ AddressFromJSONTyped),
  "AddressToJSON": () => (/* reexport */ AddressToJSON),
  "AdmissionCreateRequestFromJSON": () => (/* reexport */ AdmissionCreateRequestFromJSON),
  "AdmissionCreateRequestFromJSONTyped": () => (/* reexport */ AdmissionCreateRequestFromJSONTyped),
  "AdmissionCreateRequestToJSON": () => (/* reexport */ AdmissionCreateRequestToJSON),
  "AdmissionLineItemOptionFromJSON": () => (/* reexport */ AdmissionLineItemOptionFromJSON),
  "AdmissionLineItemOptionFromJSONTyped": () => (/* reexport */ AdmissionLineItemOptionFromJSONTyped),
  "AdmissionLineItemOptionToJSON": () => (/* reexport */ AdmissionLineItemOptionToJSON),
  "AdmissionOptionCreateRequestFromJSON": () => (/* reexport */ AdmissionOptionCreateRequestFromJSON),
  "AdmissionOptionCreateRequestFromJSONTyped": () => (/* reexport */ AdmissionOptionCreateRequestFromJSONTyped),
  "AdmissionOptionCreateRequestToJSON": () => (/* reexport */ AdmissionOptionCreateRequestToJSON),
  "AdmissionOptionLineItemResponseFromJSON": () => (/* reexport */ AdmissionOptionLineItemResponseFromJSON),
  "AdmissionOptionLineItemResponseFromJSONTyped": () => (/* reexport */ AdmissionOptionLineItemResponseFromJSONTyped),
  "AdmissionOptionLineItemResponseToJSON": () => (/* reexport */ AdmissionOptionLineItemResponseToJSON),
  "AdmissionOptionResponseFromJSON": () => (/* reexport */ AdmissionOptionResponseFromJSON),
  "AdmissionOptionResponseFromJSONTyped": () => (/* reexport */ AdmissionOptionResponseFromJSONTyped),
  "AdmissionOptionResponseToJSON": () => (/* reexport */ AdmissionOptionResponseToJSON),
  "AdmissionOptionUpdateRequestFromJSON": () => (/* reexport */ AdmissionOptionUpdateRequestFromJSON),
  "AdmissionOptionUpdateRequestFromJSONTyped": () => (/* reexport */ AdmissionOptionUpdateRequestFromJSONTyped),
  "AdmissionOptionUpdateRequestToJSON": () => (/* reexport */ AdmissionOptionUpdateRequestToJSON),
  "AdmissionResponseFromJSON": () => (/* reexport */ AdmissionResponseFromJSON),
  "AdmissionResponseFromJSONTyped": () => (/* reexport */ AdmissionResponseFromJSONTyped),
  "AdmissionResponseToJSON": () => (/* reexport */ AdmissionResponseToJSON),
  "AdmissionTemplateCreateRequestFromJSON": () => (/* reexport */ AdmissionTemplateCreateRequestFromJSON),
  "AdmissionTemplateCreateRequestFromJSONTyped": () => (/* reexport */ AdmissionTemplateCreateRequestFromJSONTyped),
  "AdmissionTemplateCreateRequestToJSON": () => (/* reexport */ AdmissionTemplateCreateRequestToJSON),
  "AdmissionTemplateResponseFromJSON": () => (/* reexport */ AdmissionTemplateResponseFromJSON),
  "AdmissionTemplateResponseFromJSONTyped": () => (/* reexport */ AdmissionTemplateResponseFromJSONTyped),
  "AdmissionTemplateResponseToJSON": () => (/* reexport */ AdmissionTemplateResponseToJSON),
  "AdmissionTemplateUpdateRequestFromJSON": () => (/* reexport */ AdmissionTemplateUpdateRequestFromJSON),
  "AdmissionTemplateUpdateRequestFromJSONTyped": () => (/* reexport */ AdmissionTemplateUpdateRequestFromJSONTyped),
  "AdmissionTemplateUpdateRequestToJSON": () => (/* reexport */ AdmissionTemplateUpdateRequestToJSON),
  "AdmissionUpdateRequestFromJSON": () => (/* reexport */ AdmissionUpdateRequestFromJSON),
  "AdmissionUpdateRequestFromJSONTyped": () => (/* reexport */ AdmissionUpdateRequestFromJSONTyped),
  "AdmissionUpdateRequestToJSON": () => (/* reexport */ AdmissionUpdateRequestToJSON),
  "AgreementCreateRequestFromJSON": () => (/* reexport */ AgreementCreateRequestFromJSON),
  "AgreementCreateRequestFromJSONTyped": () => (/* reexport */ AgreementCreateRequestFromJSONTyped),
  "AgreementCreateRequestToJSON": () => (/* reexport */ AgreementCreateRequestToJSON),
  "AgreementResponseFromJSON": () => (/* reexport */ AgreementResponseFromJSON),
  "AgreementResponseFromJSONTyped": () => (/* reexport */ AgreementResponseFromJSONTyped),
  "AgreementResponseToJSON": () => (/* reexport */ AgreementResponseToJSON),
  "AgreementUpdateRequestFromJSON": () => (/* reexport */ AgreementUpdateRequestFromJSON),
  "AgreementUpdateRequestFromJSONTyped": () => (/* reexport */ AgreementUpdateRequestFromJSONTyped),
  "AgreementUpdateRequestToJSON": () => (/* reexport */ AgreementUpdateRequestToJSON),
  "ApiVersion": () => (/* reexport */ ApiVersion),
  "AppPluginCreateFromJSON": () => (/* reexport */ AppPluginCreateFromJSON),
  "AppPluginCreateFromJSONTyped": () => (/* reexport */ AppPluginCreateFromJSONTyped),
  "AppPluginCreateToJSON": () => (/* reexport */ AppPluginCreateToJSON),
  "AppPluginFromJSON": () => (/* reexport */ AppPluginFromJSON),
  "AppPluginFromJSONTyped": () => (/* reexport */ AppPluginFromJSONTyped),
  "AppPluginHookUseActionRequestFromJSON": () => (/* reexport */ AppPluginHookUseActionRequestFromJSON),
  "AppPluginHookUseActionRequestFromJSONTyped": () => (/* reexport */ AppPluginHookUseActionRequestFromJSONTyped),
  "AppPluginHookUseActionRequestToJSON": () => (/* reexport */ AppPluginHookUseActionRequestToJSON),
  "AppPluginHookUseMapRequestFromJSON": () => (/* reexport */ AppPluginHookUseMapRequestFromJSON),
  "AppPluginHookUseMapRequestFromJSONTyped": () => (/* reexport */ AppPluginHookUseMapRequestFromJSONTyped),
  "AppPluginHookUseMapRequestToJSON": () => (/* reexport */ AppPluginHookUseMapRequestToJSON),
  "AppPluginToJSON": () => (/* reexport */ AppPluginToJSON),
  "AppPluginUpdateFromJSON": () => (/* reexport */ AppPluginUpdateFromJSON),
  "AppPluginUpdateFromJSONTyped": () => (/* reexport */ AppPluginUpdateFromJSONTyped),
  "AppPluginUpdateToJSON": () => (/* reexport */ AppPluginUpdateToJSON),
  "AppPurchaseCreateRequestFromJSON": () => (/* reexport */ AppPurchaseCreateRequestFromJSON),
  "AppPurchaseCreateRequestFromJSONTyped": () => (/* reexport */ AppPurchaseCreateRequestFromJSONTyped),
  "AppPurchaseCreateRequestStatusEnum": () => (/* reexport */ AppPurchaseCreateRequestStatusEnum),
  "AppPurchaseCreateRequestToJSON": () => (/* reexport */ AppPurchaseCreateRequestToJSON),
  "ApplicationCurrency": () => (/* reexport */ ApplicationCurrency),
  "ApplicationCurrencyFromJSON": () => (/* reexport */ ApplicationCurrencyFromJSON),
  "ApplicationCurrencyFromJSONTyped": () => (/* reexport */ ApplicationCurrencyFromJSONTyped),
  "ApplicationCurrencyToJSON": () => (/* reexport */ ApplicationCurrencyToJSON),
  "AuthResetPasswordRequestFromJSON": () => (/* reexport */ AuthResetPasswordRequestFromJSON),
  "AuthResetPasswordRequestFromJSONTyped": () => (/* reexport */ AuthResetPasswordRequestFromJSONTyped),
  "AuthResetPasswordRequestToJSON": () => (/* reexport */ AuthResetPasswordRequestToJSON),
  "AuthUserRequestFromJSON": () => (/* reexport */ AuthUserRequestFromJSON),
  "AuthUserRequestFromJSONTyped": () => (/* reexport */ AuthUserRequestFromJSONTyped),
  "AuthUserRequestToJSON": () => (/* reexport */ AuthUserRequestToJSON),
  "BASE_PATH": () => (/* reexport */ BASE_PATH),
  "BaseAPI": () => (/* reexport */ BaseAPI),
  "BaseEsuiteAppInstanceModelFromJSON": () => (/* reexport */ BaseEsuiteAppInstanceModelFromJSON),
  "BaseEsuiteAppInstanceModelFromJSONTyped": () => (/* reexport */ BaseEsuiteAppInstanceModelFromJSONTyped),
  "BaseEsuiteAppInstanceModelToJSON": () => (/* reexport */ BaseEsuiteAppInstanceModelToJSON),
  "BaseEsuiteAppInstanceResponseFromJSON": () => (/* reexport */ BaseEsuiteAppInstanceResponseFromJSON),
  "BaseEsuiteAppInstanceResponseFromJSONTyped": () => (/* reexport */ BaseEsuiteAppInstanceResponseFromJSONTyped),
  "BaseEsuiteAppInstanceResponseToJSON": () => (/* reexport */ BaseEsuiteAppInstanceResponseToJSON),
  "BlobApiResponse": () => (/* reexport */ BlobApiResponse),
  "COLLECTION_FORMATS": () => (/* reexport */ COLLECTION_FORMATS),
  "CayanGatewayRequestFromJSON": () => (/* reexport */ CayanGatewayRequestFromJSON),
  "CayanGatewayRequestFromJSONTyped": () => (/* reexport */ CayanGatewayRequestFromJSONTyped),
  "CayanGatewayRequestToJSON": () => (/* reexport */ CayanGatewayRequestToJSON),
  "CayanGatewayResponseFromJSON": () => (/* reexport */ CayanGatewayResponseFromJSON),
  "CayanGatewayResponseFromJSONTyped": () => (/* reexport */ CayanGatewayResponseFromJSONTyped),
  "CayanGatewayResponseToJSON": () => (/* reexport */ CayanGatewayResponseToJSON),
  "CheckoutCreateRequestFromJSON": () => (/* reexport */ CheckoutCreateRequestFromJSON),
  "CheckoutCreateRequestFromJSONTyped": () => (/* reexport */ CheckoutCreateRequestFromJSONTyped),
  "CheckoutCreateRequestToJSON": () => (/* reexport */ CheckoutCreateRequestToJSON),
  "CheckoutFieldOptionsFromJSON": () => (/* reexport */ CheckoutFieldOptionsFromJSON),
  "CheckoutFieldOptionsFromJSONTyped": () => (/* reexport */ CheckoutFieldOptionsFromJSONTyped),
  "CheckoutFieldOptionsToJSON": () => (/* reexport */ CheckoutFieldOptionsToJSON),
  "CheckoutIntegrationCreateRequestFromJSON": () => (/* reexport */ CheckoutIntegrationCreateRequestFromJSON),
  "CheckoutIntegrationCreateRequestFromJSONTyped": () => (/* reexport */ CheckoutIntegrationCreateRequestFromJSONTyped),
  "CheckoutIntegrationCreateRequestToJSON": () => (/* reexport */ CheckoutIntegrationCreateRequestToJSON),
  "CheckoutIntegrationFromJSON": () => (/* reexport */ CheckoutIntegrationFromJSON),
  "CheckoutIntegrationFromJSONTyped": () => (/* reexport */ CheckoutIntegrationFromJSONTyped),
  "CheckoutIntegrationToJSON": () => (/* reexport */ CheckoutIntegrationToJSON),
  "CheckoutIntegrationUpdateRequestFromJSON": () => (/* reexport */ CheckoutIntegrationUpdateRequestFromJSON),
  "CheckoutIntegrationUpdateRequestFromJSONTyped": () => (/* reexport */ CheckoutIntegrationUpdateRequestFromJSONTyped),
  "CheckoutIntegrationUpdateRequestToJSON": () => (/* reexport */ CheckoutIntegrationUpdateRequestToJSON),
  "CheckoutLineItemCreateRequestFromJSON": () => (/* reexport */ CheckoutLineItemCreateRequestFromJSON),
  "CheckoutLineItemCreateRequestFromJSONTyped": () => (/* reexport */ CheckoutLineItemCreateRequestFromJSONTyped),
  "CheckoutLineItemCreateRequestToJSON": () => (/* reexport */ CheckoutLineItemCreateRequestToJSON),
  "CheckoutLineItemResponseFromJSON": () => (/* reexport */ CheckoutLineItemResponseFromJSON),
  "CheckoutLineItemResponseFromJSONTyped": () => (/* reexport */ CheckoutLineItemResponseFromJSONTyped),
  "CheckoutLineItemResponseToJSON": () => (/* reexport */ CheckoutLineItemResponseToJSON),
  "CheckoutLineItemUpdateRequestFromJSON": () => (/* reexport */ CheckoutLineItemUpdateRequestFromJSON),
  "CheckoutLineItemUpdateRequestFromJSONTyped": () => (/* reexport */ CheckoutLineItemUpdateRequestFromJSONTyped),
  "CheckoutLineItemUpdateRequestToJSON": () => (/* reexport */ CheckoutLineItemUpdateRequestToJSON),
  "CheckoutResponseFromJSON": () => (/* reexport */ CheckoutResponseFromJSON),
  "CheckoutResponseFromJSONTyped": () => (/* reexport */ CheckoutResponseFromJSONTyped),
  "CheckoutResponseToJSON": () => (/* reexport */ CheckoutResponseToJSON),
  "CheckoutUpdateRequestDtoFromJSON": () => (/* reexport */ CheckoutUpdateRequestDtoFromJSON),
  "CheckoutUpdateRequestDtoFromJSONTyped": () => (/* reexport */ CheckoutUpdateRequestDtoFromJSONTyped),
  "CheckoutUpdateRequestDtoToJSON": () => (/* reexport */ CheckoutUpdateRequestDtoToJSON),
  "Configuration": () => (/* reexport */ Configuration),
  "CustomAppCreateRequestFromJSON": () => (/* reexport */ CustomAppCreateRequestFromJSON),
  "CustomAppCreateRequestFromJSONTyped": () => (/* reexport */ CustomAppCreateRequestFromJSONTyped),
  "CustomAppCreateRequestToJSON": () => (/* reexport */ CustomAppCreateRequestToJSON),
  "CustomAppResponseFromJSON": () => (/* reexport */ CustomAppResponseFromJSON),
  "CustomAppResponseFromJSONTyped": () => (/* reexport */ CustomAppResponseFromJSONTyped),
  "CustomAppResponseToJSON": () => (/* reexport */ CustomAppResponseToJSON),
  "CustomAppUpdateRequestFromJSON": () => (/* reexport */ CustomAppUpdateRequestFromJSON),
  "CustomAppUpdateRequestFromJSONTyped": () => (/* reexport */ CustomAppUpdateRequestFromJSONTyped),
  "CustomAppUpdateRequestToJSON": () => (/* reexport */ CustomAppUpdateRequestToJSON),
  "CustomFieldEntryFromJSON": () => (/* reexport */ CustomFieldEntryFromJSON),
  "CustomFieldEntryFromJSONTyped": () => (/* reexport */ CustomFieldEntryFromJSONTyped),
  "CustomFieldEntryToJSON": () => (/* reexport */ CustomFieldEntryToJSON),
  "CustomFieldOptionsFromJSON": () => (/* reexport */ CustomFieldOptionsFromJSON),
  "CustomFieldOptionsFromJSONTyped": () => (/* reexport */ CustomFieldOptionsFromJSONTyped),
  "CustomFieldOptionsToJSON": () => (/* reexport */ CustomFieldOptionsToJSON),
  "CustomProductOptionType": () => (/* reexport */ CustomProductOptionType),
  "CustomProductOptionTypeFromJSON": () => (/* reexport */ CustomProductOptionTypeFromJSON),
  "CustomProductOptionTypeFromJSONTyped": () => (/* reexport */ CustomProductOptionTypeFromJSONTyped),
  "CustomProductOptionTypeToJSON": () => (/* reexport */ CustomProductOptionTypeToJSON),
  "CustomProductOptionValueFromJSON": () => (/* reexport */ CustomProductOptionValueFromJSON),
  "CustomProductOptionValueFromJSONTyped": () => (/* reexport */ CustomProductOptionValueFromJSONTyped),
  "CustomProductOptionValueToJSON": () => (/* reexport */ CustomProductOptionValueToJSON),
  "CustomerCreateRequestFromJSON": () => (/* reexport */ CustomerCreateRequestFromJSON),
  "CustomerCreateRequestFromJSONTyped": () => (/* reexport */ CustomerCreateRequestFromJSONTyped),
  "CustomerCreateRequestToJSON": () => (/* reexport */ CustomerCreateRequestToJSON),
  "CustomerResponseFromJSON": () => (/* reexport */ CustomerResponseFromJSON),
  "CustomerResponseFromJSONTyped": () => (/* reexport */ CustomerResponseFromJSONTyped),
  "CustomerResponseToJSON": () => (/* reexport */ CustomerResponseToJSON),
  "CustomerUpdateRequestFromJSON": () => (/* reexport */ CustomerUpdateRequestFromJSON),
  "CustomerUpdateRequestFromJSONTyped": () => (/* reexport */ CustomerUpdateRequestFromJSONTyped),
  "CustomerUpdateRequestToJSON": () => (/* reexport */ CustomerUpdateRequestToJSON),
  "DefaultApi": () => (/* reexport */ DefaultApi),
  "DigitalSignageCreateRequestFromJSON": () => (/* reexport */ DigitalSignageCreateRequestFromJSON),
  "DigitalSignageCreateRequestFromJSONTyped": () => (/* reexport */ DigitalSignageCreateRequestFromJSONTyped),
  "DigitalSignageCreateRequestToJSON": () => (/* reexport */ DigitalSignageCreateRequestToJSON),
  "DigitalSignageFrameCreateRequestFromJSON": () => (/* reexport */ DigitalSignageFrameCreateRequestFromJSON),
  "DigitalSignageFrameCreateRequestFromJSONTyped": () => (/* reexport */ DigitalSignageFrameCreateRequestFromJSONTyped),
  "DigitalSignageFrameCreateRequestToJSON": () => (/* reexport */ DigitalSignageFrameCreateRequestToJSON),
  "DigitalSignageFrameResponseFromJSON": () => (/* reexport */ DigitalSignageFrameResponseFromJSON),
  "DigitalSignageFrameResponseFromJSONTyped": () => (/* reexport */ DigitalSignageFrameResponseFromJSONTyped),
  "DigitalSignageFrameResponseToJSON": () => (/* reexport */ DigitalSignageFrameResponseToJSON),
  "DigitalSignageFrameType": () => (/* reexport */ DigitalSignageFrameType),
  "DigitalSignageFrameTypeFromJSON": () => (/* reexport */ DigitalSignageFrameTypeFromJSON),
  "DigitalSignageFrameTypeFromJSONTyped": () => (/* reexport */ DigitalSignageFrameTypeFromJSONTyped),
  "DigitalSignageFrameTypeToJSON": () => (/* reexport */ DigitalSignageFrameTypeToJSON),
  "DigitalSignageFrameUpdateRequestFromJSON": () => (/* reexport */ DigitalSignageFrameUpdateRequestFromJSON),
  "DigitalSignageFrameUpdateRequestFromJSONTyped": () => (/* reexport */ DigitalSignageFrameUpdateRequestFromJSONTyped),
  "DigitalSignageFrameUpdateRequestToJSON": () => (/* reexport */ DigitalSignageFrameUpdateRequestToJSON),
  "DigitalSignageLayerLinkFromJSON": () => (/* reexport */ DigitalSignageLayerLinkFromJSON),
  "DigitalSignageLayerLinkFromJSONTyped": () => (/* reexport */ DigitalSignageLayerLinkFromJSONTyped),
  "DigitalSignageLayerLinkTarget": () => (/* reexport */ DigitalSignageLayerLinkTarget),
  "DigitalSignageLayerLinkTargetFromJSON": () => (/* reexport */ DigitalSignageLayerLinkTargetFromJSON),
  "DigitalSignageLayerLinkTargetFromJSONTyped": () => (/* reexport */ DigitalSignageLayerLinkTargetFromJSONTyped),
  "DigitalSignageLayerLinkTargetToJSON": () => (/* reexport */ DigitalSignageLayerLinkTargetToJSON),
  "DigitalSignageLayerLinkToJSON": () => (/* reexport */ DigitalSignageLayerLinkToJSON),
  "DigitalSignageLayerLinkType": () => (/* reexport */ DigitalSignageLayerLinkType),
  "DigitalSignageLayerLinkTypeFromJSON": () => (/* reexport */ DigitalSignageLayerLinkTypeFromJSON),
  "DigitalSignageLayerLinkTypeFromJSONTyped": () => (/* reexport */ DigitalSignageLayerLinkTypeFromJSONTyped),
  "DigitalSignageLayerLinkTypeToJSON": () => (/* reexport */ DigitalSignageLayerLinkTypeToJSON),
  "DigitalSignageResponseFromJSON": () => (/* reexport */ DigitalSignageResponseFromJSON),
  "DigitalSignageResponseFromJSONTyped": () => (/* reexport */ DigitalSignageResponseFromJSONTyped),
  "DigitalSignageResponseToJSON": () => (/* reexport */ DigitalSignageResponseToJSON),
  "DigitalSignageSlideCreateRequestFromJSON": () => (/* reexport */ DigitalSignageSlideCreateRequestFromJSON),
  "DigitalSignageSlideCreateRequestFromJSONTyped": () => (/* reexport */ DigitalSignageSlideCreateRequestFromJSONTyped),
  "DigitalSignageSlideCreateRequestToJSON": () => (/* reexport */ DigitalSignageSlideCreateRequestToJSON),
  "DigitalSignageSlideLayerModelFromJSON": () => (/* reexport */ DigitalSignageSlideLayerModelFromJSON),
  "DigitalSignageSlideLayerModelFromJSONTyped": () => (/* reexport */ DigitalSignageSlideLayerModelFromJSONTyped),
  "DigitalSignageSlideLayerModelToJSON": () => (/* reexport */ DigitalSignageSlideLayerModelToJSON),
  "DigitalSignageSlideLayerRequestFromJSON": () => (/* reexport */ DigitalSignageSlideLayerRequestFromJSON),
  "DigitalSignageSlideLayerRequestFromJSONTyped": () => (/* reexport */ DigitalSignageSlideLayerRequestFromJSONTyped),
  "DigitalSignageSlideLayerRequestToJSON": () => (/* reexport */ DigitalSignageSlideLayerRequestToJSON),
  "DigitalSignageSlideLayerType": () => (/* reexport */ DigitalSignageSlideLayerType),
  "DigitalSignageSlideLayerTypeFromJSON": () => (/* reexport */ DigitalSignageSlideLayerTypeFromJSON),
  "DigitalSignageSlideLayerTypeFromJSONTyped": () => (/* reexport */ DigitalSignageSlideLayerTypeFromJSONTyped),
  "DigitalSignageSlideLayerTypeToJSON": () => (/* reexport */ DigitalSignageSlideLayerTypeToJSON),
  "DigitalSignageSlideResponseFromJSON": () => (/* reexport */ DigitalSignageSlideResponseFromJSON),
  "DigitalSignageSlideResponseFromJSONTyped": () => (/* reexport */ DigitalSignageSlideResponseFromJSONTyped),
  "DigitalSignageSlideResponseToJSON": () => (/* reexport */ DigitalSignageSlideResponseToJSON),
  "DigitalSignageSlideUpdateRequestFromJSON": () => (/* reexport */ DigitalSignageSlideUpdateRequestFromJSON),
  "DigitalSignageSlideUpdateRequestFromJSONTyped": () => (/* reexport */ DigitalSignageSlideUpdateRequestFromJSONTyped),
  "DigitalSignageSlideUpdateRequestToJSON": () => (/* reexport */ DigitalSignageSlideUpdateRequestToJSON),
  "DigitalSignageUpdateRequestFromJSON": () => (/* reexport */ DigitalSignageUpdateRequestFromJSON),
  "DigitalSignageUpdateRequestFromJSONTyped": () => (/* reexport */ DigitalSignageUpdateRequestFromJSONTyped),
  "DigitalSignageUpdateRequestToJSON": () => (/* reexport */ DigitalSignageUpdateRequestToJSON),
  "DirectoryAppEnum": () => (/* reexport */ DirectoryAppEnum),
  "DirectoryCreateRequestFromJSON": () => (/* reexport */ DirectoryCreateRequestFromJSON),
  "DirectoryCreateRequestFromJSONTyped": () => (/* reexport */ DirectoryCreateRequestFromJSONTyped),
  "DirectoryCreateRequestToJSON": () => (/* reexport */ DirectoryCreateRequestToJSON),
  "DirectoryFloorCreateRequestFromJSON": () => (/* reexport */ DirectoryFloorCreateRequestFromJSON),
  "DirectoryFloorCreateRequestFromJSONTyped": () => (/* reexport */ DirectoryFloorCreateRequestFromJSONTyped),
  "DirectoryFloorCreateRequestToJSON": () => (/* reexport */ DirectoryFloorCreateRequestToJSON),
  "DirectoryFloorFromJSON": () => (/* reexport */ DirectoryFloorFromJSON),
  "DirectoryFloorFromJSONTyped": () => (/* reexport */ DirectoryFloorFromJSONTyped),
  "DirectoryFloorToJSON": () => (/* reexport */ DirectoryFloorToJSON),
  "DirectoryFloorUpdateRequestFromJSON": () => (/* reexport */ DirectoryFloorUpdateRequestFromJSON),
  "DirectoryFloorUpdateRequestFromJSONTyped": () => (/* reexport */ DirectoryFloorUpdateRequestFromJSONTyped),
  "DirectoryFloorUpdateRequestToJSON": () => (/* reexport */ DirectoryFloorUpdateRequestToJSON),
  "DirectoryFromJSON": () => (/* reexport */ DirectoryFromJSON),
  "DirectoryFromJSONTyped": () => (/* reexport */ DirectoryFromJSONTyped),
  "DirectoryListingCreateRequestFromJSON": () => (/* reexport */ DirectoryListingCreateRequestFromJSON),
  "DirectoryListingCreateRequestFromJSONTyped": () => (/* reexport */ DirectoryListingCreateRequestFromJSONTyped),
  "DirectoryListingCreateRequestToJSON": () => (/* reexport */ DirectoryListingCreateRequestToJSON),
  "DirectoryListingFromJSON": () => (/* reexport */ DirectoryListingFromJSON),
  "DirectoryListingFromJSONTyped": () => (/* reexport */ DirectoryListingFromJSONTyped),
  "DirectoryListingToJSON": () => (/* reexport */ DirectoryListingToJSON),
  "DirectoryListingUpdateRequestFromJSON": () => (/* reexport */ DirectoryListingUpdateRequestFromJSON),
  "DirectoryListingUpdateRequestFromJSONTyped": () => (/* reexport */ DirectoryListingUpdateRequestFromJSONTyped),
  "DirectoryListingUpdateRequestToJSON": () => (/* reexport */ DirectoryListingUpdateRequestToJSON),
  "DirectoryToJSON": () => (/* reexport */ DirectoryToJSON),
  "DirectoryUpdateRequestFromJSON": () => (/* reexport */ DirectoryUpdateRequestFromJSON),
  "DirectoryUpdateRequestFromJSONTyped": () => (/* reexport */ DirectoryUpdateRequestFromJSONTyped),
  "DirectoryUpdateRequestToJSON": () => (/* reexport */ DirectoryUpdateRequestToJSON),
  "EsuiteApp": () => (/* reexport */ EsuiteApp),
  "EsuiteAppFromJSON": () => (/* reexport */ EsuiteAppFromJSON),
  "EsuiteAppFromJSONTyped": () => (/* reexport */ EsuiteAppFromJSONTyped),
  "EsuiteAppPluginMessageFromJSON": () => (/* reexport */ EsuiteAppPluginMessageFromJSON),
  "EsuiteAppPluginMessageFromJSONTyped": () => (/* reexport */ EsuiteAppPluginMessageFromJSONTyped),
  "EsuiteAppPluginMessageToJSON": () => (/* reexport */ EsuiteAppPluginMessageToJSON),
  "EsuiteAppResponseFromJSON": () => (/* reexport */ EsuiteAppResponseFromJSON),
  "EsuiteAppResponseFromJSONTyped": () => (/* reexport */ EsuiteAppResponseFromJSONTyped),
  "EsuiteAppResponseToJSON": () => (/* reexport */ EsuiteAppResponseToJSON),
  "EsuiteAppToJSON": () => (/* reexport */ EsuiteAppToJSON),
  "EsuiteClient": () => (/* reexport */ EsuiteClient),
  "FieldOption": () => (/* reexport */ FieldOption),
  "FieldOptionFromJSON": () => (/* reexport */ FieldOptionFromJSON),
  "FieldOptionFromJSONTyped": () => (/* reexport */ FieldOptionFromJSONTyped),
  "FieldOptionToJSON": () => (/* reexport */ FieldOptionToJSON),
  "FundCreateRequestFromJSON": () => (/* reexport */ FundCreateRequestFromJSON),
  "FundCreateRequestFromJSONTyped": () => (/* reexport */ FundCreateRequestFromJSONTyped),
  "FundCreateRequestToJSON": () => (/* reexport */ FundCreateRequestToJSON),
  "FundLineItemOptionFromJSON": () => (/* reexport */ FundLineItemOptionFromJSON),
  "FundLineItemOptionFromJSONTyped": () => (/* reexport */ FundLineItemOptionFromJSONTyped),
  "FundLineItemOptionToJSON": () => (/* reexport */ FundLineItemOptionToJSON),
  "FundOptionCreateRequestFromJSON": () => (/* reexport */ FundOptionCreateRequestFromJSON),
  "FundOptionCreateRequestFromJSONTyped": () => (/* reexport */ FundOptionCreateRequestFromJSONTyped),
  "FundOptionCreateRequestToJSON": () => (/* reexport */ FundOptionCreateRequestToJSON),
  "FundOptionResponseFromJSON": () => (/* reexport */ FundOptionResponseFromJSON),
  "FundOptionResponseFromJSONTyped": () => (/* reexport */ FundOptionResponseFromJSONTyped),
  "FundOptionResponseToJSON": () => (/* reexport */ FundOptionResponseToJSON),
  "FundOptionUpdateRequestFromJSON": () => (/* reexport */ FundOptionUpdateRequestFromJSON),
  "FundOptionUpdateRequestFromJSONTyped": () => (/* reexport */ FundOptionUpdateRequestFromJSONTyped),
  "FundOptionUpdateRequestToJSON": () => (/* reexport */ FundOptionUpdateRequestToJSON),
  "FundResponseFromJSON": () => (/* reexport */ FundResponseFromJSON),
  "FundResponseFromJSONTyped": () => (/* reexport */ FundResponseFromJSONTyped),
  "FundResponseToJSON": () => (/* reexport */ FundResponseToJSON),
  "FundUpdateRequestFromJSON": () => (/* reexport */ FundUpdateRequestFromJSON),
  "FundUpdateRequestFromJSONTyped": () => (/* reexport */ FundUpdateRequestFromJSONTyped),
  "FundUpdateRequestToJSON": () => (/* reexport */ FundUpdateRequestToJSON),
  "GetProductDtoFromJSON": () => (/* reexport */ GetProductDtoFromJSON),
  "GetProductDtoFromJSONTyped": () => (/* reexport */ GetProductDtoFromJSONTyped),
  "GetProductDtoToJSON": () => (/* reexport */ GetProductDtoToJSON),
  "GoogleSlidesConfigFromJSON": () => (/* reexport */ GoogleSlidesConfigFromJSON),
  "GoogleSlidesConfigFromJSONTyped": () => (/* reexport */ GoogleSlidesConfigFromJSONTyped),
  "GoogleSlidesConfigToJSON": () => (/* reexport */ GoogleSlidesConfigToJSON),
  "ImageUploadCreateRequestFromJSON": () => (/* reexport */ ImageUploadCreateRequestFromJSON),
  "ImageUploadCreateRequestFromJSONTyped": () => (/* reexport */ ImageUploadCreateRequestFromJSONTyped),
  "ImageUploadCreateRequestToJSON": () => (/* reexport */ ImageUploadCreateRequestToJSON),
  "ImageUploadFromJSON": () => (/* reexport */ ImageUploadFromJSON),
  "ImageUploadFromJSONTyped": () => (/* reexport */ ImageUploadFromJSONTyped),
  "ImageUploadResponseFromJSON": () => (/* reexport */ ImageUploadResponseFromJSON),
  "ImageUploadResponseFromJSONTyped": () => (/* reexport */ ImageUploadResponseFromJSONTyped),
  "ImageUploadResponseToJSON": () => (/* reexport */ ImageUploadResponseToJSON),
  "ImageUploadToJSON": () => (/* reexport */ ImageUploadToJSON),
  "ImageUploadUploadRequestFromJSON": () => (/* reexport */ ImageUploadUploadRequestFromJSON),
  "ImageUploadUploadRequestFromJSONTyped": () => (/* reexport */ ImageUploadUploadRequestFromJSONTyped),
  "ImageUploadUploadRequestToJSON": () => (/* reexport */ ImageUploadUploadRequestToJSON),
  "JSONApiResponse": () => (/* reexport */ JSONApiResponse),
  "KioskCreateRequestFromJSON": () => (/* reexport */ KioskCreateRequestFromJSON),
  "KioskCreateRequestFromJSONTyped": () => (/* reexport */ KioskCreateRequestFromJSONTyped),
  "KioskCreateRequestToJSON": () => (/* reexport */ KioskCreateRequestToJSON),
  "KioskMessageFromJSON": () => (/* reexport */ KioskMessageFromJSON),
  "KioskMessageFromJSONTyped": () => (/* reexport */ KioskMessageFromJSONTyped),
  "KioskMessageToJSON": () => (/* reexport */ KioskMessageToJSON),
  "KioskNotificationResponseFromJSON": () => (/* reexport */ KioskNotificationResponseFromJSON),
  "KioskNotificationResponseFromJSONTyped": () => (/* reexport */ KioskNotificationResponseFromJSONTyped),
  "KioskNotificationResponseToJSON": () => (/* reexport */ KioskNotificationResponseToJSON),
  "KioskNotificationUpdateRequestFromJSON": () => (/* reexport */ KioskNotificationUpdateRequestFromJSON),
  "KioskNotificationUpdateRequestFromJSONTyped": () => (/* reexport */ KioskNotificationUpdateRequestFromJSONTyped),
  "KioskNotificationUpdateRequestToJSON": () => (/* reexport */ KioskNotificationUpdateRequestToJSON),
  "KioskRemoteCommand": () => (/* reexport */ KioskRemoteCommand),
  "KioskRemoteCommandFromJSON": () => (/* reexport */ KioskRemoteCommandFromJSON),
  "KioskRemoteCommandFromJSONTyped": () => (/* reexport */ KioskRemoteCommandFromJSONTyped),
  "KioskRemoteCommandToJSON": () => (/* reexport */ KioskRemoteCommandToJSON),
  "KioskRemoteCreateRequestFromJSON": () => (/* reexport */ KioskRemoteCreateRequestFromJSON),
  "KioskRemoteCreateRequestFromJSONTyped": () => (/* reexport */ KioskRemoteCreateRequestFromJSONTyped),
  "KioskRemoteCreateRequestToJSON": () => (/* reexport */ KioskRemoteCreateRequestToJSON),
  "KioskRemoteListRequestFromJSON": () => (/* reexport */ KioskRemoteListRequestFromJSON),
  "KioskRemoteListRequestFromJSONTyped": () => (/* reexport */ KioskRemoteListRequestFromJSONTyped),
  "KioskRemoteListRequestToJSON": () => (/* reexport */ KioskRemoteListRequestToJSON),
  "KioskResponseFromJSON": () => (/* reexport */ KioskResponseFromJSON),
  "KioskResponseFromJSONTyped": () => (/* reexport */ KioskResponseFromJSONTyped),
  "KioskResponseToJSON": () => (/* reexport */ KioskResponseToJSON),
  "KioskScreenshotFromJSON": () => (/* reexport */ KioskScreenshotFromJSON),
  "KioskScreenshotFromJSONTyped": () => (/* reexport */ KioskScreenshotFromJSONTyped),
  "KioskScreenshotToJSON": () => (/* reexport */ KioskScreenshotToJSON),
  "KioskUpdateRequestFromJSON": () => (/* reexport */ KioskUpdateRequestFromJSON),
  "KioskUpdateRequestFromJSONTyped": () => (/* reexport */ KioskUpdateRequestFromJSONTyped),
  "KioskUpdateRequestToJSON": () => (/* reexport */ KioskUpdateRequestToJSON),
  "LayoutBoxCreateRequestFromJSON": () => (/* reexport */ LayoutBoxCreateRequestFromJSON),
  "LayoutBoxCreateRequestFromJSONTyped": () => (/* reexport */ LayoutBoxCreateRequestFromJSONTyped),
  "LayoutBoxCreateRequestToJSON": () => (/* reexport */ LayoutBoxCreateRequestToJSON),
  "LayoutBoxFromJSON": () => (/* reexport */ LayoutBoxFromJSON),
  "LayoutBoxFromJSONTyped": () => (/* reexport */ LayoutBoxFromJSONTyped),
  "LayoutBoxToJSON": () => (/* reexport */ LayoutBoxToJSON),
  "MediaCollectionAccessCodeCreateRequestFromJSON": () => (/* reexport */ MediaCollectionAccessCodeCreateRequestFromJSON),
  "MediaCollectionAccessCodeCreateRequestFromJSONTyped": () => (/* reexport */ MediaCollectionAccessCodeCreateRequestFromJSONTyped),
  "MediaCollectionAccessCodeCreateRequestToJSON": () => (/* reexport */ MediaCollectionAccessCodeCreateRequestToJSON),
  "MediaCollectionAccessCodeResponseFromJSON": () => (/* reexport */ MediaCollectionAccessCodeResponseFromJSON),
  "MediaCollectionAccessCodeResponseFromJSONTyped": () => (/* reexport */ MediaCollectionAccessCodeResponseFromJSONTyped),
  "MediaCollectionAccessCodeResponseToJSON": () => (/* reexport */ MediaCollectionAccessCodeResponseToJSON),
  "MediaCollectionAlbumCreateRequestFromJSON": () => (/* reexport */ MediaCollectionAlbumCreateRequestFromJSON),
  "MediaCollectionAlbumCreateRequestFromJSONTyped": () => (/* reexport */ MediaCollectionAlbumCreateRequestFromJSONTyped),
  "MediaCollectionAlbumCreateRequestToJSON": () => (/* reexport */ MediaCollectionAlbumCreateRequestToJSON),
  "MediaCollectionAlbumResponseFromJSON": () => (/* reexport */ MediaCollectionAlbumResponseFromJSON),
  "MediaCollectionAlbumResponseFromJSONTyped": () => (/* reexport */ MediaCollectionAlbumResponseFromJSONTyped),
  "MediaCollectionAlbumResponseToJSON": () => (/* reexport */ MediaCollectionAlbumResponseToJSON),
  "MediaCollectionCreateRequestFromJSON": () => (/* reexport */ MediaCollectionCreateRequestFromJSON),
  "MediaCollectionCreateRequestFromJSONTyped": () => (/* reexport */ MediaCollectionCreateRequestFromJSONTyped),
  "MediaCollectionCreateRequestToJSON": () => (/* reexport */ MediaCollectionCreateRequestToJSON),
  "MediaCollectionDataFromJSON": () => (/* reexport */ MediaCollectionDataFromJSON),
  "MediaCollectionDataFromJSONTyped": () => (/* reexport */ MediaCollectionDataFromJSONTyped),
  "MediaCollectionDataToJSON": () => (/* reexport */ MediaCollectionDataToJSON),
  "MediaCollectionFileFromJSON": () => (/* reexport */ MediaCollectionFileFromJSON),
  "MediaCollectionFileFromJSONTyped": () => (/* reexport */ MediaCollectionFileFromJSONTyped),
  "MediaCollectionFileToJSON": () => (/* reexport */ MediaCollectionFileToJSON),
  "MediaCollectionItemCreateRequestFromJSON": () => (/* reexport */ MediaCollectionItemCreateRequestFromJSON),
  "MediaCollectionItemCreateRequestFromJSONTyped": () => (/* reexport */ MediaCollectionItemCreateRequestFromJSONTyped),
  "MediaCollectionItemCreateRequestToJSON": () => (/* reexport */ MediaCollectionItemCreateRequestToJSON),
  "MediaCollectionItemResponseFromJSON": () => (/* reexport */ MediaCollectionItemResponseFromJSON),
  "MediaCollectionItemResponseFromJSONTyped": () => (/* reexport */ MediaCollectionItemResponseFromJSONTyped),
  "MediaCollectionItemResponseToJSON": () => (/* reexport */ MediaCollectionItemResponseToJSON),
  "MediaCollectionPhotoTagDtoFromJSON": () => (/* reexport */ MediaCollectionPhotoTagDtoFromJSON),
  "MediaCollectionPhotoTagDtoFromJSONTyped": () => (/* reexport */ MediaCollectionPhotoTagDtoFromJSONTyped),
  "MediaCollectionPhotoTagDtoToJSON": () => (/* reexport */ MediaCollectionPhotoTagDtoToJSON),
  "MediaCollectionPhotoTagFromJSON": () => (/* reexport */ MediaCollectionPhotoTagFromJSON),
  "MediaCollectionPhotoTagFromJSONTyped": () => (/* reexport */ MediaCollectionPhotoTagFromJSONTyped),
  "MediaCollectionPhotoTagRequestDtoFromJSON": () => (/* reexport */ MediaCollectionPhotoTagRequestDtoFromJSON),
  "MediaCollectionPhotoTagRequestDtoFromJSONTyped": () => (/* reexport */ MediaCollectionPhotoTagRequestDtoFromJSONTyped),
  "MediaCollectionPhotoTagRequestDtoToJSON": () => (/* reexport */ MediaCollectionPhotoTagRequestDtoToJSON),
  "MediaCollectionPhotoTagToJSON": () => (/* reexport */ MediaCollectionPhotoTagToJSON),
  "MediaCollectionResponseFromJSON": () => (/* reexport */ MediaCollectionResponseFromJSON),
  "MediaCollectionResponseFromJSONTyped": () => (/* reexport */ MediaCollectionResponseFromJSONTyped),
  "MediaCollectionResponseToJSON": () => (/* reexport */ MediaCollectionResponseToJSON),
  "MediaCollectionSyncRecordFromJSON": () => (/* reexport */ MediaCollectionSyncRecordFromJSON),
  "MediaCollectionSyncRecordFromJSONTyped": () => (/* reexport */ MediaCollectionSyncRecordFromJSONTyped),
  "MediaCollectionSyncRecordToJSON": () => (/* reexport */ MediaCollectionSyncRecordToJSON),
  "MediaCollectionUpdateRequestFromJSON": () => (/* reexport */ MediaCollectionUpdateRequestFromJSON),
  "MediaCollectionUpdateRequestFromJSONTyped": () => (/* reexport */ MediaCollectionUpdateRequestFromJSONTyped),
  "MediaCollectionUpdateRequestToJSON": () => (/* reexport */ MediaCollectionUpdateRequestToJSON),
  "MetafieldFromJSON": () => (/* reexport */ MetafieldFromJSON),
  "MetafieldFromJSONTyped": () => (/* reexport */ MetafieldFromJSONTyped),
  "MetafieldToJSON": () => (/* reexport */ MetafieldToJSON),
  "MonerisGatewayRequestFromJSON": () => (/* reexport */ MonerisGatewayRequestFromJSON),
  "MonerisGatewayRequestFromJSONTyped": () => (/* reexport */ MonerisGatewayRequestFromJSONTyped),
  "MonerisGatewayRequestToJSON": () => (/* reexport */ MonerisGatewayRequestToJSON),
  "MonerisGatewayResponseFromJSON": () => (/* reexport */ MonerisGatewayResponseFromJSON),
  "MonerisGatewayResponseFromJSONTyped": () => (/* reexport */ MonerisGatewayResponseFromJSONTyped),
  "MonerisGatewayResponseToJSON": () => (/* reexport */ MonerisGatewayResponseToJSON),
  "NotificationEmailTemplateFromJSON": () => (/* reexport */ NotificationEmailTemplateFromJSON),
  "NotificationEmailTemplateFromJSONTyped": () => (/* reexport */ NotificationEmailTemplateFromJSONTyped),
  "NotificationEmailTemplateToJSON": () => (/* reexport */ NotificationEmailTemplateToJSON),
  "NotificationRecordModelFromJSON": () => (/* reexport */ NotificationRecordModelFromJSON),
  "NotificationRecordModelFromJSONTyped": () => (/* reexport */ NotificationRecordModelFromJSONTyped),
  "NotificationRecordModelToJSON": () => (/* reexport */ NotificationRecordModelToJSON),
  "NotificationResponseFromJSON": () => (/* reexport */ NotificationResponseFromJSON),
  "NotificationResponseFromJSONTyped": () => (/* reexport */ NotificationResponseFromJSONTyped),
  "NotificationResponseToJSON": () => (/* reexport */ NotificationResponseToJSON),
  "NotificationType": () => (/* reexport */ NotificationType),
  "NotificationTypeFromJSON": () => (/* reexport */ NotificationTypeFromJSON),
  "NotificationTypeFromJSONTyped": () => (/* reexport */ NotificationTypeFromJSONTyped),
  "NotificationTypeToJSON": () => (/* reexport */ NotificationTypeToJSON),
  "NotificationUpdateRequestFromJSON": () => (/* reexport */ NotificationUpdateRequestFromJSON),
  "NotificationUpdateRequestFromJSONTyped": () => (/* reexport */ NotificationUpdateRequestFromJSONTyped),
  "NotificationUpdateRequestToJSON": () => (/* reexport */ NotificationUpdateRequestToJSON),
  "OpenEdgeResponseFromJSON": () => (/* reexport */ OpenEdgeResponseFromJSON),
  "OpenEdgeResponseFromJSONTyped": () => (/* reexport */ OpenEdgeResponseFromJSONTyped),
  "OpenEdgeResponseToJSON": () => (/* reexport */ OpenEdgeResponseToJSON),
  "OpenedgeGatewayRequestFromJSON": () => (/* reexport */ OpenedgeGatewayRequestFromJSON),
  "OpenedgeGatewayRequestFromJSONTyped": () => (/* reexport */ OpenedgeGatewayRequestFromJSONTyped),
  "OpenedgeGatewayRequestToJSON": () => (/* reexport */ OpenedgeGatewayRequestToJSON),
  "OrderCreateRequestFromJSON": () => (/* reexport */ OrderCreateRequestFromJSON),
  "OrderCreateRequestFromJSONTyped": () => (/* reexport */ OrderCreateRequestFromJSONTyped),
  "OrderCreateRequestToJSON": () => (/* reexport */ OrderCreateRequestToJSON),
  "OrderFinancialStatus": () => (/* reexport */ OrderFinancialStatus),
  "OrderFinancialStatusFromJSON": () => (/* reexport */ OrderFinancialStatusFromJSON),
  "OrderFinancialStatusFromJSONTyped": () => (/* reexport */ OrderFinancialStatusFromJSONTyped),
  "OrderFinancialStatusToJSON": () => (/* reexport */ OrderFinancialStatusToJSON),
  "OrderFulfillmentStatus": () => (/* reexport */ OrderFulfillmentStatus),
  "OrderFulfillmentStatusFromJSON": () => (/* reexport */ OrderFulfillmentStatusFromJSON),
  "OrderFulfillmentStatusFromJSONTyped": () => (/* reexport */ OrderFulfillmentStatusFromJSONTyped),
  "OrderFulfillmentStatusToJSON": () => (/* reexport */ OrderFulfillmentStatusToJSON),
  "OrderLineItemCreateRequestFromJSON": () => (/* reexport */ OrderLineItemCreateRequestFromJSON),
  "OrderLineItemCreateRequestFromJSONTyped": () => (/* reexport */ OrderLineItemCreateRequestFromJSONTyped),
  "OrderLineItemCreateRequestToJSON": () => (/* reexport */ OrderLineItemCreateRequestToJSON),
  "OrderLineItemPropertyFromJSON": () => (/* reexport */ OrderLineItemPropertyFromJSON),
  "OrderLineItemPropertyFromJSONTyped": () => (/* reexport */ OrderLineItemPropertyFromJSONTyped),
  "OrderLineItemPropertyToJSON": () => (/* reexport */ OrderLineItemPropertyToJSON),
  "OrderLineItemResponseFromJSON": () => (/* reexport */ OrderLineItemResponseFromJSON),
  "OrderLineItemResponseFromJSONTyped": () => (/* reexport */ OrderLineItemResponseFromJSONTyped),
  "OrderLineItemResponseProductTypeEnum": () => (/* reexport */ OrderLineItemResponseProductTypeEnum),
  "OrderLineItemResponseToJSON": () => (/* reexport */ OrderLineItemResponseToJSON),
  "OrderResponseFromJSON": () => (/* reexport */ OrderResponseFromJSON),
  "OrderResponseFromJSONTyped": () => (/* reexport */ OrderResponseFromJSONTyped),
  "OrderResponseToJSON": () => (/* reexport */ OrderResponseToJSON),
  "OrderUpdateRequestFromJSON": () => (/* reexport */ OrderUpdateRequestFromJSON),
  "OrderUpdateRequestFromJSONTyped": () => (/* reexport */ OrderUpdateRequestFromJSONTyped),
  "OrderUpdateRequestFulfillmentStatusEnum": () => (/* reexport */ OrderUpdateRequestFulfillmentStatusEnum),
  "OrderUpdateRequestToJSON": () => (/* reexport */ OrderUpdateRequestToJSON),
  "OrganizationExportResponseFromJSON": () => (/* reexport */ OrganizationExportResponseFromJSON),
  "OrganizationExportResponseFromJSONTyped": () => (/* reexport */ OrganizationExportResponseFromJSONTyped),
  "OrganizationExportResponseToJSON": () => (/* reexport */ OrganizationExportResponseToJSON),
  "OrganizationResponseFromJSON": () => (/* reexport */ OrganizationResponseFromJSON),
  "OrganizationResponseFromJSONTyped": () => (/* reexport */ OrganizationResponseFromJSONTyped),
  "OrganizationResponseToJSON": () => (/* reexport */ OrganizationResponseToJSON),
  "OrganizationUser": () => (/* reexport */ OrganizationUser),
  "OrganizationUserFromJSON": () => (/* reexport */ OrganizationUserFromJSON),
  "OrganizationUserFromJSONTyped": () => (/* reexport */ OrganizationUserFromJSONTyped),
  "OrganizationUserToJSON": () => (/* reexport */ OrganizationUserToJSON),
  "PaymentGatewayCreateRequestFromJSON": () => (/* reexport */ PaymentGatewayCreateRequestFromJSON),
  "PaymentGatewayCreateRequestFromJSONTyped": () => (/* reexport */ PaymentGatewayCreateRequestFromJSONTyped),
  "PaymentGatewayCreateRequestToJSON": () => (/* reexport */ PaymentGatewayCreateRequestToJSON),
  "PaymentGatewayResponseFromJSON": () => (/* reexport */ PaymentGatewayResponseFromJSON),
  "PaymentGatewayResponseFromJSONTyped": () => (/* reexport */ PaymentGatewayResponseFromJSONTyped),
  "PaymentGatewayResponseToJSON": () => (/* reexport */ PaymentGatewayResponseToJSON),
  "PaymentGatewayResponseTypeEnum": () => (/* reexport */ PaymentGatewayResponseTypeEnum),
  "PaymentGatewayType": () => (/* reexport */ PaymentGatewayType),
  "PaymentGatewayTypeFromJSON": () => (/* reexport */ PaymentGatewayTypeFromJSON),
  "PaymentGatewayTypeFromJSONTyped": () => (/* reexport */ PaymentGatewayTypeFromJSONTyped),
  "PaymentGatewayTypeToJSON": () => (/* reexport */ PaymentGatewayTypeToJSON),
  "PaymentGatewayUpdateRequestFromJSON": () => (/* reexport */ PaymentGatewayUpdateRequestFromJSON),
  "PaymentGatewayUpdateRequestFromJSONTyped": () => (/* reexport */ PaymentGatewayUpdateRequestFromJSONTyped),
  "PaymentGatewayUpdateRequestToJSON": () => (/* reexport */ PaymentGatewayUpdateRequestToJSON),
  "PaymentTerminalCreateRequestFromJSON": () => (/* reexport */ PaymentTerminalCreateRequestFromJSON),
  "PaymentTerminalCreateRequestFromJSONTyped": () => (/* reexport */ PaymentTerminalCreateRequestFromJSONTyped),
  "PaymentTerminalCreateRequestToJSON": () => (/* reexport */ PaymentTerminalCreateRequestToJSON),
  "PaymentTerminalDevice": () => (/* reexport */ PaymentTerminalDevice),
  "PaymentTerminalDeviceFromJSON": () => (/* reexport */ PaymentTerminalDeviceFromJSON),
  "PaymentTerminalDeviceFromJSONTyped": () => (/* reexport */ PaymentTerminalDeviceFromJSONTyped),
  "PaymentTerminalDeviceToJSON": () => (/* reexport */ PaymentTerminalDeviceToJSON),
  "PaymentTerminalModelFromJSON": () => (/* reexport */ PaymentTerminalModelFromJSON),
  "PaymentTerminalModelFromJSONTyped": () => (/* reexport */ PaymentTerminalModelFromJSONTyped),
  "PaymentTerminalModelToJSON": () => (/* reexport */ PaymentTerminalModelToJSON),
  "PaymentTerminalMonerisFromJSON": () => (/* reexport */ PaymentTerminalMonerisFromJSON),
  "PaymentTerminalMonerisFromJSONTyped": () => (/* reexport */ PaymentTerminalMonerisFromJSONTyped),
  "PaymentTerminalMonerisToJSON": () => (/* reexport */ PaymentTerminalMonerisToJSON),
  "PaymentTerminalOpenedgeFromJSON": () => (/* reexport */ PaymentTerminalOpenedgeFromJSON),
  "PaymentTerminalOpenedgeFromJSONTyped": () => (/* reexport */ PaymentTerminalOpenedgeFromJSONTyped),
  "PaymentTerminalOpenedgeToJSON": () => (/* reexport */ PaymentTerminalOpenedgeToJSON),
  "PaymentTerminalResponseFromJSON": () => (/* reexport */ PaymentTerminalResponseFromJSON),
  "PaymentTerminalResponseFromJSONTyped": () => (/* reexport */ PaymentTerminalResponseFromJSONTyped),
  "PaymentTerminalResponseToJSON": () => (/* reexport */ PaymentTerminalResponseToJSON),
  "PaymentTerminalStatus": () => (/* reexport */ PaymentTerminalStatus),
  "PaymentTerminalStatusFromJSON": () => (/* reexport */ PaymentTerminalStatusFromJSON),
  "PaymentTerminalStatusFromJSONTyped": () => (/* reexport */ PaymentTerminalStatusFromJSONTyped),
  "PaymentTerminalStatusToJSON": () => (/* reexport */ PaymentTerminalStatusToJSON),
  "PaymentTerminalTransactionResponseModelFromJSON": () => (/* reexport */ PaymentTerminalTransactionResponseModelFromJSON),
  "PaymentTerminalTransactionResponseModelFromJSONTyped": () => (/* reexport */ PaymentTerminalTransactionResponseModelFromJSONTyped),
  "PaymentTerminalTransactionResponseModelToJSON": () => (/* reexport */ PaymentTerminalTransactionResponseModelToJSON),
  "PaymentTerminalTransactionType": () => (/* reexport */ PaymentTerminalTransactionType),
  "PaymentTerminalTransactionTypeFromJSON": () => (/* reexport */ PaymentTerminalTransactionTypeFromJSON),
  "PaymentTerminalTransactionTypeFromJSONTyped": () => (/* reexport */ PaymentTerminalTransactionTypeFromJSONTyped),
  "PaymentTerminalTransactionTypeToJSON": () => (/* reexport */ PaymentTerminalTransactionTypeToJSON),
  "PaymentTerminalUpdateRequestFromJSON": () => (/* reexport */ PaymentTerminalUpdateRequestFromJSON),
  "PaymentTerminalUpdateRequestFromJSONTyped": () => (/* reexport */ PaymentTerminalUpdateRequestFromJSONTyped),
  "PaymentTerminalUpdateRequestToJSON": () => (/* reexport */ PaymentTerminalUpdateRequestToJSON),
  "PhotoboothCreateRequestFromJSON": () => (/* reexport */ PhotoboothCreateRequestFromJSON),
  "PhotoboothCreateRequestFromJSONTyped": () => (/* reexport */ PhotoboothCreateRequestFromJSONTyped),
  "PhotoboothCreateRequestToJSON": () => (/* reexport */ PhotoboothCreateRequestToJSON),
  "PhotoboothFrameCreateRequestFromJSON": () => (/* reexport */ PhotoboothFrameCreateRequestFromJSON),
  "PhotoboothFrameCreateRequestFromJSONTyped": () => (/* reexport */ PhotoboothFrameCreateRequestFromJSONTyped),
  "PhotoboothFrameCreateRequestToJSON": () => (/* reexport */ PhotoboothFrameCreateRequestToJSON),
  "PhotoboothFrameResponseFromJSON": () => (/* reexport */ PhotoboothFrameResponseFromJSON),
  "PhotoboothFrameResponseFromJSONTyped": () => (/* reexport */ PhotoboothFrameResponseFromJSONTyped),
  "PhotoboothFrameResponseToJSON": () => (/* reexport */ PhotoboothFrameResponseToJSON),
  "PhotoboothResponseFromJSON": () => (/* reexport */ PhotoboothResponseFromJSON),
  "PhotoboothResponseFromJSONTyped": () => (/* reexport */ PhotoboothResponseFromJSONTyped),
  "PhotoboothResponseToJSON": () => (/* reexport */ PhotoboothResponseToJSON),
  "PhotoboothSessionCreateRequestFromJSON": () => (/* reexport */ PhotoboothSessionCreateRequestFromJSON),
  "PhotoboothSessionCreateRequestFromJSONTyped": () => (/* reexport */ PhotoboothSessionCreateRequestFromJSONTyped),
  "PhotoboothSessionCreateRequestToJSON": () => (/* reexport */ PhotoboothSessionCreateRequestToJSON),
  "PhotoboothUpdateRequestFromJSON": () => (/* reexport */ PhotoboothUpdateRequestFromJSON),
  "PhotoboothUpdateRequestFromJSONTyped": () => (/* reexport */ PhotoboothUpdateRequestFromJSONTyped),
  "PhotoboothUpdateRequestToJSON": () => (/* reexport */ PhotoboothUpdateRequestToJSON),
  "PlatformAuthenticateRequestFromJSON": () => (/* reexport */ PlatformAuthenticateRequestFromJSON),
  "PlatformAuthenticateRequestFromJSONTyped": () => (/* reexport */ PlatformAuthenticateRequestFromJSONTyped),
  "PlatformAuthenticateRequestToJSON": () => (/* reexport */ PlatformAuthenticateRequestToJSON),
  "PlatformCreateRequestFromJSON": () => (/* reexport */ PlatformCreateRequestFromJSON),
  "PlatformCreateRequestFromJSONTyped": () => (/* reexport */ PlatformCreateRequestFromJSONTyped),
  "PlatformCreateRequestToJSON": () => (/* reexport */ PlatformCreateRequestToJSON),
  "PlatformDisplayFromJSON": () => (/* reexport */ PlatformDisplayFromJSON),
  "PlatformDisplayFromJSONTyped": () => (/* reexport */ PlatformDisplayFromJSONTyped),
  "PlatformDisplayToJSON": () => (/* reexport */ PlatformDisplayToJSON),
  "PlatformNetworkDeviceFromJSON": () => (/* reexport */ PlatformNetworkDeviceFromJSON),
  "PlatformNetworkDeviceFromJSONTyped": () => (/* reexport */ PlatformNetworkDeviceFromJSONTyped),
  "PlatformNetworkDeviceToJSON": () => (/* reexport */ PlatformNetworkDeviceToJSON),
  "PlatformNetworkInterfaceFromJSON": () => (/* reexport */ PlatformNetworkInterfaceFromJSON),
  "PlatformNetworkInterfaceFromJSONTyped": () => (/* reexport */ PlatformNetworkInterfaceFromJSONTyped),
  "PlatformNetworkInterfaceToJSON": () => (/* reexport */ PlatformNetworkInterfaceToJSON),
  "PlatformOSInfoFromJSON": () => (/* reexport */ PlatformOSInfoFromJSON),
  "PlatformOSInfoFromJSONTyped": () => (/* reexport */ PlatformOSInfoFromJSONTyped),
  "PlatformOSInfoToJSON": () => (/* reexport */ PlatformOSInfoToJSON),
  "PlatformPrinterFromJSON": () => (/* reexport */ PlatformPrinterFromJSON),
  "PlatformPrinterFromJSONTyped": () => (/* reexport */ PlatformPrinterFromJSONTyped),
  "PlatformPrinterToJSON": () => (/* reexport */ PlatformPrinterToJSON),
  "PlatformResponseFromJSON": () => (/* reexport */ PlatformResponseFromJSON),
  "PlatformResponseFromJSONTyped": () => (/* reexport */ PlatformResponseFromJSONTyped),
  "PlatformResponseToJSON": () => (/* reexport */ PlatformResponseToJSON),
  "PlatformStateFromJSON": () => (/* reexport */ PlatformStateFromJSON),
  "PlatformStateFromJSONTyped": () => (/* reexport */ PlatformStateFromJSONTyped),
  "PlatformStateToJSON": () => (/* reexport */ PlatformStateToJSON),
  "PlatformUpdateRequestFromJSON": () => (/* reexport */ PlatformUpdateRequestFromJSON),
  "PlatformUpdateRequestFromJSONTyped": () => (/* reexport */ PlatformUpdateRequestFromJSONTyped),
  "PlatformUpdateRequestToJSON": () => (/* reexport */ PlatformUpdateRequestToJSON),
  "PresignedPostFromJSON": () => (/* reexport */ PresignedPostFromJSON),
  "PresignedPostFromJSONTyped": () => (/* reexport */ PresignedPostFromJSONTyped),
  "PresignedPostToJSON": () => (/* reexport */ PresignedPostToJSON),
  "ProductCategoryCreateRequestFromJSON": () => (/* reexport */ ProductCategoryCreateRequestFromJSON),
  "ProductCategoryCreateRequestFromJSONTyped": () => (/* reexport */ ProductCategoryCreateRequestFromJSONTyped),
  "ProductCategoryCreateRequestToJSON": () => (/* reexport */ ProductCategoryCreateRequestToJSON),
  "ProductCategoryIntegrationFilterFromJSON": () => (/* reexport */ ProductCategoryIntegrationFilterFromJSON),
  "ProductCategoryIntegrationFilterFromJSONTyped": () => (/* reexport */ ProductCategoryIntegrationFilterFromJSONTyped),
  "ProductCategoryIntegrationFilterToJSON": () => (/* reexport */ ProductCategoryIntegrationFilterToJSON),
  "ProductCategoryIntegrationRequestFromJSON": () => (/* reexport */ ProductCategoryIntegrationRequestFromJSON),
  "ProductCategoryIntegrationRequestFromJSONTyped": () => (/* reexport */ ProductCategoryIntegrationRequestFromJSONTyped),
  "ProductCategoryIntegrationRequestToJSON": () => (/* reexport */ ProductCategoryIntegrationRequestToJSON),
  "ProductCategoryIntegrationResponseFromJSON": () => (/* reexport */ ProductCategoryIntegrationResponseFromJSON),
  "ProductCategoryIntegrationResponseFromJSONTyped": () => (/* reexport */ ProductCategoryIntegrationResponseFromJSONTyped),
  "ProductCategoryIntegrationResponseToJSON": () => (/* reexport */ ProductCategoryIntegrationResponseToJSON),
  "ProductCategoryResponseFromJSON": () => (/* reexport */ ProductCategoryResponseFromJSON),
  "ProductCategoryResponseFromJSONTyped": () => (/* reexport */ ProductCategoryResponseFromJSONTyped),
  "ProductCategoryResponseToJSON": () => (/* reexport */ ProductCategoryResponseToJSON),
  "ProductCategoryUpdateRequestFromJSON": () => (/* reexport */ ProductCategoryUpdateRequestFromJSON),
  "ProductCategoryUpdateRequestFromJSONTyped": () => (/* reexport */ ProductCategoryUpdateRequestFromJSONTyped),
  "ProductCategoryUpdateRequestToJSON": () => (/* reexport */ ProductCategoryUpdateRequestToJSON),
  "ProductStatus": () => (/* reexport */ ProductStatus),
  "ProductStatusFromJSON": () => (/* reexport */ ProductStatusFromJSON),
  "ProductStatusFromJSONTyped": () => (/* reexport */ ProductStatusFromJSONTyped),
  "ProductStatusToJSON": () => (/* reexport */ ProductStatusToJSON),
  "ProductType": () => (/* reexport */ ProductType),
  "ProductTypeFromJSON": () => (/* reexport */ ProductTypeFromJSON),
  "ProductTypeFromJSONTyped": () => (/* reexport */ ProductTypeFromJSONTyped),
  "ProductTypeToJSON": () => (/* reexport */ ProductTypeToJSON),
  "RectangleFromJSON": () => (/* reexport */ RectangleFromJSON),
  "RectangleFromJSONTyped": () => (/* reexport */ RectangleFromJSONTyped),
  "RectangleToJSON": () => (/* reexport */ RectangleToJSON),
  "RegisterCreateRequestFromJSON": () => (/* reexport */ RegisterCreateRequestFromJSON),
  "RegisterCreateRequestFromJSONTyped": () => (/* reexport */ RegisterCreateRequestFromJSONTyped),
  "RegisterCreateRequestToJSON": () => (/* reexport */ RegisterCreateRequestToJSON),
  "RegisterResponseFromJSON": () => (/* reexport */ RegisterResponseFromJSON),
  "RegisterResponseFromJSONTyped": () => (/* reexport */ RegisterResponseFromJSONTyped),
  "RegisterResponseToJSON": () => (/* reexport */ RegisterResponseToJSON),
  "RequiredError": () => (/* reexport */ RequiredError),
  "RestAppCreateRequestFromJSON": () => (/* reexport */ RestAppCreateRequestFromJSON),
  "RestAppCreateRequestFromJSONTyped": () => (/* reexport */ RestAppCreateRequestFromJSONTyped),
  "RestAppCreateRequestToJSON": () => (/* reexport */ RestAppCreateRequestToJSON),
  "RestAppResponseFromJSON": () => (/* reexport */ RestAppResponseFromJSON),
  "RestAppResponseFromJSONTyped": () => (/* reexport */ RestAppResponseFromJSONTyped),
  "RestAppResponseToJSON": () => (/* reexport */ RestAppResponseToJSON),
  "RestAppUpdateRequestFromJSON": () => (/* reexport */ RestAppUpdateRequestFromJSON),
  "RestAppUpdateRequestFromJSONTyped": () => (/* reexport */ RestAppUpdateRequestFromJSONTyped),
  "RestAppUpdateRequestToJSON": () => (/* reexport */ RestAppUpdateRequestToJSON),
  "RevenueCenterCreateRequestFromJSON": () => (/* reexport */ RevenueCenterCreateRequestFromJSON),
  "RevenueCenterCreateRequestFromJSONTyped": () => (/* reexport */ RevenueCenterCreateRequestFromJSONTyped),
  "RevenueCenterCreateRequestToJSON": () => (/* reexport */ RevenueCenterCreateRequestToJSON),
  "RevenueCenterResponseFromJSON": () => (/* reexport */ RevenueCenterResponseFromJSON),
  "RevenueCenterResponseFromJSONTyped": () => (/* reexport */ RevenueCenterResponseFromJSONTyped),
  "RevenueCenterResponseToJSON": () => (/* reexport */ RevenueCenterResponseToJSON),
  "RevenueCenterUpdateRequestFromJSON": () => (/* reexport */ RevenueCenterUpdateRequestFromJSON),
  "RevenueCenterUpdateRequestFromJSONTyped": () => (/* reexport */ RevenueCenterUpdateRequestFromJSONTyped),
  "RevenueCenterUpdateRequestToJSON": () => (/* reexport */ RevenueCenterUpdateRequestToJSON),
  "Role": () => (/* reexport */ Role),
  "RoleFromJSON": () => (/* reexport */ RoleFromJSON),
  "RoleFromJSONTyped": () => (/* reexport */ RoleFromJSONTyped),
  "RoleName": () => (/* reexport */ RoleName),
  "RoleNameFromJSON": () => (/* reexport */ RoleNameFromJSON),
  "RoleNameFromJSONTyped": () => (/* reexport */ RoleNameFromJSONTyped),
  "RoleNameToJSON": () => (/* reexport */ RoleNameToJSON),
  "RoleResponseFromJSON": () => (/* reexport */ RoleResponseFromJSON),
  "RoleResponseFromJSONTyped": () => (/* reexport */ RoleResponseFromJSONTyped),
  "RoleResponseToJSON": () => (/* reexport */ RoleResponseToJSON),
  "RoleToJSON": () => (/* reexport */ RoleToJSON),
  "SelfCheckoutAppPreferencesCheckoutFromJSON": () => (/* reexport */ SelfCheckoutAppPreferencesCheckoutFromJSON),
  "SelfCheckoutAppPreferencesCheckoutFromJSONTyped": () => (/* reexport */ SelfCheckoutAppPreferencesCheckoutFromJSONTyped),
  "SelfCheckoutAppPreferencesCheckoutToJSON": () => (/* reexport */ SelfCheckoutAppPreferencesCheckoutToJSON),
  "SelfCheckoutAppPreferencesFromJSON": () => (/* reexport */ SelfCheckoutAppPreferencesFromJSON),
  "SelfCheckoutAppPreferencesFromJSONTyped": () => (/* reexport */ SelfCheckoutAppPreferencesFromJSONTyped),
  "SelfCheckoutAppPreferencesOrderFromJSON": () => (/* reexport */ SelfCheckoutAppPreferencesOrderFromJSON),
  "SelfCheckoutAppPreferencesOrderFromJSONTyped": () => (/* reexport */ SelfCheckoutAppPreferencesOrderFromJSONTyped),
  "SelfCheckoutAppPreferencesOrderToJSON": () => (/* reexport */ SelfCheckoutAppPreferencesOrderToJSON),
  "SelfCheckoutAppPreferencesToJSON": () => (/* reexport */ SelfCheckoutAppPreferencesToJSON),
  "SelfCheckoutCountryResponseCodeEnum": () => (/* reexport */ SelfCheckoutCountryResponseCodeEnum),
  "SelfCheckoutCountryResponseFromJSON": () => (/* reexport */ SelfCheckoutCountryResponseFromJSON),
  "SelfCheckoutCountryResponseFromJSONTyped": () => (/* reexport */ SelfCheckoutCountryResponseFromJSONTyped),
  "SelfCheckoutCountryResponseToJSON": () => (/* reexport */ SelfCheckoutCountryResponseToJSON),
  "SelfCheckoutCreateRequestFromJSON": () => (/* reexport */ SelfCheckoutCreateRequestFromJSON),
  "SelfCheckoutCreateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutCreateRequestFromJSONTyped),
  "SelfCheckoutCreateRequestToJSON": () => (/* reexport */ SelfCheckoutCreateRequestToJSON),
  "SelfCheckoutIntegrationCacheQueryFromJSON": () => (/* reexport */ SelfCheckoutIntegrationCacheQueryFromJSON),
  "SelfCheckoutIntegrationCacheQueryFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationCacheQueryFromJSONTyped),
  "SelfCheckoutIntegrationCacheQueryToJSON": () => (/* reexport */ SelfCheckoutIntegrationCacheQueryToJSON),
  "SelfCheckoutIntegrationCacheResponseFromJSON": () => (/* reexport */ SelfCheckoutIntegrationCacheResponseFromJSON),
  "SelfCheckoutIntegrationCacheResponseFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationCacheResponseFromJSONTyped),
  "SelfCheckoutIntegrationCacheResponseToJSON": () => (/* reexport */ SelfCheckoutIntegrationCacheResponseToJSON),
  "SelfCheckoutIntegrationCacheUpdateFromJSON": () => (/* reexport */ SelfCheckoutIntegrationCacheUpdateFromJSON),
  "SelfCheckoutIntegrationCacheUpdateFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationCacheUpdateFromJSONTyped),
  "SelfCheckoutIntegrationCacheUpdateToJSON": () => (/* reexport */ SelfCheckoutIntegrationCacheUpdateToJSON),
  "SelfCheckoutIntegrationCreateRequestFromJSON": () => (/* reexport */ SelfCheckoutIntegrationCreateRequestFromJSON),
  "SelfCheckoutIntegrationCreateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationCreateRequestFromJSONTyped),
  "SelfCheckoutIntegrationCreateRequestToJSON": () => (/* reexport */ SelfCheckoutIntegrationCreateRequestToJSON),
  "SelfCheckoutIntegrationResponseFromJSON": () => (/* reexport */ SelfCheckoutIntegrationResponseFromJSON),
  "SelfCheckoutIntegrationResponseFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationResponseFromJSONTyped),
  "SelfCheckoutIntegrationResponseToJSON": () => (/* reexport */ SelfCheckoutIntegrationResponseToJSON),
  "SelfCheckoutIntegrationType": () => (/* reexport */ SelfCheckoutIntegrationType),
  "SelfCheckoutIntegrationTypeFromJSON": () => (/* reexport */ SelfCheckoutIntegrationTypeFromJSON),
  "SelfCheckoutIntegrationTypeFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationTypeFromJSONTyped),
  "SelfCheckoutIntegrationTypeToJSON": () => (/* reexport */ SelfCheckoutIntegrationTypeToJSON),
  "SelfCheckoutIntegrationUpdateRequestFromJSON": () => (/* reexport */ SelfCheckoutIntegrationUpdateRequestFromJSON),
  "SelfCheckoutIntegrationUpdateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutIntegrationUpdateRequestFromJSONTyped),
  "SelfCheckoutIntegrationUpdateRequestToJSON": () => (/* reexport */ SelfCheckoutIntegrationUpdateRequestToJSON),
  "SelfCheckoutOrderCreateRequestFromJSON": () => (/* reexport */ SelfCheckoutOrderCreateRequestFromJSON),
  "SelfCheckoutOrderCreateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutOrderCreateRequestFromJSONTyped),
  "SelfCheckoutOrderCreateRequestToJSON": () => (/* reexport */ SelfCheckoutOrderCreateRequestToJSON),
  "SelfCheckoutOrderResponseFromJSON": () => (/* reexport */ SelfCheckoutOrderResponseFromJSON),
  "SelfCheckoutOrderResponseFromJSONTyped": () => (/* reexport */ SelfCheckoutOrderResponseFromJSONTyped),
  "SelfCheckoutOrderResponseToJSON": () => (/* reexport */ SelfCheckoutOrderResponseToJSON),
  "SelfCheckoutResponseFromJSON": () => (/* reexport */ SelfCheckoutResponseFromJSON),
  "SelfCheckoutResponseFromJSONTyped": () => (/* reexport */ SelfCheckoutResponseFromJSONTyped),
  "SelfCheckoutResponseToJSON": () => (/* reexport */ SelfCheckoutResponseToJSON),
  "SelfCheckoutShopifyIntegrationFromJSON": () => (/* reexport */ SelfCheckoutShopifyIntegrationFromJSON),
  "SelfCheckoutShopifyIntegrationFromJSONTyped": () => (/* reexport */ SelfCheckoutShopifyIntegrationFromJSONTyped),
  "SelfCheckoutShopifyIntegrationToJSON": () => (/* reexport */ SelfCheckoutShopifyIntegrationToJSON),
  "SelfCheckoutShopifyPreferencesFromJSON": () => (/* reexport */ SelfCheckoutShopifyPreferencesFromJSON),
  "SelfCheckoutShopifyPreferencesFromJSONTyped": () => (/* reexport */ SelfCheckoutShopifyPreferencesFromJSONTyped),
  "SelfCheckoutShopifyPreferencesToJSON": () => (/* reexport */ SelfCheckoutShopifyPreferencesToJSON),
  "SelfCheckoutTemplateCreateRequestFromJSON": () => (/* reexport */ SelfCheckoutTemplateCreateRequestFromJSON),
  "SelfCheckoutTemplateCreateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutTemplateCreateRequestFromJSONTyped),
  "SelfCheckoutTemplateCreateRequestToJSON": () => (/* reexport */ SelfCheckoutTemplateCreateRequestToJSON),
  "SelfCheckoutTemplateResponseFromJSON": () => (/* reexport */ SelfCheckoutTemplateResponseFromJSON),
  "SelfCheckoutTemplateResponseFromJSONTyped": () => (/* reexport */ SelfCheckoutTemplateResponseFromJSONTyped),
  "SelfCheckoutTemplateResponseToJSON": () => (/* reexport */ SelfCheckoutTemplateResponseToJSON),
  "SelfCheckoutTemplateTarget": () => (/* reexport */ SelfCheckoutTemplateTarget),
  "SelfCheckoutTemplateTargetFromJSON": () => (/* reexport */ SelfCheckoutTemplateTargetFromJSON),
  "SelfCheckoutTemplateTargetFromJSONTyped": () => (/* reexport */ SelfCheckoutTemplateTargetFromJSONTyped),
  "SelfCheckoutTemplateTargetToJSON": () => (/* reexport */ SelfCheckoutTemplateTargetToJSON),
  "SelfCheckoutTemplateUpdateRequestFromJSON": () => (/* reexport */ SelfCheckoutTemplateUpdateRequestFromJSON),
  "SelfCheckoutTemplateUpdateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutTemplateUpdateRequestFromJSONTyped),
  "SelfCheckoutTemplateUpdateRequestToJSON": () => (/* reexport */ SelfCheckoutTemplateUpdateRequestToJSON),
  "SelfCheckoutUIMode": () => (/* reexport */ SelfCheckoutUIMode),
  "SelfCheckoutUIModeFromJSON": () => (/* reexport */ SelfCheckoutUIModeFromJSON),
  "SelfCheckoutUIModeFromJSONTyped": () => (/* reexport */ SelfCheckoutUIModeFromJSONTyped),
  "SelfCheckoutUIModeToJSON": () => (/* reexport */ SelfCheckoutUIModeToJSON),
  "SelfCheckoutUIModelFromJSON": () => (/* reexport */ SelfCheckoutUIModelFromJSON),
  "SelfCheckoutUIModelFromJSONTyped": () => (/* reexport */ SelfCheckoutUIModelFromJSONTyped),
  "SelfCheckoutUIModelToJSON": () => (/* reexport */ SelfCheckoutUIModelToJSON),
  "SelfCheckoutUpdateRequestFromJSON": () => (/* reexport */ SelfCheckoutUpdateRequestFromJSON),
  "SelfCheckoutUpdateRequestFromJSONTyped": () => (/* reexport */ SelfCheckoutUpdateRequestFromJSONTyped),
  "SelfCheckoutUpdateRequestToJSON": () => (/* reexport */ SelfCheckoutUpdateRequestToJSON),
  "ShopifyCheckoutCollectionTreeFromJSON": () => (/* reexport */ ShopifyCheckoutCollectionTreeFromJSON),
  "ShopifyCheckoutCollectionTreeFromJSONTyped": () => (/* reexport */ ShopifyCheckoutCollectionTreeFromJSONTyped),
  "ShopifyCheckoutCollectionTreeToJSON": () => (/* reexport */ ShopifyCheckoutCollectionTreeToJSON),
  "ShopifyCheckoutConfigFromJSON": () => (/* reexport */ ShopifyCheckoutConfigFromJSON),
  "ShopifyCheckoutConfigFromJSONTyped": () => (/* reexport */ ShopifyCheckoutConfigFromJSONTyped),
  "ShopifyCheckoutConfigToJSON": () => (/* reexport */ ShopifyCheckoutConfigToJSON),
  "ShopifyCheckoutCreateRequestFromJSON": () => (/* reexport */ ShopifyCheckoutCreateRequestFromJSON),
  "ShopifyCheckoutCreateRequestFromJSONTyped": () => (/* reexport */ ShopifyCheckoutCreateRequestFromJSONTyped),
  "ShopifyCheckoutCreateRequestToJSON": () => (/* reexport */ ShopifyCheckoutCreateRequestToJSON),
  "ShopifyCheckoutIntegrationCreateRequestFromJSON": () => (/* reexport */ ShopifyCheckoutIntegrationCreateRequestFromJSON),
  "ShopifyCheckoutIntegrationCreateRequestFromJSONTyped": () => (/* reexport */ ShopifyCheckoutIntegrationCreateRequestFromJSONTyped),
  "ShopifyCheckoutIntegrationCreateRequestToJSON": () => (/* reexport */ ShopifyCheckoutIntegrationCreateRequestToJSON),
  "ShopifyCheckoutIntegrationFromJSON": () => (/* reexport */ ShopifyCheckoutIntegrationFromJSON),
  "ShopifyCheckoutIntegrationFromJSONTyped": () => (/* reexport */ ShopifyCheckoutIntegrationFromJSONTyped),
  "ShopifyCheckoutIntegrationShippingMethodFromJSON": () => (/* reexport */ ShopifyCheckoutIntegrationShippingMethodFromJSON),
  "ShopifyCheckoutIntegrationShippingMethodFromJSONTyped": () => (/* reexport */ ShopifyCheckoutIntegrationShippingMethodFromJSONTyped),
  "ShopifyCheckoutIntegrationShippingMethodToJSON": () => (/* reexport */ ShopifyCheckoutIntegrationShippingMethodToJSON),
  "ShopifyCheckoutIntegrationToJSON": () => (/* reexport */ ShopifyCheckoutIntegrationToJSON),
  "ShopifyCheckoutIntegrationUpdateRequestFromJSON": () => (/* reexport */ ShopifyCheckoutIntegrationUpdateRequestFromJSON),
  "ShopifyCheckoutIntegrationUpdateRequestFromJSONTyped": () => (/* reexport */ ShopifyCheckoutIntegrationUpdateRequestFromJSONTyped),
  "ShopifyCheckoutIntegrationUpdateRequestToJSON": () => (/* reexport */ ShopifyCheckoutIntegrationUpdateRequestToJSON),
  "ShopifyCheckoutMode": () => (/* reexport */ ShopifyCheckoutMode),
  "ShopifyCheckoutModeFromJSON": () => (/* reexport */ ShopifyCheckoutModeFromJSON),
  "ShopifyCheckoutModeFromJSONTyped": () => (/* reexport */ ShopifyCheckoutModeFromJSONTyped),
  "ShopifyCheckoutModeToJSON": () => (/* reexport */ ShopifyCheckoutModeToJSON),
  "ShopifyCheckoutModelFromJSON": () => (/* reexport */ ShopifyCheckoutModelFromJSON),
  "ShopifyCheckoutModelFromJSONTyped": () => (/* reexport */ ShopifyCheckoutModelFromJSONTyped),
  "ShopifyCheckoutModelToJSON": () => (/* reexport */ ShopifyCheckoutModelToJSON),
  "ShopifyCheckoutPOSFromJSON": () => (/* reexport */ ShopifyCheckoutPOSFromJSON),
  "ShopifyCheckoutPOSFromJSONTyped": () => (/* reexport */ ShopifyCheckoutPOSFromJSONTyped),
  "ShopifyCheckoutPOSGlobalTillFromJSON": () => (/* reexport */ ShopifyCheckoutPOSGlobalTillFromJSON),
  "ShopifyCheckoutPOSGlobalTillFromJSONTyped": () => (/* reexport */ ShopifyCheckoutPOSGlobalTillFromJSONTyped),
  "ShopifyCheckoutPOSGlobalTillToJSON": () => (/* reexport */ ShopifyCheckoutPOSGlobalTillToJSON),
  "ShopifyCheckoutPOSToJSON": () => (/* reexport */ ShopifyCheckoutPOSToJSON),
  "ShopifyCheckoutPOSType": () => (/* reexport */ ShopifyCheckoutPOSType),
  "ShopifyCheckoutPOSTypeFromJSON": () => (/* reexport */ ShopifyCheckoutPOSTypeFromJSON),
  "ShopifyCheckoutPOSTypeFromJSONTyped": () => (/* reexport */ ShopifyCheckoutPOSTypeFromJSONTyped),
  "ShopifyCheckoutPOSTypeToJSON": () => (/* reexport */ ShopifyCheckoutPOSTypeToJSON),
  "ShopifyCheckoutPaymentCreateRequestFromJSON": () => (/* reexport */ ShopifyCheckoutPaymentCreateRequestFromJSON),
  "ShopifyCheckoutPaymentCreateRequestFromJSONTyped": () => (/* reexport */ ShopifyCheckoutPaymentCreateRequestFromJSONTyped),
  "ShopifyCheckoutPaymentCreateRequestToJSON": () => (/* reexport */ ShopifyCheckoutPaymentCreateRequestToJSON),
  "ShopifyCheckoutPaymentResponseFromJSON": () => (/* reexport */ ShopifyCheckoutPaymentResponseFromJSON),
  "ShopifyCheckoutPaymentResponseFromJSONTyped": () => (/* reexport */ ShopifyCheckoutPaymentResponseFromJSONTyped),
  "ShopifyCheckoutPaymentResponseToJSON": () => (/* reexport */ ShopifyCheckoutPaymentResponseToJSON),
  "ShopifyCheckoutPaymentUpdateRequestFromJSON": () => (/* reexport */ ShopifyCheckoutPaymentUpdateRequestFromJSON),
  "ShopifyCheckoutPaymentUpdateRequestFromJSONTyped": () => (/* reexport */ ShopifyCheckoutPaymentUpdateRequestFromJSONTyped),
  "ShopifyCheckoutPaymentUpdateRequestToJSON": () => (/* reexport */ ShopifyCheckoutPaymentUpdateRequestToJSON),
  "ShopifyCheckoutResponseFromJSON": () => (/* reexport */ ShopifyCheckoutResponseFromJSON),
  "ShopifyCheckoutResponseFromJSONTyped": () => (/* reexport */ ShopifyCheckoutResponseFromJSONTyped),
  "ShopifyCheckoutResponseToJSON": () => (/* reexport */ ShopifyCheckoutResponseToJSON),
  "ShopifyCheckoutUpdateRequestFromJSON": () => (/* reexport */ ShopifyCheckoutUpdateRequestFromJSON),
  "ShopifyCheckoutUpdateRequestFromJSONTyped": () => (/* reexport */ ShopifyCheckoutUpdateRequestFromJSONTyped),
  "ShopifyCheckoutUpdateRequestToJSON": () => (/* reexport */ ShopifyCheckoutUpdateRequestToJSON),
  "ShopifyCustomerMarketingBehavior": () => (/* reexport */ ShopifyCustomerMarketingBehavior),
  "ShopifyCustomerMarketingBehaviorFromJSON": () => (/* reexport */ ShopifyCustomerMarketingBehaviorFromJSON),
  "ShopifyCustomerMarketingBehaviorFromJSONTyped": () => (/* reexport */ ShopifyCustomerMarketingBehaviorFromJSONTyped),
  "ShopifyCustomerMarketingBehaviorToJSON": () => (/* reexport */ ShopifyCustomerMarketingBehaviorToJSON),
  "ShopifyFulfillmentBehavior": () => (/* reexport */ ShopifyFulfillmentBehavior),
  "ShopifyFulfillmentBehaviorFromJSON": () => (/* reexport */ ShopifyFulfillmentBehaviorFromJSON),
  "ShopifyFulfillmentBehaviorFromJSONTyped": () => (/* reexport */ ShopifyFulfillmentBehaviorFromJSONTyped),
  "ShopifyFulfillmentBehaviorToJSON": () => (/* reexport */ ShopifyFulfillmentBehaviorToJSON),
  "ShopifyInventoryBehavior": () => (/* reexport */ ShopifyInventoryBehavior),
  "ShopifyInventoryBehaviorFromJSON": () => (/* reexport */ ShopifyInventoryBehaviorFromJSON),
  "ShopifyInventoryBehaviorFromJSONTyped": () => (/* reexport */ ShopifyInventoryBehaviorFromJSONTyped),
  "ShopifyInventoryBehaviorToJSON": () => (/* reexport */ ShopifyInventoryBehaviorToJSON),
  "ShopifyLocalDeliveryOptionsFromJSON": () => (/* reexport */ ShopifyLocalDeliveryOptionsFromJSON),
  "ShopifyLocalDeliveryOptionsFromJSONTyped": () => (/* reexport */ ShopifyLocalDeliveryOptionsFromJSONTyped),
  "ShopifyLocalDeliveryOptionsToJSON": () => (/* reexport */ ShopifyLocalDeliveryOptionsToJSON),
  "SizeFromJSON": () => (/* reexport */ SizeFromJSON),
  "SizeFromJSONTyped": () => (/* reexport */ SizeFromJSONTyped),
  "SizeToJSON": () => (/* reexport */ SizeToJSON),
  "SpinToWinConfigFromJSON": () => (/* reexport */ SpinToWinConfigFromJSON),
  "SpinToWinConfigFromJSONTyped": () => (/* reexport */ SpinToWinConfigFromJSONTyped),
  "SpinToWinConfigToJSON": () => (/* reexport */ SpinToWinConfigToJSON),
  "SpinToWinCreateRequestFromJSON": () => (/* reexport */ SpinToWinCreateRequestFromJSON),
  "SpinToWinCreateRequestFromJSONTyped": () => (/* reexport */ SpinToWinCreateRequestFromJSONTyped),
  "SpinToWinCreateRequestToJSON": () => (/* reexport */ SpinToWinCreateRequestToJSON),
  "SpinToWinResponseFromJSON": () => (/* reexport */ SpinToWinResponseFromJSON),
  "SpinToWinResponseFromJSONTyped": () => (/* reexport */ SpinToWinResponseFromJSONTyped),
  "SpinToWinResponseToJSON": () => (/* reexport */ SpinToWinResponseToJSON),
  "SpinToWinSessionCreateRequestFromJSON": () => (/* reexport */ SpinToWinSessionCreateRequestFromJSON),
  "SpinToWinSessionCreateRequestFromJSONTyped": () => (/* reexport */ SpinToWinSessionCreateRequestFromJSONTyped),
  "SpinToWinSessionCreateRequestToJSON": () => (/* reexport */ SpinToWinSessionCreateRequestToJSON),
  "SpinToWinUpdateRequestFromJSON": () => (/* reexport */ SpinToWinUpdateRequestFromJSON),
  "SpinToWinUpdateRequestFromJSONTyped": () => (/* reexport */ SpinToWinUpdateRequestFromJSONTyped),
  "SpinToWinUpdateRequestToJSON": () => (/* reexport */ SpinToWinUpdateRequestToJSON),
  "StorageCreateRequestFromJSON": () => (/* reexport */ StorageCreateRequestFromJSON),
  "StorageCreateRequestFromJSONTyped": () => (/* reexport */ StorageCreateRequestFromJSONTyped),
  "StorageCreateRequestToJSON": () => (/* reexport */ StorageCreateRequestToJSON),
  "StorageResponseFromJSON": () => (/* reexport */ StorageResponseFromJSON),
  "StorageResponseFromJSONTyped": () => (/* reexport */ StorageResponseFromJSONTyped),
  "StorageResponseToJSON": () => (/* reexport */ StorageResponseToJSON),
  "StorageUploadCompleteRequestFromJSON": () => (/* reexport */ StorageUploadCompleteRequestFromJSON),
  "StorageUploadCompleteRequestFromJSONTyped": () => (/* reexport */ StorageUploadCompleteRequestFromJSONTyped),
  "StorageUploadCompleteRequestToJSON": () => (/* reexport */ StorageUploadCompleteRequestToJSON),
  "StorageUploadCreateRequestFromJSON": () => (/* reexport */ StorageUploadCreateRequestFromJSON),
  "StorageUploadCreateRequestFromJSONTyped": () => (/* reexport */ StorageUploadCreateRequestFromJSONTyped),
  "StorageUploadCreateRequestToJSON": () => (/* reexport */ StorageUploadCreateRequestToJSON),
  "StorageUploadResponseFromJSON": () => (/* reexport */ StorageUploadResponseFromJSON),
  "StorageUploadResponseFromJSONTyped": () => (/* reexport */ StorageUploadResponseFromJSONTyped),
  "StorageUploadResponseToJSON": () => (/* reexport */ StorageUploadResponseToJSON),
  "StorageUploadType": () => (/* reexport */ StorageUploadType),
  "StorageUploadTypeFromJSON": () => (/* reexport */ StorageUploadTypeFromJSON),
  "StorageUploadTypeFromJSONTyped": () => (/* reexport */ StorageUploadTypeFromJSONTyped),
  "StorageUploadTypeToJSON": () => (/* reexport */ StorageUploadTypeToJSON),
  "StripeGatewayRequestFromJSON": () => (/* reexport */ StripeGatewayRequestFromJSON),
  "StripeGatewayRequestFromJSONTyped": () => (/* reexport */ StripeGatewayRequestFromJSONTyped),
  "StripeGatewayRequestToJSON": () => (/* reexport */ StripeGatewayRequestToJSON),
  "StripeGatewayResponseFromJSON": () => (/* reexport */ StripeGatewayResponseFromJSON),
  "StripeGatewayResponseFromJSONTyped": () => (/* reexport */ StripeGatewayResponseFromJSONTyped),
  "StripeGatewayResponseToJSON": () => (/* reexport */ StripeGatewayResponseToJSON),
  "TextApiResponse": () => (/* reexport */ TextApiResponse),
  "TokenResponseFromJSON": () => (/* reexport */ TokenResponseFromJSON),
  "TokenResponseFromJSONTyped": () => (/* reexport */ TokenResponseFromJSONTyped),
  "TokenResponseToJSON": () => (/* reexport */ TokenResponseToJSON),
  "TransactionCreateRequestFromJSON": () => (/* reexport */ TransactionCreateRequestFromJSON),
  "TransactionCreateRequestFromJSONTyped": () => (/* reexport */ TransactionCreateRequestFromJSONTyped),
  "TransactionCreateRequestToJSON": () => (/* reexport */ TransactionCreateRequestToJSON),
  "TransactionMessageFromJSON": () => (/* reexport */ TransactionMessageFromJSON),
  "TransactionMessageFromJSONTyped": () => (/* reexport */ TransactionMessageFromJSONTyped),
  "TransactionMessageToJSON": () => (/* reexport */ TransactionMessageToJSON),
  "TransactionMethod": () => (/* reexport */ TransactionMethod),
  "TransactionMethodFromJSON": () => (/* reexport */ TransactionMethodFromJSON),
  "TransactionMethodFromJSONTyped": () => (/* reexport */ TransactionMethodFromJSONTyped),
  "TransactionMethodToJSON": () => (/* reexport */ TransactionMethodToJSON),
  "TransactionResponseFromJSON": () => (/* reexport */ TransactionResponseFromJSON),
  "TransactionResponseFromJSONTyped": () => (/* reexport */ TransactionResponseFromJSONTyped),
  "TransactionResponseToJSON": () => (/* reexport */ TransactionResponseToJSON),
  "TransactionStatus": () => (/* reexport */ TransactionStatus),
  "TransactionStatusFromJSON": () => (/* reexport */ TransactionStatusFromJSON),
  "TransactionStatusFromJSONTyped": () => (/* reexport */ TransactionStatusFromJSONTyped),
  "TransactionStatusToJSON": () => (/* reexport */ TransactionStatusToJSON),
  "TransactionType": () => (/* reexport */ TransactionType),
  "TransactionTypeFromJSON": () => (/* reexport */ TransactionTypeFromJSON),
  "TransactionTypeFromJSONTyped": () => (/* reexport */ TransactionTypeFromJSONTyped),
  "TransactionTypeToJSON": () => (/* reexport */ TransactionTypeToJSON),
  "UnavailableProductDisplay": () => (/* reexport */ UnavailableProductDisplay),
  "UnavailableProductDisplayFromJSON": () => (/* reexport */ UnavailableProductDisplayFromJSON),
  "UnavailableProductDisplayFromJSONTyped": () => (/* reexport */ UnavailableProductDisplayFromJSONTyped),
  "UnavailableProductDisplayToJSON": () => (/* reexport */ UnavailableProductDisplayToJSON),
  "UserCreateRequestFromJSON": () => (/* reexport */ UserCreateRequestFromJSON),
  "UserCreateRequestFromJSONTyped": () => (/* reexport */ UserCreateRequestFromJSONTyped),
  "UserCreateRequestToJSON": () => (/* reexport */ UserCreateRequestToJSON),
  "UserResponseFromJSON": () => (/* reexport */ UserResponseFromJSON),
  "UserResponseFromJSONTyped": () => (/* reexport */ UserResponseFromJSONTyped),
  "UserResponseToJSON": () => (/* reexport */ UserResponseToJSON),
  "UserUpdateRequestFromJSON": () => (/* reexport */ UserUpdateRequestFromJSON),
  "UserUpdateRequestFromJSONTyped": () => (/* reexport */ UserUpdateRequestFromJSONTyped),
  "UserUpdateRequestToJSON": () => (/* reexport */ UserUpdateRequestToJSON),
  "VideoUploadCreateRequestFromJSON": () => (/* reexport */ VideoUploadCreateRequestFromJSON),
  "VideoUploadCreateRequestFromJSONTyped": () => (/* reexport */ VideoUploadCreateRequestFromJSONTyped),
  "VideoUploadCreateRequestToJSON": () => (/* reexport */ VideoUploadCreateRequestToJSON),
  "VideoUploadRequestFromJSON": () => (/* reexport */ VideoUploadRequestFromJSON),
  "VideoUploadRequestFromJSONTyped": () => (/* reexport */ VideoUploadRequestFromJSONTyped),
  "VideoUploadRequestToJSON": () => (/* reexport */ VideoUploadRequestToJSON),
  "VideoUploadResponseFromJSON": () => (/* reexport */ VideoUploadResponseFromJSON),
  "VideoUploadResponseFromJSONTyped": () => (/* reexport */ VideoUploadResponseFromJSONTyped),
  "VideoUploadResponseToJSON": () => (/* reexport */ VideoUploadResponseToJSON),
  "VoidApiResponse": () => (/* reexport */ VoidApiResponse),
  "WeeklyScheduleDayFromJSON": () => (/* reexport */ WeeklyScheduleDayFromJSON),
  "WeeklyScheduleDayFromJSONTyped": () => (/* reexport */ WeeklyScheduleDayFromJSONTyped),
  "WeeklyScheduleDayToJSON": () => (/* reexport */ WeeklyScheduleDayToJSON),
  "WeeklyScheduleFromJSON": () => (/* reexport */ WeeklyScheduleFromJSON),
  "WeeklyScheduleFromJSONTyped": () => (/* reexport */ WeeklyScheduleFromJSONTyped),
  "WeeklyScheduleToJSON": () => (/* reexport */ WeeklyScheduleToJSON),
  "canConsumeForm": () => (/* reexport */ canConsumeForm),
  "createEsuiteClient": () => (/* reexport */ createEsuiteClient),
  "exists": () => (/* reexport */ exists),
  "mapValues": () => (/* reexport */ mapValues),
  "querystring": () => (/* reexport */ querystring)
});

// NAMESPACE OBJECT: ./client/lib/extras/index.ts
var extras_namespaceObject = {};
__webpack_require__.r(extras_namespaceObject);
__webpack_require__.d(extras_namespaceObject, {
  "imageUpload": () => (imageUpload),
  "storage": () => (storage),
  "videoUpload": () => (videoUpload)
});

;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/runtime.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

const BASE_PATH = "http://my-organization.myeflyndev:3000".replace(/\/+$/, "");
const isBlob = (value) => typeof Blob !== 'undefined' && value instanceof Blob;
/**
 * This is the base class for all generated API classes.
 */
class BaseAPI {
    constructor(configuration = new Configuration()) {
        this.configuration = configuration;
        this.fetchApi = (url, init) => __awaiter(this, void 0, void 0, function* () {
            let fetchParams = { url, init };
            for (const middleware of this.middleware) {
                if (middleware.pre) {
                    fetchParams = (yield middleware.pre(Object.assign({ fetch: this.fetchApi }, fetchParams))) || fetchParams;
                }
            }
            let response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            for (const middleware of this.middleware) {
                if (middleware.post) {
                    response = (yield middleware.post({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        response: response.clone(),
                    })) || response;
                }
            }
            return response;
        });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware(...middlewares);
    }
    request(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url, init } = this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response.status >= 200 && response.status < 300) {
                return response;
            }
            throw response;
        });
    }
    createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }
        const body = ((typeof FormData !== "undefined" && context.body instanceof FormData) || context.body instanceof URLSearchParams || isBlob(context.body))
            ? context.body
            : JSON.stringify(context.body);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        const init = Object.assign({ method: context.method, headers: headers, body, credentials: this.configuration.credentials }, initOverrides);
        return { url, init };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
;
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
class Configuration {
    constructor(configuration = {}) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : () => apiKey;
        }
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : () => __awaiter(this, void 0, void 0, function* () { return accessToken; });
        }
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params)
        .map((key) => {
        const fullKey = prefix + (prefix.length ? `[${key}]` : key);
        const value = params[key];
        if (value instanceof Array) {
            const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
                .join(`&${encodeURIComponent(fullKey)}=`);
            return `${encodeURIComponent(fullKey)}=${multiValue}`;
        }
        if (value instanceof Date) {
            return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
        }
        if (value instanceof Object) {
            return querystring(value, fullKey);
        }
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
    })
        .filter(part => part.length > 0)
        .join('&');
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: fn(data[key]) })), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue) => jsonValue) {
        this.raw = raw;
        this.transformer = transformer;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            const val = this.transformer(yield this.raw.json());
            if (Array.isArray(val) && this.raw.__pagination) {
                val.pagination = this.raw.__pagination;
            }
            return val;
        });
    }
}
class VoidApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return undefined;
        });
    }
}
class BlobApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.raw.blob();
        });
    }
    ;
}
class TextApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.raw.text();
        });
    }
    ;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AccessCodeCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AccessCodeCreateRequestFromJSON(json) {
    return AccessCodeCreateRequestFromJSONTyped(json, false);
}
function AccessCodeCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'expiredAt': !exists(json, 'expiredAt') ? undefined : (new Date(json['expiredAt'])),
    };
}
function AccessCodeCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'expiredAt': value.expiredAt === undefined ? undefined : (value.expiredAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AccessCodeResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AccessCodeResponseFromJSON(json) {
    return AccessCodeResponseFromJSONTyped(json, false);
}
function AccessCodeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
        'createdAt': (new Date(json['createdAt'])),
        'expiredAt': (new Date(json['expiredAt'])),
        'expiresAt': (new Date(json['expiresAt'])),
        'id': json['id'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function AccessCodeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'createdAt': (value.createdAt.toISOString()),
        'expiredAt': (value.expiredAt.toISOString()),
        'expiresAt': (value.expiresAt.toISOString()),
        'id': value.id,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AccessControlCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AccessControlCreateRequestFromJSON(json) {
    return AccessControlCreateRequestFromJSONTyped(json, false);
}
function AccessControlCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ownerType': OrganizationUserFromJSON(json['ownerType']),
        'resourceType': AccessControlResourceFromJSON(json['resourceType']),
        'ownerId': json['ownerId'],
        'resourceId': json['resourceId'],
    };
}
function AccessControlCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ownerType': OrganizationUserToJSON(value.ownerType),
        'resourceType': AccessControlResourceToJSON(value.resourceType),
        'ownerId': value.ownerId,
        'resourceId': value.resourceId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AccessControlResource.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var AccessControlResource;
(function (AccessControlResource) {
    AccessControlResource["Role"] = "role";
    AccessControlResource["MediaCollection"] = "media_collection";
})(AccessControlResource || (AccessControlResource = {}));
function AccessControlResourceFromJSON(json) {
    return AccessControlResourceFromJSONTyped(json, false);
}
function AccessControlResourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AccessControlResourceToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AccessControlResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @export
* @enum {string}
*/
var AccessControlResponseOwnerTypeEnum;
(function (AccessControlResponseOwnerTypeEnum) {
    AccessControlResponseOwnerTypeEnum["Kiosk"] = "kiosk";
    AccessControlResponseOwnerTypeEnum["Plugin"] = "plugin";
    AccessControlResponseOwnerTypeEnum["User"] = "user";
    AccessControlResponseOwnerTypeEnum["RestApp"] = "rest_app";
    AccessControlResponseOwnerTypeEnum["AccessCode"] = "access_code";
})(AccessControlResponseOwnerTypeEnum || (AccessControlResponseOwnerTypeEnum = {})); /**
* @export
* @enum {string}
*/
var AccessControlResponseResourceTypeEnum;
(function (AccessControlResponseResourceTypeEnum) {
    AccessControlResponseResourceTypeEnum["Role"] = "role";
    AccessControlResponseResourceTypeEnum["MediaCollection"] = "media_collection";
})(AccessControlResponseResourceTypeEnum || (AccessControlResponseResourceTypeEnum = {}));
function AccessControlResponseFromJSON(json) {
    return AccessControlResponseFromJSONTyped(json, false);
}
function AccessControlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'ownerId': json['ownerId'],
        'ownerType': json['ownerType'],
        'resourceId': json['resourceId'],
        'resourceType': json['resourceType'],
    };
}
function AccessControlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ownerId': value.ownerId,
        'ownerType': value.ownerType,
        'resourceId': value.resourceId,
        'resourceType': value.resourceType,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AccessTokenResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AccessTokenResponseFromJSON(json) {
    return AccessTokenResponseFromJSONTyped(json, false);
}
function AccessTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'credentials': json['credentials'],
        'accessToken': json['accessToken'],
    };
}
function AccessTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'credentials': value.credentials,
        'accessToken': value.accessToken,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Activation.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ActivationFromJSON(json) {
    return ActivationFromJSONTyped(json, false);
}
function ActivationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kiosk': ActivationKioskFromJSON(json['kiosk']),
        'type': EsuiteAppFromJSON(json['type']),
        'app': BaseEsuiteAppInstanceModelFromJSON(json['app']),
        'data': json['data'],
        'enabled': json['enabled'],
        'id': json['id'],
        'paymentTerminal': PaymentTerminalModelFromJSON(json['paymentTerminal']),
        'paymentTerminalId': json['paymentTerminalId'],
        'version': json['version'],
    };
}
function ActivationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'kiosk': ActivationKioskToJSON(value.kiosk),
        'type': EsuiteAppToJSON(value.type),
        'app': BaseEsuiteAppInstanceModelToJSON(value.app),
        'data': value.data,
        'enabled': value.enabled,
        'id': value.id,
        'paymentTerminal': PaymentTerminalModelToJSON(value.paymentTerminal),
        'paymentTerminalId': value.paymentTerminalId,
        'version': value.version,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationKiosk.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ActivationKioskFromJSON(json) {
    return ActivationKioskFromJSONTyped(json, false);
}
function ActivationKioskFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}
function ActivationKioskToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationMode.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ActivationMode;
(function (ActivationMode) {
    ActivationMode["Schedule"] = "Schedule";
    ActivationMode["Single"] = "Single";
})(ActivationMode || (ActivationMode = {}));
function ActivationModeFromJSON(json) {
    return ActivationModeFromJSONTyped(json, false);
}
function ActivationModeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ActivationModeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ActivationScheduleCreateRequestFromJSON(json) {
    return ActivationScheduleCreateRequestFromJSONTyped(json, false);
}
function ActivationScheduleCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'days': !exists(json, 'days') ? undefined : (json['days'].map(ActivationScheduleDayFromJSON)),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'kioskId': !exists(json, 'kioskId') ? undefined : json['kioskId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
    };
}
function ActivationScheduleCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'days': value.days === undefined ? undefined : (value.days.map(ActivationScheduleDayToJSON)),
        'enabled': value.enabled,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'groupId': value.groupId,
        'kioskId': value.kioskId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleDay.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ActivationScheduleDayFromJSON(json) {
    return ActivationScheduleDayFromJSONTyped(json, false);
}
function ActivationScheduleDayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allDay': json['allDay'],
        'enabled': json['enabled'],
        'times': json['times'],
    };
}
function ActivationScheduleDayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'allDay': value.allDay,
        'enabled': value.enabled,
        'times': value.times,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleItemCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ActivationScheduleItemCreateRequestFromJSON(json) {
    return ActivationScheduleItemCreateRequestFromJSONTyped(json, false);
}
function ActivationScheduleItemCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'activationId': json['activationId'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}
function ActivationScheduleItemCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'activationId': value.activationId,
        'duration': value.duration,
        'enabled': value.enabled,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleItemResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ActivationScheduleItemResponseFromJSON(json) {
    return ActivationScheduleItemResponseFromJSONTyped(json, false);
}
function ActivationScheduleItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'activationId': json['activationId'],
        'duration': json['duration'],
        'enabled': json['enabled'],
        'id': json['id'],
        'scheduleId': json['scheduleId'],
        'sort': json['sort'],
    };
}
function ActivationScheduleItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'activationId': value.activationId,
        'duration': value.duration,
        'enabled': value.enabled,
        'id': value.id,
        'scheduleId': value.scheduleId,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleItemUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ActivationScheduleItemUpdateRequestFromJSON(json) {
    return ActivationScheduleItemUpdateRequestFromJSONTyped(json, false);
}
function ActivationScheduleItemUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'activationId': json['activationId'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}
function ActivationScheduleItemUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'activationId': value.activationId,
        'duration': value.duration,
        'enabled': value.enabled,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ActivationScheduleResponseFromJSON(json) {
    return ActivationScheduleResponseFromJSONTyped(json, false);
}
function ActivationScheduleResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'days': (json['days'].map(ActivationScheduleDayFromJSON)),
        'enabled': json['enabled'],
        'endDate': (new Date(json['endDate'])),
        'groupId': json['groupId'],
        'id': json['id'],
        'items': (json['items'].map(ActivationScheduleItemResponseFromJSON)),
        'kioskId': json['kioskId'],
        'startDate': (new Date(json['startDate'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function ActivationScheduleResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'days': (value.days.map(ActivationScheduleDayToJSON)),
        'enabled': value.enabled,
        'endDate': (value.endDate.toISOString()),
        'groupId': value.groupId,
        'id': value.id,
        'items': (value.items.map(ActivationScheduleItemResponseToJSON)),
        'kioskId': value.kioskId,
        'startDate': (value.startDate.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationScheduleUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ActivationScheduleUpdateRequestFromJSON(json) {
    return ActivationScheduleUpdateRequestFromJSONTyped(json, false);
}
function ActivationScheduleUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'days': !exists(json, 'days') ? undefined : (json['days'].map(ActivationScheduleDayFromJSON)),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'kioskId': !exists(json, 'kioskId') ? undefined : json['kioskId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
    };
}
function ActivationScheduleUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'days': value.days === undefined ? undefined : (value.days.map(ActivationScheduleDayToJSON)),
        'enabled': value.enabled,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'groupId': value.groupId,
        'kioskId': value.kioskId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ActivationUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ActivationUpdateRequestFromJSON(json) {
    return ActivationUpdateRequestFromJSONTyped(json, false);
}
function ActivationUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}
function ActivationUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Address.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AddressFromJSON(json) {
    return AddressFromJSONTyped(json, false);
}
function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'address1': !exists(json, 'address1') ? undefined : json['address1'],
        'address2': !exists(json, 'address2') ? undefined : json['address2'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'province': !exists(json, 'province') ? undefined : json['province'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
    };
}
function AddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'address1': value.address1,
        'address2': value.address2,
        'city': value.city,
        'province': value.province,
        'country': value.country,
        'zip': value.zip,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function AdmissionCreateRequestFromJSON(json) {
    return AdmissionCreateRequestFromJSONTyped(json, false);
}
function AdmissionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : ProductStatusFromJSON(json['status']),
        'agreementIds': !exists(json, 'agreementIds') ? undefined : json['agreementIds'],
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'notices': !exists(json, 'notices') ? undefined : json['notices'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'taskIds': !exists(json, 'taskIds') ? undefined : json['taskIds'],
        'taxable': !exists(json, 'taxable') ? undefined : json['taxable'],
        'title': json['title'],
    };
}
function AdmissionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': ProductStatusToJSON(value.status),
        'agreementIds': value.agreementIds,
        'descriptionHtml': value.descriptionHtml,
        'imageId': value.imageId,
        'notices': value.notices,
        'tags': value.tags,
        'taskIds': value.taskIds,
        'taxable': value.taxable,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionLineItemOption.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionLineItemOptionFromJSON(json) {
    return AdmissionLineItemOptionFromJSONTyped(json, false);
}
function AdmissionLineItemOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'id': json['id'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}
function AdmissionLineItemOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'answer': value.answer,
        'id': value.id,
        'quantity': value.quantity,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionOptionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function AdmissionOptionCreateRequestFromJSON(json) {
    return AdmissionOptionCreateRequestFromJSONTyped(json, false);
}
function AdmissionOptionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': CustomProductOptionTypeFromJSON(json['type']),
        'values': !exists(json, 'values') ? undefined : (json['values'].map(CustomProductOptionValueFromJSON)),
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'name': json['name'],
        'notificationId': !exists(json, 'notificationId') ? undefined : json['notificationId'],
        'priceAdjustment': !exists(json, 'priceAdjustment') ? undefined : json['priceAdjustment'],
        'print': !exists(json, 'print') ? undefined : json['print'],
        'question': !exists(json, 'question') ? undefined : json['question'],
        'required': !exists(json, 'required') ? undefined : json['required'],
    };
}
function AdmissionOptionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': CustomProductOptionTypeToJSON(value.type),
        'values': value.values === undefined ? undefined : (value.values.map(CustomProductOptionValueToJSON)),
        'descriptionHtml': value.descriptionHtml,
        'max': value.max,
        'min': value.min,
        'name': value.name,
        'notificationId': value.notificationId,
        'priceAdjustment': value.priceAdjustment,
        'print': value.print,
        'question': value.question,
        'required': value.required,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionOptionLineItemResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionOptionLineItemResponseFromJSON(json) {
    return AdmissionOptionLineItemResponseFromJSONTyped(json, false);
}
function AdmissionOptionLineItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'id': json['id'],
        'name': json['name'],
        'priceAdjustment': json['priceAdjustment'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'type': json['type'],
    };
}
function AdmissionOptionLineItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'answer': value.answer,
        'id': value.id,
        'name': value.name,
        'priceAdjustment': value.priceAdjustment,
        'quantity': value.quantity,
        'type': value.type,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionOptionResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionOptionResponseFromJSON(json) {
    return AdmissionOptionResponseFromJSONTyped(json, false);
}
function AdmissionOptionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': CustomProductOptionTypeFromJSON(json['type']),
        'admissionId': json['admissionId'],
        'descriptionHtml': json['descriptionHtml'],
        'id': json['id'],
        'max': json['max'],
        'min': json['min'],
        'name': json['name'],
        'notificationId': json['notificationId'],
        'priceAdjustment': json['priceAdjustment'],
        'print': json['print'],
        'question': json['question'],
        'required': json['required'],
        'sort': json['sort'],
    };
}
function AdmissionOptionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': CustomProductOptionTypeToJSON(value.type),
        'admissionId': value.admissionId,
        'descriptionHtml': value.descriptionHtml,
        'id': value.id,
        'max': value.max,
        'min': value.min,
        'name': value.name,
        'notificationId': value.notificationId,
        'priceAdjustment': value.priceAdjustment,
        'print': value.print,
        'question': value.question,
        'required': value.required,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionOptionUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function AdmissionOptionUpdateRequestFromJSON(json) {
    return AdmissionOptionUpdateRequestFromJSONTyped(json, false);
}
function AdmissionOptionUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : CustomProductOptionTypeFromJSON(json['type']),
        'values': !exists(json, 'values') ? undefined : (json['values'].map(CustomProductOptionValueFromJSON)),
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notificationId': !exists(json, 'notificationId') ? undefined : json['notificationId'],
        'priceAdjustment': !exists(json, 'priceAdjustment') ? undefined : json['priceAdjustment'],
        'print': !exists(json, 'print') ? undefined : json['print'],
        'question': !exists(json, 'question') ? undefined : json['question'],
        'required': !exists(json, 'required') ? undefined : json['required'],
    };
}
function AdmissionOptionUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': CustomProductOptionTypeToJSON(value.type),
        'values': value.values === undefined ? undefined : (value.values.map(CustomProductOptionValueToJSON)),
        'descriptionHtml': value.descriptionHtml,
        'max': value.max,
        'min': value.min,
        'name': value.name,
        'notificationId': value.notificationId,
        'priceAdjustment': value.priceAdjustment,
        'print': value.print,
        'question': value.question,
        'required': value.required,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionResponseFromJSON(json) {
    return AdmissionResponseFromJSONTyped(json, false);
}
function AdmissionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': ProductStatusFromJSON(json['status']),
        'agreementIds': json['agreementIds'],
        'options': (json['options'].map(AdmissionOptionResponseFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'descriptionHtml': json['descriptionHtml'],
        'handle': json['handle'],
        'id': json['id'],
        'image': ImageUploadResponseFromJSON(json['image']),
        'images': (json['images'].map(ImageUploadResponseFromJSON)),
        'notices': json['notices'],
        'tags': json['tags'],
        'taxable': json['taxable'],
        'title': json['title'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function AdmissionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': ProductStatusToJSON(value.status),
        'agreementIds': value.agreementIds,
        'options': (value.options.map(AdmissionOptionResponseToJSON)),
        'createdAt': (value.createdAt.toISOString()),
        'descriptionHtml': value.descriptionHtml,
        'handle': value.handle,
        'id': value.id,
        'image': ImageUploadResponseToJSON(value.image),
        'images': (value.images.map(ImageUploadResponseToJSON)),
        'notices': value.notices,
        'tags': value.tags,
        'taxable': value.taxable,
        'title': value.title,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionTemplateCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionTemplateCreateRequestFromJSON(json) {
    return AdmissionTemplateCreateRequestFromJSONTyped(json, false);
}
function AdmissionTemplateCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': NotificationTypeFromJSON(json['type']),
        'html': json['html'],
        'name': json['name'],
    };
}
function AdmissionTemplateCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': NotificationTypeToJSON(value.type),
        'html': value.html,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionTemplateResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionTemplateResponseFromJSON(json) {
    return AdmissionTemplateResponseFromJSONTyped(json, false);
}
function AdmissionTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bcc': json['bcc'],
        'cc': json['cc'],
        'type': NotificationTypeFromJSON(json['type']),
        'createdAt': (new Date(json['createdAt'])),
        'html': json['html'],
        'id': json['id'],
        'key': json['key'],
        'name': json['name'],
        'subject': json['subject'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function AdmissionTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bcc': value.bcc,
        'cc': value.cc,
        'type': NotificationTypeToJSON(value.type),
        'createdAt': (value.createdAt.toISOString()),
        'html': value.html,
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'subject': value.subject,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionTemplateUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AdmissionTemplateUpdateRequestFromJSON(json) {
    return AdmissionTemplateUpdateRequestFromJSONTyped(json, false);
}
function AdmissionTemplateUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bcc': !exists(json, 'bcc') ? undefined : json['bcc'],
        'cc': !exists(json, 'cc') ? undefined : json['cc'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
    };
}
function AdmissionTemplateUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bcc': value.bcc,
        'cc': value.cc,
        'html': value.html,
        'name': value.name,
        'subject': value.subject,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AdmissionUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function AdmissionUpdateRequestFromJSON(json) {
    return AdmissionUpdateRequestFromJSONTyped(json, false);
}
function AdmissionUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sortOptionsById': !exists(json, 'sortOptionsById') ? undefined : json['sortOptionsById'],
        'status': !exists(json, 'status') ? undefined : ProductStatusFromJSON(json['status']),
        'agreementIds': !exists(json, 'agreementIds') ? undefined : json['agreementIds'],
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'notices': !exists(json, 'notices') ? undefined : json['notices'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'taxable': !exists(json, 'taxable') ? undefined : json['taxable'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}
function AdmissionUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sortOptionsById': value.sortOptionsById,
        'status': ProductStatusToJSON(value.status),
        'agreementIds': value.agreementIds,
        'descriptionHtml': value.descriptionHtml,
        'imageId': value.imageId,
        'notices': value.notices,
        'tags': value.tags,
        'taskId': value.taskId,
        'taxable': value.taxable,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AgreementCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AgreementCreateRequestFromJSON(json) {
    return AgreementCreateRequestFromJSONTyped(json, false);
}
function AgreementCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'html': json['html'],
        'name': json['name'],
    };
}
function AgreementCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'html': value.html,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AgreementResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AgreementResponseFromJSON(json) {
    return AgreementResponseFromJSONTyped(json, false);
}
function AgreementResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'html': json['html'],
        'id': json['id'],
        'name': json['name'],
    };
}
function AgreementResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'html': value.html,
        'id': value.id,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AgreementUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AgreementUpdateRequestFromJSON(json) {
    return AgreementUpdateRequestFromJSONTyped(json, false);
}
function AgreementUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'html': !exists(json, 'html') ? undefined : json['html'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function AgreementUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'html': value.html,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AppPlugin.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AppPluginFromJSON(json) {
    return AppPluginFromJSONTyped(json, false);
}
function AppPluginFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'functions': json['functions'],
        'id': json['id'],
        'name': json['name'],
        'title': json['title'],
        'enabled': json['enabled'],
        'roles': json['roles'],
    };
}
function AppPluginToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'functions': value.functions,
        'id': value.id,
        'name': value.name,
        'title': value.title,
        'enabled': value.enabled,
        'roles': value.roles,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AppPluginCreate.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AppPluginCreateFromJSON(json) {
    return AppPluginCreateFromJSONTyped(json, false);
}
function AppPluginCreateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': json['title'],
    };
}
function AppPluginCreateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AppPluginHookUseActionRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AppPluginHookUseActionRequestFromJSON(json) {
    return AppPluginHookUseActionRequestFromJSONTyped(json, false);
}
function AppPluginHookUseActionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'body': !exists(json, 'body') ? undefined : json['body'],
    };
}
function AppPluginHookUseActionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'body': value.body,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AppPluginHookUseMapRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AppPluginHookUseMapRequestFromJSON(json) {
    return AppPluginHookUseMapRequestFromJSONTyped(json, false);
}
function AppPluginHookUseMapRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'body': !exists(json, 'body') ? undefined : json['body'],
    };
}
function AppPluginHookUseMapRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'body': value.body,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AppPluginUpdate.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AppPluginUpdateFromJSON(json) {
    return AppPluginUpdateFromJSONTyped(json, false);
}
function AppPluginUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'functions': !exists(json, 'functions') ? undefined : json['functions'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}
function AppPluginUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'functions': value.functions,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AppPurchaseCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
* @export
* @enum {string}
*/
var AppPurchaseCreateRequestStatusEnum;
(function (AppPurchaseCreateRequestStatusEnum) {
    AppPurchaseCreateRequestStatusEnum["Active"] = "active";
    AppPurchaseCreateRequestStatusEnum["Archived"] = "archived";
    AppPurchaseCreateRequestStatusEnum["Draft"] = "draft";
})(AppPurchaseCreateRequestStatusEnum || (AppPurchaseCreateRequestStatusEnum = {}));
function AppPurchaseCreateRequestFromJSON(json) {
    return AppPurchaseCreateRequestFromJSONTyped(json, false);
}
function AppPurchaseCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'price': json['price'],
        'status': json['status'],
        'taxable': !exists(json, 'taxable') ? undefined : json['taxable'],
        'title': json['title'],
    };
}
function AppPurchaseCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'price': value.price,
        'status': value.status,
        'taxable': value.taxable,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ApplicationCurrency.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationCurrency;
(function (ApplicationCurrency) {
    ApplicationCurrency["Cad"] = "CAD";
    ApplicationCurrency["Usd"] = "USD";
})(ApplicationCurrency || (ApplicationCurrency = {}));
function ApplicationCurrencyFromJSON(json) {
    return ApplicationCurrencyFromJSONTyped(json, false);
}
function ApplicationCurrencyFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApplicationCurrencyToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AuthResetPasswordRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AuthResetPasswordRequestFromJSON(json) {
    return AuthResetPasswordRequestFromJSONTyped(json, false);
}
function AuthResetPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function AuthResetPasswordRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/AuthUserRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function AuthUserRequestFromJSON(json) {
    return AuthUserRequestFromJSONTyped(json, false);
}
function AuthUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessCode': !exists(json, 'accessCode') ? undefined : json['accessCode'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}
function AuthUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessCode': value.accessCode,
        'password': value.password,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/BaseEsuiteAppInstanceModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function BaseEsuiteAppInstanceModelFromJSON(json) {
    return BaseEsuiteAppInstanceModelFromJSONTyped(json, false);
}
function BaseEsuiteAppInstanceModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'enabled': json['enabled'],
    };
}
function BaseEsuiteAppInstanceModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
        'enabled': value.enabled,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/BaseEsuiteAppInstanceResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function BaseEsuiteAppInstanceResponseFromJSON(json) {
    return BaseEsuiteAppInstanceResponseFromJSONTyped(json, false);
}
function BaseEsuiteAppInstanceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function BaseEsuiteAppInstanceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CayanGatewayRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function CayanGatewayRequestFromJSON(json) {
    return CayanGatewayRequestFromJSONTyped(json, false);
}
function CayanGatewayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'merchantKey': json['merchantKey'],
        'merchantName': json['merchantName'],
        'merchantSiteId': json['merchantSiteId'],
    };
}
function CayanGatewayRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'merchantKey': value.merchantKey,
        'merchantName': value.merchantName,
        'merchantSiteId': value.merchantSiteId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CayanGatewayResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function CayanGatewayResponseFromJSON(json) {
    return CayanGatewayResponseFromJSONTyped(json, false);
}
function CayanGatewayResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'merchantKey': json['merchantKey'],
        'merchantName': json['merchantName'],
        'merchantSiteId': json['merchantSiteId'],
    };
}
function CayanGatewayResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'merchantKey': value.merchantKey,
        'merchantName': value.merchantName,
        'merchantSiteId': value.merchantSiteId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutCreateRequestFromJSON(json) {
    return CheckoutCreateRequestFromJSONTyped(json, false);
}
function CheckoutCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'billingAddress': !exists(json, 'billingAddress') ? undefined : AddressFromJSON(json['billingAddress']),
        'integrations': !exists(json, 'integrations') ? undefined : (json['integrations'].map(CheckoutIntegrationCreateRequestFromJSON)),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : AddressFromJSON(json['shippingAddress']),
        'activationId': json['activationId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
function CheckoutCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'billingAddress': AddressToJSON(value.billingAddress),
        'integrations': value.integrations === undefined ? undefined : (value.integrations.map(CheckoutIntegrationCreateRequestToJSON)),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'activationId': value.activationId,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutFieldOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutFieldOptionsFromJSON(json) {
    return CheckoutFieldOptionsFromJSONTyped(json, false);
}
function CheckoutFieldOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : FieldOptionFromJSON(json['name']),
        'phone': !exists(json, 'phone') ? undefined : FieldOptionFromJSON(json['phone']),
        'email': !exists(json, 'email') ? undefined : FieldOptionFromJSON(json['email']),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : FieldOptionFromJSON(json['shippingAddress']),
    };
}
function CheckoutFieldOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': FieldOptionToJSON(value.name),
        'phone': FieldOptionToJSON(value.phone),
        'email': FieldOptionToJSON(value.email),
        'shippingAddress': FieldOptionToJSON(value.shippingAddress),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutIntegration.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CheckoutIntegrationFromJSON(json) {
    return CheckoutIntegrationFromJSONTyped(json, false);
}
function CheckoutIntegrationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'integrationId': json['integrationId'],
        'shopify': ShopifyCheckoutIntegrationFromJSON(json['shopify']),
    };
}
function CheckoutIntegrationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'integrationId': value.integrationId,
        'shopify': ShopifyCheckoutIntegrationToJSON(value.shopify),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutIntegrationCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutIntegrationCreateRequestFromJSON(json) {
    return CheckoutIntegrationCreateRequestFromJSONTyped(json, false);
}
function CheckoutIntegrationCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shopify': !exists(json, 'shopify') ? undefined : ShopifyCheckoutIntegrationCreateRequestFromJSON(json['shopify']),
        'integrationId': json['integrationId'],
    };
}
function CheckoutIntegrationCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shopify': ShopifyCheckoutIntegrationCreateRequestToJSON(value.shopify),
        'integrationId': value.integrationId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutIntegrationUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutIntegrationUpdateRequestFromJSON(json) {
    return CheckoutIntegrationUpdateRequestFromJSONTyped(json, false);
}
function CheckoutIntegrationUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shopify': !exists(json, 'shopify') ? undefined : ShopifyCheckoutIntegrationUpdateRequestFromJSON(json['shopify']),
        'integrationId': json['integrationId'],
    };
}
function CheckoutIntegrationUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shopify': ShopifyCheckoutIntegrationUpdateRequestToJSON(value.shopify),
        'integrationId': value.integrationId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutLineItemCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutLineItemCreateRequestFromJSON(json) {
    return CheckoutLineItemCreateRequestFromJSONTyped(json, false);
}
function CheckoutLineItemCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'admissionOptions': !exists(json, 'admissionOptions') ? undefined : (json['admissionOptions'].map(AdmissionLineItemOptionFromJSON)),
        'fundOption': !exists(json, 'fundOption') ? undefined : FundLineItemOptionFromJSON(json['fundOption']),
        'productType': ProductTypeFromJSON(json['productType']),
        'productId': json['productId'],
        'quantity': json['quantity'],
    };
}
function CheckoutLineItemCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'admissionOptions': value.admissionOptions === undefined ? undefined : (value.admissionOptions.map(AdmissionLineItemOptionToJSON)),
        'fundOption': FundLineItemOptionToJSON(value.fundOption),
        'productType': ProductTypeToJSON(value.productType),
        'productId': value.productId,
        'quantity': value.quantity,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutLineItemResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutLineItemResponseFromJSON(json) {
    return CheckoutLineItemResponseFromJSONTyped(json, false);
}
function CheckoutLineItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'admissionOptions': !exists(json, 'admissionOptions') ? undefined : (json['admissionOptions'].map(AdmissionOptionLineItemResponseFromJSON)),
        'productType': ProductTypeFromJSON(json['productType']),
        'admissionId': json['admissionId'],
        'appPurchaseId': json['appPurchaseId'],
        'id': json['id'],
        'image': ImageUploadResponseFromJSON(json['image']),
        'imageId': json['imageId'],
        'quantity': json['quantity'],
        'title': json['title'],
        'unitPrice': json['unitPrice'],
    };
}
function CheckoutLineItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'admissionOptions': value.admissionOptions === undefined ? undefined : (value.admissionOptions.map(AdmissionOptionLineItemResponseToJSON)),
        'productType': ProductTypeToJSON(value.productType),
        'admissionId': value.admissionId,
        'appPurchaseId': value.appPurchaseId,
        'id': value.id,
        'image': ImageUploadResponseToJSON(value.image),
        'imageId': value.imageId,
        'quantity': value.quantity,
        'title': value.title,
        'unitPrice': value.unitPrice,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutLineItemUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutLineItemUpdateRequestFromJSON(json) {
    return CheckoutLineItemUpdateRequestFromJSONTyped(json, false);
}
function CheckoutLineItemUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'admissionOptions': !exists(json, 'admissionOptions') ? undefined : (json['admissionOptions'].map(AdmissionLineItemOptionFromJSON)),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}
function CheckoutLineItemUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'admissionOptions': value.admissionOptions === undefined ? undefined : (value.admissionOptions.map(AdmissionLineItemOptionToJSON)),
        'quantity': value.quantity,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CheckoutResponseFromJSON(json) {
    return CheckoutResponseFromJSONTyped(json, false);
}
function CheckoutResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'integrations': (json['integrations'].map(CheckoutIntegrationFromJSON)),
        'billingAddress': AddressFromJSON(json['billingAddress']),
        'cancelledAt': (new Date(json['cancelledAt'])),
        'completedAt': (new Date(json['completedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'currency': json['currency'],
        'customerId': json['customerId'],
        'email': json['email'],
        'id': json['id'],
        'kioskId': json['kioskId'],
        'lineItems': (json['lineItems'].map(CheckoutLineItemResponseFromJSON)),
        'phone': json['phone'],
        'subtotalPrice': json['subtotalPrice'],
        'token': json['token'],
        'totalItems': json['totalItems'],
        'totalPrice': json['totalPrice'],
        'totalTax': json['totalTax'],
        'updatedAt': (new Date(json['updatedAt'])),
        'webUrl': json['webUrl'],
    };
}
function CheckoutResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'integrations': (value.integrations.map(CheckoutIntegrationToJSON)),
        'billingAddress': AddressToJSON(value.billingAddress),
        'cancelledAt': (value.cancelledAt.toISOString()),
        'completedAt': (value.completedAt.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'currency': value.currency,
        'customerId': value.customerId,
        'email': value.email,
        'id': value.id,
        'kioskId': value.kioskId,
        'lineItems': (value.lineItems.map(CheckoutLineItemResponseToJSON)),
        'phone': value.phone,
        'subtotalPrice': value.subtotalPrice,
        'token': value.token,
        'totalItems': value.totalItems,
        'totalPrice': value.totalPrice,
        'totalTax': value.totalTax,
        'updatedAt': (value.updatedAt.toISOString()),
        'webUrl': value.webUrl,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CheckoutUpdateRequestDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CheckoutUpdateRequestDtoFromJSON(json) {
    return CheckoutUpdateRequestDtoFromJSONTyped(json, false);
}
function CheckoutUpdateRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'billingAddress': !exists(json, 'billingAddress') ? undefined : AddressFromJSON(json['billingAddress']),
        'integrations': !exists(json, 'integrations') ? undefined : (json['integrations'].map(CheckoutIntegrationUpdateRequestFromJSON)),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : AddressFromJSON(json['shippingAddress']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
function CheckoutUpdateRequestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'billingAddress': AddressToJSON(value.billingAddress),
        'integrations': value.integrations === undefined ? undefined : (value.integrations.map(CheckoutIntegrationUpdateRequestToJSON)),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'email': value.email,
        'phone': value.phone,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomAppCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomAppCreateRequestFromJSON(json) {
    return CustomAppCreateRequestFromJSONTyped(json, false);
}
function CustomAppCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': !exists(json, 'url') ? undefined : json['url'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': json['name'],
    };
}
function CustomAppCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomAppResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function CustomAppResponseFromJSON(json) {
    return CustomAppResponseFromJSONTyped(json, false);
}
function CustomAppResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
        'data': json['data'],
        'url': json['url'],
    };
}
function CustomAppResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
        'data': value.data,
        'url': value.url,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomAppUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomAppUpdateRequestFromJSON(json) {
    return CustomAppUpdateRequestFromJSONTyped(json, false);
}
function CustomAppUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !exists(json, 'data') ? undefined : json['data'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function CustomAppUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
        'url': value.url,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomFieldEntry.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomFieldEntryFromJSON(json) {
    return CustomFieldEntryFromJSONTyped(json, false);
}
function CustomFieldEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'component': !exists(json, 'component') ? undefined : json['component'],
        'label': json['label'],
        'name': json['name'],
        'option': !exists(json, 'option') ? undefined : json['option'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'value': json['value'],
    };
}
function CustomFieldEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'component': value.component,
        'label': value.label,
        'name': value.name,
        'option': value.option,
        'width': value.width,
        'value': value.value,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomFieldOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomFieldOptionsFromJSON(json) {
    return CustomFieldOptionsFromJSONTyped(json, false);
}
function CustomFieldOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'component': !exists(json, 'component') ? undefined : json['component'],
        'label': json['label'],
        'name': json['name'],
        'option': !exists(json, 'option') ? undefined : json['option'],
        'width': !exists(json, 'width') ? undefined : json['width'],
    };
}
function CustomFieldOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'component': value.component,
        'label': value.label,
        'name': value.name,
        'option': value.option,
        'width': value.width,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomProductOptionType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var CustomProductOptionType;
(function (CustomProductOptionType) {
    CustomProductOptionType["Quantity"] = "quantity";
    CustomProductOptionType["Question"] = "question";
})(CustomProductOptionType || (CustomProductOptionType = {}));
function CustomProductOptionTypeFromJSON(json) {
    return CustomProductOptionTypeFromJSONTyped(json, false);
}
function CustomProductOptionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CustomProductOptionTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomProductOptionValue.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomProductOptionValueFromJSON(json) {
    return CustomProductOptionValueFromJSONTyped(json, false);
}
function CustomProductOptionValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'label': json['label'],
        'name': json['name'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
    };
}
function CustomProductOptionValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'answer': value.answer,
        'label': value.label,
        'name': value.name,
        'quantity': value.quantity,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomerCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomerCreateRequestFromJSON(json) {
    return CustomerCreateRequestFromJSONTyped(json, false);
}
function CustomerCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
function CustomerCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomerResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function CustomerResponseFromJSON(json) {
    return CustomerResponseFromJSONTyped(json, false);
}
function CustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
        'firstName': json['firstName'],
        'id': json['id'],
        'lastName': json['lastName'],
        'phone': json['phone'],
    };
}
function CustomerResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'firstName': value.firstName,
        'id': value.id,
        'lastName': value.lastName,
        'phone': value.phone,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/CustomerUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function CustomerUpdateRequestFromJSON(json) {
    return CustomerUpdateRequestFromJSONTyped(json, false);
}
function CustomerUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
function CustomerUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DigitalSignageCreateRequestFromJSON(json) {
    return DigitalSignageCreateRequestFromJSONTyped(json, false);
}
function DigitalSignageCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'draftData': !exists(json, 'draftData') ? undefined : json['draftData'],
        'duplicateId': !exists(json, 'duplicateId') ? undefined : json['duplicateId'],
        'height': json['height'],
        'width': json['width'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': json['name'],
    };
}
function DigitalSignageCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'draftData': value.draftData,
        'duplicateId': value.duplicateId,
        'height': value.height,
        'width': value.width,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageFrameCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageFrameCreateRequestFromJSON(json) {
    return DigitalSignageFrameCreateRequestFromJSONTyped(json, false);
}
function DigitalSignageFrameCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'googleSlides': !exists(json, 'googleSlides') ? undefined : GoogleSlidesConfigFromJSON(json['googleSlides']),
        'type': DigitalSignageFrameTypeFromJSON(json['type']),
        'bgImageId': !exists(json, 'bgImageId') ? undefined : json['bgImageId'],
        'layout': LayoutBoxCreateRequestFromJSON(json['layout']),
        'name': json['name'],
        'shopifyCheckoutId': !exists(json, 'shopifyCheckoutId') ? undefined : json['shopifyCheckoutId'],
    };
}
function DigitalSignageFrameCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'googleSlides': GoogleSlidesConfigToJSON(value.googleSlides),
        'type': DigitalSignageFrameTypeToJSON(value.type),
        'bgImageId': value.bgImageId,
        'layout': LayoutBoxCreateRequestToJSON(value.layout),
        'name': value.name,
        'shopifyCheckoutId': value.shopifyCheckoutId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageFrameResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageFrameResponseFromJSON(json) {
    return DigitalSignageFrameResponseFromJSONTyped(json, false);
}
function DigitalSignageFrameResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bgImage': ImageUploadResponseFromJSON(json['bgImage']),
        'googleSlides': !exists(json, 'googleSlides') ? undefined : GoogleSlidesConfigFromJSON(json['googleSlides']),
        'layout': LayoutBoxFromJSON(json['layout']),
        'slides': (json['slides'].map(DigitalSignageSlideResponseFromJSON)),
        'type': DigitalSignageFrameTypeFromJSON(json['type']),
        'bgImageId': json['bgImageId'],
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'name': json['name'],
        'shopifyCheckoutId': !exists(json, 'shopifyCheckoutId') ? undefined : json['shopifyCheckoutId'],
        'signageId': json['signageId'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function DigitalSignageFrameResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bgImage': ImageUploadResponseToJSON(value.bgImage),
        'googleSlides': GoogleSlidesConfigToJSON(value.googleSlides),
        'layout': LayoutBoxToJSON(value.layout),
        'slides': (value.slides.map(DigitalSignageSlideResponseToJSON)),
        'type': DigitalSignageFrameTypeToJSON(value.type),
        'bgImageId': value.bgImageId,
        'createdAt': (value.createdAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'shopifyCheckoutId': value.shopifyCheckoutId,
        'signageId': value.signageId,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageFrameType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var DigitalSignageFrameType;
(function (DigitalSignageFrameType) {
    DigitalSignageFrameType["App"] = "app";
    DigitalSignageFrameType["Widget"] = "widget";
    DigitalSignageFrameType["Slides"] = "slides";
    DigitalSignageFrameType["GoogleSlides"] = "google_slides";
    DigitalSignageFrameType["ShopifyCheckout"] = "shopify_checkout";
})(DigitalSignageFrameType || (DigitalSignageFrameType = {}));
function DigitalSignageFrameTypeFromJSON(json) {
    return DigitalSignageFrameTypeFromJSONTyped(json, false);
}
function DigitalSignageFrameTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DigitalSignageFrameTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageFrameUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageFrameUpdateRequestFromJSON(json) {
    return DigitalSignageFrameUpdateRequestFromJSONTyped(json, false);
}
function DigitalSignageFrameUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'googleSlides': !exists(json, 'googleSlides') ? undefined : GoogleSlidesConfigFromJSON(json['googleSlides']),
        'bgImageId': !exists(json, 'bgImageId') ? undefined : json['bgImageId'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'layout': LayoutBoxCreateRequestFromJSON(json['layout']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'scheduleData': !exists(json, 'scheduleData') ? undefined : json['scheduleData'],
        'shopifyCheckoutId': !exists(json, 'shopifyCheckoutId') ? undefined : json['shopifyCheckoutId'],
    };
}
function DigitalSignageFrameUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'googleSlides': GoogleSlidesConfigToJSON(value.googleSlides),
        'bgImageId': value.bgImageId,
        'duration': value.duration,
        'layout': LayoutBoxCreateRequestToJSON(value.layout),
        'name': value.name,
        'scheduleData': value.scheduleData,
        'shopifyCheckoutId': value.shopifyCheckoutId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageLayerLink.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageLayerLinkFromJSON(json) {
    return DigitalSignageLayerLinkFromJSONTyped(json, false);
}
function DigitalSignageLayerLinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appName': !exists(json, 'appName') ? undefined : json['appName'],
        'instanceId': !exists(json, 'instanceId') ? undefined : json['instanceId'],
        'target': DigitalSignageLayerLinkTargetFromJSON(json['target']),
        'type': DigitalSignageLayerLinkTypeFromJSON(json['type']),
    };
}
function DigitalSignageLayerLinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'appName': value.appName,
        'instanceId': value.instanceId,
        'target': DigitalSignageLayerLinkTargetToJSON(value.target),
        'type': DigitalSignageLayerLinkTypeToJSON(value.type),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageLayerLinkTarget.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var DigitalSignageLayerLinkTarget;
(function (DigitalSignageLayerLinkTarget) {
    DigitalSignageLayerLinkTarget["Full"] = "full";
    DigitalSignageLayerLinkTarget["Popup"] = "popup";
})(DigitalSignageLayerLinkTarget || (DigitalSignageLayerLinkTarget = {}));
function DigitalSignageLayerLinkTargetFromJSON(json) {
    return DigitalSignageLayerLinkTargetFromJSONTyped(json, false);
}
function DigitalSignageLayerLinkTargetFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DigitalSignageLayerLinkTargetToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageLayerLinkType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var DigitalSignageLayerLinkType;
(function (DigitalSignageLayerLinkType) {
    DigitalSignageLayerLinkType["None"] = "none";
    DigitalSignageLayerLinkType["Activation"] = "activation";
    DigitalSignageLayerLinkType["Slide"] = "slide";
})(DigitalSignageLayerLinkType || (DigitalSignageLayerLinkType = {}));
function DigitalSignageLayerLinkTypeFromJSON(json) {
    return DigitalSignageLayerLinkTypeFromJSONTyped(json, false);
}
function DigitalSignageLayerLinkTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DigitalSignageLayerLinkTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DigitalSignageResponseFromJSON(json) {
    return DigitalSignageResponseFromJSONTyped(json, false);
}
function DigitalSignageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'draftData': json['draftData'],
        'frames': (json['frames'].map(DigitalSignageFrameResponseFromJSON)),
        'height': json['height'],
        'width': json['width'],
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function DigitalSignageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'draftData': value.draftData,
        'frames': (value.frames.map(DigitalSignageFrameResponseToJSON)),
        'height': value.height,
        'width': value.width,
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageSlideCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageSlideCreateRequestFromJSON(json) {
    return DigitalSignageSlideCreateRequestFromJSONTyped(json, false);
}
function DigitalSignageSlideCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'layers': !exists(json, 'layers') ? undefined : (json['layers'].map(DigitalSignageSlideLayerRequestFromJSON)),
        'schedule': !exists(json, 'schedule') ? undefined : WeeklyScheduleFromJSON(json['schedule']),
        'bgImageId': !exists(json, 'bgImageId') ? undefined : json['bgImageId'],
        'duration': json['duration'],
        'frameId': !exists(json, 'frameId') ? undefined : json['frameId'],
        'name': json['name'],
    };
}
function DigitalSignageSlideCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'layers': value.layers === undefined ? undefined : (value.layers.map(DigitalSignageSlideLayerRequestToJSON)),
        'schedule': WeeklyScheduleToJSON(value.schedule),
        'bgImageId': value.bgImageId,
        'duration': value.duration,
        'frameId': value.frameId,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageSlideLayerModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageSlideLayerModelFromJSON(json) {
    return DigitalSignageSlideLayerModelFromJSONTyped(json, false);
}
function DigitalSignageSlideLayerModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'color': json['color'],
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'fontSize': json['fontSize'],
        'hAlign': json['hAlign'],
        'id': json['id'],
        'iframeCustomCss': !exists(json, 'iframeCustomCss') ? undefined : json['iframeCustomCss'],
        'iframeCustomJs': !exists(json, 'iframeCustomJs') ? undefined : json['iframeCustomJs'],
        'iframeUrl': !exists(json, 'iframeUrl') ? undefined : json['iframeUrl'],
        'image': ImageUploadFromJSON(json['image']),
        'imageId': json['imageId'],
        'layout': LayoutBoxFromJSON(json['layout']),
        'link': DigitalSignageLayerLinkFromJSON(json['link']),
        'styles': json['styles'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'type': DigitalSignageSlideLayerTypeFromJSON(json['type']),
        'updatedAt': (new Date(json['updatedAt'])),
        'vAlign': json['vAlign'],
        'video': json['video'],
        'videoId': json['videoId'],
    };
}
function DigitalSignageSlideLayerModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'color': value.color,
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'fontSize': value.fontSize,
        'hAlign': value.hAlign,
        'id': value.id,
        'iframeCustomCss': value.iframeCustomCss,
        'iframeCustomJs': value.iframeCustomJs,
        'iframeUrl': value.iframeUrl,
        'image': ImageUploadToJSON(value.image),
        'imageId': value.imageId,
        'layout': LayoutBoxToJSON(value.layout),
        'link': DigitalSignageLayerLinkToJSON(value.link),
        'styles': value.styles,
        'text': value.text,
        'type': DigitalSignageSlideLayerTypeToJSON(value.type),
        'updatedAt': (value.updatedAt.toISOString()),
        'vAlign': value.vAlign,
        'video': value.video,
        'videoId': value.videoId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageSlideLayerRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageSlideLayerRequestFromJSON(json) {
    return DigitalSignageSlideLayerRequestFromJSONTyped(json, false);
}
function DigitalSignageSlideLayerRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'layout': LayoutBoxFromJSON(json['layout']),
        'link': !exists(json, 'link') ? undefined : DigitalSignageLayerLinkFromJSON(json['link']),
        'type': DigitalSignageSlideLayerTypeFromJSON(json['type']),
        'color': json['color'],
        'fontSize': json['fontSize'],
        'hAlign': json['hAlign'],
        'iframeCustomCss': !exists(json, 'iframeCustomCss') ? undefined : json['iframeCustomCss'],
        'iframeCustomJs': !exists(json, 'iframeCustomJs') ? undefined : json['iframeCustomJs'],
        'iframeUrl': !exists(json, 'iframeUrl') ? undefined : json['iframeUrl'],
        'imageId': json['imageId'],
        'styles': json['styles'],
        'text': json['text'],
        'vAlign': json['vAlign'],
        'videoId': json['videoId'],
    };
}
function DigitalSignageSlideLayerRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'layout': LayoutBoxToJSON(value.layout),
        'link': DigitalSignageLayerLinkToJSON(value.link),
        'type': DigitalSignageSlideLayerTypeToJSON(value.type),
        'color': value.color,
        'fontSize': value.fontSize,
        'hAlign': value.hAlign,
        'iframeCustomCss': value.iframeCustomCss,
        'iframeCustomJs': value.iframeCustomJs,
        'iframeUrl': value.iframeUrl,
        'imageId': value.imageId,
        'styles': value.styles,
        'text': value.text,
        'vAlign': value.vAlign,
        'videoId': value.videoId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageSlideLayerType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var DigitalSignageSlideLayerType;
(function (DigitalSignageSlideLayerType) {
    DigitalSignageSlideLayerType["Text"] = "text";
    DigitalSignageSlideLayerType["Video"] = "video";
    DigitalSignageSlideLayerType["Iframe"] = "iframe";
    DigitalSignageSlideLayerType["Image"] = "image";
    DigitalSignageSlideLayerType["Button"] = "button";
})(DigitalSignageSlideLayerType || (DigitalSignageSlideLayerType = {}));
function DigitalSignageSlideLayerTypeFromJSON(json) {
    return DigitalSignageSlideLayerTypeFromJSONTyped(json, false);
}
function DigitalSignageSlideLayerTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DigitalSignageSlideLayerTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageSlideResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DigitalSignageSlideResponseFromJSON(json) {
    return DigitalSignageSlideResponseFromJSONTyped(json, false);
}
function DigitalSignageSlideResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bgImage': ImageUploadResponseFromJSON(json['bgImage']),
        'layers': (json['layers'].map(DigitalSignageSlideLayerModelFromJSON)),
        'schedule': WeeklyScheduleFromJSON(json['schedule']),
        'bgImageId': json['bgImageId'],
        'createdAt': (new Date(json['createdAt'])),
        'duration': json['duration'],
        'enabled': json['enabled'],
        'frameId': json['frameId'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function DigitalSignageSlideResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bgImage': ImageUploadResponseToJSON(value.bgImage),
        'layers': (value.layers.map(DigitalSignageSlideLayerModelToJSON)),
        'schedule': WeeklyScheduleToJSON(value.schedule),
        'bgImageId': value.bgImageId,
        'createdAt': (value.createdAt.toISOString()),
        'duration': value.duration,
        'enabled': value.enabled,
        'frameId': value.frameId,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageSlideUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function DigitalSignageSlideUpdateRequestFromJSON(json) {
    return DigitalSignageSlideUpdateRequestFromJSONTyped(json, false);
}
function DigitalSignageSlideUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'layers': !exists(json, 'layers') ? undefined : (json['layers'].map(DigitalSignageSlideLayerRequestFromJSON)),
        'schedule': !exists(json, 'schedule') ? undefined : WeeklyScheduleFromJSON(json['schedule']),
        'bgImageId': !exists(json, 'bgImageId') ? undefined : json['bgImageId'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function DigitalSignageSlideUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'layers': value.layers === undefined ? undefined : (value.layers.map(DigitalSignageSlideLayerRequestToJSON)),
        'schedule': WeeklyScheduleToJSON(value.schedule),
        'bgImageId': value.bgImageId,
        'duration': value.duration,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DigitalSignageUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DigitalSignageUpdateRequestFromJSON(json) {
    return DigitalSignageUpdateRequestFromJSONTyped(json, false);
}
function DigitalSignageUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'draftData': !exists(json, 'draftData') ? undefined : json['draftData'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function DigitalSignageUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'draftData': value.draftData,
        'height': value.height,
        'width': value.width,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Directory.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
* @export
* @enum {string}
*/
var DirectoryAppEnum;
(function (DirectoryAppEnum) {
    DirectoryAppEnum["MediaCollection"] = "media_collection";
    DirectoryAppEnum["DigitalSignage"] = "digital_signage";
    DirectoryAppEnum["Directory"] = "directory";
    DirectoryAppEnum["SelfCheckout"] = "self_checkout";
    DirectoryAppEnum["Photobooth"] = "photobooth";
    DirectoryAppEnum["SpinToWin"] = "spin_to_win";
    DirectoryAppEnum["ShopifyCheckout"] = "shopify_checkout";
    DirectoryAppEnum["CustomApp"] = "custom_app";
})(DirectoryAppEnum || (DirectoryAppEnum = {}));
function DirectoryFromJSON(json) {
    return DirectoryFromJSONTyped(json, false);
}
function DirectoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'enabled': json['enabled'],
        'app': json['app'],
        'floors': (json['floors'].map(DirectoryFloorFromJSON)),
        'footerHtml': json['footerHtml'],
        'headerHtml': json['headerHtml'],
        'headerImage': ImageUploadFromJSON(json['headerImage']),
        'listings': (json['listings'].map(DirectoryListingFromJSON)),
        'tickerData': json['tickerData'],
    };
}
function DirectoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
        'enabled': value.enabled,
        'app': value.app,
        'floors': (value.floors.map(DirectoryFloorToJSON)),
        'footerHtml': value.footerHtml,
        'headerHtml': value.headerHtml,
        'headerImage': ImageUploadToJSON(value.headerImage),
        'listings': (value.listings.map(DirectoryListingToJSON)),
        'tickerData': value.tickerData,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryCreateRequestFromJSON(json) {
    return DirectoryCreateRequestFromJSONTyped(json, false);
}
function DirectoryCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'footerHtml': !exists(json, 'footerHtml') ? undefined : json['footerHtml'],
        'headerHtml': !exists(json, 'headerHtml') ? undefined : json['headerHtml'],
        'name': json['name'],
    };
}
function DirectoryCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'footerHtml': value.footerHtml,
        'headerHtml': value.headerHtml,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryFloor.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryFloorFromJSON(json) {
    return DirectoryFloorFromJSONTyped(json, false);
}
function DirectoryFloorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'listingIds': json['listingIds'],
        'mapImage': ImageUploadFromJSON(json['mapImage']),
        'name': json['name'],
        'number': json['number'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function DirectoryFloorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'id': value.id,
        'listingIds': value.listingIds,
        'mapImage': ImageUploadToJSON(value.mapImage),
        'name': value.name,
        'number': value.number,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryFloorCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryFloorCreateRequestFromJSON(json) {
    return DirectoryFloorCreateRequestFromJSONTyped(json, false);
}
function DirectoryFloorCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'directoryId': json['directoryId'],
        'mapImageId': !exists(json, 'mapImageId') ? undefined : json['mapImageId'],
        'name': json['name'],
        'number': json['number'],
    };
}
function DirectoryFloorCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'directoryId': value.directoryId,
        'mapImageId': value.mapImageId,
        'name': value.name,
        'number': value.number,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryFloorUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryFloorUpdateRequestFromJSON(json) {
    return DirectoryFloorUpdateRequestFromJSONTyped(json, false);
}
function DirectoryFloorUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mapImageId': !exists(json, 'mapImageId') ? undefined : json['mapImageId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'number': !exists(json, 'number') ? undefined : json['number'],
    };
}
function DirectoryFloorUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mapImageId': value.mapImageId,
        'name': value.name,
        'number': value.number,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryListing.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryListingFromJSON(json) {
    return DirectoryListingFromJSONTyped(json, false);
}
function DirectoryListingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bannerImage': ImageUploadFromJSON(json['bannerImage']),
        'createdAt': (new Date(json['createdAt'])),
        'descriptionHtml': json['descriptionHtml'],
        'directory': DirectoryFromJSON(json['directory']),
        'directoryId': json['directoryId'],
        'floor': DirectoryFloorFromJSON(json['floor']),
        'floorId': json['floorId'],
        'floorX': json['floorX'],
        'floorY': json['floorY'],
        'id': json['id'],
        'logoImage': ImageUploadFromJSON(json['logoImage']),
        'subtitle': json['subtitle'],
        'title': json['title'],
        'unit': json['unit'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function DirectoryListingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bannerImage': ImageUploadToJSON(value.bannerImage),
        'createdAt': (value.createdAt.toISOString()),
        'descriptionHtml': value.descriptionHtml,
        'directory': DirectoryToJSON(value.directory),
        'directoryId': value.directoryId,
        'floor': DirectoryFloorToJSON(value.floor),
        'floorId': value.floorId,
        'floorX': value.floorX,
        'floorY': value.floorY,
        'id': value.id,
        'logoImage': ImageUploadToJSON(value.logoImage),
        'subtitle': value.subtitle,
        'title': value.title,
        'unit': value.unit,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryListingCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryListingCreateRequestFromJSON(json) {
    return DirectoryListingCreateRequestFromJSONTyped(json, false);
}
function DirectoryListingCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bannerImageId': !exists(json, 'bannerImageId') ? undefined : json['bannerImageId'],
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'directoryId': json['directoryId'],
        'floorId': json['floorId'],
        'floorX': !exists(json, 'floorX') ? undefined : json['floorX'],
        'floorY': !exists(json, 'floorY') ? undefined : json['floorY'],
        'logoImageId': !exists(json, 'logoImageId') ? undefined : json['logoImageId'],
        'subtitle': !exists(json, 'subtitle') ? undefined : json['subtitle'],
        'title': json['title'],
        'unit': json['unit'],
    };
}
function DirectoryListingCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bannerImageId': value.bannerImageId,
        'descriptionHtml': value.descriptionHtml,
        'directoryId': value.directoryId,
        'floorId': value.floorId,
        'floorX': value.floorX,
        'floorY': value.floorY,
        'logoImageId': value.logoImageId,
        'subtitle': value.subtitle,
        'title': value.title,
        'unit': value.unit,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryListingUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryListingUpdateRequestFromJSON(json) {
    return DirectoryListingUpdateRequestFromJSONTyped(json, false);
}
function DirectoryListingUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bannerImageId': !exists(json, 'bannerImageId') ? undefined : json['bannerImageId'],
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'floorId': !exists(json, 'floorId') ? undefined : json['floorId'],
        'floorX': !exists(json, 'floorX') ? undefined : json['floorX'],
        'floorY': !exists(json, 'floorY') ? undefined : json['floorY'],
        'logoImageId': !exists(json, 'logoImageId') ? undefined : json['logoImageId'],
        'subtitle': !exists(json, 'subtitle') ? undefined : json['subtitle'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
    };
}
function DirectoryListingUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bannerImageId': value.bannerImageId,
        'descriptionHtml': value.descriptionHtml,
        'floorId': value.floorId,
        'floorX': value.floorX,
        'floorY': value.floorY,
        'logoImageId': value.logoImageId,
        'subtitle': value.subtitle,
        'title': value.title,
        'unit': value.unit,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/DirectoryUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function DirectoryUpdateRequestFromJSON(json) {
    return DirectoryUpdateRequestFromJSONTyped(json, false);
}
function DirectoryUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'footerHtml': !exists(json, 'footerHtml') ? undefined : json['footerHtml'],
        'headerHtml': !exists(json, 'headerHtml') ? undefined : json['headerHtml'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function DirectoryUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'footerHtml': value.footerHtml,
        'headerHtml': value.headerHtml,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/EsuiteApp.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EsuiteApp;
(function (EsuiteApp) {
    EsuiteApp["MediaCollection"] = "media_collection";
    EsuiteApp["DigitalSignage"] = "digital_signage";
    EsuiteApp["Directory"] = "directory";
    EsuiteApp["SelfCheckout"] = "self_checkout";
    EsuiteApp["Photobooth"] = "photobooth";
    EsuiteApp["SpinToWin"] = "spin_to_win";
    EsuiteApp["ShopifyCheckout"] = "shopify_checkout";
    EsuiteApp["CustomApp"] = "custom_app";
})(EsuiteApp || (EsuiteApp = {}));
function EsuiteAppFromJSON(json) {
    return EsuiteAppFromJSONTyped(json, false);
}
function EsuiteAppFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function EsuiteAppToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/EsuiteAppPluginMessage.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function EsuiteAppPluginMessageFromJSON(json) {
    return EsuiteAppPluginMessageFromJSONTyped(json, false);
}
function EsuiteAppPluginMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'data': json['data'],
    };
}
function EsuiteAppPluginMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'id': value.id,
        'data': value.data,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/EsuiteAppResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function EsuiteAppResponseFromJSON(json) {
    return EsuiteAppResponseFromJSONTyped(json, false);
}
function EsuiteAppResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': EsuiteAppFromJSON(json['name']),
        'createdAt': (new Date(json['createdAt'])),
        'title': json['title'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function EsuiteAppResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': EsuiteAppToJSON(value.name),
        'createdAt': (value.createdAt.toISOString()),
        'title': value.title,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FieldOption.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var FieldOption;
(function (FieldOption) {
    FieldOption["Hide"] = "hide";
    FieldOption["Show"] = "show";
    FieldOption["Required"] = "required";
})(FieldOption || (FieldOption = {}));
function FieldOptionFromJSON(json) {
    return FieldOptionFromJSONTyped(json, false);
}
function FieldOptionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function FieldOptionToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function FundCreateRequestFromJSON(json) {
    return FundCreateRequestFromJSONTyped(json, false);
}
function FundCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : ProductStatusFromJSON(json['status']),
        'agreementIds': !exists(json, 'agreementIds') ? undefined : json['agreementIds'],
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'notices': !exists(json, 'notices') ? undefined : json['notices'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'taskIds': !exists(json, 'taskIds') ? undefined : json['taskIds'],
        'taxable': !exists(json, 'taxable') ? undefined : json['taxable'],
        'title': json['title'],
    };
}
function FundCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': ProductStatusToJSON(value.status),
        'agreementIds': value.agreementIds,
        'descriptionHtml': value.descriptionHtml,
        'imageId': value.imageId,
        'notices': value.notices,
        'tags': value.tags,
        'taskIds': value.taskIds,
        'taxable': value.taxable,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundLineItemOption.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function FundLineItemOptionFromJSON(json) {
    return FundLineItemOptionFromJSONTyped(json, false);
}
function FundLineItemOptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customAmount': !exists(json, 'customAmount') ? undefined : json['customAmount'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}
function FundLineItemOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customAmount': value.customAmount,
        'id': value.id,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundOptionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function FundOptionCreateRequestFromJSON(json) {
    return FundOptionCreateRequestFromJSONTyped(json, false);
}
function FundOptionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'name': json['name'],
        'notificationId': !exists(json, 'notificationId') ? undefined : json['notificationId'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}
function FundOptionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'descriptionHtml': value.descriptionHtml,
        'name': value.name,
        'notificationId': value.notificationId,
        'price': value.price,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundOptionResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function FundOptionResponseFromJSON(json) {
    return FundOptionResponseFromJSONTyped(json, false);
}
function FundOptionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'descriptionHtml': json['descriptionHtml'],
        'id': json['id'],
        'name': json['name'],
        'price': json['price'],
        'sort': json['sort'],
    };
}
function FundOptionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'descriptionHtml': value.descriptionHtml,
        'id': value.id,
        'name': value.name,
        'price': value.price,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundOptionUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function FundOptionUpdateRequestFromJSON(json) {
    return FundOptionUpdateRequestFromJSONTyped(json, false);
}
function FundOptionUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notificationId': !exists(json, 'notificationId') ? undefined : json['notificationId'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}
function FundOptionUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'descriptionHtml': value.descriptionHtml,
        'name': value.name,
        'notificationId': value.notificationId,
        'price': value.price,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function FundResponseFromJSON(json) {
    return FundResponseFromJSONTyped(json, false);
}
function FundResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': ProductStatusFromJSON(json['status']),
        'agreementIds': json['agreementIds'],
        'categories': (json['categories'].map(ProductCategoryResponseFromJSON)),
        'enableCustomPrice': json['enableCustomPrice'],
        'options': (json['options'].map(FundOptionResponseFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'descriptionHtml': json['descriptionHtml'],
        'handle': json['handle'],
        'id': json['id'],
        'image': ImageUploadResponseFromJSON(json['image']),
        'images': (json['images'].map(ImageUploadResponseFromJSON)),
        'notices': json['notices'],
        'tags': json['tags'],
        'taxable': json['taxable'],
        'title': json['title'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function FundResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': ProductStatusToJSON(value.status),
        'agreementIds': value.agreementIds,
        'categories': (value.categories.map(ProductCategoryResponseToJSON)),
        'enableCustomPrice': value.enableCustomPrice,
        'options': (value.options.map(FundOptionResponseToJSON)),
        'createdAt': (value.createdAt.toISOString()),
        'descriptionHtml': value.descriptionHtml,
        'handle': value.handle,
        'id': value.id,
        'image': ImageUploadResponseToJSON(value.image),
        'images': (value.images.map(ImageUploadResponseToJSON)),
        'notices': value.notices,
        'tags': value.tags,
        'taxable': value.taxable,
        'title': value.title,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/FundUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function FundUpdateRequestFromJSON(json) {
    return FundUpdateRequestFromJSONTyped(json, false);
}
function FundUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sortOptionsById': !exists(json, 'sortOptionsById') ? undefined : json['sortOptionsById'],
        'status': !exists(json, 'status') ? undefined : ProductStatusFromJSON(json['status']),
        'agreementIds': !exists(json, 'agreementIds') ? undefined : json['agreementIds'],
        'descriptionHtml': !exists(json, 'descriptionHtml') ? undefined : json['descriptionHtml'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'notices': !exists(json, 'notices') ? undefined : json['notices'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'taxable': !exists(json, 'taxable') ? undefined : json['taxable'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}
function FundUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sortOptionsById': value.sortOptionsById,
        'status': ProductStatusToJSON(value.status),
        'agreementIds': value.agreementIds,
        'descriptionHtml': value.descriptionHtml,
        'imageId': value.imageId,
        'notices': value.notices,
        'tags': value.tags,
        'taskId': value.taskId,
        'taxable': value.taxable,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/GetProductDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function GetProductDtoFromJSON(json) {
    return GetProductDtoFromJSONTyped(json, false);
}
function GetProductDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productIds': json['productIds'],
    };
}
function GetProductDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productIds': value.productIds,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/GoogleSlidesConfig.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function GoogleSlidesConfigFromJSON(json) {
    return GoogleSlidesConfigFromJSONTyped(json, false);
}
function GoogleSlidesConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'delay': json['delay'],
        'id': json['id'],
    };
}
function GoogleSlidesConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'delay': value.delay,
        'id': value.id,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ImageUpload.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ImageUploadFromJSON(json) {
    return ImageUploadFromJSONTyped(json, false);
}
function ImageUploadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'upload': json['upload'],
        'url': json['url'],
        'height': json['height'],
        'original': ImageUploadFromJSON(json['original']),
        'thumbnail': ImageUploadFromJSON(json['thumbnail']),
        'width': json['width'],
    };
}
function ImageUploadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
        'upload': value.upload,
        'url': value.url,
        'height': value.height,
        'original': ImageUploadToJSON(value.original),
        'thumbnail': ImageUploadToJSON(value.thumbnail),
        'width': value.width,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ImageUploadCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ImageUploadCreateRequestFromJSON(json) {
    return ImageUploadCreateRequestFromJSONTyped(json, false);
}
function ImageUploadCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadId': json['uploadId'],
    };
}
function ImageUploadCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadId': value.uploadId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ImageUploadResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ImageUploadResponseFromJSON(json) {
    return ImageUploadResponseFromJSONTyped(json, false);
}
function ImageUploadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'height': json['height'],
        'id': json['id'],
        'thumbnail': ImageUploadResponseFromJSON(json['thumbnail']),
        'updatedAt': (new Date(json['updatedAt'])),
        'url': json['url'],
        'width': json['width'],
    };
}
function ImageUploadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ImageUploadUploadRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ImageUploadUploadRequestFromJSON(json) {
    return ImageUploadUploadRequestFromJSONTyped(json, false);
}
function ImageUploadUploadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function ImageUploadUploadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function KioskCreateRequestFromJSON(json) {
    return KioskCreateRequestFromJSONTyped(json, false);
}
function KioskCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mode': !exists(json, 'mode') ? undefined : ActivationModeFromJSON(json['mode']),
        'activationId': !exists(json, 'activationId') ? undefined : json['activationId'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'name': json['name'],
        'password': json['password'],
        'platformId': !exists(json, 'platformId') ? undefined : json['platformId'],
        'printerName': !exists(json, 'printerName') ? undefined : json['printerName'],
        'resetTimeout': !exists(json, 'resetTimeout') ? undefined : json['resetTimeout'],
        'username': json['username'],
    };
}
function KioskCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mode': ActivationModeToJSON(value.mode),
        'activationId': value.activationId,
        'groupId': value.groupId,
        'name': value.name,
        'password': value.password,
        'platformId': value.platformId,
        'printerName': value.printerName,
        'resetTimeout': value.resetTimeout,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskMessage.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function KioskMessageFromJSON(json) {
    return KioskMessageFromJSONTyped(json, false);
}
function KioskMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kioskId': !exists(json, 'kioskId') ? undefined : json['kioskId'],
        'target': json['target'],
        'type': json['type'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}
function KioskMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'kioskId': value.kioskId,
        'target': value.target,
        'type': value.type,
        'data': value.data,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskNotificationResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function KioskNotificationResponseFromJSON(json) {
    return KioskNotificationResponseFromJSONTyped(json, false);
}
function KioskNotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network': json['network'],
    };
}
function KioskNotificationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network': value.network,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskNotificationUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function KioskNotificationUpdateRequestFromJSON(json) {
    return KioskNotificationUpdateRequestFromJSONTyped(json, false);
}
function KioskNotificationUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network': json['network'],
    };
}
function KioskNotificationUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network': value.network,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskRemoteCommand.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var KioskRemoteCommand;
(function (KioskRemoteCommand) {
    KioskRemoteCommand["Reload"] = "reload";
    KioskRemoteCommand["Platform"] = "platform";
    KioskRemoteCommand["EsuiteApp"] = "esuite_app";
})(KioskRemoteCommand || (KioskRemoteCommand = {}));
function KioskRemoteCommandFromJSON(json) {
    return KioskRemoteCommandFromJSONTyped(json, false);
}
function KioskRemoteCommandFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function KioskRemoteCommandToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskRemoteCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function KioskRemoteCreateRequestFromJSON(json) {
    return KioskRemoteCreateRequestFromJSONTyped(json, false);
}
function KioskRemoteCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': KioskRemoteCommandFromJSON(json['name']),
        'data': json['data'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}
function KioskRemoteCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': KioskRemoteCommandToJSON(value.name),
        'data': value.data,
        'id': value.id,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskRemoteListRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function KioskRemoteListRequestFromJSON(json) {
    return KioskRemoteListRequestFromJSONTyped(json, false);
}
function KioskRemoteListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}
function KioskRemoteListRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function KioskResponseFromJSON(json) {
    return KioskResponseFromJSONTyped(json, false);
}
function KioskResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mode': ActivationModeFromJSON(json['mode']),
        'activationId': !exists(json, 'activationId') ? undefined : json['activationId'],
        'bgImage': !exists(json, 'bgImage') ? undefined : ImageUploadResponseFromJSON(json['bgImage']),
        'bgImageId': !exists(json, 'bgImageId') ? undefined : json['bgImageId'],
        'createdAt': (new Date(json['createdAt'])),
        'groupId': json['groupId'],
        'id': json['id'],
        'lastScreenshot': json['lastScreenshot'],
        'lastState': PlatformStateFromJSON(json['lastState']),
        'name': json['name'],
        'notifications': KioskNotificationResponseFromJSON(json['notifications']),
        'offline': (new Date(json['offline'])),
        'paymentTerminal': !exists(json, 'paymentTerminal') ? undefined : PaymentTerminalResponseFromJSON(json['paymentTerminal']),
        'printerName': !exists(json, 'printerName') ? undefined : json['printerName'],
        'secret': json['secret'],
        'updatedAt': (new Date(json['updatedAt'])),
        'username': json['username'],
    };
}
function KioskResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mode': ActivationModeToJSON(value.mode),
        'activationId': value.activationId,
        'bgImage': ImageUploadResponseToJSON(value.bgImage),
        'bgImageId': value.bgImageId,
        'createdAt': (value.createdAt.toISOString()),
        'groupId': value.groupId,
        'id': value.id,
        'lastScreenshot': value.lastScreenshot,
        'lastState': PlatformStateToJSON(value.lastState),
        'name': value.name,
        'notifications': KioskNotificationResponseToJSON(value.notifications),
        'offline': (value.offline.toISOString()),
        'paymentTerminal': PaymentTerminalResponseToJSON(value.paymentTerminal),
        'printerName': value.printerName,
        'secret': value.secret,
        'updatedAt': (value.updatedAt.toISOString()),
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskScreenshot.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function KioskScreenshotFromJSON(json) {
    return KioskScreenshotFromJSONTyped(json, false);
}
function KioskScreenshotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'imageData': json['imageData'],
    };
}
function KioskScreenshotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'imageData': value.imageData,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/KioskUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function KioskUpdateRequestFromJSON(json) {
    return KioskUpdateRequestFromJSONTyped(json, false);
}
function KioskUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mode': !exists(json, 'mode') ? undefined : ActivationModeFromJSON(json['mode']),
        'activationId': !exists(json, 'activationId') ? undefined : json['activationId'],
        'bgImageId': !exists(json, 'bgImageId') ? undefined : json['bgImageId'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notifications': KioskNotificationUpdateRequestFromJSON(json['notifications']),
        'password': !exists(json, 'password') ? undefined : json['password'],
        'paymentTerminalId': !exists(json, 'paymentTerminalId') ? undefined : json['paymentTerminalId'],
        'platformId': !exists(json, 'platformId') ? undefined : json['platformId'],
        'printerName': !exists(json, 'printerName') ? undefined : json['printerName'],
        'resetTimeout': !exists(json, 'resetTimeout') ? undefined : json['resetTimeout'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}
function KioskUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mode': ActivationModeToJSON(value.mode),
        'activationId': value.activationId,
        'bgImageId': value.bgImageId,
        'groupId': value.groupId,
        'name': value.name,
        'notifications': KioskNotificationUpdateRequestToJSON(value.notifications),
        'password': value.password,
        'paymentTerminalId': value.paymentTerminalId,
        'platformId': value.platformId,
        'printerName': value.printerName,
        'resetTimeout': value.resetTimeout,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/LayoutBox.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function LayoutBoxFromJSON(json) {
    return LayoutBoxFromJSONTyped(json, false);
}
function LayoutBoxFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'top': json['top'],
        'left': json['left'],
        'transformX': json['transformX'],
        'transformY': json['transformY'],
        'width': json['width'],
        'height': json['height'],
        'bgColor': json['bgColor'],
        'widthPx': json['widthPx'],
        'heightPx': json['heightPx'],
    };
}
function LayoutBoxToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'top': value.top,
        'left': value.left,
        'transformX': value.transformX,
        'transformY': value.transformY,
        'width': value.width,
        'height': value.height,
        'bgColor': value.bgColor,
        'widthPx': value.widthPx,
        'heightPx': value.heightPx,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/LayoutBoxCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function LayoutBoxCreateRequestFromJSON(json) {
    return LayoutBoxCreateRequestFromJSONTyped(json, false);
}
function LayoutBoxCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bgColor': !exists(json, 'bgColor') ? undefined : json['bgColor'],
        'height': json['height'],
        'heightPx': json['heightPx'],
        'left': !exists(json, 'left') ? undefined : json['left'],
        'top': !exists(json, 'top') ? undefined : json['top'],
        'transformX': !exists(json, 'transformX') ? undefined : json['transformX'],
        'transformY': !exists(json, 'transformY') ? undefined : json['transformY'],
        'width': json['width'],
        'widthPx': json['widthPx'],
    };
}
function LayoutBoxCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bgColor': value.bgColor,
        'height': value.height,
        'heightPx': value.heightPx,
        'left': value.left,
        'top': value.top,
        'transformX': value.transformX,
        'transformY': value.transformY,
        'width': value.width,
        'widthPx': value.widthPx,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionAccessCodeCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MediaCollectionAccessCodeCreateRequestFromJSON(json) {
    return MediaCollectionAccessCodeCreateRequestFromJSONTyped(json, false);
}
function MediaCollectionAccessCodeCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionId': json['collectionId'],
    };
}
function MediaCollectionAccessCodeCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'collectionId': value.collectionId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionAccessCodeResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionAccessCodeResponseFromJSON(json) {
    return MediaCollectionAccessCodeResponseFromJSONTyped(json, false);
}
function MediaCollectionAccessCodeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessCode': AccessCodeResponseFromJSON(json['accessCode']),
        'id': json['id'],
    };
}
function MediaCollectionAccessCodeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionAlbumCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MediaCollectionAlbumCreateRequestFromJSON(json) {
    return MediaCollectionAlbumCreateRequestFromJSONTyped(json, false);
}
function MediaCollectionAlbumCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionId': json['collectionId'],
        'name': json['name'],
        'type': json['type'],
    };
}
function MediaCollectionAlbumCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'collectionId': value.collectionId,
        'name': value.name,
        'type': value.type,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionAlbumResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MediaCollectionAlbumResponseFromJSON(json) {
    return MediaCollectionAlbumResponseFromJSONTyped(json, false);
}
function MediaCollectionAlbumResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionId': json['collectionId'],
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function MediaCollectionAlbumResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function MediaCollectionCreateRequestFromJSON(json) {
    return MediaCollectionCreateRequestFromJSONTyped(json, false);
}
function MediaCollectionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'syncRecord': !exists(json, 'syncRecord') ? undefined : MediaCollectionSyncRecordFromJSON(json['syncRecord']),
        'handle': !exists(json, 'handle') ? undefined : json['handle'],
        'name': json['name'],
    };
}
function MediaCollectionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'syncRecord': MediaCollectionSyncRecordToJSON(value.syncRecord),
        'handle': value.handle,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionData.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionDataFromJSON(json) {
    return MediaCollectionDataFromJSONTyped(json, false);
}
function MediaCollectionDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'files': (json['files'].map(MediaCollectionFileFromJSON)),
    };
}
function MediaCollectionDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'files': (value.files.map(MediaCollectionFileToJSON)),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionFile.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionFileFromJSON(json) {
    return MediaCollectionFileFromJSONTyped(json, false);
}
function MediaCollectionFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'path': json['path'],
        'tags': (json['tags'].map(MediaCollectionPhotoTagFromJSON)),
        'thumbnail': json['thumbnail'],
        'type': json['type'],
        'url': json['url'],
    };
}
function MediaCollectionFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'path': value.path,
        'tags': (value.tags.map(MediaCollectionPhotoTagToJSON)),
        'thumbnail': value.thumbnail,
        'type': value.type,
        'url': value.url,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionItemCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MediaCollectionItemCreateRequestFromJSON(json) {
    return MediaCollectionItemCreateRequestFromJSONTyped(json, false);
}
function MediaCollectionItemCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadId': json['uploadId'],
        'albumId': json['albumId'],
        'type': json['type'],
    };
}
function MediaCollectionItemCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadId': value.uploadId,
        'albumId': value.albumId,
        'type': value.type,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionItemResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionItemResponseFromJSON(json) {
    return MediaCollectionItemResponseFromJSONTyped(json, false);
}
function MediaCollectionItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'albumId': json['albumId'],
        'caption': json['caption'],
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'imageTags': json['imageTags'],
        'tags': json['tags'],
        'type': json['type'],
        'updatedAd': (new Date(json['updatedAd'])),
        'upload': StorageUploadResponseFromJSON(json['upload']),
    };
}
function MediaCollectionItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionPhotoTag.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MediaCollectionPhotoTagFromJSON(json) {
    return MediaCollectionPhotoTagFromJSONTyped(json, false);
}
function MediaCollectionPhotoTagFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tag': json['tag'],
        'x': json['x'],
        'y': json['y'],
    };
}
function MediaCollectionPhotoTagToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tag': value.tag,
        'x': value.x,
        'y': value.y,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionPhotoTagDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionPhotoTagDtoFromJSON(json) {
    return MediaCollectionPhotoTagDtoFromJSONTyped(json, false);
}
function MediaCollectionPhotoTagDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'path': json['path'],
        'tag': json['tag'],
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
    };
}
function MediaCollectionPhotoTagDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'path': value.path,
        'tag': value.tag,
        'x': value.x,
        'y': value.y,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionPhotoTagRequestDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionPhotoTagRequestDtoFromJSON(json) {
    return MediaCollectionPhotoTagRequestDtoFromJSONTyped(json, false);
}
function MediaCollectionPhotoTagRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': (json['tags'].map(MediaCollectionPhotoTagDtoFromJSON)),
    };
}
function MediaCollectionPhotoTagRequestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': (value.tags.map(MediaCollectionPhotoTagDtoToJSON)),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionResponseFromJSON(json) {
    return MediaCollectionResponseFromJSONTyped(json, false);
}
function MediaCollectionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
        'data': MediaCollectionDataFromJSON(json['data']),
        'handle': json['handle'],
        'storageId': json['storageId'],
        'syncRecord': MediaCollectionSyncRecordFromJSON(json['syncRecord']),
    };
}
function MediaCollectionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionSyncRecord.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MediaCollectionSyncRecordFromJSON(json) {
    return MediaCollectionSyncRecordFromJSONTyped(json, false);
}
function MediaCollectionSyncRecordFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessKeyId': !exists(json, 'accessKeyId') ? undefined : json['accessKeyId'],
        'bucket': !exists(json, 'bucket') ? undefined : json['bucket'],
        'cdn': !exists(json, 'cdn') ? undefined : json['cdn'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'secretAccessKey': !exists(json, 'secretAccessKey') ? undefined : json['secretAccessKey'],
    };
}
function MediaCollectionSyncRecordToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessKeyId': value.accessKeyId,
        'bucket': value.bucket,
        'cdn': value.cdn,
        'endpoint': value.endpoint,
        'path': value.path,
        'secretAccessKey': value.secretAccessKey,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MediaCollectionUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function MediaCollectionUpdateRequestFromJSON(json) {
    return MediaCollectionUpdateRequestFromJSONTyped(json, false);
}
function MediaCollectionUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'syncRecord': !exists(json, 'syncRecord') ? undefined : MediaCollectionSyncRecordFromJSON(json['syncRecord']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function MediaCollectionUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'syncRecord': MediaCollectionSyncRecordToJSON(value.syncRecord),
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Metafield.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function MetafieldFromJSON(json) {
    return MetafieldFromJSONTyped(json, false);
}
function MetafieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'key': json['key'],
        'namespace': json['namespace'],
        'ownerId': json['ownerId'],
        'ownerType': json['ownerType'],
        'shopifyCheckout': ShopifyCheckoutModelFromJSON(json['shopifyCheckout']),
        'value': json['value'],
    };
}
function MetafieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'key': value.key,
        'namespace': value.namespace,
        'ownerId': value.ownerId,
        'ownerType': value.ownerType,
        'shopifyCheckout': ShopifyCheckoutModelToJSON(value.shopifyCheckout),
        'value': value.value,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MonerisGatewayRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MonerisGatewayRequestFromJSON(json) {
    return MonerisGatewayRequestFromJSONTyped(json, false);
}
function MonerisGatewayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'merchantId': json['merchantId'],
    };
}
function MonerisGatewayRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'merchantId': value.merchantId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/MonerisGatewayResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MonerisGatewayResponseFromJSON(json) {
    return MonerisGatewayResponseFromJSONTyped(json, false);
}
function MonerisGatewayResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'merchantId': json['merchantId'],
    };
}
function MonerisGatewayResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'merchantId': value.merchantId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/NotificationEmailTemplate.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function NotificationEmailTemplateFromJSON(json) {
    return NotificationEmailTemplateFromJSONTyped(json, false);
}
function NotificationEmailTemplateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bcc': !exists(json, 'bcc') ? undefined : json['bcc'],
        'cc': !exists(json, 'cc') ? undefined : json['cc'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
    };
}
function NotificationEmailTemplateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bcc': value.bcc,
        'cc': value.cc,
        'html': value.html,
        'subject': value.subject,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/NotificationRecordModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function NotificationRecordModelFromJSON(json) {
    return NotificationRecordModelFromJSONTyped(json, false);
}
function NotificationRecordModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'html': json['html'],
        'id': json['id'],
        'key': json['key'],
        'name': json['name'],
        'subject': json['subject'],
        'type': NotificationTypeFromJSON(json['type']),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function NotificationRecordModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'html': value.html,
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'subject': value.subject,
        'type': NotificationTypeToJSON(value.type),
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/NotificationResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function NotificationResponseFromJSON(json) {
    return NotificationResponseFromJSONTyped(json, false);
}
function NotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bcc': json['bcc'],
        'cc': json['cc'],
        'type': NotificationTypeFromJSON(json['type']),
        'createdAt': (new Date(json['createdAt'])),
        'html': json['html'],
        'id': json['id'],
        'key': json['key'],
        'name': json['name'],
        'subject': json['subject'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function NotificationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bcc': value.bcc,
        'cc': value.cc,
        'type': NotificationTypeToJSON(value.type),
        'createdAt': (value.createdAt.toISOString()),
        'html': value.html,
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'subject': value.subject,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/NotificationType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var NotificationType;
(function (NotificationType) {
    NotificationType["Email"] = "email";
    NotificationType["Print"] = "print";
    NotificationType["TextMessage"] = "text_message";
})(NotificationType || (NotificationType = {}));
function NotificationTypeFromJSON(json) {
    return NotificationTypeFromJSONTyped(json, false);
}
function NotificationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NotificationTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/NotificationUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function NotificationUpdateRequestFromJSON(json) {
    return NotificationUpdateRequestFromJSONTyped(json, false);
}
function NotificationUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bcc': !exists(json, 'bcc') ? undefined : json['bcc'],
        'cc': !exists(json, 'cc') ? undefined : json['cc'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
    };
}
function NotificationUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bcc': value.bcc,
        'cc': value.cc,
        'html': value.html,
        'name': value.name,
        'subject': value.subject,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OpenEdgeResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function OpenEdgeResponseFromJSON(json) {
    return OpenEdgeResponseFromJSONTyped(json, false);
}
function OpenEdgeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'webAuthKey': json['webAuthKey'],
        'webId': json['webId'],
    };
}
function OpenEdgeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'webAuthKey': value.webAuthKey,
        'webId': value.webId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OpenedgeGatewayRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function OpenedgeGatewayRequestFromJSON(json) {
    return OpenedgeGatewayRequestFromJSONTyped(json, false);
}
function OpenedgeGatewayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'webAuthKey': json['webAuthKey'],
        'webId': json['webId'],
    };
}
function OpenedgeGatewayRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'webAuthKey': value.webAuthKey,
        'webId': value.webId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function OrderCreateRequestFromJSON(json) {
    return OrderCreateRequestFromJSONTyped(json, false);
}
function OrderCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'billingAddress': !exists(json, 'billingAddress') ? undefined : AddressFromJSON(json['billingAddress']),
        'financialStatus': !exists(json, 'financialStatus') ? undefined : OrderFinancialStatusFromJSON(json['financialStatus']),
        'fulfillmentStatus': !exists(json, 'fulfillmentStatus') ? undefined : OrderFulfillmentStatusFromJSON(json['fulfillmentStatus']),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : AddressFromJSON(json['shippingAddress']),
        'checkoutToken': !exists(json, 'checkoutToken') ? undefined : json['checkoutToken'],
        'customerAcceptsMarketing': !exists(json, 'customerAcceptsMarketing') ? undefined : json['customerAcceptsMarketing'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'lineItems': !exists(json, 'lineItems') ? undefined : (json['lineItems'].map(OrderLineItemCreateRequestFromJSON)),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'revenueCenterId': !exists(json, 'revenueCenterId') ? undefined : json['revenueCenterId'],
    };
}
function OrderCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'billingAddress': AddressToJSON(value.billingAddress),
        'financialStatus': OrderFinancialStatusToJSON(value.financialStatus),
        'fulfillmentStatus': OrderFulfillmentStatusToJSON(value.fulfillmentStatus),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'checkoutToken': value.checkoutToken,
        'customerAcceptsMarketing': value.customerAcceptsMarketing,
        'customerId': value.customerId,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'lineItems': value.lineItems === undefined ? undefined : (value.lineItems.map(OrderLineItemCreateRequestToJSON)),
        'note': value.note,
        'phone': value.phone,
        'revenueCenterId': value.revenueCenterId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderFinancialStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var OrderFinancialStatus;
(function (OrderFinancialStatus) {
    OrderFinancialStatus["Pending"] = "pending";
    OrderFinancialStatus["Authorized"] = "authorized";
    OrderFinancialStatus["PartiallyPaid"] = "partially_paid";
    OrderFinancialStatus["Paid"] = "paid";
    OrderFinancialStatus["PartiallyRefunded"] = "partially_refunded";
    OrderFinancialStatus["Voided"] = "voided";
})(OrderFinancialStatus || (OrderFinancialStatus = {}));
function OrderFinancialStatusFromJSON(json) {
    return OrderFinancialStatusFromJSONTyped(json, false);
}
function OrderFinancialStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrderFinancialStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderFulfillmentStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var OrderFulfillmentStatus;
(function (OrderFulfillmentStatus) {
    OrderFulfillmentStatus["Fulfilled"] = "fulfilled";
    OrderFulfillmentStatus["Null"] = "null";
    OrderFulfillmentStatus["Restocked"] = "restocked";
    OrderFulfillmentStatus["ReadyForPickup"] = "ready_for_pickup";
})(OrderFulfillmentStatus || (OrderFulfillmentStatus = {}));
function OrderFulfillmentStatusFromJSON(json) {
    return OrderFulfillmentStatusFromJSONTyped(json, false);
}
function OrderFulfillmentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrderFulfillmentStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderLineItemCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function OrderLineItemCreateRequestFromJSON(json) {
    return OrderLineItemCreateRequestFromJSONTyped(json, false);
}
function OrderLineItemCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productType': ProductTypeFromJSON(json['productType']),
        'properties': !exists(json, 'properties') ? undefined : (json['properties'].map(OrderLineItemPropertyFromJSON)),
        'productId': json['productId'],
        'quantity': json['quantity'],
    };
}
function OrderLineItemCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productType': ProductTypeToJSON(value.productType),
        'properties': value.properties === undefined ? undefined : (value.properties.map(OrderLineItemPropertyToJSON)),
        'productId': value.productId,
        'quantity': value.quantity,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderLineItemProperty.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function OrderLineItemPropertyFromJSON(json) {
    return OrderLineItemPropertyFromJSONTyped(json, false);
}
function OrderLineItemPropertyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'value': json['value'],
    };
}
function OrderLineItemPropertyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'value': value.value,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderLineItemResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
* @export
* @enum {string}
*/
var OrderLineItemResponseProductTypeEnum;
(function (OrderLineItemResponseProductTypeEnum) {
    OrderLineItemResponseProductTypeEnum["Admission"] = "admission";
    OrderLineItemResponseProductTypeEnum["AppPurchase"] = "app_purchase";
    OrderLineItemResponseProductTypeEnum["Fund"] = "fund";
})(OrderLineItemResponseProductTypeEnum || (OrderLineItemResponseProductTypeEnum = {}));
function OrderLineItemResponseFromJSON(json) {
    return OrderLineItemResponseFromJSONTyped(json, false);
}
function OrderLineItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'properties': (json['properties'].map(OrderLineItemPropertyFromJSON)),
        'id': json['id'],
        'name': json['name'],
        'price': json['price'],
        'productId': json['productId'],
        'productType': json['productType'],
        'quantity': json['quantity'],
        'tax': json['tax'],
        'taxable': json['taxable'],
        'title': json['title'],
    };
}
function OrderLineItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'properties': (value.properties.map(OrderLineItemPropertyToJSON)),
        'id': value.id,
        'name': value.name,
        'price': value.price,
        'productId': value.productId,
        'productType': value.productType,
        'quantity': value.quantity,
        'tax': value.tax,
        'taxable': value.taxable,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function OrderResponseFromJSON(json) {
    return OrderResponseFromJSONTyped(json, false);
}
function OrderResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cancelledAt': (json['cancelledAt'] === null ? null : new Date(json['cancelledAt'])),
        'customer': json['customer'],
        'financialStatus': OrderFinancialStatusFromJSON(json['financialStatus']),
        'fulfillmentStatus': OrderFulfillmentStatusFromJSON(json['fulfillmentStatus']),
        'integrations': (json['integrations'].map(CheckoutIntegrationFromJSON)),
        'transactions': (json['transactions'].map(TransactionResponseFromJSON)),
        'updatedAt': (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
        'billingAddress': AddressFromJSON(json['billingAddress']),
        'createdAt': (new Date(json['createdAt'])),
        'currency': json['currency'],
        'customerId': json['customerId'],
        'email': json['email'],
        'id': json['id'],
        'kioskId': json['kioskId'],
        'lineItems': (json['lineItems'].map(OrderLineItemResponseFromJSON)),
        'name': json['name'],
        'orderNo': json['orderNo'],
        'phone': json['phone'],
        'revenueCenterId': json['revenueCenterId'],
        'selfCheckoutId': json['selfCheckoutId'],
        'subtotalPrice': json['subtotalPrice'],
        'totalPrice': json['totalPrice'],
        'totalTax': json['totalTax'],
    };
}
function OrderResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cancelledAt': (value.cancelledAt === null ? null : value.cancelledAt.toISOString()),
        'customer': value.customer,
        'financialStatus': OrderFinancialStatusToJSON(value.financialStatus),
        'fulfillmentStatus': OrderFulfillmentStatusToJSON(value.fulfillmentStatus),
        'integrations': (value.integrations.map(CheckoutIntegrationToJSON)),
        'transactions': (value.transactions.map(TransactionResponseToJSON)),
        'updatedAt': (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'billingAddress': AddressToJSON(value.billingAddress),
        'createdAt': (value.createdAt.toISOString()),
        'currency': value.currency,
        'customerId': value.customerId,
        'email': value.email,
        'id': value.id,
        'kioskId': value.kioskId,
        'lineItems': (value.lineItems.map(OrderLineItemResponseToJSON)),
        'name': value.name,
        'orderNo': value.orderNo,
        'phone': value.phone,
        'revenueCenterId': value.revenueCenterId,
        'selfCheckoutId': value.selfCheckoutId,
        'subtotalPrice': value.subtotalPrice,
        'totalPrice': value.totalPrice,
        'totalTax': value.totalTax,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrderUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
* @export
* @enum {string}
*/
var OrderUpdateRequestFulfillmentStatusEnum;
(function (OrderUpdateRequestFulfillmentStatusEnum) {
    OrderUpdateRequestFulfillmentStatusEnum["Fulfilled"] = "fulfilled";
    OrderUpdateRequestFulfillmentStatusEnum["Null"] = "null";
    OrderUpdateRequestFulfillmentStatusEnum["Restocked"] = "restocked";
    OrderUpdateRequestFulfillmentStatusEnum["ReadyForPickup"] = "ready_for_pickup";
})(OrderUpdateRequestFulfillmentStatusEnum || (OrderUpdateRequestFulfillmentStatusEnum = {}));
function OrderUpdateRequestFromJSON(json) {
    return OrderUpdateRequestFromJSONTyped(json, false);
}
function OrderUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'billingAddress': !exists(json, 'billingAddress') ? undefined : AddressFromJSON(json['billingAddress']),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : AddressFromJSON(json['shippingAddress']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'fulfillmentStatus': !exists(json, 'fulfillmentStatus') ? undefined : json['fulfillmentStatus'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
function OrderUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'billingAddress': AddressToJSON(value.billingAddress),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'email': value.email,
        'firstName': value.firstName,
        'fulfillmentStatus': value.fulfillmentStatus,
        'lastName': value.lastName,
        'phone': value.phone,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrganizationExportResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function OrganizationExportResponseFromJSON(json) {
    return OrganizationExportResponseFromJSONTyped(json, false);
}
function OrganizationExportResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'organization': json['organization'],
        'exportedAt': (new Date(json['exportedAt'])),
        'url': json['url'],
    };
}
function OrganizationExportResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'organization': value.organization,
        'exportedAt': (value.exportedAt.toISOString()),
        'url': value.url,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrganizationResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function OrganizationResponseFromJSON(json) {
    return OrganizationResponseFromJSONTyped(json, false);
}
function OrganizationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': AddressFromJSON(json['address']),
        'createdAt': (new Date(json['createdAt'])),
        'email': json['email'],
        'handle': json['handle'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function OrganizationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': AddressToJSON(value.address),
        'createdAt': (value.createdAt.toISOString()),
        'email': value.email,
        'handle': value.handle,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/OrganizationUser.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var OrganizationUser;
(function (OrganizationUser) {
    OrganizationUser["Kiosk"] = "kiosk";
    OrganizationUser["Plugin"] = "plugin";
    OrganizationUser["User"] = "user";
    OrganizationUser["RestApp"] = "rest_app";
    OrganizationUser["AccessCode"] = "access_code";
})(OrganizationUser || (OrganizationUser = {}));
function OrganizationUserFromJSON(json) {
    return OrganizationUserFromJSONTyped(json, false);
}
function OrganizationUserFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrganizationUserToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentGatewayCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentGatewayCreateRequestFromJSON(json) {
    return PaymentGatewayCreateRequestFromJSONTyped(json, false);
}
function PaymentGatewayCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cayan': !exists(json, 'cayan') ? undefined : CayanGatewayRequestFromJSON(json['cayan']),
        'moneris': !exists(json, 'moneris') ? undefined : MonerisGatewayRequestFromJSON(json['moneris']),
        'openedge': !exists(json, 'openedge') ? undefined : OpenedgeGatewayRequestFromJSON(json['openedge']),
        'stripe': !exists(json, 'stripe') ? undefined : StripeGatewayRequestFromJSON(json['stripe']),
        'type': PaymentGatewayTypeFromJSON(json['type']),
        'name': json['name'],
    };
}
function PaymentGatewayCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cayan': CayanGatewayRequestToJSON(value.cayan),
        'moneris': MonerisGatewayRequestToJSON(value.moneris),
        'openedge': OpenedgeGatewayRequestToJSON(value.openedge),
        'stripe': StripeGatewayRequestToJSON(value.stripe),
        'type': PaymentGatewayTypeToJSON(value.type),
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentGatewayResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
* @export
* @enum {string}
*/
var PaymentGatewayResponseTypeEnum;
(function (PaymentGatewayResponseTypeEnum) {
    PaymentGatewayResponseTypeEnum["Stripe"] = "stripe";
    PaymentGatewayResponseTypeEnum["Moneris"] = "moneris";
    PaymentGatewayResponseTypeEnum["Cayan"] = "cayan";
    PaymentGatewayResponseTypeEnum["Td"] = "td";
    PaymentGatewayResponseTypeEnum["Openedge"] = "openedge";
})(PaymentGatewayResponseTypeEnum || (PaymentGatewayResponseTypeEnum = {}));
function PaymentGatewayResponseFromJSON(json) {
    return PaymentGatewayResponseFromJSONTyped(json, false);
}
function PaymentGatewayResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cayan': CayanGatewayResponseFromJSON(json['cayan']),
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'key': json['key'],
        'moneris': MonerisGatewayResponseFromJSON(json['moneris']),
        'name': json['name'],
        'openedge': OpenEdgeResponseFromJSON(json['openedge']),
        'revenueCenterId': json['revenueCenterId'],
        'stripe': StripeGatewayResponseFromJSON(json['stripe']),
        'td': json['td'],
        'type': json['type'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function PaymentGatewayResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cayan': CayanGatewayResponseToJSON(value.cayan),
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'id': value.id,
        'key': value.key,
        'moneris': MonerisGatewayResponseToJSON(value.moneris),
        'name': value.name,
        'openedge': OpenEdgeResponseToJSON(value.openedge),
        'revenueCenterId': value.revenueCenterId,
        'stripe': StripeGatewayResponseToJSON(value.stripe),
        'td': value.td,
        'type': value.type,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentGatewayType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PaymentGatewayType;
(function (PaymentGatewayType) {
    PaymentGatewayType["Stripe"] = "stripe";
    PaymentGatewayType["Moneris"] = "moneris";
    PaymentGatewayType["Cayan"] = "cayan";
    PaymentGatewayType["Td"] = "td";
    PaymentGatewayType["Openedge"] = "openedge";
})(PaymentGatewayType || (PaymentGatewayType = {}));
function PaymentGatewayTypeFromJSON(json) {
    return PaymentGatewayTypeFromJSONTyped(json, false);
}
function PaymentGatewayTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PaymentGatewayTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentGatewayUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentGatewayUpdateRequestFromJSON(json) {
    return PaymentGatewayUpdateRequestFromJSONTyped(json, false);
}
function PaymentGatewayUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cayan': !exists(json, 'cayan') ? undefined : CayanGatewayRequestFromJSON(json['cayan']),
        'moneris': !exists(json, 'moneris') ? undefined : MonerisGatewayRequestFromJSON(json['moneris']),
        'openedge': !exists(json, 'openedge') ? undefined : OpenedgeGatewayRequestFromJSON(json['openedge']),
        'stripe': !exists(json, 'stripe') ? undefined : StripeGatewayRequestFromJSON(json['stripe']),
        'type': PaymentGatewayTypeFromJSON(json['type']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function PaymentGatewayUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cayan': CayanGatewayRequestToJSON(value.cayan),
        'moneris': MonerisGatewayRequestToJSON(value.moneris),
        'openedge': OpenedgeGatewayRequestToJSON(value.openedge),
        'stripe': StripeGatewayRequestToJSON(value.stripe),
        'type': PaymentGatewayTypeToJSON(value.type),
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentTerminalCreateRequestFromJSON(json) {
    return PaymentTerminalCreateRequestFromJSONTyped(json, false);
}
function PaymentTerminalCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'device': PaymentTerminalDeviceFromJSON(json['device']),
        'moneris': !exists(json, 'moneris') ? undefined : PaymentTerminalMonerisFromJSON(json['moneris']),
        'gatewayId': !exists(json, 'gatewayId') ? undefined : json['gatewayId'],
        'ipAddress': json['ipAddress'],
        'name': json['name'],
    };
}
function PaymentTerminalCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device': PaymentTerminalDeviceToJSON(value.device),
        'moneris': PaymentTerminalMonerisToJSON(value.moneris),
        'gatewayId': value.gatewayId,
        'ipAddress': value.ipAddress,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalDevice.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTerminalDevice;
(function (PaymentTerminalDevice) {
    PaymentTerminalDevice["MonerisVerifoneP400"] = "moneris_verifone_P400";
    PaymentTerminalDevice["MonerisVerifoneUx301"] = "moneris_verifone_ux301";
    PaymentTerminalDevice["CayanVerifoneMx915"] = "cayan_verifone_mx915";
    PaymentTerminalDevice["MonerisIngenicoIpp320"] = "moneris_ingenico_ipp320";
    PaymentTerminalDevice["OpenedgeIuc285"] = "openedge_iuc285";
    PaymentTerminalDevice["OpenedgeLane3000"] = "openedge_lane_3000";
})(PaymentTerminalDevice || (PaymentTerminalDevice = {}));
function PaymentTerminalDeviceFromJSON(json) {
    return PaymentTerminalDeviceFromJSONTyped(json, false);
}
function PaymentTerminalDeviceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PaymentTerminalDeviceToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentTerminalModelFromJSON(json) {
    return PaymentTerminalModelFromJSONTyped(json, false);
}
function PaymentTerminalModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'device': PaymentTerminalDeviceFromJSON(json['device']),
        'gateway': PaymentGatewayResponseFromJSON(json['gateway']),
        'ipAddress': !exists(json, 'ipAddress') ? undefined : json['ipAddress'],
        'moneris': PaymentTerminalMonerisFromJSON(json['moneris']),
        'openedge': PaymentTerminalOpenedgeFromJSON(json['openedge']),
    };
}
function PaymentTerminalModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device': PaymentTerminalDeviceToJSON(value.device),
        'gateway': PaymentGatewayResponseToJSON(value.gateway),
        'ipAddress': value.ipAddress,
        'moneris': PaymentTerminalMonerisToJSON(value.moneris),
        'openedge': PaymentTerminalOpenedgeToJSON(value.openedge),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalMoneris.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PaymentTerminalMonerisFromJSON(json) {
    return PaymentTerminalMonerisFromJSONTyped(json, false);
}
function PaymentTerminalMonerisFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ecrId': json['ecrId'],
    };
}
function PaymentTerminalMonerisToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ecrId': value.ecrId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalOpenedge.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PaymentTerminalOpenedgeFromJSON(json) {
    return PaymentTerminalOpenedgeFromJSONTyped(json, false);
}
function PaymentTerminalOpenedgeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'webTerminalId': json['webTerminalId'],
    };
}
function PaymentTerminalOpenedgeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'webTerminalId': value.webTerminalId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentTerminalResponseFromJSON(json) {
    return PaymentTerminalResponseFromJSONTyped(json, false);
}
function PaymentTerminalResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'device': PaymentTerminalDeviceFromJSON(json['device']),
        'moneris': PaymentTerminalMonerisFromJSON(json['moneris']),
        'openedge': PaymentTerminalOpenedgeFromJSON(json['openedge']),
        'gateway': !exists(json, 'gateway') ? undefined : PaymentGatewayResponseFromJSON(json['gateway']),
        'gatewayId': json['gatewayId'],
        'id': json['id'],
        'ipAddress': json['ipAddress'],
        'name': json['name'],
    };
}
function PaymentTerminalResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device': PaymentTerminalDeviceToJSON(value.device),
        'moneris': PaymentTerminalMonerisToJSON(value.moneris),
        'openedge': PaymentTerminalOpenedgeToJSON(value.openedge),
        'gateway': PaymentGatewayResponseToJSON(value.gateway),
        'gatewayId': value.gatewayId,
        'id': value.id,
        'ipAddress': value.ipAddress,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTerminalStatus;
(function (PaymentTerminalStatus) {
    PaymentTerminalStatus["Approved"] = "approved";
    PaymentTerminalStatus["Declined"] = "declined";
    PaymentTerminalStatus["NotCompleted"] = "not_completed";
    PaymentTerminalStatus["Unknown"] = "unknown";
})(PaymentTerminalStatus || (PaymentTerminalStatus = {}));
function PaymentTerminalStatusFromJSON(json) {
    return PaymentTerminalStatusFromJSONTyped(json, false);
}
function PaymentTerminalStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PaymentTerminalStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalTransactionResponseModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PaymentTerminalTransactionResponseModelFromJSON(json) {
    return PaymentTerminalTransactionResponseModelFromJSONTyped(json, false);
}
function PaymentTerminalTransactionResponseModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
        'approval': json['approval'],
        'card': json['card'],
        'customerReceipt': json['customerReceipt'],
        'data': json['data'],
        'invoice': json['invoice'],
        'merchantReceipt': json['merchantReceipt'],
        'status': PaymentTerminalStatusFromJSON(json['status']),
        'tip': json['tip'],
        'type': PaymentTerminalTransactionTypeFromJSON(json['type']),
    };
}
function PaymentTerminalTransactionResponseModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': value.amount,
        'approval': value.approval,
        'card': value.card,
        'customerReceipt': value.customerReceipt,
        'data': value.data,
        'invoice': value.invoice,
        'merchantReceipt': value.merchantReceipt,
        'status': PaymentTerminalStatusToJSON(value.status),
        'tip': value.tip,
        'type': PaymentTerminalTransactionTypeToJSON(value.type),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalTransactionType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTerminalTransactionType;
(function (PaymentTerminalTransactionType) {
    PaymentTerminalTransactionType["Purchase"] = "purchase";
    PaymentTerminalTransactionType["Command"] = "command";
    PaymentTerminalTransactionType["System"] = "system";
    PaymentTerminalTransactionType["Receipt"] = "receipt";
})(PaymentTerminalTransactionType || (PaymentTerminalTransactionType = {}));
function PaymentTerminalTransactionTypeFromJSON(json) {
    return PaymentTerminalTransactionTypeFromJSONTyped(json, false);
}
function PaymentTerminalTransactionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PaymentTerminalTransactionTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PaymentTerminalUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentTerminalUpdateRequestFromJSON(json) {
    return PaymentTerminalUpdateRequestFromJSONTyped(json, false);
}
function PaymentTerminalUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'device': !exists(json, 'device') ? undefined : PaymentTerminalDeviceFromJSON(json['device']),
        'moneris': !exists(json, 'moneris') ? undefined : PaymentTerminalMonerisFromJSON(json['moneris']),
        'openedge': !exists(json, 'openedge') ? undefined : PaymentTerminalOpenedgeFromJSON(json['openedge']),
        'ipAddress': !exists(json, 'ipAddress') ? undefined : json['ipAddress'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function PaymentTerminalUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device': PaymentTerminalDeviceToJSON(value.device),
        'moneris': PaymentTerminalMonerisToJSON(value.moneris),
        'openedge': PaymentTerminalOpenedgeToJSON(value.openedge),
        'ipAddress': value.ipAddress,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PhotoboothCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PhotoboothCreateRequestFromJSON(json) {
    return PhotoboothCreateRequestFromJSONTyped(json, false);
}
function PhotoboothCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': json['name'],
    };
}
function PhotoboothCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PhotoboothFrameCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PhotoboothFrameCreateRequestFromJSON(json) {
    return PhotoboothFrameCreateRequestFromJSONTyped(json, false);
}
function PhotoboothFrameCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'overlayImageId': !exists(json, 'overlayImageId') ? undefined : json['overlayImageId'],
    };
}
function PhotoboothFrameCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'overlayImageId': value.overlayImageId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PhotoboothFrameResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PhotoboothFrameResponseFromJSON(json) {
    return PhotoboothFrameResponseFromJSONTyped(json, false);
}
function PhotoboothFrameResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'overlayImageLayout': LayoutBoxFromJSON(json['overlayImageLayout']),
        'id': json['id'],
        'overlayImage': ImageUploadResponseFromJSON(json['overlayImage']),
    };
}
function PhotoboothFrameResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'overlayImageLayout': LayoutBoxToJSON(value.overlayImageLayout),
        'id': value.id,
        'overlayImage': ImageUploadResponseToJSON(value.overlayImage),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PhotoboothResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PhotoboothResponseFromJSON(json) {
    return PhotoboothResponseFromJSONTyped(json, false);
}
function PhotoboothResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
        'emailShareNotification': NotificationEmailTemplateFromJSON(json['emailShareNotification']),
        'fields': (json['fields'].map(CustomFieldOptionsFromJSON)),
        'backgroundId': !exists(json, 'backgroundId') ? undefined : json['backgroundId'],
        'frames': (json['frames'].map(PhotoboothFrameResponseFromJSON)),
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
    };
}
function PhotoboothResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'emailShareNotification': NotificationEmailTemplateToJSON(value.emailShareNotification),
        'fields': (value.fields.map(CustomFieldOptionsToJSON)),
        'backgroundId': value.backgroundId,
        'frames': (value.frames.map(PhotoboothFrameResponseToJSON)),
        'screensaverId': value.screensaverId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PhotoboothSessionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PhotoboothSessionCreateRequestFromJSON(json) {
    return PhotoboothSessionCreateRequestFromJSONTyped(json, false);
}
function PhotoboothSessionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldEntries': (json['fieldEntries'].map(CustomFieldEntryFromJSON)),
        'frameId': json['frameId'],
        'uploadId': json['uploadId'],
    };
}
function PhotoboothSessionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fieldEntries': (value.fieldEntries.map(CustomFieldEntryToJSON)),
        'frameId': value.frameId,
        'uploadId': value.uploadId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PhotoboothUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PhotoboothUpdateRequestFromJSON(json) {
    return PhotoboothUpdateRequestFromJSONTyped(json, false);
}
function PhotoboothUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'emailShareNotification': !exists(json, 'emailShareNotification') ? undefined : NotificationEmailTemplateFromJSON(json['emailShareNotification']),
        'fields': !exists(json, 'fields') ? undefined : (json['fields'].map(CustomFieldOptionsFromJSON)),
        'backgroundId': !exists(json, 'backgroundId') ? undefined : json['backgroundId'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function PhotoboothUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'emailShareNotification': NotificationEmailTemplateToJSON(value.emailShareNotification),
        'fields': value.fields === undefined ? undefined : (value.fields.map(CustomFieldOptionsToJSON)),
        'backgroundId': value.backgroundId,
        'screensaverId': value.screensaverId,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformAuthenticateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformAuthenticateRequestFromJSON(json) {
    return PlatformAuthenticateRequestFromJSONTyped(json, false);
}
function PlatformAuthenticateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'platformId': json['platformId'],
        'kioskId': json['kioskId'],
        'key': json['key'],
    };
}
function PlatformAuthenticateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'platformId': value.platformId,
        'kioskId': value.kioskId,
        'key': value.key,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformCreateRequestFromJSON(json) {
    return PlatformCreateRequestFromJSONTyped(json, false);
}
function PlatformCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'url': json['url'],
    };
}
function PlatformCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'url': value.url,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformDisplay.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PlatformDisplayFromJSON(json) {
    return PlatformDisplayFromJSONTyped(json, false);
}
function PlatformDisplayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accelerometerSupport': json['accelerometerSupport'],
        'bounds': RectangleFromJSON(json['bounds']),
        'colorDepth': json['colorDepth'],
        'colorSpace': json['colorSpace'],
        'depthPerComponent': json['depthPerComponent'],
        'displayFrequency': json['displayFrequency'],
        'id': json['id'],
        'internal': json['internal'],
        'monochrome': json['monochrome'],
        'rotation': json['rotation'],
        'scaleFactor': json['scaleFactor'],
        'size': SizeFromJSON(json['size']),
        'touchSupport': json['touchSupport'],
        'workArea': RectangleFromJSON(json['workArea']),
        'workAreaSize': SizeFromJSON(json['workAreaSize']),
    };
}
function PlatformDisplayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accelerometerSupport': value.accelerometerSupport,
        'bounds': RectangleToJSON(value.bounds),
        'colorDepth': value.colorDepth,
        'colorSpace': value.colorSpace,
        'depthPerComponent': value.depthPerComponent,
        'displayFrequency': value.displayFrequency,
        'id': value.id,
        'internal': value.internal,
        'monochrome': value.monochrome,
        'rotation': value.rotation,
        'scaleFactor': value.scaleFactor,
        'size': SizeToJSON(value.size),
        'touchSupport': value.touchSupport,
        'workArea': RectangleToJSON(value.workArea),
        'workAreaSize': SizeToJSON(value.workAreaSize),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformNetworkDevice.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformNetworkDeviceFromJSON(json) {
    return PlatformNetworkDeviceFromJSONTyped(json, false);
}
function PlatformNetworkDeviceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ip': json['ip'],
        'mac': json['mac'],
        'online': json['online'],
    };
}
function PlatformNetworkDeviceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ip': value.ip,
        'mac': value.mac,
        'online': value.online,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformNetworkInterface.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformNetworkInterfaceFromJSON(json) {
    return PlatformNetworkInterfaceFromJSONTyped(json, false);
}
function PlatformNetworkInterfaceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'netmask': json['netmask'],
        'mac': json['mac'],
        'internal': json['internal'],
        'cidr': json['cidr'],
        'family': json['family'],
        'scopeid': json['scopeid'],
    };
}
function PlatformNetworkInterfaceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'netmask': value.netmask,
        'mac': value.mac,
        'internal': value.internal,
        'cidr': value.cidr,
        'family': value.family,
        'scopeid': value.scopeid,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformOSInfo.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PlatformOSInfoFromJSON(json) {
    return PlatformOSInfoFromJSONTyped(json, false);
}
function PlatformOSInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hostname': json['hostname'],
        'networkInterfaces': (json['networkInterfaces'].map(PlatformNetworkInterfaceFromJSON)),
        'release': json['release'],
        'version': json['version'],
        'freemem': json['freemem'],
        'totalmem': json['totalmem'],
        'uptime': json['uptime'],
        'homedir': json['homedir'],
        'userInfo': json['userInfo'],
    };
}
function PlatformOSInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hostname': value.hostname,
        'networkInterfaces': (value.networkInterfaces.map(PlatformNetworkInterfaceToJSON)),
        'release': value.release,
        'version': value.version,
        'freemem': value.freemem,
        'totalmem': value.totalmem,
        'uptime': value.uptime,
        'homedir': value.homedir,
        'userInfo': value.userInfo,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformPrinter.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformPrinterFromJSON(json) {
    return PlatformPrinterFromJSONTyped(json, false);
}
function PlatformPrinterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': json['description'],
        'displayName': json['displayName'],
        'isDefault': json['isDefault'],
        'name': json['name'],
        'options': json['options'],
        'status': json['status'],
    };
}
function PlatformPrinterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'displayName': value.displayName,
        'isDefault': value.isDefault,
        'name': value.name,
        'options': value.options,
        'status': value.status,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformResponseFromJSON(json) {
    return PlatformResponseFromJSONTyped(json, false);
}
function PlatformResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'url': json['url'],
        'kiosks': json['kiosks'],
    };
}
function PlatformResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'url': value.url,
        'kiosks': value.kiosks,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformState.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PlatformStateFromJSON(json) {
    return PlatformStateFromJSONTyped(json, false);
}
function PlatformStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': (new Date(json['date'])),
        'primaryDisplay': json['primaryDisplay'],
        'displays': (json['displays'].map(PlatformDisplayFromJSON)),
        'devices': !exists(json, 'devices') ? undefined : (json['devices'].map(PlatformNetworkDeviceFromJSON)),
        'printers': (json['printers'].map(PlatformPrinterFromJSON)),
        'publicIPV4': json['publicIPV4'],
        'publicIPV6': json['publicIPV6'],
        'os': PlatformOSInfoFromJSON(json['os']),
        'platform': json['platform'],
        'speedTest': json['speedTest'],
        'nodeVersion': json['nodeVersion'],
        'version': json['version'],
        'esuitePlatformVersion': json['esuitePlatformVersion'],
    };
}
function PlatformStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': (value.date.toISOString()),
        'primaryDisplay': value.primaryDisplay,
        'displays': (value.displays.map(PlatformDisplayToJSON)),
        'devices': value.devices === undefined ? undefined : (value.devices.map(PlatformNetworkDeviceToJSON)),
        'printers': (value.printers.map(PlatformPrinterToJSON)),
        'publicIPV4': value.publicIPV4,
        'publicIPV6': value.publicIPV6,
        'os': PlatformOSInfoToJSON(value.os),
        'platform': value.platform,
        'speedTest': value.speedTest,
        'nodeVersion': value.nodeVersion,
        'version': value.version,
        'esuitePlatformVersion': value.esuitePlatformVersion,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PlatformUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformUpdateRequestFromJSON(json) {
    return PlatformUpdateRequestFromJSONTyped(json, false);
}
function PlatformUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'url': json['url'],
    };
}
function PlatformUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'url': value.url,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/PresignedPost.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PresignedPostFromJSON(json) {
    return PresignedPostFromJSONTyped(json, false);
}
function PresignedPostFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fields': json['fields'],
        'url': json['url'],
        'key': json['key'],
    };
}
function PresignedPostToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fields': value.fields,
        'url': value.url,
        'key': value.key,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductCategoryCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ProductCategoryCreateRequestFromJSON(json) {
    return ProductCategoryCreateRequestFromJSONTyped(json, false);
}
function ProductCategoryCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'admissionIds': !exists(json, 'admissionIds') ? undefined : json['admissionIds'],
        'agreementIds': !exists(json, 'agreementIds') ? undefined : json['agreementIds'],
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
        'duplicateId': !exists(json, 'duplicateId') ? undefined : json['duplicateId'],
        'fundIds': !exists(json, 'fundIds') ? undefined : json['fundIds'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'integrations': !exists(json, 'integrations') ? undefined : (json['integrations'].map(ProductCategoryIntegrationRequestFromJSON)),
        'name': json['name'],
        'signId': !exists(json, 'signId') ? undefined : json['signId'],
    };
}
function ProductCategoryCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'admissionIds': value.admissionIds,
        'agreementIds': value.agreementIds,
        'categoryIds': value.categoryIds,
        'duplicateId': value.duplicateId,
        'fundIds': value.fundIds,
        'imageId': value.imageId,
        'integrations': value.integrations === undefined ? undefined : (value.integrations.map(ProductCategoryIntegrationRequestToJSON)),
        'name': value.name,
        'signId': value.signId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductCategoryIntegrationFilter.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ProductCategoryIntegrationFilterFromJSON(json) {
    return ProductCategoryIntegrationFilterFromJSONTyped(json, false);
}
function ProductCategoryIntegrationFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'exec': json['exec'],
        'filter': json['filter'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'target': json['target'],
    };
}
function ProductCategoryIntegrationFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'exec': value.exec,
        'filter': value.filter,
        'tags': value.tags,
        'target': value.target,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductCategoryIntegrationRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ProductCategoryIntegrationRequestFromJSON(json) {
    return ProductCategoryIntegrationRequestFromJSONTyped(json, false);
}
function ProductCategoryIntegrationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'filters': !exists(json, 'filters') ? undefined : (json['filters'].map(ProductCategoryIntegrationFilterFromJSON)),
        'integrationId': json['integrationId'],
    };
}
function ProductCategoryIntegrationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'filters': value.filters === undefined ? undefined : (value.filters.map(ProductCategoryIntegrationFilterToJSON)),
        'integrationId': value.integrationId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductCategoryIntegrationResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ProductCategoryIntegrationResponseFromJSON(json) {
    return ProductCategoryIntegrationResponseFromJSONTyped(json, false);
}
function ProductCategoryIntegrationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'filters': (json['filters'].map(ProductCategoryIntegrationFilterFromJSON)),
        'id': json['id'],
        'integration': SelfCheckoutIntegrationResponseFromJSON(json['integration']),
        'integrationId': json['integrationId'],
        'integrationType': SelfCheckoutIntegrationTypeFromJSON(json['integrationType']),
    };
}
function ProductCategoryIntegrationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'filters': (value.filters.map(ProductCategoryIntegrationFilterToJSON)),
        'id': value.id,
        'integration': SelfCheckoutIntegrationResponseToJSON(value.integration),
        'integrationId': value.integrationId,
        'integrationType': SelfCheckoutIntegrationTypeToJSON(value.integrationType),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductCategoryResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ProductCategoryResponseFromJSON(json) {
    return ProductCategoryResponseFromJSONTyped(json, false);
}
function ProductCategoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'integrations': !exists(json, 'integrations') ? undefined : (json['integrations'].map(ProductCategoryIntegrationResponseFromJSON)),
        'admissionIds': json['admissionIds'],
        'agreementIds': json['agreementIds'],
        'categoryIds': json['categoryIds'],
        'fundIds': json['fundIds'],
        'id': json['id'],
        'image': !exists(json, 'image') ? undefined : ImageUploadResponseFromJSON(json['image']),
        'imageId': json['imageId'],
        'name': json['name'],
        'signId': json['signId'],
    };
}
function ProductCategoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'integrations': value.integrations === undefined ? undefined : (value.integrations.map(ProductCategoryIntegrationResponseToJSON)),
        'admissionIds': value.admissionIds,
        'agreementIds': value.agreementIds,
        'categoryIds': value.categoryIds,
        'fundIds': value.fundIds,
        'id': value.id,
        'image': ImageUploadResponseToJSON(value.image),
        'imageId': value.imageId,
        'name': value.name,
        'signId': value.signId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductCategoryUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ProductCategoryUpdateRequestFromJSON(json) {
    return ProductCategoryUpdateRequestFromJSONTyped(json, false);
}
function ProductCategoryUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'admissionIds': !exists(json, 'admissionIds') ? undefined : json['admissionIds'],
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
        'fundIds': !exists(json, 'fundIds') ? undefined : json['fundIds'],
        'integrations': !exists(json, 'integrations') ? undefined : (json['integrations'].map(ProductCategoryIntegrationRequestFromJSON)),
        'agreementIds': !exists(json, 'agreementIds') ? undefined : json['agreementIds'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'signId': !exists(json, 'signId') ? undefined : json['signId'],
    };
}
function ProductCategoryUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'admissionIds': value.admissionIds,
        'categoryIds': value.categoryIds,
        'fundIds': value.fundIds,
        'integrations': value.integrations === undefined ? undefined : (value.integrations.map(ProductCategoryIntegrationRequestToJSON)),
        'agreementIds': value.agreementIds,
        'imageId': value.imageId,
        'name': value.name,
        'signId': value.signId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["Active"] = "active";
    ProductStatus["Archived"] = "archived";
    ProductStatus["Draft"] = "draft";
})(ProductStatus || (ProductStatus = {}));
function ProductStatusFromJSON(json) {
    return ProductStatusFromJSONTyped(json, false);
}
function ProductStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ProductStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ProductType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ProductType;
(function (ProductType) {
    ProductType["Admission"] = "admission";
    ProductType["AppPurchase"] = "app_purchase";
    ProductType["Fund"] = "fund";
})(ProductType || (ProductType = {}));
function ProductTypeFromJSON(json) {
    return ProductTypeFromJSONTyped(json, false);
}
function ProductTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ProductTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Rectangle.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function RectangleFromJSON(json) {
    return RectangleFromJSONTyped(json, false);
}
function RectangleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'width': json['width'],
        'height': json['height'],
        'x': json['x'],
        'y': json['y'],
    };
}
function RectangleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'width': value.width,
        'height': value.height,
        'x': value.x,
        'y': value.y,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RegisterCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function RegisterCreateRequestFromJSON(json) {
    return RegisterCreateRequestFromJSONTyped(json, false);
}
function RegisterCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
        'firstName': json['firstName'],
        'importUrl': !exists(json, 'importUrl') ? undefined : json['importUrl'],
        'lastName': json['lastName'],
        'organizationName': json['organizationName'],
        'password': json['password'],
    };
}
function RegisterCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'firstName': value.firstName,
        'importUrl': value.importUrl,
        'lastName': value.lastName,
        'organizationName': value.organizationName,
        'password': value.password,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RegisterResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function RegisterResponseFromJSON(json) {
    return RegisterResponseFromJSONTyped(json, false);
}
function RegisterResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'organization': OrganizationResponseFromJSON(json['organization']),
        'user': UserResponseFromJSON(json['user']),
    };
}
function RegisterResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RestAppCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function RestAppCreateRequestFromJSON(json) {
    return RestAppCreateRequestFromJSONTyped(json, false);
}
function RestAppCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function RestAppCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RestAppResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function RestAppResponseFromJSON(json) {
    return RestAppResponseFromJSONTyped(json, false);
}
function RestAppResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'name': json['name'],
        'password': json['password'],
        'roles': json['roles'],
        'username': json['username'],
    };
}
function RestAppResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': (value.createdAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'password': value.password,
        'roles': value.roles,
        'username': value.username,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RestAppUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function RestAppUpdateRequestFromJSON(json) {
    return RestAppUpdateRequestFromJSONTyped(json, false);
}
function RestAppUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function RestAppUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RevenueCenterCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function RevenueCenterCreateRequestFromJSON(json) {
    return RevenueCenterCreateRequestFromJSONTyped(json, false);
}
function RevenueCenterCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currency': ApplicationCurrencyFromJSON(json['currency']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'name': json['name'],
        'taxRate': !exists(json, 'taxRate') ? undefined : json['taxRate'],
    };
}
function RevenueCenterCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency': ApplicationCurrencyToJSON(value.currency),
        'address': AddressToJSON(value.address),
        'name': value.name,
        'taxRate': value.taxRate,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RevenueCenterResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function RevenueCenterResponseFromJSON(json) {
    return RevenueCenterResponseFromJSONTyped(json, false);
}
function RevenueCenterResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': AddressFromJSON(json['address']),
        'createdAt': (new Date(json['createdAt'])),
        'currency': json['currency'],
        'id': json['id'],
        'name': json['name'],
        'taxRate': json['taxRate'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function RevenueCenterResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': AddressToJSON(value.address),
        'createdAt': (value.createdAt.toISOString()),
        'currency': value.currency,
        'id': value.id,
        'name': value.name,
        'taxRate': value.taxRate,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RevenueCenterUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function RevenueCenterUpdateRequestFromJSON(json) {
    return RevenueCenterUpdateRequestFromJSONTyped(json, false);
}
function RevenueCenterUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currency': !exists(json, 'currency') ? undefined : ApplicationCurrencyFromJSON(json['currency']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'taxRate': !exists(json, 'taxRate') ? undefined : json['taxRate'],
    };
}
function RevenueCenterUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency': ApplicationCurrencyToJSON(value.currency),
        'address': AddressToJSON(value.address),
        'name': value.name,
        'taxRate': value.taxRate,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Role.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var Role;
(function (Role) {
    Role["OrganizationUser"] = "_organization_user";
    Role["User"] = "user";
    Role["OrganizationAdmin"] = "organization_admin";
    Role["Plugin"] = "plugin";
    Role["RestApp"] = "rest_app";
    Role["AccessCode"] = "access_code";
    Role["MediaCollectionAccessCode"] = "media_collection_access_code";
    Role["Kiosk"] = "kiosk";
    Role["OrganizationKiosk"] = "organization_kiosk";
    Role["OrganizationRegistrar"] = "organization_registrar";
    Role["PhotoboothAdmin"] = "photobooth_admin";
    Role["SpinToWinAdmin"] = "spin_to_win_admin";
    Role["MediaCollectionAdmin"] = "media_collection_admin";
})(Role || (Role = {}));
function RoleFromJSON(json) {
    return RoleFromJSONTyped(json, false);
}
function RoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RoleToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RoleName.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var RoleName;
(function (RoleName) {
    RoleName["OrganizationUser"] = "_organization_user";
    RoleName["User"] = "user";
    RoleName["OrganizationAdmin"] = "organization_admin";
    RoleName["Plugin"] = "plugin";
    RoleName["RestApp"] = "rest_app";
    RoleName["AccessCode"] = "access_code";
    RoleName["MediaCollectionAccessCode"] = "media_collection_access_code";
    RoleName["Kiosk"] = "kiosk";
    RoleName["OrganizationKiosk"] = "organization_kiosk";
    RoleName["OrganizationRegistrar"] = "organization_registrar";
    RoleName["PhotoboothAdmin"] = "photobooth_admin";
    RoleName["SpinToWinAdmin"] = "spin_to_win_admin";
    RoleName["MediaCollectionAdmin"] = "media_collection_admin";
})(RoleName || (RoleName = {}));
function RoleNameFromJSON(json) {
    return RoleNameFromJSONTyped(json, false);
}
function RoleNameFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RoleNameToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/RoleResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function RoleResponseFromJSON(json) {
    return RoleResponseFromJSONTyped(json, false);
}
function RoleResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': RoleNameFromJSON(json['name']),
        'title': json['title'],
    };
}
function RoleResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': RoleNameToJSON(value.name),
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutAppPreferences.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutAppPreferencesFromJSON(json) {
    return SelfCheckoutAppPreferencesFromJSONTyped(json, false);
}
function SelfCheckoutAppPreferencesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shopify': !exists(json, 'shopify') ? undefined : SelfCheckoutShopifyPreferencesFromJSON(json['shopify']),
        'checkout': !exists(json, 'checkout') ? undefined : SelfCheckoutAppPreferencesCheckoutFromJSON(json['checkout']),
        'order': !exists(json, 'order') ? undefined : SelfCheckoutAppPreferencesOrderFromJSON(json['order']),
        'ui': !exists(json, 'ui') ? undefined : SelfCheckoutUIModelFromJSON(json['ui']),
    };
}
function SelfCheckoutAppPreferencesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shopify': SelfCheckoutShopifyPreferencesToJSON(value.shopify),
        'checkout': SelfCheckoutAppPreferencesCheckoutToJSON(value.checkout),
        'order': SelfCheckoutAppPreferencesOrderToJSON(value.order),
        'ui': SelfCheckoutUIModelToJSON(value.ui),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutAppPreferencesCheckout.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutAppPreferencesCheckoutFromJSON(json) {
    return SelfCheckoutAppPreferencesCheckoutFromJSONTyped(json, false);
}
function SelfCheckoutAppPreferencesCheckoutFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerEmailRequired': !exists(json, 'customerEmailRequired') ? undefined : json['customerEmailRequired'],
        'forceAddSingleItem': !exists(json, 'forceAddSingleItem') ? undefined : json['forceAddSingleItem'],
        'fields': !exists(json, 'fields') ? undefined : CheckoutFieldOptionsFromJSON(json['fields']),
    };
}
function SelfCheckoutAppPreferencesCheckoutToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerEmailRequired': value.customerEmailRequired,
        'forceAddSingleItem': value.forceAddSingleItem,
        'fields': CheckoutFieldOptionsToJSON(value.fields),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutAppPreferencesOrder.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutAppPreferencesOrderFromJSON(json) {
    return SelfCheckoutAppPreferencesOrderFromJSONTyped(json, false);
}
function SelfCheckoutAppPreferencesOrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enableNotification': !exists(json, 'enableNotification') ? undefined : json['enableNotification'],
        'defaultCustomer': !exists(json, 'defaultCustomer') ? undefined : CustomerCreateRequestFromJSON(json['defaultCustomer']),
        'customerMarketingBehavior': !exists(json, 'customerMarketingBehavior') ? undefined : ShopifyCustomerMarketingBehaviorFromJSON(json['customerMarketingBehavior']),
        'inventoryLocation': !exists(json, 'inventoryLocation') ? undefined : json['inventoryLocation'],
        'includeTags': !exists(json, 'includeTags') ? undefined : json['includeTags'],
        'inventoryBehavior': !exists(json, 'inventoryBehavior') ? undefined : ShopifyInventoryBehaviorFromJSON(json['inventoryBehavior']),
        'fulfillmentBehavior': !exists(json, 'fulfillmentBehavior') ? undefined : ShopifyFulfillmentBehaviorFromJSON(json['fulfillmentBehavior']),
    };
}
function SelfCheckoutAppPreferencesOrderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enableNotification': value.enableNotification,
        'defaultCustomer': CustomerCreateRequestToJSON(value.defaultCustomer),
        'customerMarketingBehavior': ShopifyCustomerMarketingBehaviorToJSON(value.customerMarketingBehavior),
        'inventoryLocation': value.inventoryLocation,
        'includeTags': value.includeTags,
        'inventoryBehavior': ShopifyInventoryBehaviorToJSON(value.inventoryBehavior),
        'fulfillmentBehavior': ShopifyFulfillmentBehaviorToJSON(value.fulfillmentBehavior),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutCountryResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @export
* @enum {string}
*/
var SelfCheckoutCountryResponseCodeEnum;
(function (SelfCheckoutCountryResponseCodeEnum) {
    SelfCheckoutCountryResponseCodeEnum["Ca"] = "CA";
    SelfCheckoutCountryResponseCodeEnum["Us"] = "US";
})(SelfCheckoutCountryResponseCodeEnum || (SelfCheckoutCountryResponseCodeEnum = {}));
function SelfCheckoutCountryResponseFromJSON(json) {
    return SelfCheckoutCountryResponseFromJSONTyped(json, false);
}
function SelfCheckoutCountryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
        'id': json['id'],
        'name': json['name'],
        'selfCheckoutIds': json['selfCheckoutIds'],
    };
}
function SelfCheckoutCountryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'id': value.id,
        'name': value.name,
        'selfCheckoutIds': value.selfCheckoutIds,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutCreateRequestFromJSON(json) {
    return SelfCheckoutCreateRequestFromJSONTyped(json, false);
}
function SelfCheckoutCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'bannerId': !exists(json, 'bannerId') ? undefined : json['bannerId'],
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
        'duplicateId': !exists(json, 'duplicateId') ? undefined : json['duplicateId'],
        'gatewayId': !exists(json, 'gatewayId') ? undefined : json['gatewayId'],
        'integrationIds': !exists(json, 'integrationIds') ? undefined : json['integrationIds'],
        'maxIdleTime': !exists(json, 'maxIdleTime') ? undefined : json['maxIdleTime'],
        'newOrderEmail': !exists(json, 'newOrderEmail') ? undefined : NotificationUpdateRequestFromJSON(json['newOrderEmail']),
        'newOrderReceipt': !exists(json, 'newOrderReceipt') ? undefined : NotificationUpdateRequestFromJSON(json['newOrderReceipt']),
        'preferences': !exists(json, 'preferences') ? undefined : SelfCheckoutAppPreferencesFromJSON(json['preferences']),
        'revenueCenterId': !exists(json, 'revenueCenterId') ? undefined : json['revenueCenterId'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'screensaverTimeout': !exists(json, 'screensaverTimeout') ? undefined : json['screensaverTimeout'],
        'shippingDefaults': !exists(json, 'shippingDefaults') ? undefined : json['shippingDefaults'],
        'shopifyId': !exists(json, 'shopifyId') ? undefined : json['shopifyId'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': json['name'],
    };
}
function SelfCheckoutCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': AddressToJSON(value.address),
        'bannerId': value.bannerId,
        'categoryIds': value.categoryIds,
        'duplicateId': value.duplicateId,
        'gatewayId': value.gatewayId,
        'integrationIds': value.integrationIds,
        'maxIdleTime': value.maxIdleTime,
        'newOrderEmail': NotificationUpdateRequestToJSON(value.newOrderEmail),
        'newOrderReceipt': NotificationUpdateRequestToJSON(value.newOrderReceipt),
        'preferences': SelfCheckoutAppPreferencesToJSON(value.preferences),
        'revenueCenterId': value.revenueCenterId,
        'screensaverId': value.screensaverId,
        'screensaverTimeout': value.screensaverTimeout,
        'shippingDefaults': value.shippingDefaults,
        'shopifyId': value.shopifyId,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationCacheQuery.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SelfCheckoutIntegrationCacheQueryFromJSON(json) {
    return SelfCheckoutIntegrationCacheQueryFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationCacheQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'query': json['query'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}
function SelfCheckoutIntegrationCacheQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'query': value.query,
        'limit': value.limit,
        'skip': value.skip,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationCacheResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SelfCheckoutIntegrationCacheResponseFromJSON(json) {
    return SelfCheckoutIntegrationCacheResponseFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationCacheResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cachedAt': (new Date(json['cachedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'updatedAt': (new Date(json['updatedAt'])),
        'url': json['url'],
    };
}
function SelfCheckoutIntegrationCacheResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cachedAt': (value.cachedAt.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'id': value.id,
        'updatedAt': (value.updatedAt.toISOString()),
        'url': value.url,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationCacheUpdate.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SelfCheckoutIntegrationCacheUpdateFromJSON(json) {
    return SelfCheckoutIntegrationCacheUpdateFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationCacheUpdateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'query': json['query'],
        'update': json['update'],
    };
}
function SelfCheckoutIntegrationCacheUpdateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'query': value.query,
        'update': value.update,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutIntegrationCreateRequestFromJSON(json) {
    return SelfCheckoutIntegrationCreateRequestFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shopify': !exists(json, 'shopify') ? undefined : SelfCheckoutShopifyIntegrationFromJSON(json['shopify']),
        'type': SelfCheckoutIntegrationTypeFromJSON(json['type']),
        'duplicateId': !exists(json, 'duplicateId') ? undefined : json['duplicateId'],
        'name': json['name'],
    };
}
function SelfCheckoutIntegrationCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shopify': SelfCheckoutShopifyIntegrationToJSON(value.shopify),
        'type': SelfCheckoutIntegrationTypeToJSON(value.type),
        'duplicateId': value.duplicateId,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SelfCheckoutIntegrationResponseFromJSON(json) {
    return SelfCheckoutIntegrationResponseFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cache': SelfCheckoutIntegrationCacheResponseFromJSON(json['cache']),
        'shopify': SelfCheckoutShopifyIntegrationFromJSON(json['shopify']),
        'type': SelfCheckoutIntegrationTypeFromJSON(json['type']),
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function SelfCheckoutIntegrationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cache': SelfCheckoutIntegrationCacheResponseToJSON(value.cache),
        'shopify': SelfCheckoutShopifyIntegrationToJSON(value.shopify),
        'type': SelfCheckoutIntegrationTypeToJSON(value.type),
        'createdAt': (value.createdAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SelfCheckoutIntegrationType;
(function (SelfCheckoutIntegrationType) {
    SelfCheckoutIntegrationType["Shopify"] = "shopify";
})(SelfCheckoutIntegrationType || (SelfCheckoutIntegrationType = {}));
function SelfCheckoutIntegrationTypeFromJSON(json) {
    return SelfCheckoutIntegrationTypeFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SelfCheckoutIntegrationTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutIntegrationUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutIntegrationUpdateRequestFromJSON(json) {
    return SelfCheckoutIntegrationUpdateRequestFromJSONTyped(json, false);
}
function SelfCheckoutIntegrationUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shopify': !exists(json, 'shopify') ? undefined : SelfCheckoutShopifyIntegrationFromJSON(json['shopify']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function SelfCheckoutIntegrationUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shopify': SelfCheckoutShopifyIntegrationToJSON(value.shopify),
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutOrderCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutOrderCreateRequestFromJSON(json) {
    return SelfCheckoutOrderCreateRequestFromJSONTyped(json, false);
}
function SelfCheckoutOrderCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metafields': !exists(json, 'metafields') ? undefined : json['metafields'],
        'order': OrderCreateRequestFromJSON(json['order']),
        'transaction': TransactionCreateRequestFromJSON(json['transaction']),
    };
}
function SelfCheckoutOrderCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metafields': value.metafields,
        'order': OrderCreateRequestToJSON(value.order),
        'transaction': TransactionCreateRequestToJSON(value.transaction),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutOrderResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SelfCheckoutOrderResponseFromJSON(json) {
    return SelfCheckoutOrderResponseFromJSONTyped(json, false);
}
function SelfCheckoutOrderResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'records': (json['records'].map(NotificationRecordModelFromJSON)),
        'order': OrderResponseFromJSON(json['order']),
    };
}
function SelfCheckoutOrderResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'records': (value.records.map(NotificationRecordModelToJSON)),
        'order': OrderResponseToJSON(value.order),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutResponseFromJSON(json) {
    return SelfCheckoutResponseFromJSONTyped(json, false);
}
function SelfCheckoutResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'categories': (json['categories'].map(ProductCategoryResponseFromJSON)),
        'integrations': (json['integrations'].map(SelfCheckoutIntegrationResponseFromJSON)),
        'newOrderEmail': NotificationResponseFromJSON(json['newOrderEmail']),
        'newOrderReceipt': NotificationResponseFromJSON(json['newOrderReceipt']),
        'preferences': SelfCheckoutAppPreferencesFromJSON(json['preferences']),
        'address': AddressFromJSON(json['address']),
        'bannerId': !exists(json, 'bannerId') ? undefined : json['bannerId'],
        'categoryIds': json['categoryIds'],
        'countries': (json['countries'].map(SelfCheckoutCountryResponseFromJSON)),
        'countryIds': json['countryIds'],
        'gatewayId': json['gatewayId'],
        'integrationIds': json['integrationIds'],
        'maxIdleTime': json['maxIdleTime'],
        'revenueCenterId': json['revenueCenterId'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'screensaverTimeout': json['screensaverTimeout'],
        'shippingDefaults': json['shippingDefaults'],
        'templates': (json['templates'].map(SelfCheckoutTemplateResponseFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function SelfCheckoutResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'categories': (value.categories.map(ProductCategoryResponseToJSON)),
        'integrations': (value.integrations.map(SelfCheckoutIntegrationResponseToJSON)),
        'newOrderEmail': NotificationResponseToJSON(value.newOrderEmail),
        'newOrderReceipt': NotificationResponseToJSON(value.newOrderReceipt),
        'preferences': SelfCheckoutAppPreferencesToJSON(value.preferences),
        'address': AddressToJSON(value.address),
        'bannerId': value.bannerId,
        'categoryIds': value.categoryIds,
        'countries': (value.countries.map(SelfCheckoutCountryResponseToJSON)),
        'countryIds': value.countryIds,
        'gatewayId': value.gatewayId,
        'integrationIds': value.integrationIds,
        'maxIdleTime': value.maxIdleTime,
        'revenueCenterId': value.revenueCenterId,
        'screensaverId': value.screensaverId,
        'screensaverTimeout': value.screensaverTimeout,
        'shippingDefaults': value.shippingDefaults,
        'templates': (value.templates.map(SelfCheckoutTemplateResponseToJSON)),
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutShopifyIntegration.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SelfCheckoutShopifyIntegrationFromJSON(json) {
    return SelfCheckoutShopifyIntegrationFromJSONTyped(json, false);
}
function SelfCheckoutShopifyIntegrationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'requireShippingMethod': !exists(json, 'requireShippingMethod') ? undefined : json['requireShippingMethod'],
        'shopName': !exists(json, 'shopName') ? undefined : json['shopName'],
        'storefrontAccessToken': !exists(json, 'storefrontAccessToken') ? undefined : json['storefrontAccessToken'],
        'submitOrders': !exists(json, 'submitOrders') ? undefined : json['submitOrders'],
        'useSalesChannel': !exists(json, 'useSalesChannel') ? undefined : json['useSalesChannel'],
    };
}
function SelfCheckoutShopifyIntegrationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiKey': value.apiKey,
        'domain': value.domain,
        'password': value.password,
        'requireShippingMethod': value.requireShippingMethod,
        'shopName': value.shopName,
        'storefrontAccessToken': value.storefrontAccessToken,
        'submitOrders': value.submitOrders,
        'useSalesChannel': value.useSalesChannel,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutShopifyPreferences.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutShopifyPreferencesFromJSON(json) {
    return SelfCheckoutShopifyPreferencesFromJSONTyped(json, false);
}
function SelfCheckoutShopifyPreferencesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'discountCodes': !exists(json, 'discountCodes') ? undefined : json['discountCodes'],
        'mulberryToken': !exists(json, 'mulberryToken') ? undefined : json['mulberryToken'],
        'parcelportToken': !exists(json, 'parcelportToken') ? undefined : json['parcelportToken'],
        'penguinLockersToken': !exists(json, 'penguinLockersToken') ? undefined : json['penguinLockersToken'],
        'hideCollectionImage': !exists(json, 'hideCollectionImage') ? undefined : json['hideCollectionImage'],
        'localDelivery': !exists(json, 'localDelivery') ? undefined : ShopifyLocalDeliveryOptionsFromJSON(json['localDelivery']),
    };
}
function SelfCheckoutShopifyPreferencesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'discountCodes': value.discountCodes,
        'mulberryToken': value.mulberryToken,
        'parcelportToken': value.parcelportToken,
        'penguinLockersToken': value.penguinLockersToken,
        'hideCollectionImage': value.hideCollectionImage,
        'localDelivery': ShopifyLocalDeliveryOptionsToJSON(value.localDelivery),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutTemplateCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutTemplateCreateRequestFromJSON(json) {
    return SelfCheckoutTemplateCreateRequestFromJSONTyped(json, false);
}
function SelfCheckoutTemplateCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target': SelfCheckoutTemplateTargetFromJSON(json['target']),
        'name': json['name'],
        'selfCheckoutIds': !exists(json, 'selfCheckoutIds') ? undefined : json['selfCheckoutIds'],
        'template': json['template'],
    };
}
function SelfCheckoutTemplateCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target': SelfCheckoutTemplateTargetToJSON(value.target),
        'name': value.name,
        'selfCheckoutIds': value.selfCheckoutIds,
        'template': value.template,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutTemplateResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SelfCheckoutTemplateResponseFromJSON(json) {
    return SelfCheckoutTemplateResponseFromJSONTyped(json, false);
}
function SelfCheckoutTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target': SelfCheckoutTemplateTargetFromJSON(json['target']),
        'id': json['id'],
        'name': json['name'],
        'selfCheckoutIds': json['selfCheckoutIds'],
        'template': json['template'],
    };
}
function SelfCheckoutTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target': SelfCheckoutTemplateTargetToJSON(value.target),
        'id': value.id,
        'name': value.name,
        'selfCheckoutIds': value.selfCheckoutIds,
        'template': value.template,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutTemplateTarget.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SelfCheckoutTemplateTarget;
(function (SelfCheckoutTemplateTarget) {
    SelfCheckoutTemplateTarget["ShopifyProductBox"] = "shopify_product_box";
    SelfCheckoutTemplateTarget["MenuCategoryCard"] = "menu_category_card";
    SelfCheckoutTemplateTarget["MenuShopifyProductCard"] = "menu_shopify_product_card";
    SelfCheckoutTemplateTarget["Cart"] = "cart";
    SelfCheckoutTemplateTarget["PaymentSuccess"] = "payment_success";
    SelfCheckoutTemplateTarget["PaymentError"] = "payment_error";
    SelfCheckoutTemplateTarget["OrderSuccessEmail"] = "order_success_email";
    SelfCheckoutTemplateTarget["OrderSuccessReceipt"] = "order_success_receipt";
    SelfCheckoutTemplateTarget["PurchaseOrder"] = "purchase_order";
})(SelfCheckoutTemplateTarget || (SelfCheckoutTemplateTarget = {}));
function SelfCheckoutTemplateTargetFromJSON(json) {
    return SelfCheckoutTemplateTargetFromJSONTyped(json, false);
}
function SelfCheckoutTemplateTargetFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SelfCheckoutTemplateTargetToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutTemplateUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SelfCheckoutTemplateUpdateRequestFromJSON(json) {
    return SelfCheckoutTemplateUpdateRequestFromJSONTyped(json, false);
}
function SelfCheckoutTemplateUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'selfCheckoutIds': !exists(json, 'selfCheckoutIds') ? undefined : json['selfCheckoutIds'],
        'template': !exists(json, 'template') ? undefined : json['template'],
    };
}
function SelfCheckoutTemplateUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'selfCheckoutIds': value.selfCheckoutIds,
        'template': value.template,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutUIMode.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SelfCheckoutUIMode;
(function (SelfCheckoutUIMode) {
    SelfCheckoutUIMode["Default"] = "default";
    SelfCheckoutUIMode["ScanAndGo"] = "scan_and_go";
})(SelfCheckoutUIMode || (SelfCheckoutUIMode = {}));
function SelfCheckoutUIModeFromJSON(json) {
    return SelfCheckoutUIModeFromJSONTyped(json, false);
}
function SelfCheckoutUIModeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SelfCheckoutUIModeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutUIModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutUIModelFromJSON(json) {
    return SelfCheckoutUIModelFromJSONTyped(json, false);
}
function SelfCheckoutUIModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mode': !exists(json, 'mode') ? undefined : SelfCheckoutUIModeFromJSON(json['mode']),
        'enableTags': !exists(json, 'enableTags') ? undefined : json['enableTags'],
        'unavailableProductDisplay': !exists(json, 'unavailableProductDisplay') ? undefined : UnavailableProductDisplayFromJSON(json['unavailableProductDisplay']),
        'menuStartIndex': !exists(json, 'menuStartIndex') ? undefined : json['menuStartIndex'],
    };
}
function SelfCheckoutUIModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mode': SelfCheckoutUIModeToJSON(value.mode),
        'enableTags': value.enableTags,
        'unavailableProductDisplay': UnavailableProductDisplayToJSON(value.unavailableProductDisplay),
        'menuStartIndex': value.menuStartIndex,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SelfCheckoutUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SelfCheckoutUpdateRequestFromJSON(json) {
    return SelfCheckoutUpdateRequestFromJSONTyped(json, false);
}
function SelfCheckoutUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'bannerId': !exists(json, 'bannerId') ? undefined : json['bannerId'],
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
        'countryIds': !exists(json, 'countryIds') ? undefined : json['countryIds'],
        'gatewayId': !exists(json, 'gatewayId') ? undefined : json['gatewayId'],
        'integrationIds': !exists(json, 'integrationIds') ? undefined : json['integrationIds'],
        'maxIdleTime': !exists(json, 'maxIdleTime') ? undefined : json['maxIdleTime'],
        'newOrderEmail': !exists(json, 'newOrderEmail') ? undefined : NotificationUpdateRequestFromJSON(json['newOrderEmail']),
        'newOrderReceipt': !exists(json, 'newOrderReceipt') ? undefined : NotificationUpdateRequestFromJSON(json['newOrderReceipt']),
        'preferences': !exists(json, 'preferences') ? undefined : SelfCheckoutAppPreferencesFromJSON(json['preferences']),
        'revenueCenterId': !exists(json, 'revenueCenterId') ? undefined : json['revenueCenterId'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'screensaverTimeout': !exists(json, 'screensaverTimeout') ? undefined : json['screensaverTimeout'],
        'shippingDefaults': !exists(json, 'shippingDefaults') ? undefined : json['shippingDefaults'],
        'shopifyId': !exists(json, 'shopifyId') ? undefined : json['shopifyId'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function SelfCheckoutUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': AddressToJSON(value.address),
        'bannerId': value.bannerId,
        'categoryIds': value.categoryIds,
        'countryIds': value.countryIds,
        'gatewayId': value.gatewayId,
        'integrationIds': value.integrationIds,
        'maxIdleTime': value.maxIdleTime,
        'newOrderEmail': NotificationUpdateRequestToJSON(value.newOrderEmail),
        'newOrderReceipt': NotificationUpdateRequestToJSON(value.newOrderReceipt),
        'preferences': SelfCheckoutAppPreferencesToJSON(value.preferences),
        'revenueCenterId': value.revenueCenterId,
        'screensaverId': value.screensaverId,
        'screensaverTimeout': value.screensaverTimeout,
        'shippingDefaults': value.shippingDefaults,
        'shopifyId': value.shopifyId,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutCollectionTree.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ShopifyCheckoutCollectionTreeFromJSON(json) {
    return ShopifyCheckoutCollectionTreeFromJSONTyped(json, false);
}
function ShopifyCheckoutCollectionTreeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionId': json['collectionId'],
        'id': json['id'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'title': json['title'],
        'type': json['type'],
    };
}
function ShopifyCheckoutCollectionTreeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'collectionId': value.collectionId,
        'id': value.id,
        'parentId': value.parentId,
        'title': value.title,
        'type': value.type,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutConfig.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ShopifyCheckoutConfigFromJSON(json) {
    return ShopifyCheckoutConfigFromJSONTyped(json, false);
}
function ShopifyCheckoutConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'catalogEnabled': !exists(json, 'catalogEnabled') ? undefined : json['catalogEnabled'],
    };
}
function ShopifyCheckoutConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'catalogEnabled': value.catalogEnabled,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutCreateRequestFromJSON(json) {
    return ShopifyCheckoutCreateRequestFromJSONTyped(json, false);
}
function ShopifyCheckoutCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionTree': !exists(json, 'collectionTree') ? undefined : (json['collectionTree'].map(ShopifyCheckoutCollectionTreeFromJSON)),
        'mode': ShopifyCheckoutModeFromJSON(json['mode']),
        'pos': !exists(json, 'pos') ? undefined : ShopifyCheckoutPOSFromJSON(json['pos']),
        'bannerId': !exists(json, 'bannerId') ? undefined : json['bannerId'],
        'integrationId': !exists(json, 'integrationId') ? undefined : json['integrationId'],
        'inventoryLocation': !exists(json, 'inventoryLocation') ? undefined : json['inventoryLocation'],
        'manualPaymentName': !exists(json, 'manualPaymentName') ? undefined : json['manualPaymentName'],
        'startPage': !exists(json, 'startPage') ? undefined : json['startPage'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': json['name'],
    };
}
function ShopifyCheckoutCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'collectionTree': value.collectionTree === undefined ? undefined : (value.collectionTree.map(ShopifyCheckoutCollectionTreeToJSON)),
        'mode': ShopifyCheckoutModeToJSON(value.mode),
        'pos': ShopifyCheckoutPOSToJSON(value.pos),
        'bannerId': value.bannerId,
        'integrationId': value.integrationId,
        'inventoryLocation': value.inventoryLocation,
        'manualPaymentName': value.manualPaymentName,
        'startPage': value.startPage,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutIntegration.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ShopifyCheckoutIntegrationFromJSON(json) {
    return ShopifyCheckoutIntegrationFromJSONTyped(json, false);
}
function ShopifyCheckoutIntegrationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'checkout': json['checkout'],
        'checkoutToken': json['checkoutToken'],
        'metafields': json['metafields'],
        'orderId': json['orderId'],
        'orderName': json['orderName'],
        'orderNumber': json['orderNumber'],
        'shippingLine': ShopifyCheckoutIntegrationShippingMethodFromJSON(json['shippingLine']),
    };
}
function ShopifyCheckoutIntegrationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkout': value.checkout,
        'checkoutToken': value.checkoutToken,
        'metafields': value.metafields,
        'orderId': value.orderId,
        'orderName': value.orderName,
        'orderNumber': value.orderNumber,
        'shippingLine': ShopifyCheckoutIntegrationShippingMethodToJSON(value.shippingLine),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutIntegrationCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ShopifyCheckoutIntegrationCreateRequestFromJSON(json) {
    return ShopifyCheckoutIntegrationCreateRequestFromJSONTyped(json, false);
}
function ShopifyCheckoutIntegrationCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'checkoutToken': json['checkoutToken'],
    };
}
function ShopifyCheckoutIntegrationCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkoutToken': value.checkoutToken,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutIntegrationShippingMethod.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ShopifyCheckoutIntegrationShippingMethodFromJSON(json) {
    return ShopifyCheckoutIntegrationShippingMethodFromJSONTyped(json, false);
}
function ShopifyCheckoutIntegrationShippingMethodFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'handle': json['handle'],
        'price': json['price'],
        'title': json['title'],
    };
}
function ShopifyCheckoutIntegrationShippingMethodToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'handle': value.handle,
        'price': value.price,
        'title': value.title,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutIntegrationUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutIntegrationUpdateRequestFromJSON(json) {
    return ShopifyCheckoutIntegrationUpdateRequestFromJSONTyped(json, false);
}
function ShopifyCheckoutIntegrationUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metafields': !exists(json, 'metafields') ? undefined : json['metafields'],
        'shippingLine': !exists(json, 'shippingLine') ? undefined : ShopifyCheckoutIntegrationShippingMethodFromJSON(json['shippingLine']),
    };
}
function ShopifyCheckoutIntegrationUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metafields': value.metafields,
        'shippingLine': ShopifyCheckoutIntegrationShippingMethodToJSON(value.shippingLine),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutMode.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ShopifyCheckoutMode;
(function (ShopifyCheckoutMode) {
    ShopifyCheckoutMode["Web"] = "web";
    ShopifyCheckoutMode["Kiosk"] = "kiosk";
})(ShopifyCheckoutMode || (ShopifyCheckoutMode = {}));
function ShopifyCheckoutModeFromJSON(json) {
    return ShopifyCheckoutModeFromJSONTyped(json, false);
}
function ShopifyCheckoutModeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShopifyCheckoutModeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutModel.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ShopifyCheckoutModelFromJSON(json) {
    return ShopifyCheckoutModelFromJSONTyped(json, false);
}
function ShopifyCheckoutModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'enabled': json['enabled'],
    };
}
function ShopifyCheckoutModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
        'enabled': value.enabled,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutPOS.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutPOSFromJSON(json) {
    return ShopifyCheckoutPOSFromJSONTyped(json, false);
}
function ShopifyCheckoutPOSFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'globalTill': !exists(json, 'globalTill') ? undefined : ShopifyCheckoutPOSGlobalTillFromJSON(json['globalTill']),
        'type': !exists(json, 'type') ? undefined : ShopifyCheckoutPOSTypeFromJSON(json['type']),
    };
}
function ShopifyCheckoutPOSToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'globalTill': ShopifyCheckoutPOSGlobalTillToJSON(value.globalTill),
        'type': ShopifyCheckoutPOSTypeToJSON(value.type),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutPOSGlobalTill.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ShopifyCheckoutPOSGlobalTillFromJSON(json) {
    return ShopifyCheckoutPOSGlobalTillFromJSONTyped(json, false);
}
function ShopifyCheckoutPOSGlobalTillFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKey': json['apiKey'],
        'locationId': json['locationId'],
        'storeId': json['storeId'],
    };
}
function ShopifyCheckoutPOSGlobalTillToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiKey': value.apiKey,
        'locationId': value.locationId,
        'storeId': value.storeId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutPOSType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ShopifyCheckoutPOSType;
(function (ShopifyCheckoutPOSType) {
    ShopifyCheckoutPOSType["None"] = "none";
    ShopifyCheckoutPOSType["GlobalTill"] = "global_till";
})(ShopifyCheckoutPOSType || (ShopifyCheckoutPOSType = {}));
function ShopifyCheckoutPOSTypeFromJSON(json) {
    return ShopifyCheckoutPOSTypeFromJSONTyped(json, false);
}
function ShopifyCheckoutPOSTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShopifyCheckoutPOSTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutPaymentCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutPaymentCreateRequestFromJSON(json) {
    return ShopifyCheckoutPaymentCreateRequestFromJSONTyped(json, false);
}
function ShopifyCheckoutPaymentCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'checkoutToken': json['checkoutToken'],
        'shopifyCheckoutId': json['shopifyCheckoutId'],
        'shopifyOrderId': !exists(json, 'shopifyOrderId') ? undefined : json['shopifyOrderId'],
        'transaction': PaymentTerminalTransactionResponseModelFromJSON(json['transaction']),
    };
}
function ShopifyCheckoutPaymentCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkoutToken': value.checkoutToken,
        'shopifyCheckoutId': value.shopifyCheckoutId,
        'shopifyOrderId': value.shopifyOrderId,
        'transaction': PaymentTerminalTransactionResponseModelToJSON(value.transaction),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutPaymentResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutPaymentResponseFromJSON(json) {
    return ShopifyCheckoutPaymentResponseFromJSONTyped(json, false);
}
function ShopifyCheckoutPaymentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'checkoutToken': json['checkoutToken'],
        'id': json['id'],
        'shopifyCheckoutId': json['shopifyCheckoutId'],
        'shopifyOrderId': !exists(json, 'shopifyOrderId') ? undefined : json['shopifyOrderId'],
        'transaction': PaymentTerminalTransactionResponseModelFromJSON(json['transaction']),
    };
}
function ShopifyCheckoutPaymentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkoutToken': value.checkoutToken,
        'id': value.id,
        'shopifyCheckoutId': value.shopifyCheckoutId,
        'shopifyOrderId': value.shopifyOrderId,
        'transaction': PaymentTerminalTransactionResponseModelToJSON(value.transaction),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutPaymentUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ShopifyCheckoutPaymentUpdateRequestFromJSON(json) {
    return ShopifyCheckoutPaymentUpdateRequestFromJSONTyped(json, false);
}
function ShopifyCheckoutPaymentUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shopifyOrderId': !exists(json, 'shopifyOrderId') ? undefined : json['shopifyOrderId'],
    };
}
function ShopifyCheckoutPaymentUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shopifyOrderId': value.shopifyOrderId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutResponseFromJSON(json) {
    return ShopifyCheckoutResponseFromJSONTyped(json, false);
}
function ShopifyCheckoutResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionTree': (json['collectionTree'].map(ShopifyCheckoutCollectionTreeFromJSON)),
        'config': ShopifyCheckoutConfigFromJSON(json['config']),
        'mode': ShopifyCheckoutModeFromJSON(json['mode']),
        'pos': !exists(json, 'pos') ? undefined : ShopifyCheckoutPOSFromJSON(json['pos']),
        'bannerId': !exists(json, 'bannerId') ? undefined : json['bannerId'],
        'integration': SelfCheckoutIntegrationResponseFromJSON(json['integration']),
        'inventoryLocation': !exists(json, 'inventoryLocation') ? undefined : json['inventoryLocation'],
        'manualPaymentName': json['manualPaymentName'],
        'metafields': (json['metafields'].map(MetafieldFromJSON)),
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'startPage': json['startPage'],
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function ShopifyCheckoutResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'collectionTree': (value.collectionTree.map(ShopifyCheckoutCollectionTreeToJSON)),
        'config': ShopifyCheckoutConfigToJSON(value.config),
        'mode': ShopifyCheckoutModeToJSON(value.mode),
        'pos': ShopifyCheckoutPOSToJSON(value.pos),
        'bannerId': value.bannerId,
        'integration': SelfCheckoutIntegrationResponseToJSON(value.integration),
        'inventoryLocation': value.inventoryLocation,
        'manualPaymentName': value.manualPaymentName,
        'metafields': (value.metafields.map(MetafieldToJSON)),
        'screensaverId': value.screensaverId,
        'startPage': value.startPage,
        'createdAt': (value.createdAt.toISOString()),
        'enabled': value.enabled,
        'id': value.id,
        'name': value.name,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCheckoutUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function ShopifyCheckoutUpdateRequestFromJSON(json) {
    return ShopifyCheckoutUpdateRequestFromJSONTyped(json, false);
}
function ShopifyCheckoutUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectionTree': !exists(json, 'collectionTree') ? undefined : (json['collectionTree'].map(ShopifyCheckoutCollectionTreeFromJSON)),
        'config': !exists(json, 'config') ? undefined : ShopifyCheckoutConfigFromJSON(json['config']),
        'mode': !exists(json, 'mode') ? undefined : ShopifyCheckoutModeFromJSON(json['mode']),
        'pos': !exists(json, 'pos') ? undefined : ShopifyCheckoutPOSFromJSON(json['pos']),
        'bannerId': !exists(json, 'bannerId') ? undefined : json['bannerId'],
        'functions': !exists(json, 'functions') ? undefined : json['functions'],
        'integrationId': !exists(json, 'integrationId') ? undefined : json['integrationId'],
        'inventoryLocation': !exists(json, 'inventoryLocation') ? undefined : json['inventoryLocation'],
        'manualPaymentName': !exists(json, 'manualPaymentName') ? undefined : json['manualPaymentName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'startPage': !exists(json, 'startPage') ? undefined : json['startPage'],
    };
}
function ShopifyCheckoutUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'collectionTree': value.collectionTree === undefined ? undefined : (value.collectionTree.map(ShopifyCheckoutCollectionTreeToJSON)),
        'config': ShopifyCheckoutConfigToJSON(value.config),
        'mode': ShopifyCheckoutModeToJSON(value.mode),
        'pos': ShopifyCheckoutPOSToJSON(value.pos),
        'bannerId': value.bannerId,
        'functions': value.functions,
        'integrationId': value.integrationId,
        'inventoryLocation': value.inventoryLocation,
        'manualPaymentName': value.manualPaymentName,
        'name': value.name,
        'screensaverId': value.screensaverId,
        'startPage': value.startPage,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyCustomerMarketingBehavior.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ShopifyCustomerMarketingBehavior;
(function (ShopifyCustomerMarketingBehavior) {
    ShopifyCustomerMarketingBehavior["Disabled"] = "disabled";
    ShopifyCustomerMarketingBehavior["OptInRequired"] = "opt_in_required";
    ShopifyCustomerMarketingBehavior["AutoAccept"] = "auto_accept";
})(ShopifyCustomerMarketingBehavior || (ShopifyCustomerMarketingBehavior = {}));
function ShopifyCustomerMarketingBehaviorFromJSON(json) {
    return ShopifyCustomerMarketingBehaviorFromJSONTyped(json, false);
}
function ShopifyCustomerMarketingBehaviorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShopifyCustomerMarketingBehaviorToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyFulfillmentBehavior.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ShopifyFulfillmentBehavior;
(function (ShopifyFulfillmentBehavior) {
    ShopifyFulfillmentBehavior["Default"] = "default";
    ShopifyFulfillmentBehavior["Always"] = "always";
})(ShopifyFulfillmentBehavior || (ShopifyFulfillmentBehavior = {}));
function ShopifyFulfillmentBehaviorFromJSON(json) {
    return ShopifyFulfillmentBehaviorFromJSONTyped(json, false);
}
function ShopifyFulfillmentBehaviorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShopifyFulfillmentBehaviorToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyInventoryBehavior.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ShopifyInventoryBehavior;
(function (ShopifyInventoryBehavior) {
    ShopifyInventoryBehavior["Bypass"] = "bypass";
    ShopifyInventoryBehavior["DecrementIgnoringPolicy"] = "decrement_ignoring_policy";
    ShopifyInventoryBehavior["DecrementObeyingPolicy"] = "decrement_obeying_policy";
})(ShopifyInventoryBehavior || (ShopifyInventoryBehavior = {}));
function ShopifyInventoryBehaviorFromJSON(json) {
    return ShopifyInventoryBehaviorFromJSONTyped(json, false);
}
function ShopifyInventoryBehaviorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShopifyInventoryBehaviorToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/ShopifyLocalDeliveryOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function ShopifyLocalDeliveryOptionsFromJSON(json) {
    return ShopifyLocalDeliveryOptionsFromJSONTyped(json, false);
}
function ShopifyLocalDeliveryOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': json['enabled'],
        'atomYardConfigUrl': !exists(json, 'atomYardConfigUrl') ? undefined : json['atomYardConfigUrl'],
    };
}
function ShopifyLocalDeliveryOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'atomYardConfigUrl': value.atomYardConfigUrl,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/Size.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SizeFromJSON(json) {
    return SizeFromJSONTyped(json, false);
}
function SizeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'width': json['width'],
        'height': json['height'],
    };
}
function SizeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'width': value.width,
        'height': value.height,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SpinToWinConfig.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function SpinToWinConfigFromJSON(json) {
    return SpinToWinConfigFromJSONTyped(json, false);
}
function SpinToWinConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'prizeRanges': !exists(json, 'prizeRanges') ? undefined : json['prizeRanges'],
    };
}
function SpinToWinConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'prizeRanges': value.prizeRanges,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SpinToWinCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SpinToWinCreateRequestFromJSON(json) {
    return SpinToWinCreateRequestFromJSONTyped(json, false);
}
function SpinToWinCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'config': !exists(json, 'config') ? undefined : SpinToWinConfigFromJSON(json['config']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': json['name'],
    };
}
function SpinToWinCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'config': SpinToWinConfigToJSON(value.config),
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SpinToWinResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SpinToWinResponseFromJSON(json) {
    return SpinToWinResponseFromJSONTyped(json, false);
}
function SpinToWinResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'enabled': json['enabled'],
        'id': json['id'],
        'name': json['name'],
        'updatedAt': (new Date(json['updatedAt'])),
        'config': SpinToWinConfigFromJSON(json['config']),
        'emailShareNotification': NotificationEmailTemplateFromJSON(json['emailShareNotification']),
        'fields': (json['fields'].map(CustomFieldOptionsFromJSON)),
        'backgroundId': !exists(json, 'backgroundId') ? undefined : json['backgroundId'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
    };
}
function SpinToWinResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'config': SpinToWinConfigToJSON(value.config),
        'emailShareNotification': NotificationEmailTemplateToJSON(value.emailShareNotification),
        'fields': (value.fields.map(CustomFieldOptionsToJSON)),
        'backgroundId': value.backgroundId,
        'screensaverId': value.screensaverId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SpinToWinSessionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SpinToWinSessionCreateRequestFromJSON(json) {
    return SpinToWinSessionCreateRequestFromJSONTyped(json, false);
}
function SpinToWinSessionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fieldEntries': (json['fieldEntries'].map(CustomFieldEntryFromJSON)),
        'score': json['score'],
        'spinToWinId': json['spinToWinId'],
        'uploadId': !exists(json, 'uploadId') ? undefined : json['uploadId'],
    };
}
function SpinToWinSessionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fieldEntries': (value.fieldEntries.map(CustomFieldEntryToJSON)),
        'score': value.score,
        'spinToWinId': value.spinToWinId,
        'uploadId': value.uploadId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/SpinToWinUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function SpinToWinUpdateRequestFromJSON(json) {
    return SpinToWinUpdateRequestFromJSONTyped(json, false);
}
function SpinToWinUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'config': !exists(json, 'config') ? undefined : SpinToWinConfigFromJSON(json['config']),
        'emailShareNotification': !exists(json, 'emailShareNotification') ? undefined : NotificationEmailTemplateFromJSON(json['emailShareNotification']),
        'fields': !exists(json, 'fields') ? undefined : (json['fields'].map(CustomFieldOptionsFromJSON)),
        'backgroundId': !exists(json, 'backgroundId') ? undefined : json['backgroundId'],
        'screensaverId': !exists(json, 'screensaverId') ? undefined : json['screensaverId'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'meta': !exists(json, 'meta') ? undefined : json['meta'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
function SpinToWinUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'config': SpinToWinConfigToJSON(value.config),
        'emailShareNotification': NotificationEmailTemplateToJSON(value.emailShareNotification),
        'fields': value.fields === undefined ? undefined : (value.fields.map(CustomFieldOptionsToJSON)),
        'backgroundId': value.backgroundId,
        'screensaverId': value.screensaverId,
        'enabled': value.enabled,
        'meta': value.meta,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StorageCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function StorageCreateRequestFromJSON(json) {
    return StorageCreateRequestFromJSONTyped(json, false);
}
function StorageCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'providerId': !exists(json, 'providerId') ? undefined : json['providerId'],
    };
}
function StorageCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'providerId': value.providerId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StorageResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function StorageResponseFromJSON(json) {
    return StorageResponseFromJSONTyped(json, false);
}
function StorageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
function StorageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StorageUploadCompleteRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function StorageUploadCompleteRequestFromJSON(json) {
    return StorageUploadCompleteRequestFromJSONTyped(json, false);
}
function StorageUploadCompleteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadId': json['uploadId'],
    };
}
function StorageUploadCompleteRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadId': value.uploadId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StorageUploadCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function StorageUploadCreateRequestFromJSON(json) {
    return StorageUploadCreateRequestFromJSONTyped(json, false);
}
function StorageUploadCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadType': StorageUploadTypeFromJSON(json['uploadType']),
        'body': !exists(json, 'body') ? undefined : json['body'],
        'maxSize': !exists(json, 'maxSize') ? undefined : json['maxSize'],
        'minSize': !exists(json, 'minSize') ? undefined : json['minSize'],
        'name': json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'typePrefix': !exists(json, 'typePrefix') ? undefined : json['typePrefix'],
    };
}
function StorageUploadCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadType': StorageUploadTypeToJSON(value.uploadType),
        'body': value.body,
        'maxSize': value.maxSize,
        'minSize': value.minSize,
        'name': value.name,
        'type': value.type,
        'typePrefix': value.typePrefix,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StorageUploadResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function StorageUploadResponseFromJSON(json) {
    return StorageUploadResponseFromJSONTyped(json, false);
}
function StorageUploadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'etag': json['etag'],
        'id': json['id'],
        'name': json['name'],
        'presignedPost': PresignedPostFromJSON(json['presignedPost']),
        'size': json['size'],
        'type': json['type'],
        'uploadedAt': (new Date(json['uploadedAt'])),
        'url': json['url'],
    };
}
function StorageUploadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StorageUploadType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var StorageUploadType;
(function (StorageUploadType) {
    StorageUploadType["PresignedPost"] = "presigned_post";
    StorageUploadType["Body"] = "body";
})(StorageUploadType || (StorageUploadType = {}));
function StorageUploadTypeFromJSON(json) {
    return StorageUploadTypeFromJSONTyped(json, false);
}
function StorageUploadTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function StorageUploadTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StripeGatewayRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function StripeGatewayRequestFromJSON(json) {
    return StripeGatewayRequestFromJSONTyped(json, false);
}
function StripeGatewayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'publishableKey': json['publishableKey'],
        'secretKey': json['secretKey'],
        'webhookSecret': json['webhookSecret'],
    };
}
function StripeGatewayRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'publishableKey': value.publishableKey,
        'secretKey': value.secretKey,
        'webhookSecret': value.webhookSecret,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/StripeGatewayResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function StripeGatewayResponseFromJSON(json) {
    return StripeGatewayResponseFromJSONTyped(json, false);
}
function StripeGatewayResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'publishableKey': json['publishableKey'],
        'secretKey': json['secretKey'],
        'webhookSecret': json['webhookSecret'],
    };
}
function StripeGatewayResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'publishableKey': value.publishableKey,
        'secretKey': value.secretKey,
        'webhookSecret': value.webhookSecret,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TokenResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function TokenResponseFromJSON(json) {
    return TokenResponseFromJSONTyped(json, false);
}
function TokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': json['token'],
    };
}
function TokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TransactionCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function TransactionCreateRequestFromJSON(json) {
    return TransactionCreateRequestFromJSONTyped(json, false);
}
function TransactionCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currency': ApplicationCurrencyFromJSON(json['currency']),
        'messages': !exists(json, 'messages') ? undefined : (json['messages'].map(TransactionMessageFromJSON)),
        'method': TransactionMethodFromJSON(json['method']),
        'status': !exists(json, 'status') ? undefined : TransactionStatusFromJSON(json['status']),
        'type': TransactionTypeFromJSON(json['type']),
        'amount': json['amount'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'gatewayId': !exists(json, 'gatewayId') ? undefined : json['gatewayId'],
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'paymentTerminalId': !exists(json, 'paymentTerminalId') ? undefined : json['paymentTerminalId'],
        'paymentTerminalResponse': !exists(json, 'paymentTerminalResponse') ? undefined : PaymentTerminalTransactionResponseModelFromJSON(json['paymentTerminalResponse']),
        'test': !exists(json, 'test') ? undefined : json['test'],
    };
}
function TransactionCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency': ApplicationCurrencyToJSON(value.currency),
        'messages': value.messages === undefined ? undefined : (value.messages.map(TransactionMessageToJSON)),
        'method': TransactionMethodToJSON(value.method),
        'status': TransactionStatusToJSON(value.status),
        'type': TransactionTypeToJSON(value.type),
        'amount': value.amount,
        'customerId': value.customerId,
        'gatewayId': value.gatewayId,
        'orderId': value.orderId,
        'paymentTerminalId': value.paymentTerminalId,
        'paymentTerminalResponse': PaymentTerminalTransactionResponseModelToJSON(value.paymentTerminalResponse),
        'test': value.test,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TransactionMessage.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function TransactionMessageFromJSON(json) {
    return TransactionMessageFromJSONTyped(json, false);
}
function TransactionMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'name': json['name'],
        'value': json['value'],
    };
}
function TransactionMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'name': value.name,
        'value': value.value,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TransactionMethod.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var TransactionMethod;
(function (TransactionMethod) {
    TransactionMethod["Gateway"] = "gateway";
    TransactionMethod["Cash"] = "cash";
    TransactionMethod["Cheque"] = "cheque";
    TransactionMethod["Other"] = "other";
    TransactionMethod["BankTransfer"] = "bank_transfer";
})(TransactionMethod || (TransactionMethod = {}));
function TransactionMethodFromJSON(json) {
    return TransactionMethodFromJSONTyped(json, false);
}
function TransactionMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TransactionMethodToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TransactionResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function TransactionResponseFromJSON(json) {
    return TransactionResponseFromJSONTyped(json, false);
}
function TransactionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gatewayType': PaymentGatewayTypeFromJSON(json['gatewayType']),
        'messages': (json['messages'].map(TransactionMessageFromJSON)),
        'method': TransactionMethodFromJSON(json['method']),
        'status': TransactionStatusFromJSON(json['status']),
        'type': TransactionStatusFromJSON(json['type']),
        'amount': json['amount'],
        'createdAt': (new Date(json['createdAt'])),
        'currency': json['currency'],
        'gatewayId': json['gatewayId'],
        'id': json['id'],
        'orderId': json['orderId'],
        'paymentTerminalId': json['paymentTerminalId'],
        'paymentTerminalResponse': PaymentTerminalTransactionResponseModelFromJSON(json['paymentTerminalResponse']),
        'test': json['test'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function TransactionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gatewayType': PaymentGatewayTypeToJSON(value.gatewayType),
        'messages': (value.messages.map(TransactionMessageToJSON)),
        'method': TransactionMethodToJSON(value.method),
        'status': TransactionStatusToJSON(value.status),
        'type': TransactionStatusToJSON(value.type),
        'amount': value.amount,
        'createdAt': (value.createdAt.toISOString()),
        'currency': value.currency,
        'gatewayId': value.gatewayId,
        'id': value.id,
        'orderId': value.orderId,
        'paymentTerminalId': value.paymentTerminalId,
        'paymentTerminalResponse': PaymentTerminalTransactionResponseModelToJSON(value.paymentTerminalResponse),
        'test': value.test,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TransactionStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Success"] = "success";
    TransactionStatus["Pending"] = "pending";
    TransactionStatus["Error"] = "error";
})(TransactionStatus || (TransactionStatus = {}));
function TransactionStatusFromJSON(json) {
    return TransactionStatusFromJSONTyped(json, false);
}
function TransactionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TransactionStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/TransactionType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var TransactionType;
(function (TransactionType) {
    TransactionType["Purchase"] = "purchase";
    TransactionType["Void"] = "void";
    TransactionType["Refund"] = "refund";
})(TransactionType || (TransactionType = {}));
function TransactionTypeFromJSON(json) {
    return TransactionTypeFromJSONTyped(json, false);
}
function TransactionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function TransactionTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/UnavailableProductDisplay.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var UnavailableProductDisplay;
(function (UnavailableProductDisplay) {
    UnavailableProductDisplay["None"] = "none";
    UnavailableProductDisplay["Hide"] = "hide";
    UnavailableProductDisplay["ShowBadge"] = "show_badge";
})(UnavailableProductDisplay || (UnavailableProductDisplay = {}));
function UnavailableProductDisplayFromJSON(json) {
    return UnavailableProductDisplayFromJSONTyped(json, false);
}
function UnavailableProductDisplayFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function UnavailableProductDisplayToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/UserCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function UserCreateRequestFromJSON(json) {
    return UserCreateRequestFromJSONTyped(json, false);
}
function UserCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roles': !exists(json, 'roles') ? undefined : (json['roles'].map(RoleFromJSON)),
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'password': json['password'],
    };
}
function UserCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'roles': value.roles === undefined ? undefined : (value.roles.map(RoleToJSON)),
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'password': value.password,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/UserResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function UserResponseFromJSON(json) {
    return UserResponseFromJSONTyped(json, false);
}
function UserResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roles': (json['roles'].map(RoleResponseFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'email': json['email'],
        'firstName': json['firstName'],
        'id': json['id'],
        'lastName': json['lastName'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}
function UserResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'roles': (value.roles.map(RoleResponseToJSON)),
        'createdAt': (value.createdAt.toISOString()),
        'email': value.email,
        'firstName': value.firstName,
        'id': value.id,
        'lastName': value.lastName,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/UserUpdateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function UserUpdateRequestFromJSON(json) {
    return UserUpdateRequestFromJSONTyped(json, false);
}
function UserUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roles': !exists(json, 'roles') ? undefined : (json['roles'].map(RoleNameFromJSON)),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}
function UserUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'roles': value.roles === undefined ? undefined : (value.roles.map(RoleNameToJSON)),
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'password': value.password,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/VideoUploadCreateRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function VideoUploadCreateRequestFromJSON(json) {
    return VideoUploadCreateRequestFromJSONTyped(json, false);
}
function VideoUploadCreateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadId': json['uploadId'],
    };
}
function VideoUploadCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadId': value.uploadId,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/VideoUploadRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function VideoUploadRequestFromJSON(json) {
    return VideoUploadRequestFromJSONTyped(json, false);
}
function VideoUploadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
function VideoUploadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/VideoUploadResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function VideoUploadResponseFromJSON(json) {
    return VideoUploadResponseFromJSONTyped(json, false);
}
function VideoUploadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'poster': ImageUploadResponseFromJSON(json['poster']),
        'thumbnail': ImageUploadResponseFromJSON(json['thumbnail']),
        'updatedAt': (new Date(json['updatedAt'])),
        'url': json['url'],
        'duration': json['duration'],
        'height': json['height'],
        'width': json['width'],
    };
}
function VideoUploadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'poster': ImageUploadResponseToJSON(value.poster),
        'thumbnail': ImageUploadResponseToJSON(value.thumbnail),
        'duration': value.duration,
        'height': value.height,
        'width': value.width,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/WeeklySchedule.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function WeeklyScheduleFromJSON(json) {
    return WeeklyScheduleFromJSONTyped(json, false);
}
function WeeklyScheduleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'days': (json['days'].map(WeeklyScheduleDayFromJSON)),
    };
}
function WeeklyScheduleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start': (value.start.toISOString()),
        'end': (value.end.toISOString()),
        'days': (value.days.map(WeeklyScheduleDayToJSON)),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/WeeklyScheduleDay.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function WeeklyScheduleDayFromJSON(json) {
    return WeeklyScheduleDayFromJSONTyped(json, false);
}
function WeeklyScheduleDayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'day': json['day'],
        'intervals': json['intervals'],
    };
}
function WeeklyScheduleDayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'day': value.day,
        'intervals': value.intervals,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/models/index.ts
/* tslint:disable */
/* eslint-disable */


























































































































































































































































































;// CONCATENATED MODULE: ./client/lib/esuite-api/apis/DefaultApi.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite API
 * Admin API to manage all variety of E Suite Organization Resources.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 *
 */
class DefaultApi extends BaseAPI {
    /**
     */
    accessCodeControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AccessCodeCreateRequest === null || requestParameters.AccessCodeCreateRequest === undefined) {
                throw new RequiredError('AccessCodeCreateRequest', 'Required parameter requestParameters.AccessCodeCreateRequest was null or undefined when calling accessCodeControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_code`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AccessCodeCreateRequestToJSON(requestParameters.AccessCodeCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    accessCodeControllerCreate(AccessCodeCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessCodeControllerCreateRaw({ AccessCodeCreateRequest: AccessCodeCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessCodeControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accessCodeControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_code/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    accessCodeControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessCodeControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessCodeControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_code`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessCodeResponseFromJSON));
        });
    }
    /**
     */
    accessCodeControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessCodeControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessCodeControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accessCodeControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_code/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    accessCodeControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.accessCodeControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    accessCodeControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accessCodeControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling accessCodeControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_code/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    accessCodeControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessCodeControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessControlControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AccessControlCreateRequest === null || requestParameters.AccessControlCreateRequest === undefined) {
                throw new RequiredError('AccessControlCreateRequest', 'Required parameter requestParameters.AccessControlCreateRequest was null or undefined when calling accessControlControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_control`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AccessControlCreateRequestToJSON(requestParameters.AccessControlCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessControlResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    accessControlControllerCreate(AccessControlCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessControlControllerCreateRaw({ AccessControlCreateRequest: AccessControlCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessControlControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accessControlControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_control/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessControlResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    accessControlControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessControlControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessControlControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_control`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AccessControlResponseFromJSON));
        });
    }
    /**
     */
    accessControlControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessControlControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    accessControlControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accessControlControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_control/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    accessControlControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.accessControlControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    accessControlControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accessControlControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling accessControlControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/access_control/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessControlResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    accessControlControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.accessControlControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationFromJSON(jsonValue));
        });
    }
    /**
     */
    activationControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.kioskId !== undefined) {
                queryParameters['kioskId'] = requestParameters.kioskId;
            }
            if (requestParameters.kioskIds) {
                queryParameters['kioskIds'] = requestParameters.kioskIds;
            }
            if (requestParameters.digitalSignageId !== undefined) {
                queryParameters['digitalSignageId'] = requestParameters.digitalSignageId;
            }
            if (requestParameters.directoryId !== undefined) {
                queryParameters['directoryId'] = requestParameters.directoryId;
            }
            if (requestParameters.mediaCollectionId !== undefined) {
                queryParameters['mediaCollectionId'] = requestParameters.mediaCollectionId;
            }
            if (requestParameters.photoboothId !== undefined) {
                queryParameters['photoboothId'] = requestParameters.photoboothId;
            }
            if (requestParameters.selfCheckoutId !== undefined) {
                queryParameters['selfCheckoutId'] = requestParameters.selfCheckoutId;
            }
            if (requestParameters.spinToWinId !== undefined) {
                queryParameters['spinToWinId'] = requestParameters.spinToWinId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activations`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivationFromJSON));
        });
    }
    /**
     */
    activationControllerList({ kioskId, kioskIds, digitalSignageId, directoryId, mediaCollectionId, photoboothId, selfCheckoutId, spinToWinId, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationControllerListRaw({ kioskId: kioskId, kioskIds: kioskIds, digitalSignageId: digitalSignageId, directoryId: directoryId, mediaCollectionId: mediaCollectionId, photoboothId: photoboothId, selfCheckoutId: selfCheckoutId, spinToWinId: spinToWinId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationControllerResetForKioskRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.kioskId === null || requestParameters.kioskId === undefined) {
                throw new RequiredError('kioskId', 'Required parameter requestParameters.kioskId was null or undefined when calling activationControllerResetForKiosk.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activations/kiosk/{kioskId}`.replace(`{${"kioskId"}}`, encodeURIComponent(String(requestParameters.kioskId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    activationControllerResetForKiosk(kioskId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.activationControllerResetForKioskRaw({ kioskId: kioskId }, initOverrides);
        });
    }
    /**
     */
    activationControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationControllerUpdate.');
            }
            if (requestParameters.ActivationUpdateRequest === null || requestParameters.ActivationUpdateRequest === undefined) {
                throw new RequiredError('ActivationUpdateRequest', 'Required parameter requestParameters.ActivationUpdateRequest was null or undefined when calling activationControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ActivationUpdateRequestToJSON(requestParameters.ActivationUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationFromJSON(jsonValue));
        });
    }
    /**
     */
    activationControllerUpdate(id, ActivationUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationControllerUpdateRaw({ id: id, ActivationUpdateRequest: ActivationUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ActivationScheduleCreateRequest === null || requestParameters.ActivationScheduleCreateRequest === undefined) {
                throw new RequiredError('ActivationScheduleCreateRequest', 'Required parameter requestParameters.ActivationScheduleCreateRequest was null or undefined when calling activationScheduleControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ActivationScheduleCreateRequestToJSON(requestParameters.ActivationScheduleCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationScheduleResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    activationScheduleControllerCreate(ActivationScheduleCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleControllerCreateRaw({ ActivationScheduleCreateRequest: ActivationScheduleCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationScheduleControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationScheduleResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    activationScheduleControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivationScheduleResponseFromJSON));
        });
    }
    /**
     */
    activationScheduleControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationScheduleControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    activationScheduleControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.activationScheduleControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    activationScheduleControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationScheduleControllerUpdate.');
            }
            if (requestParameters.ActivationScheduleUpdateRequest === null || requestParameters.ActivationScheduleUpdateRequest === undefined) {
                throw new RequiredError('ActivationScheduleUpdateRequest', 'Required parameter requestParameters.ActivationScheduleUpdateRequest was null or undefined when calling activationScheduleControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ActivationScheduleUpdateRequestToJSON(requestParameters.ActivationScheduleUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationScheduleResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    activationScheduleControllerUpdate(id, ActivationScheduleUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleControllerUpdateRaw({ id: id, ActivationScheduleUpdateRequest: ActivationScheduleUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleItemControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                throw new RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling activationScheduleItemControllerCreate.');
            }
            if (requestParameters.ActivationScheduleItemCreateRequest === null || requestParameters.ActivationScheduleItemCreateRequest === undefined) {
                throw new RequiredError('ActivationScheduleItemCreateRequest', 'Required parameter requestParameters.ActivationScheduleItemCreateRequest was null or undefined when calling activationScheduleItemControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{scheduleId}/items`.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters.scheduleId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ActivationScheduleItemCreateRequestToJSON(requestParameters.ActivationScheduleItemCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationScheduleItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    activationScheduleItemControllerCreate(scheduleId, ActivationScheduleItemCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleItemControllerCreateRaw({ scheduleId: scheduleId, ActivationScheduleItemCreateRequest: ActivationScheduleItemCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleItemControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationScheduleItemControllerGet.');
            }
            if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                throw new RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling activationScheduleItemControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{scheduleId}/items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters.scheduleId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationScheduleItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    activationScheduleItemControllerGet(id, scheduleId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleItemControllerGetRaw({ id: id, scheduleId: scheduleId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleItemControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                throw new RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling activationScheduleItemControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{scheduleId}/items`.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters.scheduleId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivationScheduleItemResponseFromJSON));
        });
    }
    /**
     */
    activationScheduleItemControllerList(scheduleId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleItemControllerListRaw({ scheduleId: scheduleId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    activationScheduleItemControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationScheduleItemControllerRemove.');
            }
            if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                throw new RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling activationScheduleItemControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{scheduleId}/items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters.scheduleId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    activationScheduleItemControllerRemove(id, scheduleId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.activationScheduleItemControllerRemoveRaw({ id: id, scheduleId: scheduleId }, initOverrides);
        });
    }
    /**
     */
    activationScheduleItemControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling activationScheduleItemControllerUpdate.');
            }
            if (requestParameters.scheduleId === null || requestParameters.scheduleId === undefined) {
                throw new RequiredError('scheduleId', 'Required parameter requestParameters.scheduleId was null or undefined when calling activationScheduleItemControllerUpdate.');
            }
            if (requestParameters.ActivationScheduleItemUpdateRequest === null || requestParameters.ActivationScheduleItemUpdateRequest === undefined) {
                throw new RequiredError('ActivationScheduleItemUpdateRequest', 'Required parameter requestParameters.ActivationScheduleItemUpdateRequest was null or undefined when calling activationScheduleItemControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/activation_schedules/{scheduleId}/items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters.scheduleId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ActivationScheduleItemUpdateRequestToJSON(requestParameters.ActivationScheduleItemUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ActivationScheduleItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    activationScheduleItemControllerUpdate(id, scheduleId, ActivationScheduleItemUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.activationScheduleItemControllerUpdateRaw({ id: id, scheduleId: scheduleId, ActivationScheduleItemUpdateRequest: ActivationScheduleItemUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AdmissionCreateRequest === null || requestParameters.AdmissionCreateRequest === undefined) {
                throw new RequiredError('AdmissionCreateRequest', 'Required parameter requestParameters.AdmissionCreateRequest was null or undefined when calling admissionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AdmissionCreateRequestToJSON(requestParameters.AdmissionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionControllerCreate(AdmissionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionControllerCreateRaw({ AdmissionCreateRequest: AdmissionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionControllerDuplicateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionControllerDuplicate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{id}/duplicate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionControllerDuplicate(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionControllerDuplicateRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AdmissionResponseFromJSON));
        });
    }
    /**
     */
    admissionControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    admissionControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.admissionControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    admissionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionControllerUpdate.');
            }
            if (requestParameters.AdmissionUpdateRequest === null || requestParameters.AdmissionUpdateRequest === undefined) {
                throw new RequiredError('AdmissionUpdateRequest', 'Required parameter requestParameters.AdmissionUpdateRequest was null or undefined when calling admissionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: AdmissionUpdateRequestToJSON(requestParameters.AdmissionUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionControllerUpdate(id, AdmissionUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionControllerUpdateRaw({ id: id, AdmissionUpdateRequest: AdmissionUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionOptionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.admissionId === null || requestParameters.admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter requestParameters.admissionId was null or undefined when calling admissionOptionControllerCreate.');
            }
            if (requestParameters.AdmissionOptionCreateRequest === null || requestParameters.AdmissionOptionCreateRequest === undefined) {
                throw new RequiredError('AdmissionOptionCreateRequest', 'Required parameter requestParameters.AdmissionOptionCreateRequest was null or undefined when calling admissionOptionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{admissionId}/options`.replace(`{${"admissionId"}}`, encodeURIComponent(String(requestParameters.admissionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AdmissionOptionCreateRequestToJSON(requestParameters.AdmissionOptionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionOptionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionOptionControllerCreate(admissionId, AdmissionOptionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionOptionControllerCreateRaw({ admissionId: admissionId, AdmissionOptionCreateRequest: AdmissionOptionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionOptionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionOptionControllerGet.');
            }
            if (requestParameters.admissionId === null || requestParameters.admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter requestParameters.admissionId was null or undefined when calling admissionOptionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{admissionId}/options/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"admissionId"}}`, encodeURIComponent(String(requestParameters.admissionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionOptionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionOptionControllerGet(id, admissionId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionOptionControllerGetRaw({ id: id, admissionId: admissionId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionOptionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.admissionId === null || requestParameters.admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter requestParameters.admissionId was null or undefined when calling admissionOptionControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{admissionId}/options`.replace(`{${"admissionId"}}`, encodeURIComponent(String(requestParameters.admissionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AdmissionOptionResponseFromJSON));
        });
    }
    /**
     */
    admissionOptionControllerList(admissionId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionOptionControllerListRaw({ admissionId: admissionId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionOptionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.admissionId === null || requestParameters.admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter requestParameters.admissionId was null or undefined when calling admissionOptionControllerRemove.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionOptionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{admissionId}/options/{id}`.replace(`{${"admissionId"}}`, encodeURIComponent(String(requestParameters.admissionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    admissionOptionControllerRemove(admissionId, id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.admissionOptionControllerRemoveRaw({ admissionId: admissionId, id: id }, initOverrides);
        });
    }
    /**
     */
    admissionOptionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.admissionId === null || requestParameters.admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter requestParameters.admissionId was null or undefined when calling admissionOptionControllerUpdate.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionOptionControllerUpdate.');
            }
            if (requestParameters.AdmissionOptionUpdateRequest === null || requestParameters.AdmissionOptionUpdateRequest === undefined) {
                throw new RequiredError('AdmissionOptionUpdateRequest', 'Required parameter requestParameters.AdmissionOptionUpdateRequest was null or undefined when calling admissionOptionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admissions/{admissionId}/options/{id}`.replace(`{${"admissionId"}}`, encodeURIComponent(String(requestParameters.admissionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: AdmissionOptionUpdateRequestToJSON(requestParameters.AdmissionOptionUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionOptionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionOptionControllerUpdate(admissionId, id, AdmissionOptionUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionOptionControllerUpdateRaw({ admissionId: admissionId, id: id, AdmissionOptionUpdateRequest: AdmissionOptionUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionTemplateControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AdmissionTemplateCreateRequest === null || requestParameters.AdmissionTemplateCreateRequest === undefined) {
                throw new RequiredError('AdmissionTemplateCreateRequest', 'Required parameter requestParameters.AdmissionTemplateCreateRequest was null or undefined when calling admissionTemplateControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admission_templates`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AdmissionTemplateCreateRequestToJSON(requestParameters.AdmissionTemplateCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionTemplateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionTemplateControllerCreate(AdmissionTemplateCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionTemplateControllerCreateRaw({ AdmissionTemplateCreateRequest: AdmissionTemplateCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionTemplateControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionTemplateControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admission_templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionTemplateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionTemplateControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionTemplateControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionTemplateControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admission_templates`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AdmissionTemplateResponseFromJSON));
        });
    }
    /**
     */
    admissionTemplateControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionTemplateControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    admissionTemplateControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionTemplateControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admission_templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    admissionTemplateControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.admissionTemplateControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    admissionTemplateControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling admissionTemplateControllerUpdate.');
            }
            if (requestParameters.AdmissionTemplateUpdateRequest === null || requestParameters.AdmissionTemplateUpdateRequest === undefined) {
                throw new RequiredError('AdmissionTemplateUpdateRequest', 'Required parameter requestParameters.AdmissionTemplateUpdateRequest was null or undefined when calling admissionTemplateControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/admission_templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: AdmissionTemplateUpdateRequestToJSON(requestParameters.AdmissionTemplateUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AdmissionTemplateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    admissionTemplateControllerUpdate(id, AdmissionTemplateUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.admissionTemplateControllerUpdateRaw({ id: id, AdmissionTemplateUpdateRequest: AdmissionTemplateUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    agreementControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AgreementCreateRequest === null || requestParameters.AgreementCreateRequest === undefined) {
                throw new RequiredError('AgreementCreateRequest', 'Required parameter requestParameters.AgreementCreateRequest was null or undefined when calling agreementControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/agreements`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AgreementCreateRequestToJSON(requestParameters.AgreementCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AgreementResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    agreementControllerCreate(AgreementCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.agreementControllerCreateRaw({ AgreementCreateRequest: AgreementCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    agreementControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling agreementControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/agreements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AgreementResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    agreementControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.agreementControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    agreementControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.ids) {
                queryParameters['ids'] = requestParameters.ids;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/agreements`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AgreementResponseFromJSON));
        });
    }
    /**
     */
    agreementControllerList({ ids, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.agreementControllerListRaw({ ids: ids }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    agreementControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling agreementControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/agreements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    agreementControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.agreementControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    agreementControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling agreementControllerUpdate.');
            }
            if (requestParameters.AgreementUpdateRequest === null || requestParameters.AgreementUpdateRequest === undefined) {
                throw new RequiredError('AgreementUpdateRequest', 'Required parameter requestParameters.AgreementUpdateRequest was null or undefined when calling agreementControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/agreements/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: AgreementUpdateRequestToJSON(requestParameters.AgreementUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AgreementResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    agreementControllerUpdate(id, AgreementUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.agreementControllerUpdateRaw({ id: id, AgreementUpdateRequest: AgreementUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiControllerGetApiStatusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ERROR_UNKNOWN === null || requestParameters.ERROR_UNKNOWN === undefined) {
                throw new RequiredError('ERROR_UNKNOWN', 'Required parameter requestParameters.ERROR_UNKNOWN was null or undefined when calling apiControllerGetApiStatus.');
            }
            const queryParameters = {};
            if (requestParameters.ERROR_UNKNOWN !== undefined) {
                queryParameters[''] = requestParameters.ERROR_UNKNOWN;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/status`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    apiControllerGetApiStatus(ERROR_UNKNOWN, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiControllerGetApiStatusRaw({ ERROR_UNKNOWN: ERROR_UNKNOWN }, initOverrides);
        });
    }
    /**
     */
    appPluginControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AppPluginCreate === null || requestParameters.AppPluginCreate === undefined) {
                throw new RequiredError('AppPluginCreate', 'Required parameter requestParameters.AppPluginCreate was null or undefined when calling appPluginControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/plugins`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AppPluginCreateToJSON(requestParameters.AppPluginCreate),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AppPluginFromJSON(jsonValue));
        });
    }
    /**
     */
    appPluginControllerCreate(AppPluginCreate, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPluginControllerCreateRaw({ AppPluginCreate: AppPluginCreate }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPluginControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPluginControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/plugins/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AppPluginFromJSON(jsonValue));
        });
    }
    /**
     */
    appPluginControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPluginControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPluginControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/plugins`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(AppPluginFromJSON));
        });
    }
    /**
     */
    appPluginControllerList({ name, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPluginControllerListRaw({ name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPluginControllerOutputRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPluginControllerOutput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/plugins/{id}/output`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EsuiteAppPluginMessageFromJSON(jsonValue));
        });
    }
    /**
     */
    appPluginControllerOutput(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPluginControllerOutputRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPluginControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPluginControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/plugins/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    appPluginControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.appPluginControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    appPluginControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPluginControllerUpdate.');
            }
            if (requestParameters.AppPluginUpdate === null || requestParameters.AppPluginUpdate === undefined) {
                throw new RequiredError('AppPluginUpdate', 'Required parameter requestParameters.AppPluginUpdate was null or undefined when calling appPluginControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/plugins/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: AppPluginUpdateToJSON(requestParameters.AppPluginUpdate),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AppPluginFromJSON(jsonValue));
        });
    }
    /**
     */
    appPluginControllerUpdate(id, AppPluginUpdate, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPluginControllerUpdateRaw({ id: id, AppPluginUpdate: AppPluginUpdate }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPluginHookControllerUseActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling appPluginHookControllerUseAction.');
            }
            if (requestParameters.AppPluginHookUseActionRequest === null || requestParameters.AppPluginHookUseActionRequest === undefined) {
                throw new RequiredError('AppPluginHookUseActionRequest', 'Required parameter requestParameters.AppPluginHookUseActionRequest was null or undefined when calling appPluginHookControllerUseAction.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/plugin_hooks/action/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AppPluginHookUseActionRequestToJSON(requestParameters.AppPluginHookUseActionRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    appPluginHookControllerUseAction(name, AppPluginHookUseActionRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.appPluginHookControllerUseActionRaw({ name: name, AppPluginHookUseActionRequest: AppPluginHookUseActionRequest }, initOverrides);
        });
    }
    /**
     */
    appPluginHookControllerUseMapRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling appPluginHookControllerUseMap.');
            }
            if (requestParameters.AppPluginHookUseMapRequest === null || requestParameters.AppPluginHookUseMapRequest === undefined) {
                throw new RequiredError('AppPluginHookUseMapRequest', 'Required parameter requestParameters.AppPluginHookUseMapRequest was null or undefined when calling appPluginHookControllerUseMap.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/plugin_hooks/map/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AppPluginHookUseMapRequestToJSON(requestParameters.AppPluginHookUseMapRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    appPluginHookControllerUseMap(name, AppPluginHookUseMapRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPluginHookControllerUseMapRaw({ name: name, AppPluginHookUseMapRequest: AppPluginHookUseMapRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPurchaseControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AppPurchaseCreateRequest === null || requestParameters.AppPurchaseCreateRequest === undefined) {
                throw new RequiredError('AppPurchaseCreateRequest', 'Required parameter requestParameters.AppPurchaseCreateRequest was null or undefined when calling appPurchaseControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/app_purchases`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AppPurchaseCreateRequestToJSON(requestParameters.AppPurchaseCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    appPurchaseControllerCreate(AppPurchaseCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPurchaseControllerCreateRaw({ AppPurchaseCreateRequest: AppPurchaseCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPurchaseControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPurchaseControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/app_purchases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    appPurchaseControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPurchaseControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPurchaseControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/app_purchases`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    appPurchaseControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPurchaseControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    appPurchaseControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPurchaseControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/app_purchases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    appPurchaseControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.appPurchaseControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    appPurchaseControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling appPurchaseControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling appPurchaseControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/app_purchases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    appPurchaseControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.appPurchaseControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    authControllerAuthenticateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userType === null || requestParameters.userType === undefined) {
                throw new RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling authControllerAuthenticate.');
            }
            if (requestParameters.AuthUserRequest === null || requestParameters.AuthUserRequest === undefined) {
                throw new RequiredError('AuthUserRequest', 'Required parameter requestParameters.AuthUserRequest was null or undefined when calling authControllerAuthenticate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/auth/{userType}/login`.replace(`{${"userType"}}`, encodeURIComponent(String(requestParameters.userType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AuthUserRequestToJSON(requestParameters.AuthUserRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TokenResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    authControllerAuthenticate(userType, AuthUserRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerAuthenticateRaw({ userType: userType, AuthUserRequest: AuthUserRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    authControllerGetAccessTokenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userType === null || requestParameters.userType === undefined) {
                throw new RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling authControllerGetAccessToken.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling authControllerGetAccessToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/auth/{userType}/access_token/{userId}`.replace(`{${"userType"}}`, encodeURIComponent(String(requestParameters.userType))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AccessTokenResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    authControllerGetAccessToken(userType, userId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerGetAccessTokenRaw({ userType: userType, userId: userId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    authControllerGetUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userType === null || requestParameters.userType === undefined) {
                throw new RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling authControllerGetUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/auth/{userType}/me`.replace(`{${"userType"}}`, encodeURIComponent(String(requestParameters.userType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    authControllerGetUser(userType, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerGetUserRaw({ userType: userType }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    authControllerLogoutUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userType === null || requestParameters.userType === undefined) {
                throw new RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling authControllerLogoutUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/auth/{userType}/logout`.replace(`{${"userType"}}`, encodeURIComponent(String(requestParameters.userType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new TextApiResponse(response);
        });
    }
    /**
     */
    authControllerLogoutUser(userType, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerLogoutUserRaw({ userType: userType }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    authControllerPlatformLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.PlatformAuthenticateRequest === null || requestParameters.PlatformAuthenticateRequest === undefined) {
                throw new RequiredError('PlatformAuthenticateRequest', 'Required parameter requestParameters.PlatformAuthenticateRequest was null or undefined when calling authControllerPlatformLogin.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/auth/platform_login`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PlatformAuthenticateRequestToJSON(requestParameters.PlatformAuthenticateRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    authControllerPlatformLogin(PlatformAuthenticateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authControllerPlatformLoginRaw({ PlatformAuthenticateRequest: PlatformAuthenticateRequest }, initOverrides);
        });
    }
    /**
     */
    authControllerRefreshTokenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userType === null || requestParameters.userType === undefined) {
                throw new RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling authControllerRefreshToken.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/auth/{userType}/refresh_token`.replace(`{${"userType"}}`, encodeURIComponent(String(requestParameters.userType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TokenResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    authControllerRefreshToken(userType, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerRefreshTokenRaw({ userType: userType }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    authControllerSendResetPasswordEmailRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userType === null || requestParameters.userType === undefined) {
                throw new RequiredError('userType', 'Required parameter requestParameters.userType was null or undefined when calling authControllerSendResetPasswordEmail.');
            }
            if (requestParameters.AuthResetPasswordRequest === null || requestParameters.AuthResetPasswordRequest === undefined) {
                throw new RequiredError('AuthResetPasswordRequest', 'Required parameter requestParameters.AuthResetPasswordRequest was null or undefined when calling authControllerSendResetPasswordEmail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/auth/{userType}/send_reset_password_email`.replace(`{${"userType"}}`, encodeURIComponent(String(requestParameters.userType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AuthResetPasswordRequestToJSON(requestParameters.AuthResetPasswordRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    authControllerSendResetPasswordEmail(userType, AuthResetPasswordRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authControllerSendResetPasswordEmailRaw({ userType: userType, AuthResetPasswordRequest: AuthResetPasswordRequest }, initOverrides);
        });
    }
    /**
     */
    checkoutControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.CheckoutCreateRequest === null || requestParameters.CheckoutCreateRequest === undefined) {
                throw new RequiredError('CheckoutCreateRequest', 'Required parameter requestParameters.CheckoutCreateRequest was null or undefined when calling checkoutControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CheckoutCreateRequestToJSON(requestParameters.CheckoutCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    checkoutControllerCreate(CheckoutCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutControllerCreateRaw({ CheckoutCreateRequest: CheckoutCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling checkoutControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    checkoutControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(CheckoutResponseFromJSON));
        });
    }
    /**
     */
    checkoutControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling checkoutControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    checkoutControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.checkoutControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    checkoutControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling checkoutControllerUpdate.');
            }
            if (requestParameters.CheckoutUpdateRequestDto === null || requestParameters.CheckoutUpdateRequestDto === undefined) {
                throw new RequiredError('CheckoutUpdateRequestDto', 'Required parameter requestParameters.CheckoutUpdateRequestDto was null or undefined when calling checkoutControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CheckoutUpdateRequestDtoToJSON(requestParameters.CheckoutUpdateRequestDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    checkoutControllerUpdate(id, CheckoutUpdateRequestDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutControllerUpdateRaw({ id: id, CheckoutUpdateRequestDto: CheckoutUpdateRequestDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutLineItemControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.checkoutId === null || requestParameters.checkoutId === undefined) {
                throw new RequiredError('checkoutId', 'Required parameter requestParameters.checkoutId was null or undefined when calling checkoutLineItemControllerCreate.');
            }
            if (requestParameters.CheckoutLineItemCreateRequest === null || requestParameters.CheckoutLineItemCreateRequest === undefined) {
                throw new RequiredError('CheckoutLineItemCreateRequest', 'Required parameter requestParameters.CheckoutLineItemCreateRequest was null or undefined when calling checkoutLineItemControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{checkoutId}/line_items`.replace(`{${"checkoutId"}}`, encodeURIComponent(String(requestParameters.checkoutId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CheckoutLineItemCreateRequestToJSON(requestParameters.CheckoutLineItemCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CheckoutLineItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    checkoutLineItemControllerCreate(checkoutId, CheckoutLineItemCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutLineItemControllerCreateRaw({ checkoutId: checkoutId, CheckoutLineItemCreateRequest: CheckoutLineItemCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutLineItemControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling checkoutLineItemControllerGet.');
            }
            if (requestParameters.checkoutId === null || requestParameters.checkoutId === undefined) {
                throw new RequiredError('checkoutId', 'Required parameter requestParameters.checkoutId was null or undefined when calling checkoutLineItemControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{checkoutId}/line_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"checkoutId"}}`, encodeURIComponent(String(requestParameters.checkoutId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CheckoutLineItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    checkoutLineItemControllerGet(id, checkoutId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutLineItemControllerGetRaw({ id: id, checkoutId: checkoutId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutLineItemControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.checkoutId === null || requestParameters.checkoutId === undefined) {
                throw new RequiredError('checkoutId', 'Required parameter requestParameters.checkoutId was null or undefined when calling checkoutLineItemControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{checkoutId}/line_items`.replace(`{${"checkoutId"}}`, encodeURIComponent(String(requestParameters.checkoutId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(CheckoutLineItemResponseFromJSON));
        });
    }
    /**
     */
    checkoutLineItemControllerList(checkoutId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutLineItemControllerListRaw({ checkoutId: checkoutId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    checkoutLineItemControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling checkoutLineItemControllerRemove.');
            }
            if (requestParameters.checkoutId === null || requestParameters.checkoutId === undefined) {
                throw new RequiredError('checkoutId', 'Required parameter requestParameters.checkoutId was null or undefined when calling checkoutLineItemControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{checkoutId}/line_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"checkoutId"}}`, encodeURIComponent(String(requestParameters.checkoutId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    checkoutLineItemControllerRemove(id, checkoutId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.checkoutLineItemControllerRemoveRaw({ id: id, checkoutId: checkoutId }, initOverrides);
        });
    }
    /**
     */
    checkoutLineItemControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling checkoutLineItemControllerUpdate.');
            }
            if (requestParameters.checkoutId === null || requestParameters.checkoutId === undefined) {
                throw new RequiredError('checkoutId', 'Required parameter requestParameters.checkoutId was null or undefined when calling checkoutLineItemControllerUpdate.');
            }
            if (requestParameters.CheckoutLineItemUpdateRequest === null || requestParameters.CheckoutLineItemUpdateRequest === undefined) {
                throw new RequiredError('CheckoutLineItemUpdateRequest', 'Required parameter requestParameters.CheckoutLineItemUpdateRequest was null or undefined when calling checkoutLineItemControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/checkouts/{checkoutId}/line_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"checkoutId"}}`, encodeURIComponent(String(requestParameters.checkoutId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CheckoutLineItemUpdateRequestToJSON(requestParameters.CheckoutLineItemUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CheckoutLineItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    checkoutLineItemControllerUpdate(id, checkoutId, CheckoutLineItemUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.checkoutLineItemControllerUpdateRaw({ id: id, checkoutId: checkoutId, CheckoutLineItemUpdateRequest: CheckoutLineItemUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customAppControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.CustomAppCreateRequest === null || requestParameters.CustomAppCreateRequest === undefined) {
                throw new RequiredError('CustomAppCreateRequest', 'Required parameter requestParameters.CustomAppCreateRequest was null or undefined when calling customAppControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/custom_apps`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CustomAppCreateRequestToJSON(requestParameters.CustomAppCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CustomAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    customAppControllerCreate(CustomAppCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customAppControllerCreateRaw({ CustomAppCreateRequest: CustomAppCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customAppControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling customAppControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/custom_apps/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CustomAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    customAppControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customAppControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customAppControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/custom_apps`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomAppResponseFromJSON));
        });
    }
    /**
     */
    customAppControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customAppControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customAppControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling customAppControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/custom_apps/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    customAppControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.customAppControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    customAppControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling customAppControllerUpdate.');
            }
            if (requestParameters.CustomAppUpdateRequest === null || requestParameters.CustomAppUpdateRequest === undefined) {
                throw new RequiredError('CustomAppUpdateRequest', 'Required parameter requestParameters.CustomAppUpdateRequest was null or undefined when calling customAppControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/custom_apps/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CustomAppUpdateRequestToJSON(requestParameters.CustomAppUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CustomAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    customAppControllerUpdate(id, CustomAppUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customAppControllerUpdateRaw({ id: id, CustomAppUpdateRequest: CustomAppUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customerControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling customerControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CustomerResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    customerControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customerControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customerControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/customers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerResponseFromJSON));
        });
    }
    /**
     */
    customerControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customerControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    customerControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling customerControllerUpdate.');
            }
            if (requestParameters.CustomerUpdateRequest === null || requestParameters.CustomerUpdateRequest === undefined) {
                throw new RequiredError('CustomerUpdateRequest', 'Required parameter requestParameters.CustomerUpdateRequest was null or undefined when calling customerControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/customers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CustomerUpdateRequestToJSON(requestParameters.CustomerUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CustomerResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    customerControllerUpdate(id, CustomerUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.customerControllerUpdateRaw({ id: id, CustomerUpdateRequest: CustomerUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageControllerAppRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.appId === null || requestParameters.appId === undefined) {
                throw new RequiredError('appId', 'Required parameter requestParameters.appId was null or undefined when calling digitalSignageControllerApp.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{appId}/app`.replace(`{${"appId"}}`, encodeURIComponent(String(requestParameters.appId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new TextApiResponse(response);
        });
    }
    /**
     */
    digitalSignageControllerApp(appId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageControllerAppRaw({ appId: appId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.DigitalSignageCreateRequest === null || requestParameters.DigitalSignageCreateRequest === undefined) {
                throw new RequiredError('DigitalSignageCreateRequest', 'Required parameter requestParameters.DigitalSignageCreateRequest was null or undefined when calling digitalSignageControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DigitalSignageCreateRequestToJSON(requestParameters.DigitalSignageCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageControllerCreate(DigitalSignageCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageControllerCreateRaw({ DigitalSignageCreateRequest: DigitalSignageCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DigitalSignageResponseFromJSON));
        });
    }
    /**
     */
    digitalSignageControllerList({ limit, skip, name, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageControllerListRaw({ limit: limit, skip: skip, name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    digitalSignageControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.digitalSignageControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    digitalSignageControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageControllerUpdate.');
            }
            if (requestParameters.DigitalSignageUpdateRequest === null || requestParameters.DigitalSignageUpdateRequest === undefined) {
                throw new RequiredError('DigitalSignageUpdateRequest', 'Required parameter requestParameters.DigitalSignageUpdateRequest was null or undefined when calling digitalSignageControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DigitalSignageUpdateRequestToJSON(requestParameters.DigitalSignageUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageControllerUpdate(id, DigitalSignageUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageControllerUpdateRaw({ id: id, DigitalSignageUpdateRequest: DigitalSignageUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageFrameControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signageId === null || requestParameters.signageId === undefined) {
                throw new RequiredError('signageId', 'Required parameter requestParameters.signageId was null or undefined when calling digitalSignageFrameControllerCreate.');
            }
            if (requestParameters.DigitalSignageFrameCreateRequest === null || requestParameters.DigitalSignageFrameCreateRequest === undefined) {
                throw new RequiredError('DigitalSignageFrameCreateRequest', 'Required parameter requestParameters.DigitalSignageFrameCreateRequest was null or undefined when calling digitalSignageFrameControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{signageId}/frames`.replace(`{${"signageId"}}`, encodeURIComponent(String(requestParameters.signageId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DigitalSignageFrameCreateRequestToJSON(requestParameters.DigitalSignageFrameCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageFrameResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageFrameControllerCreate(signageId, DigitalSignageFrameCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageFrameControllerCreateRaw({ signageId: signageId, DigitalSignageFrameCreateRequest: DigitalSignageFrameCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageFrameControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signageId === null || requestParameters.signageId === undefined) {
                throw new RequiredError('signageId', 'Required parameter requestParameters.signageId was null or undefined when calling digitalSignageFrameControllerGet.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageFrameControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{signageId}/frames/{id}`.replace(`{${"signageId"}}`, encodeURIComponent(String(requestParameters.signageId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageFrameResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageFrameControllerGet(signageId, id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageFrameControllerGetRaw({ signageId: signageId, id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageFrameControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signageId === null || requestParameters.signageId === undefined) {
                throw new RequiredError('signageId', 'Required parameter requestParameters.signageId was null or undefined when calling digitalSignageFrameControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{signageId}/frames`.replace(`{${"signageId"}}`, encodeURIComponent(String(requestParameters.signageId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DigitalSignageFrameResponseFromJSON));
        });
    }
    /**
     */
    digitalSignageFrameControllerList(signageId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageFrameControllerListRaw({ signageId: signageId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageFrameControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signageId === null || requestParameters.signageId === undefined) {
                throw new RequiredError('signageId', 'Required parameter requestParameters.signageId was null or undefined when calling digitalSignageFrameControllerRemove.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageFrameControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{signageId}/frames/{id}`.replace(`{${"signageId"}}`, encodeURIComponent(String(requestParameters.signageId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    digitalSignageFrameControllerRemove(signageId, id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.digitalSignageFrameControllerRemoveRaw({ signageId: signageId, id: id }, initOverrides);
        });
    }
    /**
     */
    digitalSignageFrameControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signageId === null || requestParameters.signageId === undefined) {
                throw new RequiredError('signageId', 'Required parameter requestParameters.signageId was null or undefined when calling digitalSignageFrameControllerUpdate.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageFrameControllerUpdate.');
            }
            if (requestParameters.DigitalSignageFrameUpdateRequest === null || requestParameters.DigitalSignageFrameUpdateRequest === undefined) {
                throw new RequiredError('DigitalSignageFrameUpdateRequest', 'Required parameter requestParameters.DigitalSignageFrameUpdateRequest was null or undefined when calling digitalSignageFrameControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage/{signageId}/frames/{id}`.replace(`{${"signageId"}}`, encodeURIComponent(String(requestParameters.signageId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DigitalSignageFrameUpdateRequestToJSON(requestParameters.DigitalSignageFrameUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageFrameResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageFrameControllerUpdate(signageId, id, DigitalSignageFrameUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageFrameControllerUpdateRaw({ signageId: signageId, id: id, DigitalSignageFrameUpdateRequest: DigitalSignageFrameUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageSlideControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.DigitalSignageSlideCreateRequest === null || requestParameters.DigitalSignageSlideCreateRequest === undefined) {
                throw new RequiredError('DigitalSignageSlideCreateRequest', 'Required parameter requestParameters.DigitalSignageSlideCreateRequest was null or undefined when calling digitalSignageSlideControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage_slides`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DigitalSignageSlideCreateRequestToJSON(requestParameters.DigitalSignageSlideCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageSlideResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageSlideControllerCreate(DigitalSignageSlideCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageSlideControllerCreateRaw({ DigitalSignageSlideCreateRequest: DigitalSignageSlideCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageSlideControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageSlideControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage_slides/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageSlideResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageSlideControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageSlideControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageSlideControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.frameId !== undefined) {
                queryParameters['frameId'] = requestParameters.frameId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage_slides`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DigitalSignageSlideResponseFromJSON));
        });
    }
    /**
     */
    digitalSignageSlideControllerList({ limit, skip, frameId, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageSlideControllerListRaw({ limit: limit, skip: skip, frameId: frameId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    digitalSignageSlideControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageSlideControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage_slides/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    digitalSignageSlideControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.digitalSignageSlideControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    digitalSignageSlideControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling digitalSignageSlideControllerUpdate.');
            }
            if (requestParameters.DigitalSignageSlideUpdateRequest === null || requestParameters.DigitalSignageSlideUpdateRequest === undefined) {
                throw new RequiredError('DigitalSignageSlideUpdateRequest', 'Required parameter requestParameters.DigitalSignageSlideUpdateRequest was null or undefined when calling digitalSignageSlideControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/digital_signage_slides/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DigitalSignageSlideUpdateRequestToJSON(requestParameters.DigitalSignageSlideUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DigitalSignageSlideResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    digitalSignageSlideControllerUpdate(id, DigitalSignageSlideUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.digitalSignageSlideControllerUpdateRaw({ id: id, DigitalSignageSlideUpdateRequest: DigitalSignageSlideUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryControllerAppRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryControllerApp.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directories/{id}/app`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    directoryControllerApp(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.directoryControllerAppRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    directoryControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.DirectoryCreateRequest === null || requestParameters.DirectoryCreateRequest === undefined) {
                throw new RequiredError('DirectoryCreateRequest', 'Required parameter requestParameters.DirectoryCreateRequest was null or undefined when calling directoryControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directories`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DirectoryCreateRequestToJSON(requestParameters.DirectoryCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryControllerCreate(DirectoryCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryControllerCreateRaw({ DirectoryCreateRequest: DirectoryCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directories`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DirectoryFromJSON));
        });
    }
    /**
     */
    directoryControllerList({ name, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryControllerListRaw({ name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    directoryControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.directoryControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    directoryControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryControllerUpdate.');
            }
            if (requestParameters.DirectoryUpdateRequest === null || requestParameters.DirectoryUpdateRequest === undefined) {
                throw new RequiredError('DirectoryUpdateRequest', 'Required parameter requestParameters.DirectoryUpdateRequest was null or undefined when calling directoryControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DirectoryUpdateRequestToJSON(requestParameters.DirectoryUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryControllerUpdate(id, DirectoryUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryControllerUpdateRaw({ id: id, DirectoryUpdateRequest: DirectoryUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryFloorControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.DirectoryFloorCreateRequest === null || requestParameters.DirectoryFloorCreateRequest === undefined) {
                throw new RequiredError('DirectoryFloorCreateRequest', 'Required parameter requestParameters.DirectoryFloorCreateRequest was null or undefined when calling directoryFloorControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_floors`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DirectoryFloorCreateRequestToJSON(requestParameters.DirectoryFloorCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryFloorFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryFloorControllerCreate(DirectoryFloorCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryFloorControllerCreateRaw({ DirectoryFloorCreateRequest: DirectoryFloorCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryFloorControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryFloorControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_floors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryFloorFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryFloorControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryFloorControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryFloorControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.directoryId === null || requestParameters.directoryId === undefined) {
                throw new RequiredError('directoryId', 'Required parameter requestParameters.directoryId was null or undefined when calling directoryFloorControllerList.');
            }
            const queryParameters = {};
            if (requestParameters.directoryId !== undefined) {
                queryParameters['directoryId'] = requestParameters.directoryId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_floors`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DirectoryFloorFromJSON));
        });
    }
    /**
     */
    directoryFloorControllerList(directoryId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryFloorControllerListRaw({ directoryId: directoryId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryFloorControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryFloorControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_floors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    directoryFloorControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.directoryFloorControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    directoryFloorControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryFloorControllerUpdate.');
            }
            if (requestParameters.DirectoryFloorUpdateRequest === null || requestParameters.DirectoryFloorUpdateRequest === undefined) {
                throw new RequiredError('DirectoryFloorUpdateRequest', 'Required parameter requestParameters.DirectoryFloorUpdateRequest was null or undefined when calling directoryFloorControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_floors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DirectoryFloorUpdateRequestToJSON(requestParameters.DirectoryFloorUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryFloorFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryFloorControllerUpdate(id, DirectoryFloorUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryFloorControllerUpdateRaw({ id: id, DirectoryFloorUpdateRequest: DirectoryFloorUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryListingControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.DirectoryListingCreateRequest === null || requestParameters.DirectoryListingCreateRequest === undefined) {
                throw new RequiredError('DirectoryListingCreateRequest', 'Required parameter requestParameters.DirectoryListingCreateRequest was null or undefined when calling directoryListingControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_listings`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DirectoryListingCreateRequestToJSON(requestParameters.DirectoryListingCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryListingFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryListingControllerCreate(DirectoryListingCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryListingControllerCreateRaw({ DirectoryListingCreateRequest: DirectoryListingCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryListingControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryListingControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_listings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryListingFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryListingControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryListingControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryListingControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.directoryId === null || requestParameters.directoryId === undefined) {
                throw new RequiredError('directoryId', 'Required parameter requestParameters.directoryId was null or undefined when calling directoryListingControllerList.');
            }
            const queryParameters = {};
            if (requestParameters.directoryId !== undefined) {
                queryParameters['directoryId'] = requestParameters.directoryId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_listings`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(DirectoryListingFromJSON));
        });
    }
    /**
     */
    directoryListingControllerList(directoryId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryListingControllerListRaw({ directoryId: directoryId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    directoryListingControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryListingControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_listings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    directoryListingControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.directoryListingControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    directoryListingControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling directoryListingControllerUpdate.');
            }
            if (requestParameters.DirectoryListingUpdateRequest === null || requestParameters.DirectoryListingUpdateRequest === undefined) {
                throw new RequiredError('DirectoryListingUpdateRequest', 'Required parameter requestParameters.DirectoryListingUpdateRequest was null or undefined when calling directoryListingControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/directory_listings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: DirectoryListingUpdateRequestToJSON(requestParameters.DirectoryListingUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => DirectoryListingFromJSON(jsonValue));
        });
    }
    /**
     */
    directoryListingControllerUpdate(id, DirectoryListingUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.directoryListingControllerUpdateRaw({ id: id, DirectoryListingUpdateRequest: DirectoryListingUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    esuiteAppControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling esuiteAppControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/esuite_app/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EsuiteAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    esuiteAppControllerGet(name, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.esuiteAppControllerGetRaw({ name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    esuiteAppControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/esuite_app`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(EsuiteAppResponseFromJSON));
        });
    }
    /**
     */
    esuiteAppControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.esuiteAppControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    esuiteAppControllerListInstancesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.name === null || requestParameters.name === undefined) {
                throw new RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling esuiteAppControllerListInstances.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/esuite_app/{name}/instances`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(BaseEsuiteAppInstanceResponseFromJSON));
        });
    }
    /**
     */
    esuiteAppControllerListInstances(name, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.esuiteAppControllerListInstancesRaw({ name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.FundCreateRequest === null || requestParameters.FundCreateRequest === undefined) {
                throw new RequiredError('FundCreateRequest', 'Required parameter requestParameters.FundCreateRequest was null or undefined when calling fundControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FundCreateRequestToJSON(requestParameters.FundCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FundResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fundControllerCreate(FundCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundControllerCreateRaw({ FundCreateRequest: FundCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling fundControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FundResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fundControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(FundResponseFromJSON));
        });
    }
    /**
     */
    fundControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling fundControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    fundControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fundControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    fundControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling fundControllerUpdate.');
            }
            if (requestParameters.FundUpdateRequest === null || requestParameters.FundUpdateRequest === undefined) {
                throw new RequiredError('FundUpdateRequest', 'Required parameter requestParameters.FundUpdateRequest was null or undefined when calling fundControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: FundUpdateRequestToJSON(requestParameters.FundUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FundResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fundControllerUpdate(id, FundUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundControllerUpdateRaw({ id: id, FundUpdateRequest: FundUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundOptionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fundId === null || requestParameters.fundId === undefined) {
                throw new RequiredError('fundId', 'Required parameter requestParameters.fundId was null or undefined when calling fundOptionControllerCreate.');
            }
            if (requestParameters.FundOptionCreateRequest === null || requestParameters.FundOptionCreateRequest === undefined) {
                throw new RequiredError('FundOptionCreateRequest', 'Required parameter requestParameters.FundOptionCreateRequest was null or undefined when calling fundOptionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{fundId}/options`.replace(`{${"fundId"}}`, encodeURIComponent(String(requestParameters.fundId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FundOptionCreateRequestToJSON(requestParameters.FundOptionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FundOptionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fundOptionControllerCreate(fundId, FundOptionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundOptionControllerCreateRaw({ fundId: fundId, FundOptionCreateRequest: FundOptionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundOptionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling fundOptionControllerGet.');
            }
            if (requestParameters.fundId === null || requestParameters.fundId === undefined) {
                throw new RequiredError('fundId', 'Required parameter requestParameters.fundId was null or undefined when calling fundOptionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{fundId}/options/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"fundId"}}`, encodeURIComponent(String(requestParameters.fundId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FundOptionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fundOptionControllerGet(id, fundId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundOptionControllerGetRaw({ id: id, fundId: fundId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundOptionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fundId === null || requestParameters.fundId === undefined) {
                throw new RequiredError('fundId', 'Required parameter requestParameters.fundId was null or undefined when calling fundOptionControllerList.');
            }
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{fundId}/options`.replace(`{${"fundId"}}`, encodeURIComponent(String(requestParameters.fundId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(FundOptionResponseFromJSON));
        });
    }
    /**
     */
    fundOptionControllerList(fundId, { limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundOptionControllerListRaw({ fundId: fundId, limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    fundOptionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fundId === null || requestParameters.fundId === undefined) {
                throw new RequiredError('fundId', 'Required parameter requestParameters.fundId was null or undefined when calling fundOptionControllerRemove.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling fundOptionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{fundId}/options/{id}`.replace(`{${"fundId"}}`, encodeURIComponent(String(requestParameters.fundId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    fundOptionControllerRemove(fundId, id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fundOptionControllerRemoveRaw({ fundId: fundId, id: id }, initOverrides);
        });
    }
    /**
     */
    fundOptionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fundId === null || requestParameters.fundId === undefined) {
                throw new RequiredError('fundId', 'Required parameter requestParameters.fundId was null or undefined when calling fundOptionControllerUpdate.');
            }
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling fundOptionControllerUpdate.');
            }
            if (requestParameters.FundOptionUpdateRequest === null || requestParameters.FundOptionUpdateRequest === undefined) {
                throw new RequiredError('FundOptionUpdateRequest', 'Required parameter requestParameters.FundOptionUpdateRequest was null or undefined when calling fundOptionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/funds/{fundId}/options/{id}`.replace(`{${"fundId"}}`, encodeURIComponent(String(requestParameters.fundId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: FundOptionUpdateRequestToJSON(requestParameters.FundOptionUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => FundOptionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    fundOptionControllerUpdate(fundId, id, FundOptionUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fundOptionControllerUpdateRaw({ fundId: fundId, id: id, FundOptionUpdateRequest: FundOptionUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    imageUploadControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ImageUploadCreateRequest === null || requestParameters.ImageUploadCreateRequest === undefined) {
                throw new RequiredError('ImageUploadCreateRequest', 'Required parameter requestParameters.ImageUploadCreateRequest was null or undefined when calling imageUploadControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/images`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ImageUploadCreateRequestToJSON(requestParameters.ImageUploadCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ImageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    imageUploadControllerCreate(ImageUploadCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.imageUploadControllerCreateRaw({ ImageUploadCreateRequest: ImageUploadCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    imageUploadControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling imageUploadControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/images/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ImageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    imageUploadControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.imageUploadControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    imageUploadControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/images`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ImageUploadResponseFromJSON));
        });
    }
    /**
     */
    imageUploadControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.imageUploadControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    imageUploadControllerUploadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ImageUploadUploadRequest === null || requestParameters.ImageUploadUploadRequest === undefined) {
                throw new RequiredError('ImageUploadUploadRequest', 'Required parameter requestParameters.ImageUploadUploadRequest was null or undefined when calling imageUploadControllerUpload.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/images/upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ImageUploadUploadRequestToJSON(requestParameters.ImageUploadUploadRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    imageUploadControllerUpload(ImageUploadUploadRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.imageUploadControllerUploadRaw({ ImageUploadUploadRequest: ImageUploadUploadRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.KioskCreateRequest === null || requestParameters.KioskCreateRequest === undefined) {
                throw new RequiredError('KioskCreateRequest', 'Required parameter requestParameters.KioskCreateRequest was null or undefined when calling kioskControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: KioskCreateRequestToJSON(requestParameters.KioskCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => KioskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    kioskControllerCreate(KioskCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerCreateRaw({ KioskCreateRequest: KioskCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => KioskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    kioskControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.username !== undefined) {
                queryParameters['username'] = requestParameters.username;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(KioskResponseFromJSON));
        });
    }
    /**
     */
    kioskControllerList({ limit, skip, username, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerListRaw({ limit: limit, skip: skip, username: username }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    kioskControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kioskControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    kioskControllerSendMessageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerSendMessage.');
            }
            if (requestParameters.KioskMessage === null || requestParameters.KioskMessage === undefined) {
                throw new RequiredError('KioskMessage', 'Required parameter requestParameters.KioskMessage was null or undefined when calling kioskControllerSendMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}/send_message`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: KioskMessageToJSON(requestParameters.KioskMessage),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => KioskMessageFromJSON(jsonValue));
        });
    }
    /**
     */
    kioskControllerSendMessage(id, KioskMessage, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerSendMessageRaw({ id: id, KioskMessage: KioskMessage }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerSseRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerSse.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}/sse`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskControllerSse(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerSseRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerUpdate.');
            }
            if (requestParameters.KioskUpdateRequest === null || requestParameters.KioskUpdateRequest === undefined) {
                throw new RequiredError('KioskUpdateRequest', 'Required parameter requestParameters.KioskUpdateRequest was null or undefined when calling kioskControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: KioskUpdateRequestToJSON(requestParameters.KioskUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => KioskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    kioskControllerUpdate(id, KioskUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerUpdateRaw({ id: id, KioskUpdateRequest: KioskUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerUpdateScreenshotRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerUpdateScreenshot.');
            }
            if (requestParameters.KioskScreenshot === null || requestParameters.KioskScreenshot === undefined) {
                throw new RequiredError('KioskScreenshot', 'Required parameter requestParameters.KioskScreenshot was null or undefined when calling kioskControllerUpdateScreenshot.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}/last_screenshot`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: KioskScreenshotToJSON(requestParameters.KioskScreenshot),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskControllerUpdateScreenshot(id, KioskScreenshot, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerUpdateScreenshotRaw({ id: id, KioskScreenshot: KioskScreenshot }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskControllerUpdateStateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskControllerUpdateState.');
            }
            if (requestParameters.PlatformState === null || requestParameters.PlatformState === undefined) {
                throw new RequiredError('PlatformState', 'Required parameter requestParameters.PlatformState was null or undefined when calling kioskControllerUpdateState.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosks/{id}/last_state`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: PlatformStateToJSON(requestParameters.PlatformState),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => KioskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    kioskControllerUpdateState(id, PlatformState, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskControllerUpdateStateRaw({ id: id, PlatformState: PlatformState }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskGroupControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling kioskGroupControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosk_groups`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskGroupControllerCreate(body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskGroupControllerCreateRaw({ body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskGroupControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskGroupControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosk_groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskGroupControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskGroupControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskGroupControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosk_groups`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskGroupControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskGroupControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskGroupControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskGroupControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosk_groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    kioskGroupControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kioskGroupControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    kioskGroupControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling kioskGroupControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling kioskGroupControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/kiosk_groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskGroupControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskGroupControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskRemoteControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.KioskRemoteListRequest === null || requestParameters.KioskRemoteListRequest === undefined) {
                throw new RequiredError('KioskRemoteListRequest', 'Required parameter requestParameters.KioskRemoteListRequest was null or undefined when calling kioskRemoteControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/kiosk_remote`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
                body: KioskRemoteListRequestToJSON(requestParameters.KioskRemoteListRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    kioskRemoteControllerList(KioskRemoteListRequest, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.kioskRemoteControllerListRaw({ KioskRemoteListRequest: KioskRemoteListRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    kioskRemoteControllerSubmitRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.KioskRemoteCreateRequest === null || requestParameters.KioskRemoteCreateRequest === undefined) {
                throw new RequiredError('KioskRemoteCreateRequest', 'Required parameter requestParameters.KioskRemoteCreateRequest was null or undefined when calling kioskRemoteControllerSubmit.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/kiosk_remote`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: KioskRemoteCreateRequestToJSON(requestParameters.KioskRemoteCreateRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    kioskRemoteControllerSubmit(KioskRemoteCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kioskRemoteControllerSubmitRaw({ KioskRemoteCreateRequest: KioskRemoteCreateRequest }, initOverrides);
        });
    }
    /**
     */
    mailerControllerSendRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling mailerControllerSend.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/mailer/send`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    mailerControllerSend(body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mailerControllerSendRaw({ body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.MediaCollectionAccessCodeCreateRequest === null || requestParameters.MediaCollectionAccessCodeCreateRequest === undefined) {
                throw new RequiredError('MediaCollectionAccessCodeCreateRequest', 'Required parameter requestParameters.MediaCollectionAccessCodeCreateRequest was null or undefined when calling mediaCollectionAccessCodeControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_access_codes`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MediaCollectionAccessCodeCreateRequestToJSON(requestParameters.MediaCollectionAccessCodeCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionAccessCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerCreate(MediaCollectionAccessCodeCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAccessCodeControllerCreateRaw({ MediaCollectionAccessCodeCreateRequest: MediaCollectionAccessCodeCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionAccessCodeControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_access_codes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionAccessCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAccessCodeControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.collectionId === null || requestParameters.collectionId === undefined) {
                throw new RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling mediaCollectionAccessCodeControllerList.');
            }
            const queryParameters = {};
            if (requestParameters.collectionId !== undefined) {
                queryParameters['collectionId'] = requestParameters.collectionId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_access_codes`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaCollectionAccessCodeResponseFromJSON));
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerList(collectionId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAccessCodeControllerListRaw({ collectionId: collectionId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionAccessCodeControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_access_codes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mediaCollectionAccessCodeControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionAccessCodeControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling mediaCollectionAccessCodeControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_access_codes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionAccessCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionAccessCodeControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAccessCodeControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAlbumControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.MediaCollectionAlbumCreateRequest === null || requestParameters.MediaCollectionAlbumCreateRequest === undefined) {
                throw new RequiredError('MediaCollectionAlbumCreateRequest', 'Required parameter requestParameters.MediaCollectionAlbumCreateRequest was null or undefined when calling mediaCollectionAlbumControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_albums`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MediaCollectionAlbumCreateRequestToJSON(requestParameters.MediaCollectionAlbumCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionAlbumResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionAlbumControllerCreate(MediaCollectionAlbumCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAlbumControllerCreateRaw({ MediaCollectionAlbumCreateRequest: MediaCollectionAlbumCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAlbumControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionAlbumControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_albums/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionAlbumResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionAlbumControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAlbumControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAlbumControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.collectionId === null || requestParameters.collectionId === undefined) {
                throw new RequiredError('collectionId', 'Required parameter requestParameters.collectionId was null or undefined when calling mediaCollectionAlbumControllerList.');
            }
            const queryParameters = {};
            if (requestParameters.collectionId !== undefined) {
                queryParameters['collectionId'] = requestParameters.collectionId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_albums`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaCollectionAlbumResponseFromJSON));
        });
    }
    /**
     */
    mediaCollectionAlbumControllerList(collectionId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAlbumControllerListRaw({ collectionId: collectionId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionAlbumControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionAlbumControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_albums/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    mediaCollectionAlbumControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mediaCollectionAlbumControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    mediaCollectionAlbumControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionAlbumControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling mediaCollectionAlbumControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_albums/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionAlbumResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionAlbumControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionAlbumControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.MediaCollectionCreateRequest === null || requestParameters.MediaCollectionCreateRequest === undefined) {
                throw new RequiredError('MediaCollectionCreateRequest', 'Required parameter requestParameters.MediaCollectionCreateRequest was null or undefined when calling mediaCollectionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MediaCollectionCreateRequestToJSON(requestParameters.MediaCollectionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionControllerCreate(MediaCollectionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerCreateRaw({ MediaCollectionCreateRequest: MediaCollectionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerDuplicateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionControllerDuplicate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections/{id}/duplicate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionControllerDuplicate(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerDuplicateRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaCollectionResponseFromJSON));
        });
    }
    /**
     */
    mediaCollectionControllerList({ limit, skip, name, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerListRaw({ limit: limit, skip: skip, name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    mediaCollectionControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mediaCollectionControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    mediaCollectionControllerSyncRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionControllerSync.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections/{id}/sync`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionControllerSync(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerSyncRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerTagPhotosRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionControllerTagPhotos.');
            }
            if (requestParameters.MediaCollectionPhotoTagRequestDto === null || requestParameters.MediaCollectionPhotoTagRequestDto === undefined) {
                throw new RequiredError('MediaCollectionPhotoTagRequestDto', 'Required parameter requestParameters.MediaCollectionPhotoTagRequestDto was null or undefined when calling mediaCollectionControllerTagPhotos.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections/{id}/tag_photos`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MediaCollectionPhotoTagRequestDtoToJSON(requestParameters.MediaCollectionPhotoTagRequestDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionControllerTagPhotos(id, MediaCollectionPhotoTagRequestDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerTagPhotosRaw({ id: id, MediaCollectionPhotoTagRequestDto: MediaCollectionPhotoTagRequestDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionControllerUpdate.');
            }
            if (requestParameters.MediaCollectionUpdateRequest === null || requestParameters.MediaCollectionUpdateRequest === undefined) {
                throw new RequiredError('MediaCollectionUpdateRequest', 'Required parameter requestParameters.MediaCollectionUpdateRequest was null or undefined when calling mediaCollectionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_collections/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: MediaCollectionUpdateRequestToJSON(requestParameters.MediaCollectionUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionControllerUpdate(id, MediaCollectionUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionControllerUpdateRaw({ id: id, MediaCollectionUpdateRequest: MediaCollectionUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionItemControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.MediaCollectionItemCreateRequest === null || requestParameters.MediaCollectionItemCreateRequest === undefined) {
                throw new RequiredError('MediaCollectionItemCreateRequest', 'Required parameter requestParameters.MediaCollectionItemCreateRequest was null or undefined when calling mediaCollectionItemControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_items`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MediaCollectionItemCreateRequestToJSON(requestParameters.MediaCollectionItemCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionItemControllerCreate(MediaCollectionItemCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionItemControllerCreateRaw({ MediaCollectionItemCreateRequest: MediaCollectionItemCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionItemControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionItemControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionItemControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionItemControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionItemControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.albumId === null || requestParameters.albumId === undefined) {
                throw new RequiredError('albumId', 'Required parameter requestParameters.albumId was null or undefined when calling mediaCollectionItemControllerList.');
            }
            const queryParameters = {};
            if (requestParameters.albumId !== undefined) {
                queryParameters['albumId'] = requestParameters.albumId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_items`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(MediaCollectionItemResponseFromJSON));
        });
    }
    /**
     */
    mediaCollectionItemControllerList(albumId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionItemControllerListRaw({ albumId: albumId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mediaCollectionItemControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionItemControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    mediaCollectionItemControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mediaCollectionItemControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    mediaCollectionItemControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling mediaCollectionItemControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling mediaCollectionItemControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/media_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MediaCollectionItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mediaCollectionItemControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mediaCollectionItemControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    notificationControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.idOrKey === null || requestParameters.idOrKey === undefined) {
                throw new RequiredError('idOrKey', 'Required parameter requestParameters.idOrKey was null or undefined when calling notificationControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/notifications/{idOrKey}`.replace(`{${"idOrKey"}}`, encodeURIComponent(String(requestParameters.idOrKey))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => NotificationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    notificationControllerGet(idOrKey, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.notificationControllerGetRaw({ idOrKey: idOrKey }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    notificationControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/notifications`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(NotificationResponseFromJSON));
        });
    }
    /**
     */
    notificationControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.notificationControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    notificationControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling notificationControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    notificationControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.notificationControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    notificationControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling notificationControllerUpdate.');
            }
            if (requestParameters.NotificationUpdateRequest === null || requestParameters.NotificationUpdateRequest === undefined) {
                throw new RequiredError('NotificationUpdateRequest', 'Required parameter requestParameters.NotificationUpdateRequest was null or undefined when calling notificationControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: NotificationUpdateRequestToJSON(requestParameters.NotificationUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => NotificationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    notificationControllerUpdate(id, NotificationUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.notificationControllerUpdateRaw({ id: id, NotificationUpdateRequest: NotificationUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.OrderCreateRequest === null || requestParameters.OrderCreateRequest === undefined) {
                throw new RequiredError('OrderCreateRequest', 'Required parameter requestParameters.OrderCreateRequest was null or undefined when calling orderControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OrderCreateRequestToJSON(requestParameters.OrderCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    orderControllerCreate(OrderCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderControllerCreateRaw({ OrderCreateRequest: OrderCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling orderControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    orderControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.fromDate !== undefined) {
                queryParameters['fromDate'] = requestParameters.fromDate;
            }
            if (requestParameters.toDate !== undefined) {
                queryParameters['toDate'] = requestParameters.toDate;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderResponseFromJSON));
        });
    }
    /**
     */
    orderControllerList({ limit, skip, fromDate, toDate, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderControllerListRaw({ limit: limit, skip: skip, fromDate: fromDate, toDate: toDate }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling orderControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    orderControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.orderControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    orderControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling orderControllerUpdate.');
            }
            if (requestParameters.OrderUpdateRequest === null || requestParameters.OrderUpdateRequest === undefined) {
                throw new RequiredError('OrderUpdateRequest', 'Required parameter requestParameters.OrderUpdateRequest was null or undefined when calling orderControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: OrderUpdateRequestToJSON(requestParameters.OrderUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    orderControllerUpdate(id, OrderUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderControllerUpdateRaw({ id: id, OrderUpdateRequest: OrderUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderControllerWebhookRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.source === null || requestParameters.source === undefined) {
                throw new RequiredError('source', 'Required parameter requestParameters.source was null or undefined when calling orderControllerWebhook.');
            }
            const queryParameters = {};
            if (requestParameters.source !== undefined) {
                queryParameters['source'] = requestParameters.source;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/whs`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    orderControllerWebhook(source, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderControllerWebhookRaw({ source: source }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderLineItemControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling orderLineItemControllerCreate.');
            }
            if (requestParameters.OrderLineItemCreateRequest === null || requestParameters.OrderLineItemCreateRequest === undefined) {
                throw new RequiredError('OrderLineItemCreateRequest', 'Required parameter requestParameters.OrderLineItemCreateRequest was null or undefined when calling orderLineItemControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{orderId}/line_items`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OrderLineItemCreateRequestToJSON(requestParameters.OrderLineItemCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrderLineItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    orderLineItemControllerCreate(orderId, OrderLineItemCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderLineItemControllerCreateRaw({ orderId: orderId, OrderLineItemCreateRequest: OrderLineItemCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderLineItemControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling orderLineItemControllerGet.');
            }
            if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling orderLineItemControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{orderId}/line_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrderLineItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    orderLineItemControllerGet(id, orderId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderLineItemControllerGetRaw({ id: id, orderId: orderId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderLineItemControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling orderLineItemControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{orderId}/line_items`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderLineItemResponseFromJSON));
        });
    }
    /**
     */
    orderLineItemControllerList(orderId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderLineItemControllerListRaw({ orderId: orderId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    orderLineItemControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling orderLineItemControllerRemove.');
            }
            if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling orderLineItemControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{orderId}/line_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    orderLineItemControllerRemove(id, orderId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.orderLineItemControllerRemoveRaw({ id: id, orderId: orderId }, initOverrides);
        });
    }
    /**
     */
    orderLineItemControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling orderLineItemControllerUpdate.');
            }
            if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling orderLineItemControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling orderLineItemControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/orders/{orderId}/line_items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrderLineItemResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    orderLineItemControllerUpdate(id, orderId, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.orderLineItemControllerUpdateRaw({ id: id, orderId: orderId, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    organizationControllerExportRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/organization/export`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrganizationExportResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    organizationControllerExport(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.organizationControllerExportRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    organizationControllerGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/organization`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OrganizationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    organizationControllerGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.organizationControllerGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentGatewayControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.PaymentGatewayCreateRequest === null || requestParameters.PaymentGatewayCreateRequest === undefined) {
                throw new RequiredError('PaymentGatewayCreateRequest', 'Required parameter requestParameters.PaymentGatewayCreateRequest was null or undefined when calling paymentGatewayControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_gateways`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentGatewayCreateRequestToJSON(requestParameters.PaymentGatewayCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentGatewayResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentGatewayControllerCreate(PaymentGatewayCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentGatewayControllerCreateRaw({ PaymentGatewayCreateRequest: PaymentGatewayCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentGatewayControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling paymentGatewayControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_gateways/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentGatewayResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentGatewayControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentGatewayControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentGatewayControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_gateways`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentGatewayResponseFromJSON));
        });
    }
    /**
     */
    paymentGatewayControllerList({ limit, skip, name, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentGatewayControllerListRaw({ limit: limit, skip: skip, name: name }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentGatewayControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling paymentGatewayControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_gateways/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    paymentGatewayControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.paymentGatewayControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    paymentGatewayControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling paymentGatewayControllerUpdate.');
            }
            if (requestParameters.PaymentGatewayUpdateRequest === null || requestParameters.PaymentGatewayUpdateRequest === undefined) {
                throw new RequiredError('PaymentGatewayUpdateRequest', 'Required parameter requestParameters.PaymentGatewayUpdateRequest was null or undefined when calling paymentGatewayControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_gateways/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentGatewayUpdateRequestToJSON(requestParameters.PaymentGatewayUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentGatewayResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentGatewayControllerUpdate(id, PaymentGatewayUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentGatewayControllerUpdateRaw({ id: id, PaymentGatewayUpdateRequest: PaymentGatewayUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.PaymentTerminalCreateRequest === null || requestParameters.PaymentTerminalCreateRequest === undefined) {
                throw new RequiredError('PaymentTerminalCreateRequest', 'Required parameter requestParameters.PaymentTerminalCreateRequest was null or undefined when calling paymentTerminalControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_terminals`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalCreateRequestToJSON(requestParameters.PaymentTerminalCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerCreate(PaymentTerminalCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerCreateRaw({ PaymentTerminalCreateRequest: PaymentTerminalCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling paymentTerminalControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_terminals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.gatewayId !== undefined) {
                queryParameters['gatewayId'] = requestParameters.gatewayId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_terminals`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentTerminalResponseFromJSON));
        });
    }
    /**
     */
    paymentTerminalControllerList({ gatewayId, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerListRaw({ gatewayId: gatewayId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling paymentTerminalControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_terminals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    paymentTerminalControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.paymentTerminalControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    paymentTerminalControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling paymentTerminalControllerUpdate.');
            }
            if (requestParameters.PaymentTerminalUpdateRequest === null || requestParameters.PaymentTerminalUpdateRequest === undefined) {
                throw new RequiredError('PaymentTerminalUpdateRequest', 'Required parameter requestParameters.PaymentTerminalUpdateRequest was null or undefined when calling paymentTerminalControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/payment_terminals/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalUpdateRequestToJSON(requestParameters.PaymentTerminalUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerUpdate(id, PaymentTerminalUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerUpdateRaw({ id: id, PaymentTerminalUpdateRequest: PaymentTerminalUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.PhotoboothCreateRequest === null || requestParameters.PhotoboothCreateRequest === undefined) {
                throw new RequiredError('PhotoboothCreateRequest', 'Required parameter requestParameters.PhotoboothCreateRequest was null or undefined when calling photoboothControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PhotoboothCreateRequestToJSON(requestParameters.PhotoboothCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PhotoboothResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    photoboothControllerCreate(PhotoboothCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothControllerCreateRaw({ PhotoboothCreateRequest: PhotoboothCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PhotoboothResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    photoboothControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(PhotoboothResponseFromJSON));
        });
    }
    /**
     */
    photoboothControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    photoboothControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.photoboothControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    photoboothControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothControllerUpdate.');
            }
            if (requestParameters.PhotoboothUpdateRequest === null || requestParameters.PhotoboothUpdateRequest === undefined) {
                throw new RequiredError('PhotoboothUpdateRequest', 'Required parameter requestParameters.PhotoboothUpdateRequest was null or undefined when calling photoboothControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: PhotoboothUpdateRequestToJSON(requestParameters.PhotoboothUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PhotoboothResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    photoboothControllerUpdate(id, PhotoboothUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothControllerUpdateRaw({ id: id, PhotoboothUpdateRequest: PhotoboothUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothFrameControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothFrameControllerCreate.');
            }
            if (requestParameters.PhotoboothFrameCreateRequest === null || requestParameters.PhotoboothFrameCreateRequest === undefined) {
                throw new RequiredError('PhotoboothFrameCreateRequest', 'Required parameter requestParameters.PhotoboothFrameCreateRequest was null or undefined when calling photoboothFrameControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/frames`.replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PhotoboothFrameCreateRequestToJSON(requestParameters.PhotoboothFrameCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PhotoboothFrameResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    photoboothFrameControllerCreate(photoboothId, PhotoboothFrameCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothFrameControllerCreateRaw({ photoboothId: photoboothId, PhotoboothFrameCreateRequest: PhotoboothFrameCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothFrameControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothFrameControllerGet.');
            }
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothFrameControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/frames/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PhotoboothFrameResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    photoboothFrameControllerGet(id, photoboothId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothFrameControllerGetRaw({ id: id, photoboothId: photoboothId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothFrameControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothFrameControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/frames`.replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(PhotoboothFrameResponseFromJSON));
        });
    }
    /**
     */
    photoboothFrameControllerList(photoboothId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothFrameControllerListRaw({ photoboothId: photoboothId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothFrameControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothFrameControllerRemove.');
            }
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothFrameControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/frames/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    photoboothFrameControllerRemove(id, photoboothId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.photoboothFrameControllerRemoveRaw({ id: id, photoboothId: photoboothId }, initOverrides);
        });
    }
    /**
     */
    photoboothFrameControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothFrameControllerUpdate.');
            }
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothFrameControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling photoboothFrameControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/frames/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PhotoboothFrameResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    photoboothFrameControllerUpdate(id, photoboothId, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothFrameControllerUpdateRaw({ id: id, photoboothId: photoboothId, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothSessionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothSessionControllerCreate.');
            }
            if (requestParameters.PhotoboothSessionCreateRequest === null || requestParameters.PhotoboothSessionCreateRequest === undefined) {
                throw new RequiredError('PhotoboothSessionCreateRequest', 'Required parameter requestParameters.PhotoboothSessionCreateRequest was null or undefined when calling photoboothSessionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/sessions`.replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PhotoboothSessionCreateRequestToJSON(requestParameters.PhotoboothSessionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    photoboothSessionControllerCreate(photoboothId, PhotoboothSessionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothSessionControllerCreateRaw({ photoboothId: photoboothId, PhotoboothSessionCreateRequest: PhotoboothSessionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothSessionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothSessionControllerGet.');
            }
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothSessionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/sessions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    photoboothSessionControllerGet(id, photoboothId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothSessionControllerGetRaw({ id: id, photoboothId: photoboothId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothSessionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothSessionControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/sessions`.replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    photoboothSessionControllerList(photoboothId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothSessionControllerListRaw({ photoboothId: photoboothId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    photoboothSessionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothSessionControllerRemove.');
            }
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothSessionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/sessions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    photoboothSessionControllerRemove(id, photoboothId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.photoboothSessionControllerRemoveRaw({ id: id, photoboothId: photoboothId }, initOverrides);
        });
    }
    /**
     */
    photoboothSessionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling photoboothSessionControllerUpdate.');
            }
            if (requestParameters.photoboothId === null || requestParameters.photoboothId === undefined) {
                throw new RequiredError('photoboothId', 'Required parameter requestParameters.photoboothId was null or undefined when calling photoboothSessionControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling photoboothSessionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/photobooth/{photoboothId}/sessions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"photoboothId"}}`, encodeURIComponent(String(requestParameters.photoboothId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    photoboothSessionControllerUpdate(id, photoboothId, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.photoboothSessionControllerUpdateRaw({ id: id, photoboothId: photoboothId, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.PlatformCreateRequest === null || requestParameters.PlatformCreateRequest === undefined) {
                throw new RequiredError('PlatformCreateRequest', 'Required parameter requestParameters.PlatformCreateRequest was null or undefined when calling platformControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/platforms`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PlatformCreateRequestToJSON(requestParameters.PlatformCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PlatformResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    platformControllerCreate(PlatformCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.platformControllerCreateRaw({ PlatformCreateRequest: PlatformCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling platformControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PlatformResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    platformControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.platformControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/platforms`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(PlatformResponseFromJSON));
        });
    }
    /**
     */
    platformControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.platformControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling platformControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    platformControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.platformControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    platformControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling platformControllerUpdate.');
            }
            if (requestParameters.PlatformUpdateRequest === null || requestParameters.PlatformUpdateRequest === undefined) {
                throw new RequiredError('PlatformUpdateRequest', 'Required parameter requestParameters.PlatformUpdateRequest was null or undefined when calling platformControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/platforms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: PlatformUpdateRequestToJSON(requestParameters.PlatformUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PlatformResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    platformControllerUpdate(id, PlatformUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.platformControllerUpdateRaw({ id: id, PlatformUpdateRequest: PlatformUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productCategoryControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ProductCategoryCreateRequest === null || requestParameters.ProductCategoryCreateRequest === undefined) {
                throw new RequiredError('ProductCategoryCreateRequest', 'Required parameter requestParameters.ProductCategoryCreateRequest was null or undefined when calling productCategoryControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/product_categories`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProductCategoryCreateRequestToJSON(requestParameters.ProductCategoryCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ProductCategoryResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    productCategoryControllerCreate(ProductCategoryCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productCategoryControllerCreateRaw({ ProductCategoryCreateRequest: ProductCategoryCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productCategoryControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling productCategoryControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/product_categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ProductCategoryResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    productCategoryControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productCategoryControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productCategoryControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.ids) {
                queryParameters['ids'] = requestParameters.ids;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/product_categories`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductCategoryResponseFromJSON));
        });
    }
    /**
     */
    productCategoryControllerList({ ids, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productCategoryControllerListRaw({ ids: ids }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productCategoryControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling productCategoryControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/product_categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    productCategoryControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.productCategoryControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    productCategoryControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling productCategoryControllerUpdate.');
            }
            if (requestParameters.ProductCategoryUpdateRequest === null || requestParameters.ProductCategoryUpdateRequest === undefined) {
                throw new RequiredError('ProductCategoryUpdateRequest', 'Required parameter requestParameters.ProductCategoryUpdateRequest was null or undefined when calling productCategoryControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/product_categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ProductCategoryUpdateRequestToJSON(requestParameters.ProductCategoryUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ProductCategoryResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    productCategoryControllerUpdate(id, ProductCategoryUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productCategoryControllerUpdateRaw({ id: id, ProductCategoryUpdateRequest: ProductCategoryUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    registerControllerRegisterOrganizationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.RegisterCreateRequest === null || requestParameters.RegisterCreateRequest === undefined) {
                throw new RequiredError('RegisterCreateRequest', 'Required parameter requestParameters.RegisterCreateRequest was null or undefined when calling registerControllerRegisterOrganization.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/register`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RegisterCreateRequestToJSON(requestParameters.RegisterCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RegisterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    registerControllerRegisterOrganization(RegisterCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.registerControllerRegisterOrganizationRaw({ RegisterCreateRequest: RegisterCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    restAppControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.RestAppCreateRequest === null || requestParameters.RestAppCreateRequest === undefined) {
                throw new RequiredError('RestAppCreateRequest', 'Required parameter requestParameters.RestAppCreateRequest was null or undefined when calling restAppControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/rest_apps`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RestAppCreateRequestToJSON(requestParameters.RestAppCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RestAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    restAppControllerCreate(RestAppCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.restAppControllerCreateRaw({ RestAppCreateRequest: RestAppCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    restAppControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling restAppControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/rest_apps/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RestAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    restAppControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.restAppControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    restAppControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/rest_apps`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(RestAppResponseFromJSON));
        });
    }
    /**
     */
    restAppControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.restAppControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    restAppControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling restAppControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/rest_apps/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    restAppControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.restAppControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    restAppControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling restAppControllerUpdate.');
            }
            if (requestParameters.RestAppUpdateRequest === null || requestParameters.RestAppUpdateRequest === undefined) {
                throw new RequiredError('RestAppUpdateRequest', 'Required parameter requestParameters.RestAppUpdateRequest was null or undefined when calling restAppControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/rest_apps/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: RestAppUpdateRequestToJSON(requestParameters.RestAppUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RestAppResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    restAppControllerUpdate(id, RestAppUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.restAppControllerUpdateRaw({ id: id, RestAppUpdateRequest: RestAppUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    revenueCenterControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.RevenueCenterCreateRequest === null || requestParameters.RevenueCenterCreateRequest === undefined) {
                throw new RequiredError('RevenueCenterCreateRequest', 'Required parameter requestParameters.RevenueCenterCreateRequest was null or undefined when calling revenueCenterControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/revenue_centers`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RevenueCenterCreateRequestToJSON(requestParameters.RevenueCenterCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RevenueCenterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    revenueCenterControllerCreate(RevenueCenterCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.revenueCenterControllerCreateRaw({ RevenueCenterCreateRequest: RevenueCenterCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    revenueCenterControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling revenueCenterControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/revenue_centers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RevenueCenterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    revenueCenterControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.revenueCenterControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    revenueCenterControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/revenue_centers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(RevenueCenterResponseFromJSON));
        });
    }
    /**
     */
    revenueCenterControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.revenueCenterControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    revenueCenterControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling revenueCenterControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/revenue_centers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    revenueCenterControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.revenueCenterControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    revenueCenterControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling revenueCenterControllerUpdate.');
            }
            if (requestParameters.RevenueCenterUpdateRequest === null || requestParameters.RevenueCenterUpdateRequest === undefined) {
                throw new RequiredError('RevenueCenterUpdateRequest', 'Required parameter requestParameters.RevenueCenterUpdateRequest was null or undefined when calling revenueCenterControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/revenue_centers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: RevenueCenterUpdateRequestToJSON(requestParameters.RevenueCenterUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RevenueCenterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    revenueCenterControllerUpdate(id, RevenueCenterUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.revenueCenterControllerUpdateRaw({ id: id, RevenueCenterUpdateRequest: RevenueCenterUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    roleControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/roles`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleResponseFromJSON));
        });
    }
    /**
     */
    roleControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.roleControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.SelfCheckoutCreateRequest === null || requestParameters.SelfCheckoutCreateRequest === undefined) {
                throw new RequiredError('SelfCheckoutCreateRequest', 'Required parameter requestParameters.SelfCheckoutCreateRequest was null or undefined when calling selfCheckoutControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutCreateRequestToJSON(requestParameters.SelfCheckoutCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutControllerCreate(SelfCheckoutCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutControllerCreateRaw({ SelfCheckoutCreateRequest: SelfCheckoutCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SelfCheckoutResponseFromJSON));
        });
    }
    /**
     */
    selfCheckoutControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutControllerRemoveRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutControllerRestoreNotificationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutControllerRestoreNotifications.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{id}/restore_notifications`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutControllerRestoreNotifications(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutControllerRestoreNotificationsRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutControllerUpdate.');
            }
            if (requestParameters.SelfCheckoutUpdateRequest === null || requestParameters.SelfCheckoutUpdateRequest === undefined) {
                throw new RequiredError('SelfCheckoutUpdateRequest', 'Required parameter requestParameters.SelfCheckoutUpdateRequest was null or undefined when calling selfCheckoutControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutUpdateRequestToJSON(requestParameters.SelfCheckoutUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutControllerUpdate(id, SelfCheckoutUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutControllerUpdateRaw({ id: id, SelfCheckoutUpdateRequest: SelfCheckoutUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutCountryControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_countries`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SelfCheckoutCountryResponseFromJSON));
        });
    }
    /**
     */
    selfCheckoutCountryControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutCountryControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.SelfCheckoutIntegrationCreateRequest === null || requestParameters.SelfCheckoutIntegrationCreateRequest === undefined) {
                throw new RequiredError('SelfCheckoutIntegrationCreateRequest', 'Required parameter requestParameters.SelfCheckoutIntegrationCreateRequest was null or undefined when calling selfCheckoutIntegrationControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutIntegrationCreateRequestToJSON(requestParameters.SelfCheckoutIntegrationCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutIntegrationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerCreate(SelfCheckoutIntegrationCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerCreateRaw({ SelfCheckoutIntegrationCreateRequest: SelfCheckoutIntegrationCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerFindRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerFind.');
            }
            if (requestParameters.cache === null || requestParameters.cache === undefined) {
                throw new RequiredError('cache', 'Required parameter requestParameters.cache was null or undefined when calling selfCheckoutIntegrationControllerFind.');
            }
            if (requestParameters.SelfCheckoutIntegrationCacheQuery === null || requestParameters.SelfCheckoutIntegrationCacheQuery === undefined) {
                throw new RequiredError('SelfCheckoutIntegrationCacheQuery', 'Required parameter requestParameters.SelfCheckoutIntegrationCacheQuery was null or undefined when calling selfCheckoutIntegrationControllerFind.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}/{cache}/find`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"cache"}}`, encodeURIComponent(String(requestParameters.cache))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutIntegrationCacheQueryToJSON(requestParameters.SelfCheckoutIntegrationCacheQuery),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerFind(id, cache, SelfCheckoutIntegrationCacheQuery, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerFindRaw({ id: id, cache: cache, SelfCheckoutIntegrationCacheQuery: SelfCheckoutIntegrationCacheQuery }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutIntegrationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerGetCustomersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerGetCustomers.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling selfCheckoutIntegrationControllerGetCustomers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}/customers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerGetCustomers(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerGetCustomersRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerGetProductsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerGetProducts.');
            }
            if (requestParameters.GetProductDto === null || requestParameters.GetProductDto === undefined) {
                throw new RequiredError('GetProductDto', 'Required parameter requestParameters.GetProductDto was null or undefined when calling selfCheckoutIntegrationControllerGetProducts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}/products`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GetProductDtoToJSON(requestParameters.GetProductDto),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerGetProducts(id, GetProductDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerGetProductsRaw({ id: id, GetProductDto: GetProductDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SelfCheckoutIntegrationResponseFromJSON));
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.selfCheckoutIntegrationControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerUpdate.');
            }
            if (requestParameters.SelfCheckoutIntegrationUpdateRequest === null || requestParameters.SelfCheckoutIntegrationUpdateRequest === undefined) {
                throw new RequiredError('SelfCheckoutIntegrationUpdateRequest', 'Required parameter requestParameters.SelfCheckoutIntegrationUpdateRequest was null or undefined when calling selfCheckoutIntegrationControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutIntegrationUpdateRequestToJSON(requestParameters.SelfCheckoutIntegrationUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutIntegrationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerUpdate(id, SelfCheckoutIntegrationUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerUpdateRaw({ id: id, SelfCheckoutIntegrationUpdateRequest: SelfCheckoutIntegrationUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerUpdateCacheRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutIntegrationControllerUpdateCache.');
            }
            if (requestParameters.cache === null || requestParameters.cache === undefined) {
                throw new RequiredError('cache', 'Required parameter requestParameters.cache was null or undefined when calling selfCheckoutIntegrationControllerUpdateCache.');
            }
            if (requestParameters.SelfCheckoutIntegrationCacheUpdate === null || requestParameters.SelfCheckoutIntegrationCacheUpdate === undefined) {
                throw new RequiredError('SelfCheckoutIntegrationCacheUpdate', 'Required parameter requestParameters.SelfCheckoutIntegrationCacheUpdate was null or undefined when calling selfCheckoutIntegrationControllerUpdateCache.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_integration/{id}/cache/{cache}/update`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"cache"}}`, encodeURIComponent(String(requestParameters.cache))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutIntegrationCacheUpdateToJSON(requestParameters.SelfCheckoutIntegrationCacheUpdate),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutIntegrationControllerUpdateCache(id, cache, SelfCheckoutIntegrationCacheUpdate, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutIntegrationControllerUpdateCacheRaw({ id: id, cache: cache, SelfCheckoutIntegrationCacheUpdate: SelfCheckoutIntegrationCacheUpdate }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutOrderControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerCreate.');
            }
            if (requestParameters.SelfCheckoutOrderCreateRequest === null || requestParameters.SelfCheckoutOrderCreateRequest === undefined) {
                throw new RequiredError('SelfCheckoutOrderCreateRequest', 'Required parameter requestParameters.SelfCheckoutOrderCreateRequest was null or undefined when calling selfCheckoutOrderControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders`.replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutOrderCreateRequestToJSON(requestParameters.SelfCheckoutOrderCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutOrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutOrderControllerCreate(selfCheckoutId, SelfCheckoutOrderCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutOrderControllerCreateRaw({ selfCheckoutId: selfCheckoutId, SelfCheckoutOrderCreateRequest: SelfCheckoutOrderCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutOrderControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutOrderControllerGet.');
            }
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutOrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutOrderControllerGet(id, selfCheckoutId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutOrderControllerGetRaw({ id: id, selfCheckoutId: selfCheckoutId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutOrderControllerGetByOrderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutOrderControllerGetByOrder.');
            }
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerGetByOrder.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders/order/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutOrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutOrderControllerGetByOrder(id, selfCheckoutId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutOrderControllerGetByOrderRaw({ id: id, selfCheckoutId: selfCheckoutId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutOrderControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders`.replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SelfCheckoutOrderResponseFromJSON));
        });
    }
    /**
     */
    selfCheckoutOrderControllerList(selfCheckoutId, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutOrderControllerListRaw({ selfCheckoutId: selfCheckoutId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutOrderControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutOrderControllerRemove.');
            }
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutOrderControllerRemove(id, selfCheckoutId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.selfCheckoutOrderControllerRemoveRaw({ id: id, selfCheckoutId: selfCheckoutId }, initOverrides);
        });
    }
    /**
     */
    selfCheckoutOrderControllerSubmitShopifyOrderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutOrderControllerSubmitShopifyOrder.');
            }
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerSubmitShopifyOrder.');
            }
            if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
                throw new RequiredError('integrationId', 'Required parameter requestParameters.integrationId was null or undefined when calling selfCheckoutOrderControllerSubmitShopifyOrder.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders/order/{id}/sync_integrations/{integrationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutOrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutOrderControllerSubmitShopifyOrder(id, selfCheckoutId, integrationId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutOrderControllerSubmitShopifyOrderRaw({ id: id, selfCheckoutId: selfCheckoutId, integrationId: integrationId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutOrderControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutOrderControllerUpdate.');
            }
            if (requestParameters.selfCheckoutId === null || requestParameters.selfCheckoutId === undefined) {
                throw new RequiredError('selfCheckoutId', 'Required parameter requestParameters.selfCheckoutId was null or undefined when calling selfCheckoutOrderControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling selfCheckoutOrderControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout/{selfCheckoutId}/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"selfCheckoutId"}}`, encodeURIComponent(String(requestParameters.selfCheckoutId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutOrderResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutOrderControllerUpdate(id, selfCheckoutId, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutOrderControllerUpdateRaw({ id: id, selfCheckoutId: selfCheckoutId, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutTemplateControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.SelfCheckoutTemplateCreateRequest === null || requestParameters.SelfCheckoutTemplateCreateRequest === undefined) {
                throw new RequiredError('SelfCheckoutTemplateCreateRequest', 'Required parameter requestParameters.SelfCheckoutTemplateCreateRequest was null or undefined when calling selfCheckoutTemplateControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_template`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutTemplateCreateRequestToJSON(requestParameters.SelfCheckoutTemplateCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutTemplateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutTemplateControllerCreate(SelfCheckoutTemplateCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutTemplateControllerCreateRaw({ SelfCheckoutTemplateCreateRequest: SelfCheckoutTemplateCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutTemplateControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutTemplateControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutTemplateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutTemplateControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutTemplateControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutTemplateControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_template`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SelfCheckoutTemplateResponseFromJSON));
        });
    }
    /**
     */
    selfCheckoutTemplateControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutTemplateControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    selfCheckoutTemplateControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutTemplateControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    selfCheckoutTemplateControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.selfCheckoutTemplateControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    selfCheckoutTemplateControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling selfCheckoutTemplateControllerUpdate.');
            }
            if (requestParameters.SelfCheckoutTemplateUpdateRequest === null || requestParameters.SelfCheckoutTemplateUpdateRequest === undefined) {
                throw new RequiredError('SelfCheckoutTemplateUpdateRequest', 'Required parameter requestParameters.SelfCheckoutTemplateUpdateRequest was null or undefined when calling selfCheckoutTemplateControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/self_checkout_template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SelfCheckoutTemplateUpdateRequestToJSON(requestParameters.SelfCheckoutTemplateUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SelfCheckoutTemplateResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    selfCheckoutTemplateControllerUpdate(id, SelfCheckoutTemplateUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.selfCheckoutTemplateControllerUpdateRaw({ id: id, SelfCheckoutTemplateUpdateRequest: SelfCheckoutTemplateUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ShopifyCheckoutCreateRequest === null || requestParameters.ShopifyCheckoutCreateRequest === undefined) {
                throw new RequiredError('ShopifyCheckoutCreateRequest', 'Required parameter requestParameters.ShopifyCheckoutCreateRequest was null or undefined when calling shopifyCheckoutControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/shopify_checkout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ShopifyCheckoutCreateRequestToJSON(requestParameters.ShopifyCheckoutCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ShopifyCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    shopifyCheckoutControllerCreate(ShopifyCheckoutCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutControllerCreateRaw({ ShopifyCheckoutCreateRequest: ShopifyCheckoutCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shopifyCheckoutControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/shopify_checkout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ShopifyCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    shopifyCheckoutControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.integrationId !== undefined) {
                queryParameters['integrationId'] = requestParameters.integrationId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/shopify_checkout`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopifyCheckoutResponseFromJSON));
        });
    }
    /**
     */
    shopifyCheckoutControllerList({ integrationId, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutControllerListRaw({ integrationId: integrationId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shopifyCheckoutControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/shopify_checkout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    shopifyCheckoutControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.shopifyCheckoutControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    shopifyCheckoutControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shopifyCheckoutControllerUpdate.');
            }
            if (requestParameters.ShopifyCheckoutUpdateRequest === null || requestParameters.ShopifyCheckoutUpdateRequest === undefined) {
                throw new RequiredError('ShopifyCheckoutUpdateRequest', 'Required parameter requestParameters.ShopifyCheckoutUpdateRequest was null or undefined when calling shopifyCheckoutControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/shopify_checkout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ShopifyCheckoutUpdateRequestToJSON(requestParameters.ShopifyCheckoutUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ShopifyCheckoutResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    shopifyCheckoutControllerUpdate(id, ShopifyCheckoutUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutControllerUpdateRaw({ id: id, ShopifyCheckoutUpdateRequest: ShopifyCheckoutUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ShopifyCheckoutPaymentCreateRequest === null || requestParameters.ShopifyCheckoutPaymentCreateRequest === undefined) {
                throw new RequiredError('ShopifyCheckoutPaymentCreateRequest', 'Required parameter requestParameters.ShopifyCheckoutPaymentCreateRequest was null or undefined when calling shopifyCheckoutPaymentControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/shopify_checkout_payment`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ShopifyCheckoutPaymentCreateRequestToJSON(requestParameters.ShopifyCheckoutPaymentCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ShopifyCheckoutPaymentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerCreate(ShopifyCheckoutPaymentCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutPaymentControllerCreateRaw({ ShopifyCheckoutPaymentCreateRequest: ShopifyCheckoutPaymentCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shopifyCheckoutPaymentControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/shopify_checkout_payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ShopifyCheckoutPaymentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutPaymentControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/shopify_checkout_payment`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopifyCheckoutPaymentResponseFromJSON));
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutPaymentControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shopifyCheckoutPaymentControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/shopify_checkout_payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.shopifyCheckoutPaymentControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shopifyCheckoutPaymentControllerUpdate.');
            }
            if (requestParameters.ShopifyCheckoutPaymentUpdateRequest === null || requestParameters.ShopifyCheckoutPaymentUpdateRequest === undefined) {
                throw new RequiredError('ShopifyCheckoutPaymentUpdateRequest', 'Required parameter requestParameters.ShopifyCheckoutPaymentUpdateRequest was null or undefined when calling shopifyCheckoutPaymentControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/shopify_checkout_payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ShopifyCheckoutPaymentUpdateRequestToJSON(requestParameters.ShopifyCheckoutPaymentUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ShopifyCheckoutPaymentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    shopifyCheckoutPaymentControllerUpdate(id, ShopifyCheckoutPaymentUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyCheckoutPaymentControllerUpdateRaw({ id: id, ShopifyCheckoutPaymentUpdateRequest: ShopifyCheckoutPaymentUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.SpinToWinCreateRequest === null || requestParameters.SpinToWinCreateRequest === undefined) {
                throw new RequiredError('SpinToWinCreateRequest', 'Required parameter requestParameters.SpinToWinCreateRequest was null or undefined when calling spinToWinControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SpinToWinCreateRequestToJSON(requestParameters.SpinToWinCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SpinToWinResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    spinToWinControllerCreate(SpinToWinCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinControllerCreateRaw({ SpinToWinCreateRequest: SpinToWinCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling spinToWinControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SpinToWinResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    spinToWinControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SpinToWinResponseFromJSON));
        });
    }
    /**
     */
    spinToWinControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling spinToWinControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    spinToWinControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.spinToWinControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    spinToWinControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling spinToWinControllerUpdate.');
            }
            if (requestParameters.SpinToWinUpdateRequest === null || requestParameters.SpinToWinUpdateRequest === undefined) {
                throw new RequiredError('SpinToWinUpdateRequest', 'Required parameter requestParameters.SpinToWinUpdateRequest was null or undefined when calling spinToWinControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SpinToWinUpdateRequestToJSON(requestParameters.SpinToWinUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SpinToWinResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    spinToWinControllerUpdate(id, SpinToWinUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinControllerUpdateRaw({ id: id, SpinToWinUpdateRequest: SpinToWinUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinSessionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.SpinToWinSessionCreateRequest === null || requestParameters.SpinToWinSessionCreateRequest === undefined) {
                throw new RequiredError('SpinToWinSessionCreateRequest', 'Required parameter requestParameters.SpinToWinSessionCreateRequest was null or undefined when calling spinToWinSessionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win_session`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SpinToWinSessionCreateRequestToJSON(requestParameters.SpinToWinSessionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    spinToWinSessionControllerCreate(SpinToWinSessionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinSessionControllerCreateRaw({ SpinToWinSessionCreateRequest: SpinToWinSessionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinSessionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling spinToWinSessionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win_session/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    spinToWinSessionControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinSessionControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinSessionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.spinToWinId !== undefined) {
                queryParameters['spinToWinId'] = requestParameters.spinToWinId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win_session`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    spinToWinSessionControllerList({ spinToWinId, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinSessionControllerListRaw({ spinToWinId: spinToWinId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    spinToWinSessionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling spinToWinSessionControllerRemove.');
            }
            if (requestParameters.spinToWinId === null || requestParameters.spinToWinId === undefined) {
                throw new RequiredError('spinToWinId', 'Required parameter requestParameters.spinToWinId was null or undefined when calling spinToWinSessionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win_session/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"spinToWinId"}}`, encodeURIComponent(String(requestParameters.spinToWinId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    spinToWinSessionControllerRemove(id, spinToWinId, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.spinToWinSessionControllerRemoveRaw({ id: id, spinToWinId: spinToWinId }, initOverrides);
        });
    }
    /**
     */
    spinToWinSessionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling spinToWinSessionControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling spinToWinSessionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/spin_to_win_session/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    spinToWinSessionControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spinToWinSessionControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.StorageCreateRequest === null || requestParameters.StorageCreateRequest === undefined) {
                throw new RequiredError('StorageCreateRequest', 'Required parameter requestParameters.StorageCreateRequest was null or undefined when calling storageControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: StorageCreateRequestToJSON(requestParameters.StorageCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageControllerCreate(StorageCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageControllerCreateRaw({ StorageCreateRequest: StorageCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling storageControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(StorageResponseFromJSON));
        });
    }
    /**
     */
    storageControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling storageControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    storageControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storageControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    storageControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling storageControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling storageControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageUploadControllerCompleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.storageName === null || requestParameters.storageName === undefined) {
                throw new RequiredError('storageName', 'Required parameter requestParameters.storageName was null or undefined when calling storageUploadControllerComplete.');
            }
            if (requestParameters.StorageUploadCompleteRequest === null || requestParameters.StorageUploadCompleteRequest === undefined) {
                throw new RequiredError('StorageUploadCompleteRequest', 'Required parameter requestParameters.StorageUploadCompleteRequest was null or undefined when calling storageUploadControllerComplete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{storageName}/uploads/complete`.replace(`{${"storageName"}}`, encodeURIComponent(String(requestParameters.storageName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: StorageUploadCompleteRequestToJSON(requestParameters.StorageUploadCompleteRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageUploadControllerComplete(storageName, StorageUploadCompleteRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageUploadControllerCompleteRaw({ storageName: storageName, StorageUploadCompleteRequest: StorageUploadCompleteRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageUploadControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.storageName === null || requestParameters.storageName === undefined) {
                throw new RequiredError('storageName', 'Required parameter requestParameters.storageName was null or undefined when calling storageUploadControllerCreate.');
            }
            if (requestParameters.StorageUploadCreateRequest === null || requestParameters.StorageUploadCreateRequest === undefined) {
                throw new RequiredError('StorageUploadCreateRequest', 'Required parameter requestParameters.StorageUploadCreateRequest was null or undefined when calling storageUploadControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{storageName}/uploads`.replace(`{${"storageName"}}`, encodeURIComponent(String(requestParameters.storageName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: StorageUploadCreateRequestToJSON(requestParameters.StorageUploadCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageUploadControllerCreate(storageName, StorageUploadCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageUploadControllerCreateRaw({ storageName: storageName, StorageUploadCreateRequest: StorageUploadCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageUploadControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling storageUploadControllerGet.');
            }
            if (requestParameters.storageName === null || requestParameters.storageName === undefined) {
                throw new RequiredError('storageName', 'Required parameter requestParameters.storageName was null or undefined when calling storageUploadControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{storageName}/uploads/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"storageName"}}`, encodeURIComponent(String(requestParameters.storageName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageUploadControllerGet(id, storageName, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageUploadControllerGetRaw({ id: id, storageName: storageName }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageUploadControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.storageName === null || requestParameters.storageName === undefined) {
                throw new RequiredError('storageName', 'Required parameter requestParameters.storageName was null or undefined when calling storageUploadControllerList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{storageName}/uploads`.replace(`{${"storageName"}}`, encodeURIComponent(String(requestParameters.storageName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(StorageUploadResponseFromJSON));
        });
    }
    /**
     */
    storageUploadControllerList(storageName, { initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageUploadControllerListRaw({ storageName: storageName }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageUploadControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling storageUploadControllerRemove.');
            }
            if (requestParameters.storageName === null || requestParameters.storageName === undefined) {
                throw new RequiredError('storageName', 'Required parameter requestParameters.storageName was null or undefined when calling storageUploadControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{storageName}/uploads/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"storageName"}}`, encodeURIComponent(String(requestParameters.storageName))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    storageUploadControllerRemove(id, storageName, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storageUploadControllerRemoveRaw({ id: id, storageName: storageName }, initOverrides);
        });
    }
    /**
     */
    storageUploadControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling storageUploadControllerUpdate.');
            }
            if (requestParameters.storageName === null || requestParameters.storageName === undefined) {
                throw new RequiredError('storageName', 'Required parameter requestParameters.storageName was null or undefined when calling storageUploadControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling storageUploadControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/storage/{storageName}/uploads/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"storageName"}}`, encodeURIComponent(String(requestParameters.storageName))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    storageUploadControllerUpdate(id, storageName, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageUploadControllerUpdateRaw({ id: id, storageName: storageName, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    transactionControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.TransactionCreateRequest === null || requestParameters.TransactionCreateRequest === undefined) {
                throw new RequiredError('TransactionCreateRequest', 'Required parameter requestParameters.TransactionCreateRequest was null or undefined when calling transactionControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/transactions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: TransactionCreateRequestToJSON(requestParameters.TransactionCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    transactionControllerCreate(TransactionCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.transactionControllerCreateRaw({ TransactionCreateRequest: TransactionCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    transactionControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling transactionControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/transactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    transactionControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.transactionControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    transactionControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            if (requestParameters.orderId !== undefined) {
                queryParameters['orderId'] = requestParameters.orderId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/transactions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(TransactionResponseFromJSON));
        });
    }
    /**
     */
    transactionControllerList({ limit, skip, orderId, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.transactionControllerListRaw({ limit: limit, skip: skip, orderId: orderId }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    transactionControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling transactionControllerRemove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/transactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    transactionControllerRemove(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.transactionControllerRemoveRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    transactionControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling transactionControllerUpdate.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling transactionControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/transactions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    transactionControllerUpdate(id, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.transactionControllerUpdateRaw({ id: id, body: body }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.UserCreateRequest === null || requestParameters.UserCreateRequest === undefined) {
                throw new RequiredError('UserCreateRequest', 'Required parameter requestParameters.UserCreateRequest was null or undefined when calling userControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/users`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserCreateRequestToJSON(requestParameters.UserCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    userControllerCreate(UserCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userControllerCreateRaw({ UserCreateRequest: UserCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userControllerDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling userControllerDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    userControllerDelete(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.userControllerDeleteRaw({ id: id }, initOverrides);
        });
    }
    /**
     */
    userControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling userControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    userControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userControllerListRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/users`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(UserResponseFromJSON));
        });
    }
    /**
     */
    userControllerList({ initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userControllerListRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    userControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling userControllerUpdate.');
            }
            if (requestParameters.UserUpdateRequest === null || requestParameters.UserUpdateRequest === undefined) {
                throw new RequiredError('UserUpdateRequest', 'Required parameter requestParameters.UserUpdateRequest was null or undefined when calling userControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UserUpdateRequestToJSON(requestParameters.UserUpdateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UserResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    userControllerUpdate(id, UserUpdateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.userControllerUpdateRaw({ id: id, UserUpdateRequest: UserUpdateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    videoUploadControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.VideoUploadCreateRequest === null || requestParameters.VideoUploadCreateRequest === undefined) {
                throw new RequiredError('VideoUploadCreateRequest', 'Required parameter requestParameters.VideoUploadCreateRequest was null or undefined when calling videoUploadControllerCreate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/videos`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: VideoUploadCreateRequestToJSON(requestParameters.VideoUploadCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VideoUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    videoUploadControllerCreate(VideoUploadCreateRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.videoUploadControllerCreateRaw({ VideoUploadCreateRequest: VideoUploadCreateRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    videoUploadControllerGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling videoUploadControllerGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/videos/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VideoUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    videoUploadControllerGet(id, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.videoUploadControllerGetRaw({ id: id }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    videoUploadControllerListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.skip !== undefined) {
                queryParameters['skip'] = requestParameters.skip;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/videos`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(VideoUploadResponseFromJSON));
        });
    }
    /**
     */
    videoUploadControllerList({ limit, skip, initOverrides } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.videoUploadControllerListRaw({ limit: limit, skip: skip }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    videoUploadControllerUploadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.VideoUploadRequest === null || requestParameters.VideoUploadRequest === undefined) {
                throw new RequiredError('VideoUploadRequest', 'Required parameter requestParameters.VideoUploadRequest was null or undefined when calling videoUploadControllerUpload.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/uploads/videos/upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: VideoUploadRequestToJSON(requestParameters.VideoUploadRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => StorageUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    videoUploadControllerUpload(VideoUploadRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.videoUploadControllerUploadRaw({ VideoUploadRequest: VideoUploadRequest }, initOverrides);
            return yield response.value();
        });
    }
}

;// CONCATENATED MODULE: ./client/lib/esuite-api/apis/index.ts
/* tslint:disable */
/* eslint-disable */


;// CONCATENATED MODULE: ./client/lib/esuite-api/index.ts
/* tslint:disable */
/* eslint-disable */




;// CONCATENATED MODULE: ./client/lib/util/authorized-upload.ts
const authorizedUpload = (file, presignedPost) => {
    const formData = new FormData();
    formData.append("Content-Type", file.type);
    Object.entries(presignedPost.fields).forEach(([k, v]) => {
        formData.append(k, v);
    });
    formData.append('key', presignedPost.key);
    formData.append('acl', 'public-read');
    formData.append("file", file); // must be the last one
    return fetch(presignedPost.url, {
        method: "POST",
        body: formData,
    });
};

;// CONCATENATED MODULE: ./client/lib/extras/video-upload.ts


const videoUpload = (client) => {
    return {
        uploadFile: (file) => __awaiter(void 0, void 0, void 0, function* () {
            // const signed = await client.imageUpload.authorizeUpload() as any;
            const upload = yield client.videoUpload.upload({ name: file.name });
            yield authorizedUpload(file, upload.presignedPost);
            return client.videoUpload.create({ uploadId: upload.id });
        })
    };
};

;// CONCATENATED MODULE: ./client/lib/extras/image-upload.ts


const imageUpload = (client) => {
    return {
        uploadFile: (file) => __awaiter(void 0, void 0, void 0, function* () {
            // const signed = await client.imageUpload.authorizeUpload() as any;
            const upload = yield client.imageUpload.upload({ name: file.name });
            yield authorizedUpload(file, upload.presignedPost);
            return client.imageUpload.create({ uploadId: upload.id });
        })
    };
};

;// CONCATENATED MODULE: ./client/lib/extras/storage.ts



const storage = (client) => {
    return {
        uploadSingle: (storageName, file) => __awaiter(void 0, void 0, void 0, function* () {
            const signed = yield client.storageUpload.create(storageName, {
                name: file.name,
                uploadType: StorageUploadType.PresignedPost,
            });
            yield authorizedUpload(file, signed.presignedPost);
            return client.storageUpload.complete(storageName, { uploadId: signed.id });
        })
    };
};

;// CONCATENATED MODULE: ./client/lib/extras/public_api.ts




;// CONCATENATED MODULE: ./client/lib/extras/index.ts
/* Exports all additional functionality that is to be implemented in
EsuiteClient
 */


;// CONCATENATED MODULE: ./client/lib/controller-remap.ts
/*
Remap Controller Names
 */
const controllerRemap = {
    images: 'imageUpload',
};
const getRemap = (resource) => {
    for (const key of Object.keys(controllerRemap)) {
        if (controllerRemap[key] === resource) {
            return key;
        }
    }
};

// EXTERNAL MODULE: ./client/node_modules/base-64/base64.js
var base64 = __webpack_require__(713);
;// CONCATENATED MODULE: ./client/lib/esuite-client.ts





/*
Constants
 */
let TOKEN_STORE;
const TOKEN_GETTER = () => TOKEN_STORE;
const TOKEN_SETTER = (token) => TOKEN_STORE = token;
/*
Additional Hooks to extend base API functionality
 */
const beforeHooks = {};
const afterHooks = {
    auth: {
        // Automatically assign key to memory so we can retrieve and refresh.
        refreshToken: (resp) => {
            TOKEN_SETTER(resp.token);
            // Todo: add logic here to auto refresh the token.
        },
        authenticate: (resp) => {
            TOKEN_SETTER(resp.token);
        }
    }
};
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["V1"] = "V1";
})(ApiVersion || (ApiVersion = {}));
/*
Given an API configuration object this function will create and return an instance
of EsuiteClient. Internally reformats a standard Swagger API with additional configurations and
more hierarchical structure.
 */
const createEsuiteClient = (config = {}, version = ApiVersion.V1) => {
    const basePath = config.domain || ((window === null || window === void 0 ? void 0 : window.location) ? window.location.protocol + '//' + window.location.host : '');
    if (!basePath) {
        throw new Error('No API domain available.');
    }
    if (Object.keys(config).includes('accessToken')) {
        TOKEN_SETTER(config.accessToken);
    }
    const apiConfig = new Configuration({
        basePath,
        username: config.username,
        password: config.password,
        accessToken: TOKEN_GETTER,
        credentials: 'include',
        fetchApi: config.fetchApi,
        middleware: [
            {
                pre: (context) => __awaiter(void 0, void 0, void 0, function* () {
                    if (config.username && config.password) {
                        const creds = base64.encode([config.username, config.password].join(':'));
                        context.init.headers = Object.assign(Object.assign({}, context.init.headers), { 'Authorization': `Basic ${creds}` });
                    }
                    if (TOKEN_GETTER()) {
                        context.init.headers = Object.assign(Object.assign({}, context.init.headers), { 'Authorization': `Bearer ${TOKEN_GETTER()}` });
                    }
                    if (config.headers) {
                        for (const [name, value] of config.headers) {
                            context.init.headers = Object.assign(Object.assign({}, context.init.headers), { [name]: value });
                        }
                    }
                    if (config.organization) {
                        context.init.headers = Object.assign(Object.assign({}, context.init.headers), { ['X-Esuite-Organization']: config.organization });
                    }
                    return context;
                })
            },
            {
                post: (context) => __awaiter(void 0, void 0, void 0, function* () {
                    const isPaginatedResource = context.response.headers.has('X-EF-TotalPages');
                    if (isPaginatedResource) {
                        const links = (context.response.headers.get('Link') || '').split(',');
                        let nextPageParameters;
                        let previousPageParameters;
                        for (const link of links) {
                            if (link.indexOf('rel="prev"') > -1) {
                                const previousPageURL = new URL(link.replace('; rel="prev"', '').slice(1, -1));
                                previousPageParameters = {
                                    skip: previousPageURL.searchParams.get('skip'),
                                    limit: previousPageURL.searchParams.get('limit'),
                                };
                            }
                            else if (link.indexOf('rel="next"') > -1) {
                                const nextPageURL = new URL(link.replace('; rel="next"', '').slice(1, -1));
                                nextPageParameters = {
                                    skip: nextPageURL.searchParams.get('skip'),
                                    limit: nextPageURL.searchParams.get('limit'),
                                };
                            }
                        }
                        const totalPages = parseInt(context.response.headers.get('X-EF-TotalPages'), 10);
                        const count = parseInt(context.response.headers.get('X-EF-Count'), 10);
                        const skip = parseInt(context.response.headers.get('X-EF-Skip'), 10);
                        const limit = parseInt(context.response.headers.get('X-EF-Limit'), 10);
                        // These are retrieved and set on the array in JSONApiResponse in runtime.ts
                        //  is in the client-types.js file
                        context.response.__pagination = {
                            totalPages,
                            count,
                            skip,
                            limit,
                            nextPageParameters,
                            previousPageParameters,
                        };
                    }
                    return context.response;
                })
            }
        ],
    });
    return buildClient(DefaultApi, apiConfig, version);
};
function buildClient(apiType, apiConfig, apiVersion) {
    const baseApi = new DefaultApi(apiConfig);
    const client = {
        get accessToken() {
            return TOKEN_GETTER();
        },
        set accessToken(at) {
            TOKEN_SETTER(at);
        }
    };
    // Loop through parent object for all API methods.
    for (const resourceMethodKey of Object.getOwnPropertyNames(Object.getPrototypeOf(baseApi))) {
        // Filter only public Controller methods (without Raw suffix)
        if (resourceMethodKey.indexOf('Controller') > -1 && resourceMethodKey.lastIndexOf('Raw') !== (resourceMethodKey.length - 3)) {
            const resource = resourceMethodKey.slice(0, resourceMethodKey.indexOf('Controller'));
            let version = (resourceMethodKey.slice(resourceMethodKey.indexOf('Controller') + 10).match(/V([0-9]*)/) || [''])[0];
            let methodKey = resourceMethodKey.slice(resourceMethodKey.indexOf('Controller') + 10).replace(version, '');
            // Remap resource key if any remaps
            let resourceRemap = getRemap(resource);
            // If the API is versioned make sure to skip it if it does not match the current version
            if (version && version.toLowerCase() !== apiVersion.toLowerCase()) {
                continue;
            }
            // Ensure client object exists
            if (!client[resource]) {
                client[resource] = {};
            }
            // Ensure client object exists
            if (resourceRemap && !client[resourceRemap]) {
                client[resourceRemap] = {};
            }
            // Assign methodKey by extracting method key from full method name.
            methodKey = methodKey.slice(0, 1).toLowerCase() + methodKey.slice(1);
            // Set method key with reference to baseApi method
            client[resource][methodKey] = (...args) => {
                var _a;
                // Run Before Hooks and pass arguments
                if ((_a = beforeHooks[resource]) === null || _a === void 0 ? void 0 : _a[methodKey]) {
                    beforeHooks[resource][methodKey](...args);
                }
                return baseApi[resourceMethodKey].apply(baseApi, args)
                    .then(resp => {
                    var _a;
                    // Run after hooks with results of the API
                    if ((_a = afterHooks[resource]) === null || _a === void 0 ? void 0 : _a[methodKey]) {
                        afterHooks[resource][methodKey](resp);
                    }
                    return resp;
                });
            };
            if (resourceRemap) {
                client[resourceRemap] = client[resource];
            }
        }
    }
    // Load extra methods
    for (const resourceGeneratorKey of Object.keys(extras_namespaceObject)) {
        const extraMethods = extras_namespaceObject[resourceGeneratorKey](client);
        for (const methodKey of Object.keys(extraMethods)) {
            client[resourceGeneratorKey][methodKey] = extraMethods[methodKey];
        }
    }
    return client;
}

;// CONCATENATED MODULE: ./client/lib/public_api.ts
/*
Consumes generated Swagger API and re-exports re-structured and re-typed version.
With additional configuration options including sub-domain setup.
 */


;// CONCATENATED MODULE: ./client/lib/api-structure.ts
class EsuiteClient {
    constructor() {
        this.accessToken = '';
        this.accessCode = {};
        this.accessControl = {};
        this.activation = {};
        this.activationSchedule = {};
        this.activationScheduleItem = {};
        this.admission = {};
        this.admissionOption = {};
        this.admissionTemplate = {};
        this.agreement = {};
        this.api = {};
        this.appPlugin = {};
        this.appPluginHook = {};
        this.appPurchase = {};
        this.auth = {};
        this.checkout = {};
        this.checkoutLineItem = {};
        this.customApp = {};
        this.customer = {};
        this.digitalSignage = {};
        this.digitalSignageFrame = {};
        this.digitalSignageSlide = {};
        this.directory = {};
        this.directoryFloor = {};
        this.directoryListing = {};
        this.esuiteApp = {};
        this.fund = {};
        this.fundOption = {};
        this.imageUpload = {};
        this.kiosk = {};
        this.kioskGroup = {};
        this.kioskRemote = {};
        this.mailer = {};
        this.mediaCollectionAccessCode = {};
        this.mediaCollectionAlbum = {};
        this.mediaCollection = {};
        this.mediaCollectionItem = {};
        this.notification = {};
        this.order = {};
        this.orderLineItem = {};
        this.organization = {};
        this.paymentGateway = {};
        this.paymentTerminal = {};
        this.photobooth = {};
        this.photoboothFrame = {};
        this.photoboothSession = {};
        this.platform = {};
        this.productCategory = {};
        this.register = {};
        this.restApp = {};
        this.revenueCenter = {};
        this.role = {};
        this.selfCheckout = {};
        this.selfCheckoutCountry = {};
        this.selfCheckoutIntegration = {};
        this.selfCheckoutOrder = {};
        this.selfCheckoutTemplate = {};
        this.shopifyCheckout = {};
        this.shopifyCheckoutPayment = {};
        this.spinToWin = {};
        this.spinToWinSession = {};
        this.storage = {};
        this.storageUpload = {};
        this.transaction = {};
        this.user = {};
        this.videoUpload = {};
    }
}
;
/*
type BaseClientRemapper = {
    [K in keyof ControllerRemap]: BaseClient[ControllerRemap[K]];
}

export type EsuiteClient = BaseClient & BaseClientRemapper;
*/

;// CONCATENATED MODULE: ./client/lib/index.ts





})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});